var $s = Object.defineProperty, el = Object.defineProperties;
var tl = Object.getOwnPropertyDescriptors;
var Xt = Object.getOwnPropertySymbols;
var ji = Object.prototype.hasOwnProperty, Ai = Object.prototype.propertyIsEnumerable;
var ei = (e, t) => (t = Symbol[e]) ? t : Symbol.for("Symbol." + e);
var ti = (e, t, i) => t in e ? $s(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i, R = (e, t) => {
  for (var i in t || (t = {}))
    ji.call(t, i) && ti(e, i, t[i]);
  if (Xt)
    for (var i of Xt(t))
      Ai.call(t, i) && ti(e, i, t[i]);
  return e;
}, ge = (e, t) => el(e, tl(t));
var fe = (e, t) => {
  var i = {};
  for (var n in e)
    ji.call(e, n) && t.indexOf(n) < 0 && (i[n] = e[n]);
  if (e != null && Xt)
    for (var n of Xt(e))
      t.indexOf(n) < 0 && Ai.call(e, n) && (i[n] = e[n]);
  return i;
};
var N = (e, t, i) => (ti(e, typeof t != "symbol" ? t + "" : t, i), i);
var A = (e, t, i) => new Promise((n, s) => {
  var l = (a) => {
    try {
      r(i.next(a));
    } catch (c) {
      s(c);
    }
  }, o = (a) => {
    try {
      r(i.throw(a));
    } catch (c) {
      s(c);
    }
  }, r = (a) => a.done ? n(a.value) : Promise.resolve(a.value).then(l, o);
  r((i = i.apply(e, t)).next());
}), il = function(e, t) {
  this[0] = e, this[1] = t;
};
var ii = (e) => {
  var t = e[ei("asyncIterator")], i = !1, n, s = {};
  return t == null ? (t = e[ei("iterator")](), n = (l) => s[l] = (o) => t[l](o)) : (t = t.call(e), n = (l) => s[l] = (o) => {
    if (i) {
      if (i = !1, l === "throw")
        throw o;
      return o;
    }
    return i = !0, {
      done: !1,
      value: new il(new Promise((r) => {
        var a = t[l](o);
        if (!(a instanceof Object))
          throw TypeError("Object expected");
        r(a);
      }), 1)
    };
  }), s[ei("iterator")] = () => s, n("next"), "throw" in t ? n("throw") : s.throw = (l) => {
    throw l;
  }, "return" in t && n("return"), s;
};
import { K as nl, i as _i, d as sl, a as ll, Q as ol, p as al, b as qn, g as rl, c as cl, m as dl, e as Xe, S as Ve, s as ve, G as ni, f as qi, r as $i, F as Ke, h as ul, E as ml, j as si, k as tt, l as en, M as Fe, n as Ze, V as hl, H as tn, o as pl, q as bl, t as li, u as nn, v as Zl, w as yl } from "./index-CVSDPaOD.js";
import { y as dc, x as uc } from "./index-CVSDPaOD.js";
function Gl(e, t) {
  for (var i = 0; i < t.length; i++) {
    const n = t[i];
    if (typeof n != "string" && !Array.isArray(n)) {
      for (const s in n)
        if (s !== "default" && !(s in e)) {
          const l = Object.getOwnPropertyDescriptor(n, s);
          l && Object.defineProperty(e, s, l.get ? l : {
            enumerable: !0,
            get: () => n[s]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
function Xl(e) {
  return `"${e.replace(gl, Vl)}"`;
}
const gl = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function Vl(e) {
  return Wl[e.charCodeAt(0)];
}
const Wl = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 2F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 3F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 4F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  // 5F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 6F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], fl = Object.freeze({});
function Il(e, t, i = ol) {
  const n = /* @__PURE__ */ new Map();
  for (const V of Object.values(nl))
    n.set(V, Sl(t, V));
  let s, l = Array.isArray(e), o = [e], r = -1, a = [], c = e, d, u;
  const p = [], h = [];
  do {
    r++;
    const V = r === o.length, I = V && a.length !== 0;
    if (V) {
      if (d = h.length === 0 ? void 0 : p[p.length - 1], c = u, u = h.pop(), I)
        if (l) {
          c = c.slice();
          let G = 0;
          for (const [w, U] of a) {
            const f = w - G;
            U === null ? (c.splice(f, 1), G++) : c[f] = U;
          }
        } else {
          c = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(c)
          );
          for (const [G, w] of a)
            c[G] = w;
        }
      r = s.index, o = s.keys, a = s.edits, l = s.inArray, s = s.prev;
    } else if (u) {
      if (d = l ? r : o[r], c = u[d], c == null)
        continue;
      p.push(d);
    }
    let y;
    if (!Array.isArray(c)) {
      var Z, b;
      _i(c) || sl(!1, `Invalid AST Node: ${ll(c)}.`);
      const G = V ? (Z = n.get(c.kind)) === null || Z === void 0 ? void 0 : Z.leave : (b = n.get(c.kind)) === null || b === void 0 ? void 0 : b.enter;
      if (y = G == null ? void 0 : G.call(t, c, d, u, p, h), y === fl)
        break;
      if (y === !1) {
        if (!V) {
          p.pop();
          continue;
        }
      } else if (y !== void 0 && (a.push([d, y]), !V))
        if (_i(y))
          c = y;
        else {
          p.pop();
          continue;
        }
    }
    if (y === void 0 && I && a.push([d, c]), V)
      p.pop();
    else {
      var W;
      s = {
        inArray: l,
        index: r,
        keys: o,
        edits: a,
        prev: s
      }, l = Array.isArray(c), o = l ? c : (W = i[c.kind]) !== null && W !== void 0 ? W : [], r = -1, a = [], u && h.push(u), u = c;
    }
  } while (s !== void 0);
  return a.length !== 0 ? a[a.length - 1][1] : e;
}
function Sl(e, t) {
  const i = e[t];
  return typeof i == "object" ? i : typeof i == "function" ? {
    enter: i,
    leave: void 0
  } : {
    enter: e.enter,
    leave: e.leave
  };
}
function $n(e) {
  return Il(e, Cl);
}
const Rl = 80, Cl = {
  Name: {
    leave: (e) => e.value
  },
  Variable: {
    leave: (e) => "$" + e.name
  },
  // Document
  Document: {
    leave: (e) => S(e.definitions, `

`)
  },
  OperationDefinition: {
    leave(e) {
      const t = v("(", S(e.variableDefinitions, ", "), ")"), i = S(
        [
          e.operation,
          S([e.name, t]),
          S(e.directives, " ")
        ],
        " "
      );
      return (i === "query" ? "" : i + " ") + e.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: e, type: t, defaultValue: i, directives: n }) => e + ": " + t + v(" = ", i) + v(" ", S(n, " "))
  },
  SelectionSet: {
    leave: ({ selections: e }) => me(e)
  },
  Field: {
    leave({ alias: e, name: t, arguments: i, directives: n, selectionSet: s }) {
      const l = v("", e, ": ") + t;
      let o = l + v("(", S(i, ", "), ")");
      return o.length > Rl && (o = l + v(`(
`, Ct(S(i, `
`)), `
)`)), S([o, S(n, " "), s], " ");
    }
  },
  Argument: {
    leave: ({ name: e, value: t }) => e + ": " + t
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name: e, directives: t }) => "..." + e + v(" ", S(t, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: e, directives: t, selectionSet: i }) => S(
      [
        "...",
        v("on ", e),
        S(t, " "),
        i
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({ name: e, typeCondition: t, variableDefinitions: i, directives: n, selectionSet: s }) => (
      // or removed in the future.
      `fragment ${e}${v("(", S(i, ", "), ")")} on ${t} ${v("", S(n, " "), " ")}` + s
    )
  },
  // Value
  IntValue: {
    leave: ({ value: e }) => e
  },
  FloatValue: {
    leave: ({ value: e }) => e
  },
  StringValue: {
    leave: ({ value: e, block: t }) => t ? al(e) : Xl(e)
  },
  BooleanValue: {
    leave: ({ value: e }) => e ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: e }) => e
  },
  ListValue: {
    leave: ({ values: e }) => "[" + S(e, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: e }) => "{" + S(e, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: e, value: t }) => e + ": " + t
  },
  // Directive
  Directive: {
    leave: ({ name: e, arguments: t }) => "@" + e + v("(", S(t, ", "), ")")
  },
  // Type
  NamedType: {
    leave: ({ name: e }) => e
  },
  ListType: {
    leave: ({ type: e }) => "[" + e + "]"
  },
  NonNullType: {
    leave: ({ type: e }) => e + "!"
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description: e, directives: t, operationTypes: i }) => v("", e, `
`) + S(["schema", S(t, " "), me(i)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: e, type: t }) => e + ": " + t
  },
  ScalarTypeDefinition: {
    leave: ({ description: e, name: t, directives: i }) => v("", e, `
`) + S(["scalar", t, S(i, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: e, name: t, interfaces: i, directives: n, fields: s }) => v("", e, `
`) + S(
      [
        "type",
        t,
        v("implements ", S(i, " & ")),
        S(n, " "),
        me(s)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: e, name: t, arguments: i, type: n, directives: s }) => v("", e, `
`) + t + (sn(i) ? v(`(
`, Ct(S(i, `
`)), `
)`) : v("(", S(i, ", "), ")")) + ": " + n + v(" ", S(s, " "))
  },
  InputValueDefinition: {
    leave: ({ description: e, name: t, type: i, defaultValue: n, directives: s }) => v("", e, `
`) + S(
      [t + ": " + i, v("= ", n), S(s, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: e, name: t, interfaces: i, directives: n, fields: s }) => v("", e, `
`) + S(
      [
        "interface",
        t,
        v("implements ", S(i, " & ")),
        S(n, " "),
        me(s)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: e, name: t, directives: i, types: n }) => v("", e, `
`) + S(
      ["union", t, S(i, " "), v("= ", S(n, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: e, name: t, directives: i, values: n }) => v("", e, `
`) + S(["enum", t, S(i, " "), me(n)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: e, name: t, directives: i }) => v("", e, `
`) + S([t, S(i, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: e, name: t, directives: i, fields: n }) => v("", e, `
`) + S(["input", t, S(i, " "), me(n)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description: e, name: t, arguments: i, repeatable: n, locations: s }) => v("", e, `
`) + "directive @" + t + (sn(i) ? v(`(
`, Ct(S(i, `
`)), `
)`) : v("(", S(i, ", "), ")")) + (n ? " repeatable" : "") + " on " + S(s, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: e, operationTypes: t }) => S(
      ["extend schema", S(e, " "), me(t)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: e, directives: t }) => S(["extend scalar", e, S(t, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: e, interfaces: t, directives: i, fields: n }) => S(
      [
        "extend type",
        e,
        v("implements ", S(t, " & ")),
        S(i, " "),
        me(n)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: e, interfaces: t, directives: i, fields: n }) => S(
      [
        "extend interface",
        e,
        v("implements ", S(t, " & ")),
        S(i, " "),
        me(n)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: e, directives: t, types: i }) => S(
      [
        "extend union",
        e,
        S(t, " "),
        v("= ", S(i, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: e, directives: t, values: i }) => S(["extend enum", e, S(t, " "), me(i)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: e, directives: t, fields: i }) => S(["extend input", e, S(t, " "), me(i)], " ")
  }
};
function S(e, t = "") {
  var i;
  return (i = e == null ? void 0 : e.filter((n) => n).join(t)) !== null && i !== void 0 ? i : "";
}
function me(e) {
  return v(`{
`, Ct(S(e, `
`)), `
}`);
}
function v(e, t, i = "") {
  return t != null && t !== "" ? e + t + i : "";
}
function Ct(e) {
  return v("  ", e.replace(/\n/g, `
  `));
}
function sn(e) {
  var t;
  return (t = e == null ? void 0 : e.some((i) => i.includes(`
`))) !== null && t !== void 0 ? t : !1;
}
var Ll = Object.defineProperty, Yl = (e, t, i) => t in e ? Ll(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i, g = (e, t, i) => (Yl(e, typeof t != "symbol" ? t + "" : t, i), i), ln, Nl = Object.defineProperty, kl = (e, t, i) => t in e ? Nl(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i, on = (e, t, i) => (kl(e, typeof t != "symbol" ? t + "" : t, i), i), _ = /* @__PURE__ */ ((e) => (e[e.Document = 0] = "Document", e[e.DocumentType = 1] = "DocumentType", e[e.Element = 2] = "Element", e[e.Text = 3] = "Text", e[e.CDATA = 4] = "CDATA", e[e.Comment = 5] = "Comment", e))(_ || {});
const an = {
  Node: ["childNodes", "parentNode", "parentElement", "textContent"],
  ShadowRoot: ["host", "styleSheets"],
  Element: ["shadowRoot", "querySelector", "querySelectorAll"],
  MutationObserver: []
}, rn = {
  Node: ["contains", "getRootNode"],
  ShadowRoot: ["getSelection"],
  Element: [],
  MutationObserver: ["constructor"]
}, gt = {};
function Ji(e) {
  if (gt[e])
    return gt[e];
  const t = globalThis[e], i = t.prototype, n = e in an ? an[e] : void 0, s = !!(n && // @ts-expect-error 2345
  n.every(
    (r) => {
      var a, c;
      return !!((c = (a = Object.getOwnPropertyDescriptor(i, r)) == null ? void 0 : a.get) != null && c.toString().includes("[native code]"));
    }
  )), l = e in rn ? rn[e] : void 0, o = !!(l && l.every(
    // @ts-expect-error 2345
    (r) => {
      var a;
      return typeof i[r] == "function" && ((a = i[r]) == null ? void 0 : a.toString().includes("[native code]"));
    }
  ));
  if (s && o)
    return gt[e] = t.prototype, t.prototype;
  try {
    const r = document.createElement("iframe");
    document.body.appendChild(r);
    const a = r.contentWindow;
    if (!a)
      return t.prototype;
    const c = a[e].prototype;
    return document.body.removeChild(r), c ? gt[e] = c : i;
  } catch (r) {
    return i;
  }
}
const oi = {};
function Ye(e, t, i) {
  var n;
  const s = `${e}.${String(i)}`;
  if (oi[s])
    return oi[s].call(
      t
    );
  const l = Ji(e), o = (n = Object.getOwnPropertyDescriptor(
    l,
    i
  )) == null ? void 0 : n.get;
  return o ? (oi[s] = o, o.call(t)) : t[i];
}
const ai = {};
function es(e, t, i) {
  const n = `${e}.${String(i)}`;
  if (ai[n])
    return ai[n].bind(
      t
    );
  const l = Ji(e)[i];
  return typeof l != "function" ? t[i] : (ai[n] = l, l.bind(t));
}
function Jl(e) {
  return Ye("Node", e, "childNodes");
}
function wl(e) {
  return Ye("Node", e, "parentNode");
}
function Tl(e) {
  return Ye("Node", e, "parentElement");
}
function vl(e) {
  return Ye("Node", e, "textContent");
}
function xl(e, t) {
  return es("Node", e, "contains")(t);
}
function Kl(e) {
  return es("Node", e, "getRootNode")();
}
function Fl(e) {
  return !e || !("host" in e) ? null : Ye("ShadowRoot", e, "host");
}
function Ul(e) {
  return e.styleSheets;
}
function Hl(e) {
  return !e || !("shadowRoot" in e) ? null : Ye("Element", e, "shadowRoot");
}
function Ml(e, t) {
  return Ye("Element", e, "querySelector")(t);
}
function zl(e, t) {
  return Ye("Element", e, "querySelectorAll")(t);
}
function Bl() {
  return Ji("MutationObserver").constructor;
}
const $ = {
  childNodes: Jl,
  parentNode: wl,
  parentElement: Tl,
  textContent: vl,
  contains: xl,
  getRootNode: Kl,
  host: Fl,
  styleSheets: Ul,
  shadowRoot: Hl,
  querySelector: Ml,
  querySelectorAll: zl,
  mutationObserver: Bl
};
function ts(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function lt(e) {
  const t = (
    // anchor and textarea elements also have a `host` property
    // but only shadow roots have a `mode` property
    e && "host" in e && "mode" in e && $.host(e) || null
  );
  return !!(t && "shadowRoot" in t && $.shadowRoot(t) === e);
}
function ot(e) {
  return Object.prototype.toString.call(e) === "[object ShadowRoot]";
}
function Pl(e) {
  return e.includes(" background-clip: text;") && !e.includes(" -webkit-background-clip: text;") && (e = e.replace(
    /\sbackground-clip:\s*text;/g,
    " -webkit-background-clip: text; background-clip: text;"
  )), e;
}
function El(e) {
  const { cssText: t } = e;
  if (t.split('"').length < 3)
    return t;
  const i = ["@import", `url(${JSON.stringify(e.href)})`];
  return e.layerName === "" ? i.push("layer") : e.layerName && i.push(`layer(${e.layerName})`), e.supportsText && i.push(`supports(${e.supportsText})`), e.media.length && i.push(e.media.mediaText), i.join(" ") + ";";
}
function Jt(e) {
  try {
    const t = e.rules || e.cssRules;
    if (!t)
      return null;
    const i = Array.from(
      t,
      (n) => is(n, e.href)
    ).join("");
    return Pl(i);
  } catch (t) {
    return null;
  }
}
function is(e, t) {
  if (Dl(e)) {
    let i;
    try {
      i = // for same-origin stylesheets,
      // we can access the imported stylesheet rules directly
      Jt(e.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
      El(e);
    } catch (n) {
      i = e.cssText;
    }
    return e.styleSheet.href ? wt(i, e.styleSheet.href) : i;
  } else {
    let i = e.cssText;
    return Ql(e) && e.selectorText.includes(":") && (i = Ol(i)), t ? wt(i, t) : i;
  }
}
function Ol(e) {
  const t = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
  return e.replace(t, "$1\\$2");
}
function Dl(e) {
  return "styleSheet" in e;
}
function Ql(e) {
  return "selectorText" in e;
}
class ns {
  constructor() {
    on(this, "idNodeMap", /* @__PURE__ */ new Map()), on(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
  }
  getId(t) {
    var i;
    if (!t)
      return -1;
    const n = (i = this.getMeta(t)) == null ? void 0 : i.id;
    return n != null ? n : -1;
  }
  getNode(t) {
    return this.idNodeMap.get(t) || null;
  }
  getIds() {
    return Array.from(this.idNodeMap.keys());
  }
  getMeta(t) {
    return this.nodeMetaMap.get(t) || null;
  }
  // removes the node from idNodeMap
  // doesn't remove the node from nodeMetaMap
  removeNodeFromMap(t) {
    const i = this.getId(t);
    this.idNodeMap.delete(i), t.childNodes && t.childNodes.forEach(
      (n) => this.removeNodeFromMap(n)
    );
  }
  has(t) {
    return this.idNodeMap.has(t);
  }
  hasNode(t) {
    return this.nodeMetaMap.has(t);
  }
  add(t, i) {
    const n = i.id;
    this.idNodeMap.set(n, t), this.nodeMetaMap.set(t, i);
  }
  replace(t, i) {
    const n = this.getNode(t);
    if (n) {
      const s = this.nodeMetaMap.get(n);
      s && this.nodeMetaMap.set(i, s);
    }
    this.idNodeMap.set(t, i);
  }
  reset() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
}
function jl() {
  return new ns();
}
function wi({
  element: e,
  maskInputOptions: t,
  tagName: i,
  type: n,
  value: s,
  overwriteRecord: l,
  maskInputFn: o
}) {
  let r = s || "";
  return os({
    maskInputOptions: t,
    tagName: i,
    type: n,
    overwriteRecord: l
  }) && (o ? r = o(r, e) : r = "*".repeat(r.length)), r;
}
function Qe(e) {
  return e.toLowerCase();
}
const cn = "__rrweb_original__";
function Al(e) {
  const t = e.getContext("2d");
  if (!t)
    return !0;
  const i = 50;
  for (let n = 0; n < e.width; n += i)
    for (let s = 0; s < e.height; s += i) {
      const l = t.getImageData, o = cn in l ? l[cn] : l;
      if (new Uint32Array(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        o.call(
          t,
          n,
          s,
          Math.min(i, e.width - n),
          Math.min(i, e.height - s)
        ).data.buffer
      ).some((a) => a !== 0))
        return !1;
    }
  return !0;
}
function Ti(e) {
  const t = e.type;
  return e.hasAttribute("data-rr-is-password") ? "password" : t ? (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    Qe(t)
  ) : null;
}
function ss(e, t) {
  var l;
  let i;
  try {
    i = new URL(e, t != null ? t : window.location.href);
  } catch (o) {
    return null;
  }
  const n = /\.([0-9a-z]+)(?:$)/i, s = i.pathname.match(n);
  return (l = s == null ? void 0 : s[1]) != null ? l : null;
}
function _l(e) {
  let t = "";
  return e.indexOf("//") > -1 ? t = e.split("/").slice(0, 3).join("/") : t = e.split("/")[0], t = t.split("?")[0], t;
}
const ql = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm, $l = /^(?:[a-z+]+:)?\/\//i, eo = /^www\..*/i, to = /^(data:)([^,]*),(.*)/i;
function wt(e, t) {
  return (e || "").replace(
    ql,
    (i, n, s, l, o, r) => {
      const a = s || o || r, c = n || l || "";
      if (!a)
        return i;
      if ($l.test(a) || eo.test(a))
        return `url(${c}${a}${c})`;
      if (to.test(a))
        return `url(${c}${a}${c})`;
      if (a[0] === "/")
        return `url(${c}${_l(t) + a}${c})`;
      const d = t.split("/"), u = a.split("/");
      d.pop();
      for (const p of u)
        p !== "." && (p === ".." ? d.pop() : d.push(p));
      return `url(${c}${d.join("/")}${c})`;
    }
  );
}
function vi(e) {
  return e = e.replace(/[^ -~]+/g, ""), e = (e == null ? void 0 : e.split(" ").map((t) => Math.random().toString(20).substr(2, t.length)).join(" ")) || "", e;
}
function fi(e) {
  return e === "img" || e === "video" || e === "audio" || e === "source";
}
const io = new RegExp(
  /[a-zA-Z0-9.!#$%&'*+=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*/
), no = new RegExp(/[0-9]{9,16}/), so = new RegExp(/[0-9]{3}-?[0-9]{2}-?[0-9]{4}/), lo = new RegExp(
  /[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}/
), oo = new RegExp(/[0-9]{4}-?[0-9]{4}-?[0-9]{4}-?[0-9]{4}/), ao = new RegExp(
  /[0-9]{1,5}.?[0-9]{0,3}\s[a-zA-Z]{2,30}\s[a-zA-Z]{2,15}/
), ro = new RegExp(/(?:[0-9]{1,3}.){3}[0-9]{1,3}/), co = [
  io,
  no,
  so,
  lo,
  oo,
  ao,
  ro
];
function ls(e) {
  return e ? co.some((t) => t.test(e)) : !1;
}
const os = ({
  maskInputOptions: e,
  tagName: t,
  type: i,
  overwriteRecord: n
}) => {
  const s = i && i.toLowerCase();
  return n !== "true" && (!!e[t.toLowerCase()] || !!(s && e[s]));
};
let uo = 1;
const mo = new RegExp("[^a-z0-9-_:]"), dt = -2;
function as() {
  return uo++;
}
function ho(e) {
  if (e instanceof HTMLFormElement)
    return "form";
  const t = Qe(e.tagName);
  return mo.test(t) ? "div" : t;
}
let Ue, dn;
const po = /^[^ \t\n\r\u000c]+/, bo = /^[, \t\n\r\u000c]+/;
function Zo(e, t) {
  if (t.trim() === "")
    return t;
  let i = 0;
  function n(l) {
    let o;
    const r = l.exec(t.substring(i));
    return r ? (o = r[0], i += o.length, o) : "";
  }
  const s = [];
  for (; n(bo), !(i >= t.length); ) {
    let l = n(po);
    if (l.slice(-1) === ",")
      l = Be(e, l.substring(0, l.length - 1)), s.push(l);
    else {
      let o = "";
      l = Be(e, l);
      let r = !1;
      for (; ; ) {
        const a = t.charAt(i);
        if (a === "") {
          s.push((l + o).trim());
          break;
        } else if (r)
          a === ")" && (r = !1);
        else if (a === ",") {
          i += 1, s.push((l + o).trim());
          break;
        } else
          a === "(" && (r = !0);
        o += a, i += 1;
      }
    }
  }
  return s.join(", ");
}
const un = /* @__PURE__ */ new WeakMap();
function Be(e, t) {
  return !t || t.trim() === "" ? t : xi(e, t);
}
function yo(e) {
  return !!(e.tagName === "svg" || e.ownerSVGElement);
}
function xi(e, t) {
  let i = un.get(e);
  if (i || (i = e.createElement("a"), un.set(e, i)), !t)
    t = "";
  else if (t.startsWith("blob:") || t.startsWith("data:"))
    return t;
  return i.setAttribute("href", t), i.href;
}
function rs(e, t, i, n) {
  return n && (i === "src" || i === "href" && !(t === "use" && n[0] === "#") || i === "xlink:href" && n[0] !== "#" || i === "background" && (t === "table" || t === "td" || t === "th") ? Be(e, n) : i === "srcset" ? Zo(e, n) : i === "style" ? wt(n, xi(e)) : t === "object" && i === "data" ? Be(e, n) : n);
}
function cs(e, t, i) {
  return (e === "video" || e === "audio") && t === "autoplay";
}
function mn(e, t, i) {
  try {
    if (typeof t == "string") {
      if (e.classList.contains(t))
        return !0;
    } else
      for (let n = e.classList.length; n--; ) {
        const s = e.classList[n];
        if (t.test(s))
          return !0;
      }
    if (i)
      return e.matches(i);
  } catch (n) {
  }
  return !1;
}
function Tt(e, t, i) {
  if (!e)
    return !1;
  if (e.nodeType !== e.ELEMENT_NODE)
    return i ? Tt($.parentNode(e), t, i) : !1;
  for (let n = e.classList.length; n--; ) {
    const s = e.classList[n];
    if (t.test(s))
      return !0;
  }
  return i ? Tt($.parentNode(e), t, i) : !1;
}
function ds(e, t, i, n) {
  let s;
  if (ts(e)) {
    if (s = e, !$.childNodes(s).length)
      return !1;
  } else {
    if ($.parentElement(e) === null)
      return !1;
    s = $.parentElement(e);
  }
  try {
    if (typeof t == "string") {
      if (n) {
        if (s.closest(`.${t}`))
          return !0;
      } else if (s.classList.contains(t))
        return !0;
    } else if (Tt(s, t, n))
      return !0;
    if (i) {
      if (n) {
        if (s.closest(i))
          return !0;
      } else if (s.matches(i))
        return !0;
    }
  } catch (l) {
  }
  return !1;
}
function Go(e, t, i) {
  const n = e.contentWindow;
  if (!n)
    return;
  let s = !1, l;
  try {
    l = n.document.readyState;
  } catch (r) {
    return;
  }
  if (l !== "complete") {
    const r = setTimeout(() => {
      s || (t(), s = !0);
    }, i);
    e.addEventListener("load", () => {
      clearTimeout(r), s = !0, t();
    });
    return;
  }
  const o = "about:blank";
  if (n.location.href !== o || e.src === o || e.src === "")
    return setTimeout(t, 0), e.addEventListener("load", t);
  e.addEventListener("load", t);
}
function Xo(e, t, i) {
  let n = !1, s;
  try {
    s = e.sheet;
  } catch (o) {
    return;
  }
  if (s)
    return;
  const l = setTimeout(() => {
    n || (t(), n = !0);
  }, i);
  e.addEventListener("load", () => {
    clearTimeout(l), n = !0, t();
  });
}
function go(e, t) {
  const {
    doc: i,
    mirror: n,
    blockClass: s,
    blockSelector: l,
    needsMask: o,
    inlineStylesheet: r,
    maskInputOptions: a = {},
    maskTextClass: c,
    maskTextFn: d,
    maskInputFn: u,
    dataURLOptions: p = {},
    inlineImages: h,
    recordCanvas: Z,
    keepIframeSrcFn: b,
    newlyAddedElement: W = !1,
    privacySetting: V
  } = t, I = Vo(i, n);
  switch (e.nodeType) {
    case e.DOCUMENT_NODE:
      return e.compatMode !== "CSS1Compat" ? {
        type: _.Document,
        childNodes: [],
        compatMode: e.compatMode
        // probably "BackCompat"
      } : {
        type: _.Document,
        childNodes: []
      };
    case e.DOCUMENT_TYPE_NODE:
      return {
        type: _.DocumentType,
        name: e.name,
        publicId: e.publicId,
        systemId: e.systemId,
        rootId: I
      };
    case e.ELEMENT_NODE:
      return fo(e, {
        doc: i,
        blockClass: s,
        blockSelector: l,
        inlineStylesheet: r,
        maskInputOptions: a,
        maskInputFn: u,
        maskTextClass: c,
        dataURLOptions: p,
        inlineImages: h,
        recordCanvas: Z,
        keepIframeSrcFn: b,
        newlyAddedElement: W,
        privacySetting: V,
        rootId: I
      });
    case e.TEXT_NODE:
      return Wo(e, {
        doc: i,
        needsMask: o,
        maskTextFn: d,
        privacySetting: V,
        rootId: I
      });
    case e.CDATA_SECTION_NODE:
      return {
        type: _.CDATA,
        textContent: "",
        rootId: I
      };
    case e.COMMENT_NODE:
      return {
        type: _.Comment,
        textContent: $.textContent(e) || "",
        rootId: I
      };
    default:
      return !1;
  }
}
function Vo(e, t) {
  if (!t.hasNode(e))
    return;
  const i = t.getId(e);
  return i === 1 ? void 0 : i;
}
function Wo(e, t) {
  var i, n;
  const {
    needsMask: s,
    maskTextFn: l,
    privacySetting: o,
    rootId: r
  } = t, a = $.parentNode(e), c = a && a.tagName;
  let d = $.textContent(e);
  const u = c === "STYLE" ? !0 : void 0, p = c === "SCRIPT" ? !0 : void 0;
  let h = !1;
  if (u && d) {
    try {
      e.nextSibling || e.previousSibling || (i = a.sheet) != null && i.cssRules && (d = Jt(a.sheet));
    } catch (V) {
      console.warn(
        `Cannot get CSS styles from text's parentNode. Error: ${V}`,
        e
      );
    }
    d = wt(d, xi(t.doc)), h = !0;
  }
  p ? (d = "SCRIPT_PLACEHOLDER", h = !0) : c === "NOSCRIPT" && (d = "", h = !0), !u && !p && d && s && (d = l ? l(d, $.parentElement(e)) : d.replace(/[\S]/g, "*"));
  const Z = o === "strict", b = (n = e.parentElement) == null ? void 0 : n.getAttribute("data-hl-record"), W = o === "default" && ls(d);
  return (Z || W) && !b && !h && c && !(/* @__PURE__ */ new Set([
    "HEAD",
    "TITLE",
    "STYLE",
    "SCRIPT",
    "HTML",
    "BODY",
    "NOSCRIPT"
  ])).has(c) && d && (d = vi(d)), {
    type: _.Text,
    textContent: d || "",
    isStyle: u,
    rootId: r
  };
}
function fo(e, t) {
  const {
    doc: i,
    blockClass: n,
    blockSelector: s,
    inlineStylesheet: l,
    maskInputOptions: o = {},
    maskInputFn: r,
    maskTextClass: a,
    dataURLOptions: c = {},
    inlineImages: d,
    recordCanvas: u,
    keepIframeSrcFn: p,
    newlyAddedElement: h = !1,
    privacySetting: Z,
    rootId: b
  } = t;
  let W = mn(e, n, s);
  const V = mn(e, a, null), I = Z === "strict";
  let y = ho(e), G = {};
  const w = e.attributes.length;
  for (let f = 0; f < w; f++) {
    const C = e.attributes[f];
    cs(y, C.name) || (G[C.name] = rs(
      i,
      y,
      Qe(C.name),
      C.value
    ));
  }
  if (y === "link" && l) {
    const f = Array.from(i.styleSheets).find((z) => z.href === e.href);
    let C = null;
    f && (C = Jt(f)), C && (delete G.rel, delete G.href, G._cssText = C);
  }
  if (y === "style" && e.sheet && // TODO: Currently we only try to get dynamic stylesheet when it is an empty style element
  !(e.innerText || $.textContent(e) || "").trim().length) {
    const f = Jt(
      e.sheet
    );
    f && (G._cssText = f);
  }
  if (y === "input" || y === "textarea" || y === "select") {
    const f = e.value, C = e.checked;
    G.type !== "radio" && G.type !== "checkbox" && G.type !== "submit" && G.type !== "button" && f ? G.value = wi({
      element: e,
      type: Ti(e),
      tagName: y,
      value: f,
      overwriteRecord: e.getAttribute("data-hl-record"),
      maskInputOptions: o,
      maskInputFn: r
    }) : C && (G.checked = C);
  }
  if (y === "option" && (e.selected && !o.select ? G.selected = !0 : delete G.selected), y === "dialog" && e.open && (G.rr_open_mode = e.matches("dialog:modal") ? "modal" : "non-modal"), y === "canvas" && u) {
    if (e.__context === "2d")
      Al(e) || (G.rr_dataURL = e.toDataURL(
        c.type,
        c.quality
      ));
    else if (!("__context" in e)) {
      const f = e.toDataURL(
        c.type,
        c.quality
      ), C = i.createElement("canvas");
      C.width = e.width, C.height = e.height;
      const z = C.toDataURL(
        c.type,
        c.quality
      );
      f !== z && (G.rr_dataURL = f);
    }
  }
  if (y === "img" && d && !W && !V && !I) {
    Ue || (Ue = i.createElement("canvas"), dn = Ue.getContext("2d"));
    const f = e, C = f.currentSrc || f.getAttribute("src") || "<unknown-src>", z = f.crossOrigin, J = () => {
      f.removeEventListener("load", J);
      try {
        Ue.width = f.naturalWidth, Ue.height = f.naturalHeight, dn.drawImage(f, 0, 0), G.rr_dataURL = Ue.toDataURL(
          c.type,
          c.quality
        );
      } catch (M) {
        if (f.crossOrigin !== "anonymous") {
          f.crossOrigin = "anonymous", f.complete && f.naturalWidth !== 0 ? J() : f.addEventListener("load", J);
          return;
        } else
          console.warn(
            `Cannot inline img src=${C}! Error: ${M}`
          );
      }
      f.crossOrigin === "anonymous" && (z ? G.crossOrigin = z : f.removeAttribute("crossorigin"));
    };
    f.complete && f.naturalWidth !== 0 ? J() : f.addEventListener("load", J);
  }
  if (y === "audio" || y === "video") {
    const f = G;
    f.rr_mediaState = e.paused ? "paused" : "played", f.rr_mediaCurrentTime = e.currentTime, f.rr_mediaPlaybackRate = e.playbackRate, f.rr_mediaMuted = e.muted, f.rr_mediaLoop = e.loop, f.rr_mediaVolume = e.volume;
  }
  if (h || (e.scrollLeft && (G.rr_scrollLeft = e.scrollLeft), e.scrollTop && (G.rr_scrollTop = e.scrollTop)), W || V || I && fi(y)) {
    const { width: f, height: C } = e.getBoundingClientRect();
    G = {
      class: G.class,
      rr_width: `${f}px`,
      rr_height: `${C}px`
    };
  }
  I && fi(y) && (W = !0), y === "iframe" && !p(G.src) && (e.contentDocument || (G.rr_src = G.src), delete G.src);
  let U;
  try {
    customElements.get(y) && (U = !0);
  } catch (f) {
  }
  if (d && y === "video") {
    const f = e;
    if (f.src === "" || f.src.indexOf("blob:") !== -1) {
      const { width: C, height: z } = e.getBoundingClientRect();
      G = {
        width: C,
        height: z,
        rr_width: `${C}px`,
        rr_height: `${z}px`,
        rr_inlined_video: !0
      }, y = "canvas";
      const J = i.createElement("canvas");
      J.width = e.width, J.height = e.height, G.rr_dataURL = J.toDataURL(
        c.type,
        c.quality
      );
    }
  }
  return {
    type: _.Element,
    tagName: y,
    attributes: G,
    childNodes: [],
    isSVG: yo(e) || void 0,
    needBlock: W,
    needMask: V,
    rootId: b,
    isCustom: U
  };
}
function O(e) {
  return e == null ? "" : e.toLowerCase();
}
function Io(e, t) {
  if (t.comment && e.type === _.Comment)
    return !0;
  if (e.type === _.Element) {
    if (t.script && // script tag
    (e.tagName === "script" || // (module)preload link
    e.tagName === "link" && (e.attributes.rel === "preload" || e.attributes.rel === "modulepreload") && e.attributes.as === "script" || // prefetch link
    e.tagName === "link" && e.attributes.rel === "prefetch" && typeof e.attributes.href == "string" && ss(e.attributes.href) === "js"))
      return !0;
    if (t.headFavicon && (e.tagName === "link" && e.attributes.rel === "shortcut icon" || e.tagName === "meta" && (O(e.attributes.name).match(
      /^msapplication-tile(image|color)$/
    ) || O(e.attributes.name) === "application-name" || O(e.attributes.rel) === "icon" || O(e.attributes.rel) === "apple-touch-icon" || O(e.attributes.rel) === "shortcut icon")))
      return !0;
    if (e.tagName === "meta") {
      if (t.headMetaDescKeywords && O(e.attributes.name).match(/^description|keywords$/))
        return !0;
      if (t.headMetaSocial && (O(e.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
      O(e.attributes.name).match(/^(og|twitter):/) || O(e.attributes.name) === "pinterest"))
        return !0;
      if (t.headMetaRobots && (O(e.attributes.name) === "robots" || O(e.attributes.name) === "googlebot" || O(e.attributes.name) === "bingbot"))
        return !0;
      if (t.headMetaHttpEquiv && e.attributes["http-equiv"] !== void 0)
        return !0;
      if (t.headMetaAuthorship && (O(e.attributes.name) === "author" || O(e.attributes.name) === "generator" || O(e.attributes.name) === "framework" || O(e.attributes.name) === "publisher" || O(e.attributes.name) === "progid" || O(e.attributes.property).match(/^article:/) || O(e.attributes.property).match(/^product:/)))
        return !0;
      if (t.headMetaVerification && (O(e.attributes.name) === "google-site-verification" || O(e.attributes.name) === "yandex-verification" || O(e.attributes.name) === "csrf-token" || O(e.attributes.name) === "p:domain_verify" || O(e.attributes.name) === "verify-v1" || O(e.attributes.name) === "verification" || O(e.attributes.name) === "shopify-checkout-api-token"))
        return !0;
    }
  }
  return !1;
}
function Pe(e, t) {
  const {
    doc: i,
    mirror: n,
    blockClass: s,
    blockSelector: l,
    maskTextClass: o,
    maskTextSelector: r,
    skipChild: a = !1,
    inlineStylesheet: c = !0,
    maskInputOptions: d = {},
    maskTextFn: u,
    maskInputFn: p,
    slimDOMOptions: h,
    dataURLOptions: Z = {},
    inlineImages: b = !1,
    recordCanvas: W = !1,
    onSerialize: V,
    onIframeLoad: I,
    iframeLoadTimeout: y = 5e3,
    onStylesheetLoad: G,
    stylesheetLoadTimeout: w = 5e3,
    keepIframeSrcFn: U = () => !1,
    newlyAddedElement: f = !1,
    privacySetting: C
  } = t;
  let { needsMask: z } = t, { preserveWhiteSpace: J = !0 } = t;
  z || (z = ds(
    e,
    o,
    r,
    z === void 0
  ));
  const M = go(e, {
    doc: i,
    mirror: n,
    blockClass: s,
    blockSelector: l,
    needsMask: z,
    inlineStylesheet: c,
    maskInputOptions: d,
    maskTextClass: o,
    maskTextFn: u,
    maskInputFn: p,
    dataURLOptions: Z,
    inlineImages: b,
    recordCanvas: W,
    keepIframeSrcFn: U,
    newlyAddedElement: f,
    privacySetting: C
  });
  if (!M)
    return console.warn(e, "not serialized"), null;
  let q;
  n.hasNode(e) ? q = n.getId(e) : Io(M, h) || !J && M.type === _.Text && !M.isStyle && !M.textContent.replace(/^\s+|\s+$/gm, "").length ? q = dt : q = as();
  const k = Object.assign(M, { id: q });
  if (n.add(e, k), q === dt)
    return null;
  V && V(e);
  let m = !a, X = C, L = C === "strict";
  if (k.type === _.Element) {
    if (m = m && !k.needBlock, L || (L = !!k.needBlock || !!k.needMask), X = L ? "strict" : X, L && fi(k.tagName)) {
      const Y = e.cloneNode();
      Y.src = "", n.add(Y, k);
    }
    delete k.needBlock, delete k.needMask;
    const T = $.shadowRoot(e);
    T && ot(T) && (k.isShadowHost = !0);
  }
  if ((k.type === _.Document || k.type === _.Element) && m) {
    h.headWhitespace && k.type === _.Element && k.tagName === "head" && (J = !1);
    const T = {
      doc: i,
      mirror: n,
      blockClass: s,
      blockSelector: l,
      needsMask: z,
      maskTextClass: o,
      maskTextSelector: r,
      skipChild: a,
      inlineStylesheet: c,
      maskInputOptions: d,
      maskTextFn: u,
      maskInputFn: p,
      slimDOMOptions: h,
      dataURLOptions: Z,
      inlineImages: b,
      recordCanvas: W,
      preserveWhiteSpace: J,
      onSerialize: V,
      onIframeLoad: I,
      iframeLoadTimeout: y,
      onStylesheetLoad: G,
      stylesheetLoadTimeout: w,
      keepIframeSrcFn: U,
      privacySetting: X
    };
    if (!(k.type === _.Element && k.tagName === "textarea" && k.attributes.value !== void 0))
      for (const oe of Array.from($.childNodes(e))) {
        const ee = Pe(oe, T);
        ee && k.childNodes.push(ee);
      }
    let Y = null;
    if (ts(e) && (Y = $.shadowRoot(e)))
      for (const oe of Array.from($.childNodes(Y))) {
        const ee = Pe(oe, T);
        ee && (ot(Y) && (ee.isShadow = !0), k.childNodes.push(ee));
      }
  }
  const E = $.parentNode(e);
  return E && lt(E) && ot(E) && (k.isShadow = !0), k.type === _.Element && k.tagName === "iframe" && Go(
    e,
    () => {
      const T = e.contentDocument;
      if (T && I) {
        const Y = Pe(T, {
          doc: T,
          mirror: n,
          blockClass: s,
          blockSelector: l,
          needsMask: z,
          maskTextClass: o,
          maskTextSelector: r,
          skipChild: !1,
          inlineStylesheet: c,
          maskInputOptions: d,
          maskTextFn: u,
          maskInputFn: p,
          slimDOMOptions: h,
          dataURLOptions: Z,
          inlineImages: b,
          recordCanvas: W,
          preserveWhiteSpace: J,
          onSerialize: V,
          onIframeLoad: I,
          iframeLoadTimeout: y,
          onStylesheetLoad: G,
          stylesheetLoadTimeout: w,
          keepIframeSrcFn: U,
          privacySetting: C
        });
        Y && I(
          e,
          Y
        );
      }
    },
    y
  ), k.type === _.Element && k.tagName === "link" && typeof k.attributes.rel == "string" && (k.attributes.rel === "stylesheet" || k.attributes.rel === "preload" && typeof k.attributes.href == "string" && ss(k.attributes.href) === "css") && Xo(
    e,
    () => {
      if (G) {
        const T = Pe(e, {
          doc: i,
          mirror: n,
          blockClass: s,
          blockSelector: l,
          needsMask: z,
          maskTextClass: o,
          maskTextSelector: r,
          skipChild: !1,
          inlineStylesheet: c,
          maskInputOptions: d,
          maskTextFn: u,
          maskInputFn: p,
          slimDOMOptions: h,
          dataURLOptions: Z,
          inlineImages: b,
          recordCanvas: W,
          preserveWhiteSpace: J,
          onSerialize: V,
          onIframeLoad: I,
          iframeLoadTimeout: y,
          onStylesheetLoad: G,
          stylesheetLoadTimeout: w,
          keepIframeSrcFn: U,
          privacySetting: C
        });
        T && G(
          e,
          T
        );
      }
    },
    w
  ), k;
}
function So(e, t) {
  const {
    mirror: i = new ns(),
    blockClass: n = "highlight-block",
    blockSelector: s = null,
    maskTextClass: l = "highlight-mask",
    maskTextSelector: o = null,
    inlineStylesheet: r = !0,
    inlineImages: a = !1,
    recordCanvas: c = !1,
    maskAllInputs: d = !1,
    maskTextFn: u,
    maskInputFn: p,
    slimDOM: h = !1,
    dataURLOptions: Z,
    preserveWhiteSpace: b,
    onSerialize: W,
    onIframeLoad: V,
    iframeLoadTimeout: I,
    onStylesheetLoad: y,
    stylesheetLoadTimeout: G,
    keepIframeSrcFn: w = () => !1,
    privacySetting: U = "default"
  } = t || {};
  return Pe(e, {
    doc: e,
    mirror: i,
    blockClass: n,
    blockSelector: s,
    maskTextClass: l,
    maskTextSelector: o,
    skipChild: !1,
    inlineStylesheet: r,
    maskInputOptions: d === !0 ? {
      color: !0,
      date: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0,
      textarea: !0,
      select: !0,
      password: !0
    } : d === !1 ? {
      password: !0
    } : d,
    maskTextFn: u,
    maskInputFn: p,
    slimDOMOptions: h || h === "all" ? (
      // if true: set of sensible options that should not throw away any information
      {
        script: !0,
        comment: !0,
        headFavicon: !0,
        headWhitespace: !0,
        headMetaDescKeywords: h === "all",
        // destructive
        headMetaSocial: !0,
        headMetaRobots: !0,
        headMetaHttpEquiv: !0,
        headMetaAuthorship: !0,
        headMetaVerification: !0
      }
    ) : h || {},
    dataURLOptions: Z,
    inlineImages: a,
    recordCanvas: c,
    preserveWhiteSpace: b,
    onSerialize: W,
    onIframeLoad: V,
    iframeLoadTimeout: I,
    onStylesheetLoad: y,
    stylesheetLoadTimeout: G,
    keepIframeSrcFn: w,
    newlyAddedElement: !1,
    privacySetting: U
  });
}
var Ro = Object.defineProperty, Co = (e, t, i) => t in e ? Ro(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i, ae = (e, t, i) => (Co(e, typeof t != "symbol" ? t + "" : t, i), i);
class Ki {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
  constructor(...t) {
    ae(this, "parentElement", null), ae(this, "parentNode", null), ae(this, "ownerDocument"), ae(this, "firstChild", null), ae(this, "lastChild", null), ae(this, "previousSibling", null), ae(this, "nextSibling", null), ae(this, "ELEMENT_NODE", 1), ae(this, "TEXT_NODE", 3), ae(this, "nodeType"), ae(this, "nodeName"), ae(this, "RRNodeType");
  }
  get childNodes() {
    const t = [];
    let i = this.firstChild;
    for (; i; )
      t.push(i), i = i.nextSibling;
    return t;
  }
  contains(t) {
    if (t instanceof Ki) {
      if (t.ownerDocument !== this.ownerDocument)
        return !1;
      if (t === this)
        return !0;
    } else
      return !1;
    for (; t.parentNode; ) {
      if (t.parentNode === this)
        return !0;
      t = t.parentNode;
    }
    return !1;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  appendChild(t) {
    throw new Error(
      "RRDomException: Failed to execute 'appendChild' on 'RRNode': This RRNode type does not support this method."
    );
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  insertBefore(t, i) {
    throw new Error(
      "RRDomException: Failed to execute 'insertBefore' on 'RRNode': This RRNode type does not support this method."
    );
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  removeChild(t) {
    throw new Error(
      "RRDomException: Failed to execute 'removeChild' on 'RRNode': This RRNode type does not support this method."
    );
  }
  toString() {
    return "RRNode";
  }
}
const hn = {
  Node: ["childNodes", "parentNode", "parentElement", "textContent"],
  ShadowRoot: ["host", "styleSheets"],
  Element: ["shadowRoot", "querySelector", "querySelectorAll"],
  MutationObserver: []
}, pn = {
  Node: ["contains", "getRootNode"],
  ShadowRoot: ["getSelection"],
  Element: [],
  MutationObserver: ["constructor"]
}, Vt = {};
function Fi(e) {
  if (Vt[e])
    return Vt[e];
  const t = globalThis[e], i = t.prototype, n = e in hn ? hn[e] : void 0, s = !!(n && // @ts-expect-error 2345
  n.every(
    (r) => {
      var a, c;
      return !!((c = (a = Object.getOwnPropertyDescriptor(i, r)) == null ? void 0 : a.get) != null && c.toString().includes("[native code]"));
    }
  )), l = e in pn ? pn[e] : void 0, o = !!(l && l.every(
    // @ts-expect-error 2345
    (r) => {
      var a;
      return typeof i[r] == "function" && ((a = i[r]) == null ? void 0 : a.toString().includes("[native code]"));
    }
  ));
  if (s && o)
    return Vt[e] = t.prototype, t.prototype;
  try {
    const r = document.createElement("iframe");
    document.body.appendChild(r);
    const a = r.contentWindow;
    if (!a)
      return t.prototype;
    const c = a[e].prototype;
    return document.body.removeChild(r), c ? Vt[e] = c : i;
  } catch (r) {
    return i;
  }
}
const ri = {};
function Ne(e, t, i) {
  var n;
  const s = `${e}.${String(i)}`;
  if (ri[s])
    return ri[s].call(
      t
    );
  const l = Fi(e), o = (n = Object.getOwnPropertyDescriptor(
    l,
    i
  )) == null ? void 0 : n.get;
  return o ? (ri[s] = o, o.call(t)) : t[i];
}
const ci = {};
function us(e, t, i) {
  const n = `${e}.${String(i)}`;
  if (ci[n])
    return ci[n].bind(
      t
    );
  const l = Fi(e)[i];
  return typeof l != "function" ? t[i] : (ci[n] = l, l.bind(t));
}
function Lo(e) {
  return Ne("Node", e, "childNodes");
}
function Yo(e) {
  return Ne("Node", e, "parentNode");
}
function No(e) {
  return Ne("Node", e, "parentElement");
}
function ko(e) {
  return Ne("Node", e, "textContent");
}
function Jo(e, t) {
  return us("Node", e, "contains")(t);
}
function wo(e) {
  return us("Node", e, "getRootNode")();
}
function To(e) {
  return !e || !("host" in e) ? null : Ne("ShadowRoot", e, "host");
}
function vo(e) {
  return e.styleSheets;
}
function xo(e) {
  return !e || !("shadowRoot" in e) ? null : Ne("Element", e, "shadowRoot");
}
function Ko(e, t) {
  return Ne("Element", e, "querySelector")(t);
}
function Fo(e, t) {
  return Ne("Element", e, "querySelectorAll")(t);
}
function ms() {
  return Fi("MutationObserver").constructor;
}
const x = {
  childNodes: Lo,
  parentNode: Yo,
  parentElement: No,
  textContent: ko,
  contains: Jo,
  getRootNode: wo,
  host: To,
  styleSheets: vo,
  shadowRoot: xo,
  querySelector: Ko,
  querySelectorAll: Fo,
  mutationObserver: ms
};
function se(e, t, i = document) {
  const n = { capture: !0 };
  return i.addEventListener(e, t, n), () => i.removeEventListener(e, t, n);
}
const Me = `Please stop import mirror directly. Instead of that,\r
now you can use replayer.getMirror() to access the mirror instance of a replayer,\r
or you can use record.mirror to access the mirror instance during recording.`;
let bn = {
  map: {},
  getId() {
    return console.error(Me), -1;
  },
  getNode() {
    return console.error(Me), null;
  },
  removeNodeFromMap() {
    console.error(Me);
  },
  has() {
    return console.error(Me), !1;
  },
  reset() {
    console.error(Me);
  }
};
typeof window != "undefined" && window.Proxy && window.Reflect && (bn = new Proxy(bn, {
  get(e, t, i) {
    return t === "map" && console.error(Me), Reflect.get(e, t, i);
  }
}));
function ut(e, t, i = {}) {
  let n = null, s = 0;
  return function(...l) {
    const o = Date.now();
    !s && i.leading === !1 && (s = o);
    const r = t - (o - s), a = this;
    r <= 0 || r > t ? (n && (clearTimeout(n), n = null), s = o, e.apply(a, l)) : !n && i.trailing !== !1 && (n = setTimeout(() => {
      s = i.leading === !1 ? 0 : Date.now(), n = null, e.apply(a, l);
    }, r));
  };
}
function Et(e, t, i, n, s = window) {
  const l = s.Object.getOwnPropertyDescriptor(e, t);
  return s.Object.defineProperty(
    e,
    t,
    n ? i : {
      set(o) {
        setTimeout(() => {
          i.set.call(this, o);
        }, 0), l && l.set && l.set.call(this, o);
      }
    }
  ), () => Et(e, t, l || {}, !0);
}
function _e(e, t, i) {
  try {
    if (!(t in e))
      return () => {
      };
    const n = e[t], s = i(n);
    return typeof s == "function" && (s.prototype = s.prototype || {}, Object.defineProperties(s, {
      __rrweb_original__: {
        enumerable: !1,
        value: n
      }
    })), e[t] = s, () => {
      e[t] = n;
    };
  } catch (n) {
    return () => {
    };
  }
}
let vt = Date.now;
/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString()) || (vt = () => (/* @__PURE__ */ new Date()).getTime());
function hs(e) {
  var t, i, n, s;
  const l = e.document;
  return {
    left: l.scrollingElement ? l.scrollingElement.scrollLeft : e.pageXOffset !== void 0 ? e.pageXOffset : l.documentElement.scrollLeft || (l == null ? void 0 : l.body) && ((t = x.parentElement(l.body)) == null ? void 0 : t.scrollLeft) || ((i = l == null ? void 0 : l.body) == null ? void 0 : i.scrollLeft) || 0,
    top: l.scrollingElement ? l.scrollingElement.scrollTop : e.pageYOffset !== void 0 ? e.pageYOffset : (l == null ? void 0 : l.documentElement.scrollTop) || (l == null ? void 0 : l.body) && ((n = x.parentElement(l.body)) == null ? void 0 : n.scrollTop) || ((s = l == null ? void 0 : l.body) == null ? void 0 : s.scrollTop) || 0
  };
}
function ps() {
  return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function bs() {
  return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function Zs(e) {
  return e ? e.nodeType === e.ELEMENT_NODE ? e : x.parentElement(e) : null;
}
const Uo = (e) => {
  try {
    if (e instanceof HTMLElement)
      return e.tagName === "CANVAS";
  } catch (t) {
    return !1;
  }
  return !1;
};
function te(e, t, i, n) {
  if (!e)
    return !1;
  const s = Zs(e);
  if (!s)
    return !1;
  try {
    if (typeof t == "string") {
      if (s.classList.contains(t) || n && s.closest("." + t) !== null)
        return !0;
    } else if (Tt(s, t, n))
      return !0;
  } catch (l) {
  }
  return !!(i && (s.matches(i) || n && s.closest(i) !== null));
}
function Ho(e, t) {
  return t.getId(e) !== -1;
}
function di(e, t, i) {
  return e.tagName === "TITLE" && i.headTitleMutations ? !0 : t.getId(e) === dt;
}
function ys(e, t) {
  if (lt(e))
    return !1;
  const i = t.getId(e);
  if (!t.has(i))
    return !0;
  const n = x.parentNode(e);
  return n && n.nodeType === e.DOCUMENT_NODE ? !1 : n ? ys(n, t) : !0;
}
function Ii(e) {
  return !!e.changedTouches;
}
function Mo(e = window) {
  "NodeList" in e && !e.NodeList.prototype.forEach && (e.NodeList.prototype.forEach = Array.prototype.forEach), "DOMTokenList" in e && !e.DOMTokenList.prototype.forEach && (e.DOMTokenList.prototype.forEach = Array.prototype.forEach);
}
function Gs(e, t) {
  return !!(e.nodeName === "IFRAME" && t.getMeta(e));
}
function Xs(e, t) {
  return !!(e.nodeName === "LINK" && e.nodeType === e.ELEMENT_NODE && e.getAttribute && e.getAttribute("rel") === "stylesheet" && t.getMeta(e));
}
function Si(e) {
  return e ? e instanceof Ki && "shadowRoot" in e ? !!e.shadowRoot : !!x.shadowRoot(e) : !1;
}
class zo {
  constructor() {
    g(this, "id", 1), g(this, "styleIDMap", /* @__PURE__ */ new WeakMap()), g(this, "idStyleMap", /* @__PURE__ */ new Map());
  }
  getId(t) {
    var i;
    return (i = this.styleIDMap.get(t)) != null ? i : -1;
  }
  has(t) {
    return this.styleIDMap.has(t);
  }
  /**
   * @returns If the stylesheet is in the mirror, returns the id of the stylesheet. If not, return the new assigned id.
   */
  add(t, i) {
    if (this.has(t))
      return this.getId(t);
    let n;
    return i === void 0 ? n = this.id++ : n = i, this.styleIDMap.set(t, n), this.idStyleMap.set(n, t), n;
  }
  getStyle(t) {
    return this.idStyleMap.get(t) || null;
  }
  reset() {
    this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map(), this.id = 1;
  }
  generateId() {
    return this.id++;
  }
}
function gs(e) {
  var t;
  let i = null;
  return "getRootNode" in e && ((t = x.getRootNode(e)) == null ? void 0 : t.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && x.host(x.getRootNode(e)) && (i = x.host(x.getRootNode(e))), i;
}
function Bo(e) {
  let t = e, i;
  for (; i = gs(t); )
    t = i;
  return t;
}
function Po(e) {
  const t = e.ownerDocument;
  if (!t)
    return !1;
  const i = Bo(e);
  return x.contains(t, i);
}
function Vs(e) {
  const t = e.ownerDocument;
  return t ? x.contains(t, e) || Po(e) : !1;
}
var H = /* @__PURE__ */ ((e) => (e[e.DomContentLoaded = 0] = "DomContentLoaded", e[e.Load = 1] = "Load", e[e.FullSnapshot = 2] = "FullSnapshot", e[e.IncrementalSnapshot = 3] = "IncrementalSnapshot", e[e.Meta = 4] = "Meta", e[e.Custom = 5] = "Custom", e[e.Plugin = 6] = "Plugin", e))(H || {}), K = /* @__PURE__ */ ((e) => (e[e.Mutation = 0] = "Mutation", e[e.MouseMove = 1] = "MouseMove", e[e.MouseInteraction = 2] = "MouseInteraction", e[e.Scroll = 3] = "Scroll", e[e.ViewportResize = 4] = "ViewportResize", e[e.Input = 5] = "Input", e[e.TouchMove = 6] = "TouchMove", e[e.MediaInteraction = 7] = "MediaInteraction", e[e.StyleSheetRule = 8] = "StyleSheetRule", e[e.CanvasMutation = 9] = "CanvasMutation", e[e.Font = 10] = "Font", e[e.Log = 11] = "Log", e[e.Drag = 12] = "Drag", e[e.StyleDeclaration = 13] = "StyleDeclaration", e[e.Selection = 14] = "Selection", e[e.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", e[e.CustomElement = 16] = "CustomElement", e))(K || {}), le = /* @__PURE__ */ ((e) => (e[e.MouseUp = 0] = "MouseUp", e[e.MouseDown = 1] = "MouseDown", e[e.Click = 2] = "Click", e[e.ContextMenu = 3] = "ContextMenu", e[e.DblClick = 4] = "DblClick", e[e.Focus = 5] = "Focus", e[e.Blur = 6] = "Blur", e[e.TouchStart = 7] = "TouchStart", e[e.TouchMove_Departed = 8] = "TouchMove_Departed", e[e.TouchEnd = 9] = "TouchEnd", e[e.TouchCancel = 10] = "TouchCancel", e))(le || {}), Ie = /* @__PURE__ */ ((e) => (e[e.Mouse = 0] = "Mouse", e[e.Pen = 1] = "Pen", e[e.Touch = 2] = "Touch", e))(Ie || {}), je = /* @__PURE__ */ ((e) => (e[e["2D"] = 0] = "2D", e[e.WebGL = 1] = "WebGL", e[e.WebGL2 = 2] = "WebGL2", e))(je || {}), ze = /* @__PURE__ */ ((e) => (e[e.Play = 0] = "Play", e[e.Pause = 1] = "Pause", e[e.Seeked = 2] = "Seeked", e[e.VolumeChange = 3] = "VolumeChange", e[e.RateChange = 4] = "RateChange", e))(ze || {});
function Zn(e) {
  return "__ln" in e;
}
class Eo {
  constructor() {
    g(this, "length", 0), g(this, "head", null), g(this, "tail", null);
  }
  get(t) {
    if (t >= this.length)
      throw new Error("Position outside of list range");
    let i = this.head;
    for (let n = 0; n < t; n++)
      i = (i == null ? void 0 : i.next) || null;
    return i;
  }
  addNode(t) {
    const i = {
      value: t,
      previous: null,
      next: null
    };
    if (t.__ln = i, t.previousSibling && Zn(t.previousSibling)) {
      const n = t.previousSibling.__ln.next;
      i.next = n, i.previous = t.previousSibling.__ln, t.previousSibling.__ln.next = i, n && (n.previous = i);
    } else if (t.nextSibling && Zn(t.nextSibling) && t.nextSibling.__ln.previous) {
      const n = t.nextSibling.__ln.previous;
      i.previous = n, i.next = t.nextSibling.__ln, t.nextSibling.__ln.previous = i, n && (n.next = i);
    } else
      this.head && (this.head.previous = i), i.next = this.head, this.head = i;
    i.next === null && (this.tail = i), this.length++;
  }
  removeNode(t) {
    const i = t.__ln;
    this.head && (i.previous ? (i.previous.next = i.next, i.next ? i.next.previous = i.previous : this.tail = i.previous) : (this.head = i.next, this.head ? this.head.previous = null : this.tail = null), t.__ln && delete t.__ln, this.length--);
  }
}
const yn = (e, t) => `${e}@${t}`;
class Oo {
  constructor() {
    g(this, "frozen", !1), g(this, "locked", !1), g(this, "texts", []), g(this, "attributes", []), g(this, "attributeMap", /* @__PURE__ */ new WeakMap()), g(this, "removes", []), g(this, "mapRemoves", []), g(this, "movedMap", {}), g(this, "addedSet", /* @__PURE__ */ new Set()), g(this, "movedSet", /* @__PURE__ */ new Set()), g(this, "droppedSet", /* @__PURE__ */ new Set()), g(this, "mutationCb"), g(this, "blockClass"), g(this, "blockSelector"), g(this, "maskTextClass"), g(this, "maskTextSelector"), g(this, "inlineStylesheet"), g(this, "maskInputOptions"), g(this, "maskTextFn"), g(this, "maskInputFn"), g(this, "keepIframeSrcFn"), g(this, "recordCanvas"), g(this, "inlineImages"), g(this, "privacySetting"), g(this, "slimDOMOptions"), g(this, "dataURLOptions"), g(this, "doc"), g(this, "mirror"), g(this, "iframeManager"), g(this, "stylesheetManager"), g(this, "shadowDomManager"), g(this, "canvasManager"), g(this, "processedNodeManager"), g(this, "unattachedDoc"), g(this, "processMutations", (t) => {
      t.forEach(this.processMutation), this.emit();
    }), g(this, "emit", () => {
      if (this.frozen || this.locked)
        return;
      const t = [], i = /* @__PURE__ */ new Set(), n = new Eo(), s = (a) => {
        let c = a, d = dt;
        for (; d === dt; )
          c = c && c.nextSibling, d = c && this.mirror.getId(c);
        return d;
      }, l = (a) => {
        const c = x.parentNode(a);
        if (!c || !Vs(a) || c.tagName === "TEXTAREA")
          return;
        const d = lt(c) ? this.mirror.getId(gs(a)) : this.mirror.getId(c), u = s(a);
        if (d === -1 || u === -1)
          return n.addNode(a);
        const p = Pe(a, {
          doc: this.doc,
          mirror: this.mirror,
          blockClass: this.blockClass,
          blockSelector: this.blockSelector,
          maskTextClass: this.maskTextClass,
          maskTextSelector: this.maskTextSelector,
          skipChild: !0,
          newlyAddedElement: !0,
          inlineStylesheet: this.inlineStylesheet,
          maskInputOptions: this.maskInputOptions,
          maskTextFn: this.maskTextFn,
          maskInputFn: this.maskInputFn,
          slimDOMOptions: this.slimDOMOptions,
          dataURLOptions: this.dataURLOptions,
          recordCanvas: this.recordCanvas,
          inlineImages: this.inlineImages,
          privacySetting: this.privacySetting,
          onSerialize: (h) => {
            Gs(h, this.mirror) && this.iframeManager.addIframe(h), Xs(h, this.mirror) && this.stylesheetManager.trackLinkElement(
              h
            ), Si(a) && this.shadowDomManager.addShadowRoot(x.shadowRoot(a), this.doc);
          },
          onIframeLoad: (h, Z) => {
            this.iframeManager.attachIframe(h, Z), this.shadowDomManager.observeAttachShadow(h);
          },
          onStylesheetLoad: (h, Z) => {
            this.stylesheetManager.attachLinkElement(h, Z);
          }
        });
        p && (t.push({
          parentId: d,
          nextId: u,
          node: p
        }), i.add(p.id));
      };
      for (; this.mapRemoves.length; )
        this.mirror.removeNodeFromMap(this.mapRemoves.shift());
      for (const a of this.movedSet)
        Gn(this.removes, a, this.mirror) && !this.movedSet.has(x.parentNode(a)) || l(a);
      for (const a of this.addedSet)
        !Xn(this.droppedSet, a) && !Gn(this.removes, a, this.mirror) || Xn(this.movedSet, a) ? l(a) : this.droppedSet.add(a);
      let o = null;
      for (; n.length; ) {
        let a = null;
        if (o) {
          const c = this.mirror.getId(x.parentNode(o.value)), d = s(o.value);
          c !== -1 && d !== -1 && (a = o);
        }
        if (!a) {
          let c = n.tail;
          for (; c; ) {
            const d = c;
            if (c = c.previous, d) {
              const u = this.mirror.getId(x.parentNode(d.value));
              if (s(d.value) === -1)
                continue;
              if (u !== -1) {
                a = d;
                break;
              } else {
                const h = d.value, Z = x.parentNode(h);
                if (Z && Z.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                  const b = x.host(Z);
                  if (this.mirror.getId(b) !== -1) {
                    a = d;
                    break;
                  }
                }
              }
            }
          }
        }
        if (!a) {
          for (; n.head; )
            n.removeNode(n.head.value);
          break;
        }
        o = a.previous, n.removeNode(a.value), l(a.value);
      }
      const r = {
        texts: this.texts.map((a) => {
          var c, d;
          const u = a.node, p = x.parentNode(u);
          p && p.tagName === "TEXTAREA" && this.genTextAreaValueMutation(p);
          let h = a.value;
          const Z = this.privacySetting === "strict", b = this.privacySetting === "default" && ls(h), W = (d = (c = a.node) == null ? void 0 : c.parentElement) == null ? void 0 : d.getAttribute("data-hl-record");
          return (Z || b) && !W && h && (h = vi(h)), {
            id: this.mirror.getId(u),
            value: h
          };
        }).filter((a) => !i.has(a.id)).filter((a) => this.mirror.has(a.id)),
        attributes: this.attributes.map((a) => {
          const { attributes: c } = a;
          if (typeof c.style == "string") {
            const d = JSON.stringify(a.styleDiff), u = JSON.stringify(a._unchangedStyles);
            d.length < c.style.length && (d + u).split("var(").length === c.style.split("var(").length && (c.style = a.styleDiff);
          }
          return {
            id: this.mirror.getId(a.node),
            attributes: c
          };
        }).filter((a) => !i.has(a.id)).filter((a) => this.mirror.has(a.id)),
        removes: this.removes,
        adds: t
      };
      !r.texts.length && !r.attributes.length && !r.removes.length && !r.adds.length || (this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.movedMap = {}, this.mutationCb(r));
    }), g(this, "genTextAreaValueMutation", (t) => {
      let i = this.attributeMap.get(t);
      i || (i = {
        node: t,
        attributes: {},
        styleDiff: {},
        _unchangedStyles: {}
      }, this.attributes.push(i), this.attributeMap.set(t, i)), i.attributes.value = Array.from(
        x.childNodes(t),
        (n) => x.textContent(n) || ""
      ).join("");
    }), g(this, "processMutation", (t) => {
      if (!di(t.target, this.mirror, this.slimDOMOptions))
        switch (t.type) {
          case "characterData": {
            const i = x.textContent(t.target);
            !te(t.target, this.blockClass, this.blockSelector, !1) && i !== t.oldValue && this.texts.push({
              value: ds(
                t.target,
                this.maskTextClass,
                this.maskTextSelector,
                !0
                // checkAncestors
              ) && i ? this.maskTextFn ? this.maskTextFn(i, Zs(t.target)) : i.replace(/[\S]/g, "*") : i,
              node: t.target
            });
            break;
          }
          case "attributes": {
            const i = t.target;
            let n = t.attributeName, s = t.target.getAttribute(n);
            if (n === "value") {
              const o = Ti(i);
              s = wi({
                element: i,
                maskInputOptions: this.maskInputOptions,
                tagName: i.tagName,
                type: o,
                value: s,
                overwriteRecord: i.getAttribute("data-hl-record"),
                maskInputFn: this.maskInputFn
              });
            }
            if (te(t.target, this.blockClass, this.blockSelector, !1) || s === t.oldValue)
              return;
            let l = this.attributeMap.get(t.target);
            if (i.tagName === "IFRAME" && n === "src" && !this.keepIframeSrcFn(s))
              if (!i.contentDocument)
                n = "rr_src";
              else
                return;
            if (l || (l = {
              node: t.target,
              attributes: {},
              styleDiff: {},
              _unchangedStyles: {}
            }, this.attributes.push(l), this.attributeMap.set(t.target, l)), n === "type" && i.tagName === "INPUT" && (t.oldValue || "").toLowerCase() === "password" && i.setAttribute("data-rr-is-password", "true"), !cs(i.tagName, n)) {
              if (t.target.tagName === "INPUT") {
                const r = t.target;
                if (r.type === "password") {
                  l.attributes.value = "*".repeat(r.value.length);
                  break;
                }
              }
              if (l.attributes[n] = rs(
                this.doc,
                Qe(i.tagName),
                Qe(n),
                s
              ), n === "style") {
                if (!this.unattachedDoc)
                  try {
                    this.unattachedDoc = document.implementation.createHTMLDocument();
                  } catch (a) {
                    this.unattachedDoc = this.doc;
                  }
                const r = this.unattachedDoc.createElement("span");
                t.oldValue && r.setAttribute("style", t.oldValue);
                for (const a of Array.from(i.style)) {
                  const c = i.style.getPropertyValue(a), d = i.style.getPropertyPriority(a);
                  c !== r.style.getPropertyValue(a) || d !== r.style.getPropertyPriority(a) ? d === "" ? l.styleDiff[a] = c : l.styleDiff[a] = [c, d] : l._unchangedStyles[a] = [c, d];
                }
                for (const a of Array.from(r.style))
                  i.style.getPropertyValue(a) === "" && (l.styleDiff[a] = !1);
              } else
                n === "open" && i.tagName === "DIALOG" && (i.matches("dialog:modal") ? l.attributes.rr_open_mode = "modal" : l.attributes.rr_open_mode = "non-modal");
            }
            break;
          }
          case "childList": {
            if (te(t.target, this.blockClass, this.blockSelector, !0))
              return;
            if (t.target.tagName === "TEXTAREA") {
              this.genTextAreaValueMutation(t.target);
              return;
            }
            t.addedNodes.forEach((i) => this.genAdds(i, t.target)), t.removedNodes.forEach((i) => {
              const n = this.mirror.getId(i), s = lt(t.target) ? this.mirror.getId(x.host(t.target)) : this.mirror.getId(t.target);
              te(t.target, this.blockClass, this.blockSelector, !1) || di(i, this.mirror, this.slimDOMOptions) || !Ho(i, this.mirror) || (this.addedSet.has(i) ? (Ri(this.addedSet, i), this.droppedSet.add(i)) : this.addedSet.has(t.target) && n === -1 || ys(t.target, this.mirror) || (this.movedSet.has(i) && this.movedMap[yn(n, s)] ? Ri(this.movedSet, i) : this.removes.push({
                parentId: s,
                id: n,
                isShadow: lt(t.target) && ot(t.target) ? !0 : void 0
              })), this.mapRemoves.push(i));
            });
            break;
          }
        }
    }), g(this, "genAdds", (t, i) => {
      if (!this.processedNodeManager.inOtherBuffer(t, this) && !(this.addedSet.has(t) || this.movedSet.has(t))) {
        if (this.mirror.hasNode(t)) {
          if (di(t, this.mirror, this.slimDOMOptions))
            return;
          this.movedSet.add(t);
          let n = null;
          i && this.mirror.hasNode(i) && (n = this.mirror.getId(i)), n && n !== -1 && (this.movedMap[yn(this.mirror.getId(t), n)] = !0);
        } else
          this.addedSet.add(t), this.droppedSet.delete(t);
        te(t, this.blockClass, this.blockSelector, !1) || (x.childNodes(t).forEach((n) => this.genAdds(n)), Si(t) && x.childNodes(x.shadowRoot(t)).forEach((n) => {
          this.processedNodeManager.add(n, this), this.genAdds(n, t);
        }));
      }
    });
  }
  init(t) {
    [
      "mutationCb",
      "blockClass",
      "blockSelector",
      "maskTextClass",
      "maskTextSelector",
      "inlineStylesheet",
      "maskInputOptions",
      "maskTextFn",
      "maskInputFn",
      "keepIframeSrcFn",
      "recordCanvas",
      "inlineImages",
      "privacySetting",
      "slimDOMOptions",
      "dataURLOptions",
      "doc",
      "mirror",
      "iframeManager",
      "stylesheetManager",
      "shadowDomManager",
      "canvasManager",
      "processedNodeManager"
    ].forEach((i) => {
      this[i] = t[i];
    });
  }
  freeze() {
    this.frozen = !0, this.canvasManager.freeze();
  }
  unfreeze() {
    this.frozen = !1, this.canvasManager.unfreeze(), this.emit();
  }
  isFrozen() {
    return this.frozen;
  }
  lock() {
    this.locked = !0, this.canvasManager.lock();
  }
  unlock() {
    this.locked = !1, this.canvasManager.unlock(), this.emit();
  }
  reset() {
    this.shadowDomManager.reset(), this.canvasManager.reset();
  }
}
function Ri(e, t) {
  e.delete(t), x.childNodes(t).forEach((i) => Ri(e, i));
}
function Gn(e, t, i) {
  return e.length === 0 ? !1 : Do(e, t, i);
}
function Do(e, t, i) {
  let n = x.parentNode(t);
  for (; n; ) {
    const s = i.getId(n);
    if (e.some((l) => l.id === s))
      return !0;
    n = x.parentNode(n);
  }
  return !1;
}
function Xn(e, t) {
  return e.size === 0 ? !1 : Ws(e, t);
}
function Ws(e, t) {
  const i = x.parentNode(t);
  return i ? e.has(i) ? !0 : Ws(e, i) : !1;
}
let at;
function Qo(e) {
  at = e;
}
function jo() {
  at = void 0;
}
const F = (e) => at ? (...i) => {
  try {
    return e(...i);
  } catch (n) {
    if (at && at(n) === !0)
      return;
    throw n;
  }
} : e, Te = [];
function ht(e) {
  try {
    if ("composedPath" in e) {
      const t = e.composedPath();
      if (t.length)
        return t[0];
    } else if ("path" in e && e.path.length)
      return e.path[0];
  } catch (t) {
  }
  return e && e.target;
}
function fs(e, t) {
  const i = new Oo();
  Te.push(i), i.init(e);
  const n = new (ms())(
    F(i.processMutations.bind(i))
  );
  return n.observe(t, {
    attributes: !0,
    attributeOldValue: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
  }), n;
}
function Ao({
  mousemoveCb: e,
  sampling: t,
  doc: i,
  mirror: n
}) {
  if (t.mousemove === !1)
    return () => {
    };
  const s = typeof t.mousemove == "number" ? t.mousemove : 50, l = typeof t.mousemoveCallback == "number" ? t.mousemoveCallback : 500;
  let o = [], r;
  const a = ut(
    F(
      (u) => {
        const p = Date.now() - r;
        e(
          o.map((h) => (h.timeOffset -= p, h)),
          u
        ), o = [], r = null;
      }
    ),
    l
  ), c = F(
    ut(
      F((u) => {
        const p = ht(u), { clientX: h, clientY: Z } = Ii(u) ? u.changedTouches[0] : u;
        r || (r = vt()), o.push({
          x: h,
          y: Z,
          id: n.getId(p),
          timeOffset: vt() - r
        }), a(
          typeof DragEvent != "undefined" && u instanceof DragEvent ? K.Drag : u instanceof MouseEvent ? K.MouseMove : K.TouchMove
        );
      }),
      s,
      {
        trailing: !1
      }
    )
  ), d = [
    se("mousemove", c, i),
    se("touchmove", c, i),
    se("drag", c, i)
  ];
  return F(() => {
    d.forEach((u) => u());
  });
}
function _o({
  mouseInteractionCb: e,
  doc: t,
  mirror: i,
  blockClass: n,
  blockSelector: s,
  sampling: l
}) {
  if (l.mouseInteraction === !1)
    return () => {
    };
  const o = l.mouseInteraction === !0 || l.mouseInteraction === void 0 ? {} : l.mouseInteraction, r = [];
  let a = null;
  const c = (d) => (u) => {
    const p = ht(u);
    if (te(p, n, s, !0) || // We ignore canvas elements for rage click detection because we cannot infer what inside the canvas is getting interacted with.
    Uo(p))
      return;
    let h = null, Z = d;
    if ("pointerType" in u) {
      switch (u.pointerType) {
        case "mouse":
          h = Ie.Mouse;
          break;
        case "touch":
          h = Ie.Touch;
          break;
        case "pen":
          h = Ie.Pen;
          break;
      }
      h === Ie.Touch && (le[d] === le.MouseDown ? Z = "TouchStart" : le[d] === le.MouseUp && (Z = "TouchEnd"));
    } else
      Ii(u) && (h = Ie.Touch);
    h !== null ? (a = h, (Z.startsWith("Touch") && h === Ie.Touch || Z.startsWith("Mouse") && h === Ie.Mouse) && (h = null)) : le[d] === le.Click && (h = a, a = null);
    const b = Ii(u) ? u.changedTouches[0] : u;
    if (!b)
      return;
    const W = i.getId(p), { clientX: V, clientY: I } = b;
    F(e)(R({
      type: le[Z],
      id: W,
      x: V,
      y: I
    }, h !== null && { pointerType: h }));
  };
  return Object.keys(le).filter(
    (d) => Number.isNaN(Number(d)) && !d.endsWith("_Departed") && o[d] !== !1
  ).forEach((d) => {
    let u = Qe(d);
    const p = c(d);
    if (window.PointerEvent)
      switch (le[d]) {
        case le.MouseDown:
        case le.MouseUp:
          u = u.replace(
            "mouse",
            "pointer"
          );
          break;
        case le.TouchStart:
        case le.TouchEnd:
          return;
      }
    r.push(se(u, p, t));
  }), F(() => {
    r.forEach((d) => d());
  });
}
function Is({
  scrollCb: e,
  doc: t,
  mirror: i,
  blockClass: n,
  blockSelector: s,
  sampling: l
}) {
  const o = F(
    ut(
      F((r) => {
        const a = ht(r);
        if (!a || te(a, n, s, !0))
          return;
        const c = i.getId(a);
        if (a === t && t.defaultView) {
          const d = hs(t.defaultView);
          e({
            id: c,
            x: d.left,
            y: d.top
          });
        } else
          e({
            id: c,
            x: a.scrollLeft,
            y: a.scrollTop
          });
      }),
      l.scroll || 100
    )
  );
  return se("scroll", o, t);
}
function qo({ viewportResizeCb: e }, { win: t }) {
  let i = -1, n = -1;
  const s = F(
    ut(
      F(() => {
        const l = ps(), o = bs();
        (i !== l || n !== o) && (e({
          width: Number(o),
          height: Number(l)
        }), i = l, n = o);
      }),
      200
    )
  );
  return se("resize", s, t);
}
const $o = ["INPUT", "TEXTAREA", "SELECT"], gn = /* @__PURE__ */ new WeakMap();
function ea({
  inputCb: e,
  doc: t,
  mirror: i,
  blockClass: n,
  blockSelector: s,
  ignoreClass: l,
  ignoreSelector: o,
  maskInputOptions: r,
  maskInputFn: a,
  sampling: c,
  userTriggeredOnInput: d
}) {
  function u(I) {
    let y = ht(I);
    const G = I.isTrusted, w = y && y.tagName;
    if (y && w === "OPTION" && (y = x.parentElement(y)), !y || !w || $o.indexOf(w) < 0 || te(y, n, s, !0) || y.classList.contains(l) || o && y.matches(o))
      return;
    let U = y.value, f = !1;
    const C = Ti(y) || "", z = y.getAttribute("data-hl-record");
    C === "radio" || C === "checkbox" ? f = y.checked : os({
      maskInputOptions: r,
      type: C,
      tagName: w,
      overwriteRecord: z
    }) && (U = wi({
      element: y,
      maskInputOptions: r,
      tagName: w,
      type: C,
      value: U,
      overwriteRecord: z,
      maskInputFn: a
    })), p(
      y,
      d ? { text: U, isChecked: f, userTriggered: G } : { text: U, isChecked: f }
    );
    const J = y.name;
    C === "radio" && J && f && t.querySelectorAll(`input[type="radio"][name="${J}"]`).forEach((M) => {
      if (M !== y) {
        const q = M.value;
        p(
          M,
          d ? { text: q, isChecked: !f, userTriggered: !1 } : { text: q, isChecked: !f }
        );
      }
    });
  }
  function p(I, y) {
    const G = gn.get(I);
    if (!G || G.text !== y.text || G.isChecked !== y.isChecked) {
      gn.set(I, y);
      const w = i.getId(I);
      F(e)(ge(R({}, y), {
        id: w
      }));
    }
  }
  const Z = (c.input === "last" ? ["change"] : ["input", "change"]).map(
    (I) => se(I, F(u), t)
  ), b = t.defaultView;
  if (!b)
    return () => {
      Z.forEach((I) => I());
    };
  const W = b.Object.getOwnPropertyDescriptor(
    b.HTMLInputElement.prototype,
    "value"
  ), V = [
    [b.HTMLInputElement.prototype, "value"],
    [b.HTMLInputElement.prototype, "checked"],
    [b.HTMLSelectElement.prototype, "value"],
    [b.HTMLTextAreaElement.prototype, "value"],
    // Some UI library use selectedIndex to set select value
    [b.HTMLSelectElement.prototype, "selectedIndex"],
    [b.HTMLOptionElement.prototype, "selected"]
  ];
  return W && W.set && Z.push(
    ...V.map(
      (I) => Et(
        I[0],
        I[1],
        {
          set() {
            F(u)({
              target: this,
              isTrusted: !1
              // userTriggered to false as this could well be programmatic
            });
          }
        },
        !1,
        b
      )
    )
  ), F(() => {
    Z.forEach((I) => I());
  });
}
function xt(e) {
  const t = [];
  function i(n, s) {
    if (Wt("CSSGroupingRule") && n.parentRule instanceof CSSGroupingRule || Wt("CSSMediaRule") && n.parentRule instanceof CSSMediaRule || Wt("CSSSupportsRule") && n.parentRule instanceof CSSSupportsRule || Wt("CSSConditionRule") && n.parentRule instanceof CSSConditionRule) {
      const o = Array.from(
        n.parentRule.cssRules
      ).indexOf(n);
      s.unshift(o);
    } else if (n.parentStyleSheet) {
      const o = Array.from(n.parentStyleSheet.cssRules).indexOf(n);
      s.unshift(o);
    }
    return s;
  }
  return i(e, t);
}
function Se(e, t, i) {
  let n, s;
  return e ? (e.ownerNode ? n = t.getId(e.ownerNode) : s = i.getId(e), {
    styleId: s,
    id: n
  }) : {};
}
function ta({ styleSheetRuleCb: e, mirror: t, stylesheetManager: i }, { win: n }) {
  if (!n.CSSStyleSheet || !n.CSSStyleSheet.prototype)
    return () => {
    };
  const s = n.CSSStyleSheet.prototype.insertRule;
  n.CSSStyleSheet.prototype.insertRule = new Proxy(s, {
    apply: F(
      (d, u, p) => {
        const [h, Z] = p, { id: b, styleId: W } = Se(
          u,
          t,
          i.styleMirror
        );
        return (b && b !== -1 || W && W !== -1) && e({
          id: b,
          styleId: W,
          adds: [{ rule: h, index: Z }]
        }), d.apply(u, p);
      }
    )
  }), n.CSSStyleSheet.prototype.addRule = function(d, u, p = this.cssRules.length) {
    const h = `${d} { ${u} }`;
    return n.CSSStyleSheet.prototype.insertRule.apply(this, [h, p]);
  };
  const l = n.CSSStyleSheet.prototype.deleteRule;
  n.CSSStyleSheet.prototype.deleteRule = new Proxy(l, {
    apply: F(
      (d, u, p) => {
        const [h] = p, { id: Z, styleId: b } = Se(
          u,
          t,
          i.styleMirror
        );
        return (Z && Z !== -1 || b && b !== -1) && e({
          id: Z,
          styleId: b,
          removes: [{ index: h }]
        }), d.apply(u, p);
      }
    )
  }), n.CSSStyleSheet.prototype.removeRule = function(d) {
    return n.CSSStyleSheet.prototype.deleteRule.apply(this, [d]);
  };
  let o;
  n.CSSStyleSheet.prototype.replace && (o = n.CSSStyleSheet.prototype.replace, n.CSSStyleSheet.prototype.replace = new Proxy(o, {
    apply: F(
      (d, u, p) => {
        const [h] = p, { id: Z, styleId: b } = Se(
          u,
          t,
          i.styleMirror
        );
        return (Z && Z !== -1 || b && b !== -1) && e({
          id: Z,
          styleId: b,
          replace: h
        }), d.apply(u, p);
      }
    )
  }));
  let r;
  n.CSSStyleSheet.prototype.replaceSync && (r = n.CSSStyleSheet.prototype.replaceSync, n.CSSStyleSheet.prototype.replaceSync = new Proxy(r, {
    apply: F(
      (d, u, p) => {
        const [h] = p, { id: Z, styleId: b } = Se(
          u,
          t,
          i.styleMirror
        );
        return (Z && Z !== -1 || b && b !== -1) && e({
          id: Z,
          styleId: b,
          replaceSync: h
        }), d.apply(u, p);
      }
    )
  }));
  const a = {};
  ft("CSSGroupingRule") ? a.CSSGroupingRule = n.CSSGroupingRule : (ft("CSSMediaRule") && (a.CSSMediaRule = n.CSSMediaRule), ft("CSSConditionRule") && (a.CSSConditionRule = n.CSSConditionRule), ft("CSSSupportsRule") && (a.CSSSupportsRule = n.CSSSupportsRule));
  const c = {};
  return Object.entries(a).forEach(([d, u]) => {
    c[d] = {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      insertRule: u.prototype.insertRule,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      deleteRule: u.prototype.deleteRule
    }, u.prototype.insertRule = new Proxy(
      c[d].insertRule,
      {
        apply: F(
          (p, h, Z) => {
            const [b, W] = Z, { id: V, styleId: I } = Se(
              h.parentStyleSheet,
              t,
              i.styleMirror
            );
            return (V && V !== -1 || I && I !== -1) && e({
              id: V,
              styleId: I,
              adds: [
                {
                  rule: b,
                  index: [
                    ...xt(h),
                    W || 0
                    // defaults to 0
                  ]
                }
              ]
            }), p.apply(h, Z);
          }
        )
      }
    ), u.prototype.deleteRule = new Proxy(
      c[d].deleteRule,
      {
        apply: F(
          (p, h, Z) => {
            const [b] = Z, { id: W, styleId: V } = Se(
              h.parentStyleSheet,
              t,
              i.styleMirror
            );
            return (W && W !== -1 || V && V !== -1) && e({
              id: W,
              styleId: V,
              removes: [
                { index: [...xt(h), b] }
              ]
            }), p.apply(h, Z);
          }
        )
      }
    );
  }), F(() => {
    n.CSSStyleSheet.prototype.insertRule = s, n.CSSStyleSheet.prototype.deleteRule = l, o && (n.CSSStyleSheet.prototype.replace = o), r && (n.CSSStyleSheet.prototype.replaceSync = r), Object.entries(a).forEach(([d, u]) => {
      u.prototype.insertRule = c[d].insertRule, u.prototype.deleteRule = c[d].deleteRule;
    });
  });
}
function Ss({
  mirror: e,
  stylesheetManager: t
}, i) {
  var n, s, l;
  let o = null;
  i.nodeName === "#document" ? o = e.getId(i) : o = e.getId(x.host(i));
  const r = i.nodeName === "#document" ? (n = i.defaultView) == null ? void 0 : n.Document : (l = (s = i.ownerDocument) == null ? void 0 : s.defaultView) == null ? void 0 : l.ShadowRoot, a = r != null && r.prototype ? Object.getOwnPropertyDescriptor(
    r == null ? void 0 : r.prototype,
    "adoptedStyleSheets"
  ) : void 0;
  return o === null || o === -1 || !r || !a ? () => {
  } : (Object.defineProperty(i, "adoptedStyleSheets", {
    configurable: a.configurable,
    enumerable: a.enumerable,
    get() {
      var c;
      return (c = a.get) == null ? void 0 : c.call(this);
    },
    set(c) {
      var d;
      const u = (d = a.set) == null ? void 0 : d.call(this, c);
      if (o !== null && o !== -1)
        try {
          t.adoptStyleSheets(c, o);
        } catch (p) {
        }
      return u;
    }
  }), F(() => {
    Object.defineProperty(i, "adoptedStyleSheets", {
      configurable: a.configurable,
      enumerable: a.enumerable,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      get: a.get,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      set: a.set
    });
  }));
}
function ia({
  styleDeclarationCb: e,
  mirror: t,
  ignoreCSSAttributes: i,
  stylesheetManager: n
}, { win: s }) {
  const l = s.CSSStyleDeclaration.prototype.setProperty;
  s.CSSStyleDeclaration.prototype.setProperty = new Proxy(l, {
    apply: F(
      (r, a, c) => {
        var d;
        const [u, p, h] = c;
        if (i.has(u))
          return l.apply(a, [u, p, h]);
        const { id: Z, styleId: b } = Se(
          (d = a.parentRule) == null ? void 0 : d.parentStyleSheet,
          t,
          n.styleMirror
        );
        return (Z && Z !== -1 || b && b !== -1) && e({
          id: Z,
          styleId: b,
          set: {
            property: u,
            value: p,
            priority: h
          },
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          index: xt(a.parentRule)
        }), r.apply(a, c);
      }
    )
  });
  const o = s.CSSStyleDeclaration.prototype.removeProperty;
  return s.CSSStyleDeclaration.prototype.removeProperty = new Proxy(o, {
    apply: F(
      (r, a, c) => {
        var d;
        const [u] = c;
        if (i.has(u))
          return o.apply(a, [u]);
        const { id: p, styleId: h } = Se(
          (d = a.parentRule) == null ? void 0 : d.parentStyleSheet,
          t,
          n.styleMirror
        );
        return (p && p !== -1 || h && h !== -1) && e({
          id: p,
          styleId: h,
          remove: {
            property: u
          },
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          index: xt(a.parentRule)
        }), r.apply(a, c);
      }
    )
  }), F(() => {
    s.CSSStyleDeclaration.prototype.setProperty = l, s.CSSStyleDeclaration.prototype.removeProperty = o;
  });
}
function na({
  mediaInteractionCb: e,
  blockClass: t,
  blockSelector: i,
  mirror: n,
  sampling: s,
  doc: l
}) {
  const o = F(
    (a) => ut(
      F((c) => {
        const d = ht(c);
        if (!d || te(d, t, i, !0))
          return;
        const { currentTime: u, volume: p, muted: h, playbackRate: Z, loop: b } = d;
        e({
          type: a,
          id: n.getId(d),
          currentTime: u,
          volume: p,
          muted: h,
          playbackRate: Z,
          loop: b
        });
      }),
      s.media || 500
    )
  ), r = [
    se("play", o(ze.Play), l),
    se("pause", o(ze.Pause), l),
    se("seeked", o(ze.Seeked), l),
    se("volumechange", o(ze.VolumeChange), l),
    se("ratechange", o(ze.RateChange), l)
  ];
  return F(() => {
    r.forEach((a) => a());
  });
}
function sa({ fontCb: e, doc: t }) {
  const i = t.defaultView;
  if (!i)
    return () => {
    };
  const n = [], s = /* @__PURE__ */ new WeakMap(), l = i.FontFace;
  i.FontFace = function(a, c, d) {
    const u = new l(a, c, d);
    return s.set(u, {
      family: a,
      buffer: typeof c != "string",
      descriptors: d,
      fontSource: typeof c == "string" ? c : JSON.stringify(Array.from(new Uint8Array(c)))
    }), u;
  };
  const o = _e(
    t.fonts,
    "add",
    function(r) {
      return function(a) {
        return setTimeout(
          F(() => {
            const c = s.get(a);
            c && (e(c), s.delete(a));
          }),
          0
        ), r.apply(this, [a]);
      };
    }
  );
  return n.push(() => {
    i.FontFace = l;
  }), n.push(o), F(() => {
    n.forEach((r) => r());
  });
}
function la(e) {
  const { doc: t, mirror: i, blockClass: n, blockSelector: s, selectionCb: l } = e;
  let o = !0;
  const r = F(() => {
    const a = t.getSelection();
    if (!a || o && (a != null && a.isCollapsed))
      return;
    o = a.isCollapsed || !1;
    const c = [], d = a.rangeCount || 0;
    for (let u = 0; u < d; u++) {
      const p = a.getRangeAt(u), { startContainer: h, startOffset: Z, endContainer: b, endOffset: W } = p;
      te(h, n, s, !0) || te(b, n, s, !0) || c.push({
        start: i.getId(h),
        startOffset: Z,
        end: i.getId(b),
        endOffset: W
      });
    }
    l({ ranges: c });
  });
  return r(), se("selectionchange", r);
}
function oa({
  doc: e,
  customElementCb: t
}) {
  const i = e.defaultView;
  return !i || !i.customElements ? () => {
  } : _e(
    i.customElements,
    "define",
    function(s) {
      return function(l, o, r) {
        try {
          t({
            define: {
              name: l
            }
          });
        } catch (a) {
          console.warn(`Custom element callback failed for ${l}`);
        }
        return s.apply(this, [l, o, r]);
      };
    }
  );
}
function aa(e, t) {
  const {
    mutationCb: i,
    mousemoveCb: n,
    mouseInteractionCb: s,
    scrollCb: l,
    viewportResizeCb: o,
    inputCb: r,
    mediaInteractionCb: a,
    styleSheetRuleCb: c,
    styleDeclarationCb: d,
    canvasMutationCb: u,
    fontCb: p,
    selectionCb: h,
    customElementCb: Z
  } = e;
  e.mutationCb = (...b) => {
    t.mutation && t.mutation(...b), i(...b);
  }, e.mousemoveCb = (...b) => {
    t.mousemove && t.mousemove(...b), n(...b);
  }, e.mouseInteractionCb = (...b) => {
    t.mouseInteraction && t.mouseInteraction(...b), s(...b);
  }, e.scrollCb = (...b) => {
    t.scroll && t.scroll(...b), l(...b);
  }, e.viewportResizeCb = (...b) => {
    t.viewportResize && t.viewportResize(...b), o(...b);
  }, e.inputCb = (...b) => {
    t.input && t.input(...b), r(...b);
  }, e.mediaInteractionCb = (...b) => {
    t.mediaInteaction && t.mediaInteaction(...b), a(...b);
  }, e.styleSheetRuleCb = (...b) => {
    t.styleSheetRule && t.styleSheetRule(...b), c(...b);
  }, e.styleDeclarationCb = (...b) => {
    t.styleDeclaration && t.styleDeclaration(...b), d(...b);
  }, e.canvasMutationCb = (...b) => {
    t.canvasMutation && t.canvasMutation(...b), u(...b);
  }, e.fontCb = (...b) => {
    t.font && t.font(...b), p(...b);
  }, e.selectionCb = (...b) => {
    t.selection && t.selection(...b), h(...b);
  }, e.customElementCb = (...b) => {
    t.customElement && t.customElement(...b), Z(...b);
  };
}
function ra(e, t = {}) {
  const i = e.doc.defaultView;
  if (!i)
    return () => {
    };
  aa(e, t);
  let n;
  e.recordDOM && (n = fs(e, e.doc));
  const s = Ao(e), l = _o(e), o = Is(e), r = qo(e, {
    win: i
  }), a = ea(e), c = na(e);
  let d = () => {
  }, u = () => {
  }, p = () => {
  }, h = () => {
  };
  e.recordDOM && (d = ta(e, { win: i }), u = Ss(e, e.doc), p = ia(e, {
    win: i
  }), e.collectFonts && (h = sa(e)));
  const Z = la(e), b = oa(e), W = [];
  for (const V of e.plugins)
    W.push(
      V.observer(V.callback, i, V.options)
    );
  return F(() => {
    Te.forEach((V) => V.reset()), n == null || n.disconnect(), s(), l(), o(), r(), a(), c(), d(), u(), p(), h(), Z(), b(), W.forEach((V) => V());
  });
}
function Wt(e) {
  return typeof window[e] != "undefined";
}
function ft(e) {
  return !!(typeof window[e] != "undefined" && // Note: Generally, this check _shouldn't_ be necessary
  // However, in some scenarios (e.g. jsdom) this can sometimes fail, so we check for it here
  window[e].prototype && "insertRule" in window[e].prototype && "deleteRule" in window[e].prototype);
}
class Vn {
  constructor(t) {
    g(this, "iframeIdToRemoteIdMap", /* @__PURE__ */ new WeakMap()), g(this, "iframeRemoteIdToIdMap", /* @__PURE__ */ new WeakMap()), this.generateIdFn = t;
  }
  getId(t, i, n, s) {
    const l = n || this.getIdToRemoteIdMap(t), o = s || this.getRemoteIdToIdMap(t);
    let r = l.get(i);
    return r || (r = this.generateIdFn(), l.set(i, r), o.set(r, i)), r;
  }
  getIds(t, i) {
    const n = this.getIdToRemoteIdMap(t), s = this.getRemoteIdToIdMap(t);
    return i.map(
      (l) => this.getId(t, l, n, s)
    );
  }
  getRemoteId(t, i, n) {
    const s = n || this.getRemoteIdToIdMap(t);
    if (typeof i != "number")
      return i;
    const l = s.get(i);
    return l || -1;
  }
  getRemoteIds(t, i) {
    const n = this.getRemoteIdToIdMap(t);
    return i.map((s) => this.getRemoteId(t, s, n));
  }
  reset(t) {
    if (!t) {
      this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
      return;
    }
    this.iframeIdToRemoteIdMap.delete(t), this.iframeRemoteIdToIdMap.delete(t);
  }
  getIdToRemoteIdMap(t) {
    let i = this.iframeIdToRemoteIdMap.get(t);
    return i || (i = /* @__PURE__ */ new Map(), this.iframeIdToRemoteIdMap.set(t, i)), i;
  }
  getRemoteIdToIdMap(t) {
    let i = this.iframeRemoteIdToIdMap.get(t);
    return i || (i = /* @__PURE__ */ new Map(), this.iframeRemoteIdToIdMap.set(t, i)), i;
  }
}
class ca {
  constructor(t) {
    g(this, "iframes", /* @__PURE__ */ new WeakMap()), g(this, "crossOriginIframeMap", /* @__PURE__ */ new WeakMap()), g(this, "crossOriginIframeMirror", new Vn(as)), g(this, "crossOriginIframeStyleMirror"), g(this, "crossOriginIframeRootIdMap", /* @__PURE__ */ new WeakMap()), g(this, "mirror"), g(this, "mutationCb"), g(this, "wrappedEmit"), g(this, "loadListener"), g(this, "stylesheetManager"), g(this, "recordCrossOriginIframes"), this.mutationCb = t.mutationCb, this.wrappedEmit = t.wrappedEmit, this.stylesheetManager = t.stylesheetManager, this.recordCrossOriginIframes = t.recordCrossOriginIframes, this.crossOriginIframeStyleMirror = new Vn(
      this.stylesheetManager.styleMirror.generateId.bind(
        this.stylesheetManager.styleMirror
      )
    ), this.mirror = t.mirror, this.recordCrossOriginIframes && window.addEventListener("message", this.handleMessage.bind(this));
  }
  addIframe(t) {
    this.iframes.set(t, !0), t.contentWindow && this.crossOriginIframeMap.set(t.contentWindow, t);
  }
  addLoadListener(t) {
    this.loadListener = t;
  }
  attachIframe(t, i) {
    var n, s;
    this.mutationCb({
      adds: [
        {
          parentId: this.mirror.getId(t),
          nextId: null,
          node: i
        }
      ],
      removes: [],
      texts: [],
      attributes: [],
      isAttachIframe: !0
    }), this.recordCrossOriginIframes && ((n = t.contentWindow) == null || n.addEventListener(
      "message",
      this.handleMessage.bind(this)
    )), (s = this.loadListener) == null || s.call(this, t), t.contentDocument && t.contentDocument.adoptedStyleSheets && t.contentDocument.adoptedStyleSheets.length > 0 && this.stylesheetManager.adoptStyleSheets(
      t.contentDocument.adoptedStyleSheets,
      this.mirror.getId(t.contentDocument)
    );
  }
  handleMessage(t) {
    const i = t;
    if (i.data.type !== "rrweb" || // To filter out the rrweb messages which are forwarded by some sites.
    i.origin !== i.data.origin)
      return;
    const n = t.source;
    if (!n)
      return;
    const s = this.crossOriginIframeMap.get(n);
    if (!s)
      return;
    const l = this.transformCrossOriginEvent(
      s,
      i.data.event
    );
    l && this.wrappedEmit(
      l,
      i.data.isCheckout
    );
  }
  transformCrossOriginEvent(t, i) {
    var n;
    switch (i.type) {
      case H.FullSnapshot: {
        this.crossOriginIframeMirror.reset(t), this.crossOriginIframeStyleMirror.reset(t), this.replaceIdOnNode(i.data.node, t);
        const s = i.data.node.id;
        return this.crossOriginIframeRootIdMap.set(t, s), this.patchRootIdOnNode(i.data.node, s), {
          timestamp: i.timestamp,
          type: H.IncrementalSnapshot,
          data: {
            source: K.Mutation,
            adds: [
              {
                parentId: this.mirror.getId(t),
                nextId: null,
                node: i.data.node
              }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: !0
          }
        };
      }
      case H.Meta:
      case H.Load:
      case H.DomContentLoaded:
        return !1;
      case H.Plugin:
        return i;
      case H.Custom:
        return this.replaceIds(
          i.data.payload,
          t,
          ["id", "parentId", "previousId", "nextId"]
        ), i;
      case H.IncrementalSnapshot:
        switch (i.data.source) {
          case K.Mutation:
            return i.data.adds.forEach((s) => {
              this.replaceIds(s, t, [
                "parentId",
                "nextId",
                "previousId"
              ]), this.replaceIdOnNode(s.node, t);
              const l = this.crossOriginIframeRootIdMap.get(t);
              l && this.patchRootIdOnNode(s.node, l);
            }), i.data.removes.forEach((s) => {
              this.replaceIds(s, t, ["parentId", "id"]);
            }), i.data.attributes.forEach((s) => {
              this.replaceIds(s, t, ["id"]);
            }), i.data.texts.forEach((s) => {
              this.replaceIds(s, t, ["id"]);
            }), i;
          case K.Drag:
          case K.TouchMove:
          case K.MouseMove:
            return i.data.positions.forEach((s) => {
              this.replaceIds(s, t, ["id"]);
            }), i;
          case K.ViewportResize:
            return !1;
          case K.MediaInteraction:
          case K.MouseInteraction:
          case K.Scroll:
          case K.CanvasMutation:
          case K.Input:
            return this.replaceIds(i.data, t, ["id"]), i;
          case K.StyleSheetRule:
          case K.StyleDeclaration:
            return this.replaceIds(i.data, t, ["id"]), this.replaceStyleIds(i.data, t, ["styleId"]), i;
          case K.Font:
            return i;
          case K.Selection:
            return i.data.ranges.forEach((s) => {
              this.replaceIds(s, t, ["start", "end"]);
            }), i;
          case K.AdoptedStyleSheet:
            return this.replaceIds(i.data, t, ["id"]), this.replaceStyleIds(i.data, t, ["styleIds"]), (n = i.data.styles) == null || n.forEach((s) => {
              this.replaceStyleIds(s, t, ["styleId"]);
            }), i;
        }
    }
    return !1;
  }
  replace(t, i, n, s) {
    for (const l of s)
      !Array.isArray(i[l]) && typeof i[l] != "number" || (Array.isArray(i[l]) ? i[l] = t.getIds(
        n,
        i[l]
      ) : i[l] = t.getId(n, i[l]));
    return i;
  }
  replaceIds(t, i, n) {
    return this.replace(this.crossOriginIframeMirror, t, i, n);
  }
  replaceStyleIds(t, i, n) {
    return this.replace(this.crossOriginIframeStyleMirror, t, i, n);
  }
  replaceIdOnNode(t, i) {
    this.replaceIds(t, i, ["id", "rootId"]), "childNodes" in t && t.childNodes.forEach((n) => {
      this.replaceIdOnNode(n, i);
    });
  }
  patchRootIdOnNode(t, i) {
    t.type !== _.Document && !t.rootId && (t.rootId = i), "childNodes" in t && t.childNodes.forEach((n) => {
      this.patchRootIdOnNode(n, i);
    });
  }
}
class da {
  constructor(t) {
    g(this, "shadowDoms", /* @__PURE__ */ new WeakSet()), g(this, "mutationCb"), g(this, "scrollCb"), g(this, "bypassOptions"), g(this, "mirror"), g(this, "restoreHandlers", []), this.mutationCb = t.mutationCb, this.scrollCb = t.scrollCb, this.bypassOptions = t.bypassOptions, this.mirror = t.mirror, this.init();
  }
  init() {
    this.reset(), this.patchAttachShadow(Element, document);
  }
  addShadowRoot(t, i) {
    if (!ot(t) || this.shadowDoms.has(t))
      return;
    this.shadowDoms.add(t);
    const n = fs(
      ge(R({}, this.bypassOptions), {
        doc: i,
        mutationCb: this.mutationCb,
        mirror: this.mirror,
        shadowDomManager: this
      }),
      t
    );
    this.restoreHandlers.push(() => n.disconnect()), this.restoreHandlers.push(
      Is(ge(R({}, this.bypassOptions), {
        scrollCb: this.scrollCb,
        // https://gist.github.com/praveenpuglia/0832da687ed5a5d7a0907046c9ef1813
        // scroll is not allowed to pass the boundary, so we need to listen the shadow document
        doc: t,
        mirror: this.mirror
      }))
    ), setTimeout(() => {
      t.adoptedStyleSheets && t.adoptedStyleSheets.length > 0 && this.bypassOptions.stylesheetManager.adoptStyleSheets(
        t.adoptedStyleSheets,
        this.mirror.getId(x.host(t))
      ), this.restoreHandlers.push(
        Ss(
          {
            mirror: this.mirror,
            stylesheetManager: this.bypassOptions.stylesheetManager
          },
          t
        )
      );
    }, 0);
  }
  /**
   * Monkey patch 'attachShadow' of an IFrameElement to observe newly added shadow doms.
   */
  observeAttachShadow(t) {
    !t.contentWindow || !t.contentDocument || this.patchAttachShadow(
      t.contentWindow.Element,
      t.contentDocument
    );
  }
  /**
   * Patch 'attachShadow' to observe newly added shadow doms.
   */
  patchAttachShadow(t, i) {
    const n = this;
    this.restoreHandlers.push(
      _e(
        t.prototype,
        "attachShadow",
        function(s) {
          return function(l) {
            const o = s.call(this, l), r = x.shadowRoot(this);
            return r && Vs(this) && n.addShadowRoot(r, i), o;
          };
        }
      )
    );
  }
  reset() {
    this.restoreHandlers.forEach((t) => {
      try {
        t();
      } catch (i) {
      }
    }), this.restoreHandlers = [], this.shadowDoms = /* @__PURE__ */ new WeakSet();
  }
}
var Ee = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", ua = typeof Uint8Array == "undefined" ? [] : new Uint8Array(256);
for (var It = 0; It < Ee.length; It++)
  ua[Ee.charCodeAt(It)] = It;
var ma = function(e) {
  var t = new Uint8Array(e), i, n = t.length, s = "";
  for (i = 0; i < n; i += 3)
    s += Ee[t[i] >> 2], s += Ee[(t[i] & 3) << 4 | t[i + 1] >> 4], s += Ee[(t[i + 1] & 15) << 2 | t[i + 2] >> 6], s += Ee[t[i + 2] & 63];
  return n % 3 === 2 ? s = s.substring(0, s.length - 1) + "=" : n % 3 === 1 && (s = s.substring(0, s.length - 2) + "=="), s;
};
const Wn = /* @__PURE__ */ new Map();
function ha(e, t) {
  let i = Wn.get(e);
  return i || (i = /* @__PURE__ */ new Map(), Wn.set(e, i)), i.has(t) || i.set(t, []), i.get(t);
}
const Rs = (e, t, i) => {
  if (!e || !(Ls(e, t) || typeof e == "object"))
    return;
  const n = e.constructor.name, s = ha(i, n);
  let l = s.indexOf(e);
  return l === -1 && (l = s.length, s.push(e)), l;
};
function Lt(e, t, i) {
  if (e instanceof Array)
    return e.map((n) => Lt(n, t, i));
  if (e === null)
    return e;
  if (e instanceof Float32Array || e instanceof Float64Array || e instanceof Int32Array || e instanceof Uint32Array || e instanceof Uint8Array || e instanceof Uint16Array || e instanceof Int16Array || e instanceof Int8Array || e instanceof Uint8ClampedArray)
    return {
      rr_type: e.constructor.name,
      args: [Object.values(e)]
    };
  if (
    // SharedArrayBuffer disabled on most browsers due to spectre.
    // More info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/SharedArrayBuffer
    // value instanceof SharedArrayBuffer ||
    e instanceof ArrayBuffer
  ) {
    const n = e.constructor.name, s = ma(e);
    return {
      rr_type: n,
      base64: s
    };
  } else {
    if (e instanceof DataView)
      return {
        rr_type: e.constructor.name,
        args: [
          Lt(e.buffer, t, i),
          e.byteOffset,
          e.byteLength
        ]
      };
    if (e instanceof HTMLImageElement) {
      const n = e.constructor.name, { src: s } = e;
      return {
        rr_type: n,
        src: s
      };
    } else if (e instanceof HTMLCanvasElement) {
      const n = "HTMLImageElement", s = e.toDataURL();
      return {
        rr_type: n,
        src: s
      };
    } else {
      if (e instanceof ImageData)
        return {
          rr_type: e.constructor.name,
          args: [Lt(e.data, t, i), e.width, e.height]
        };
      if (Ls(e, t) || typeof e == "object") {
        const n = e.constructor.name, s = Rs(e, t, i);
        return {
          rr_type: n,
          index: s
        };
      }
    }
  }
  return e;
}
const Cs = (e, t, i) => e.map((n) => Lt(n, t, i)), Ls = (e, t) => !![
  "WebGLActiveInfo",
  "WebGLBuffer",
  "WebGLFramebuffer",
  "WebGLProgram",
  "WebGLRenderbuffer",
  "WebGLShader",
  "WebGLShaderPrecisionFormat",
  "WebGLTexture",
  "WebGLUniformLocation",
  "WebGLVertexArrayObject",
  // In old Chrome versions, value won't be an instanceof WebGLVertexArrayObject.
  "WebGLVertexArrayObjectOES"
].filter(
  (s) => typeof t[s] == "function"
).find(
  (s) => e instanceof t[s]
);
function pa(e, t, i, n) {
  const s = [], l = Object.getOwnPropertyNames(
    t.CanvasRenderingContext2D.prototype
  );
  for (const o of l)
    try {
      if (typeof t.CanvasRenderingContext2D.prototype[o] != "function")
        continue;
      const r = _e(
        t.CanvasRenderingContext2D.prototype,
        o,
        function(a) {
          return function(...c) {
            return te(this.canvas, i, n, !0) || setTimeout(() => {
              const d = Cs(c, t, this);
              e(this.canvas, {
                type: je["2D"],
                property: o,
                args: d
              });
            }, 0), a.apply(this, c);
          };
        }
      );
      s.push(r);
    } catch (r) {
      const a = Et(
        t.CanvasRenderingContext2D.prototype,
        o,
        {
          set(c) {
            e(this.canvas, {
              type: je["2D"],
              property: o,
              args: [c],
              setter: !0
            });
          }
        }
      );
      s.push(a);
    }
  return () => {
    s.forEach((o) => o());
  };
}
function ba(e) {
  return e === "experimental-webgl" ? "webgl" : e;
}
function fn(e, t, i, n) {
  const s = [];
  try {
    const l = _e(
      e.HTMLCanvasElement.prototype,
      "getContext",
      function(o) {
        return function(r, ...a) {
          if (!te(this, t, i, !0)) {
            const c = ba(r);
            if ("__context" in this || (this.__context = c), n && ["webgl", "webgl2"].includes(c))
              if (a[0] && typeof a[0] == "object") {
                const d = a[0];
                d.preserveDrawingBuffer || (d.preserveDrawingBuffer = !0);
              } else
                a.splice(0, 1, {
                  preserveDrawingBuffer: !0
                });
          }
          return o.apply(this, [r, ...a]);
        };
      }
    );
    s.push(l);
  } catch (l) {
    console.error("failed to patch HTMLCanvasElement.prototype.getContext");
  }
  return () => {
    s.forEach((l) => l());
  };
}
function In(e, t, i, n, s, l) {
  const o = [], r = Object.getOwnPropertyNames(e);
  for (const a of r)
    if (
      //prop.startsWith('get') ||  // e.g. getProgramParameter, but too risky
      ![
        "isContextLost",
        "canvas",
        "drawingBufferWidth",
        "drawingBufferHeight"
      ].includes(a)
    )
      try {
        if (typeof e[a] != "function")
          continue;
        const c = _e(
          e,
          a,
          function(d) {
            return function(...u) {
              const p = d.apply(this, u);
              if (Rs(p, l, this), "tagName" in this.canvas && !te(
                this.canvas,
                n,
                s,
                !0
              )) {
                const h = Cs(u, l, this), Z = {
                  type: t,
                  property: a,
                  args: h
                };
                i(this.canvas, Z);
              }
              return p;
            };
          }
        );
        o.push(c);
      } catch (c) {
        const d = Et(e, a, {
          set(u) {
            i(this.canvas, {
              type: t,
              property: a,
              args: [u],
              setter: !0
            });
          }
        });
        o.push(d);
      }
  return o;
}
function Za(e, t, i, n) {
  const s = [];
  return s.push(
    ...In(
      t.WebGLRenderingContext.prototype,
      je.WebGL,
      e,
      i,
      n,
      t
    )
  ), typeof t.WebGL2RenderingContext != "undefined" && s.push(
    ...In(
      t.WebGL2RenderingContext.prototype,
      je.WebGL2,
      e,
      i,
      n,
      t
    )
  ), () => {
    s.forEach((l) => l());
  };
}
const Ys = "KGZ1bmN0aW9uKCkgewogICJ1c2Ugc3RyaWN0IjsKICB2YXIgY2hhcnMgPSAiQUJDREVGR0hJSktMTU5PUFFSU1RVVldYWVphYmNkZWZnaGlqa2xtbm9wcXJzdHV2d3h5ejAxMjM0NTY3ODkrLyI7CiAgdmFyIGxvb2t1cCA9IHR5cGVvZiBVaW50OEFycmF5ID09PSAidW5kZWZpbmVkIiA/IFtdIDogbmV3IFVpbnQ4QXJyYXkoMjU2KTsKICBmb3IgKHZhciBpID0gMDsgaSA8IGNoYXJzLmxlbmd0aDsgaSsrKSB7CiAgICBsb29rdXBbY2hhcnMuY2hhckNvZGVBdChpKV0gPSBpOwogIH0KICB2YXIgZW5jb2RlID0gZnVuY3Rpb24oYXJyYXlidWZmZXIpIHsKICAgIHZhciBieXRlcyA9IG5ldyBVaW50OEFycmF5KGFycmF5YnVmZmVyKSwgaTIsIGxlbiA9IGJ5dGVzLmxlbmd0aCwgYmFzZTY0ID0gIiI7CiAgICBmb3IgKGkyID0gMDsgaTIgPCBsZW47IGkyICs9IDMpIHsKICAgICAgYmFzZTY0ICs9IGNoYXJzW2J5dGVzW2kyXSA+PiAyXTsKICAgICAgYmFzZTY0ICs9IGNoYXJzWyhieXRlc1tpMl0gJiAzKSA8PCA0IHwgYnl0ZXNbaTIgKyAxXSA+PiA0XTsKICAgICAgYmFzZTY0ICs9IGNoYXJzWyhieXRlc1tpMiArIDFdICYgMTUpIDw8IDIgfCBieXRlc1tpMiArIDJdID4+IDZdOwogICAgICBiYXNlNjQgKz0gY2hhcnNbYnl0ZXNbaTIgKyAyXSAmIDYzXTsKICAgIH0KICAgIGlmIChsZW4gJSAzID09PSAyKSB7CiAgICAgIGJhc2U2NCA9IGJhc2U2NC5zdWJzdHJpbmcoMCwgYmFzZTY0Lmxlbmd0aCAtIDEpICsgIj0iOwogICAgfSBlbHNlIGlmIChsZW4gJSAzID09PSAxKSB7CiAgICAgIGJhc2U2NCA9IGJhc2U2NC5zdWJzdHJpbmcoMCwgYmFzZTY0Lmxlbmd0aCAtIDIpICsgIj09IjsKICAgIH0KICAgIHJldHVybiBiYXNlNjQ7CiAgfTsKICBjb25zdCBsYXN0QmxvYk1hcCA9IC8qIEBfX1BVUkVfXyAqLyBuZXcgTWFwKCk7CiAgY29uc3QgdHJhbnNwYXJlbnRCbG9iTWFwID0gLyogQF9fUFVSRV9fICovIG5ldyBNYXAoKTsKICBhc3luYyBmdW5jdGlvbiBnZXRUcmFuc3BhcmVudEJsb2JGb3Iod2lkdGgsIGhlaWdodCwgZGF0YVVSTE9wdGlvbnMpIHsKICAgIGNvbnN0IGlkID0gYCR7d2lkdGh9LSR7aGVpZ2h0fWA7CiAgICBpZiAoIk9mZnNjcmVlbkNhbnZhcyIgaW4gZ2xvYmFsVGhpcykgewogICAgICBpZiAodHJhbnNwYXJlbnRCbG9iTWFwLmhhcyhpZCkpCiAgICAgICAgcmV0dXJuIHRyYW5zcGFyZW50QmxvYk1hcC5nZXQoaWQpOwogICAgICBjb25zdCBvZmZzY3JlZW4gPSBuZXcgT2Zmc2NyZWVuQ2FudmFzKHdpZHRoLCBoZWlnaHQpOwogICAgICBvZmZzY3JlZW4uZ2V0Q29udGV4dCgiMmQiKTsKICAgICAgY29uc3QgYmxvYiA9IGF3YWl0IG9mZnNjcmVlbi5jb252ZXJ0VG9CbG9iKGRhdGFVUkxPcHRpb25zKTsKICAgICAgY29uc3QgYXJyYXlCdWZmZXIgPSBhd2FpdCBibG9iLmFycmF5QnVmZmVyKCk7CiAgICAgIGNvbnN0IGJhc2U2NCA9IGVuY29kZShhcnJheUJ1ZmZlcik7CiAgICAgIHRyYW5zcGFyZW50QmxvYk1hcC5zZXQoaWQsIGJhc2U2NCk7CiAgICAgIHJldHVybiBiYXNlNjQ7CiAgICB9IGVsc2UgewogICAgICByZXR1cm4gIiI7CiAgICB9CiAgfQogIGNvbnN0IHdvcmtlciA9IHNlbGY7CiAgbGV0IGxvZ0RlYnVnID0gZmFsc2U7CiAgY29uc3QgZGVidWcgPSAoLi4uYXJncykgPT4gewogICAgaWYgKGxvZ0RlYnVnKSB7CiAgICAgIGNvbnNvbGUuZGVidWcoLi4uYXJncyk7CiAgICB9CiAgfTsKICB3b3JrZXIub25tZXNzYWdlID0gYXN5bmMgZnVuY3Rpb24oZSkgewogICAgbG9nRGVidWcgPSAhIWUuZGF0YS5sb2dEZWJ1ZzsKICAgIGlmICgiT2Zmc2NyZWVuQ2FudmFzIiBpbiBnbG9iYWxUaGlzKSB7CiAgICAgIGNvbnN0IHsgaWQsIGJpdG1hcCwgd2lkdGgsIGhlaWdodCwgZHgsIGR5LCBkdywgZGgsIGRhdGFVUkxPcHRpb25zIH0gPSBlLmRhdGE7CiAgICAgIGNvbnN0IHRyYW5zcGFyZW50QmFzZTY0ID0gZ2V0VHJhbnNwYXJlbnRCbG9iRm9yKAogICAgICAgIHdpZHRoLAogICAgICAgIGhlaWdodCwKICAgICAgICBkYXRhVVJMT3B0aW9ucwogICAgICApOwogICAgICBjb25zdCBvZmZzY3JlZW4gPSBuZXcgT2Zmc2NyZWVuQ2FudmFzKHdpZHRoLCBoZWlnaHQpOwogICAgICBjb25zdCBjdHggPSBvZmZzY3JlZW4uZ2V0Q29udGV4dCgiMmQiKTsKICAgICAgY3R4LmRyYXdJbWFnZShiaXRtYXAsIDAsIDAsIHdpZHRoLCBoZWlnaHQpOwogICAgICBiaXRtYXAuY2xvc2UoKTsKICAgICAgY29uc3QgYmxvYiA9IGF3YWl0IG9mZnNjcmVlbi5jb252ZXJ0VG9CbG9iKGRhdGFVUkxPcHRpb25zKTsKICAgICAgY29uc3QgdHlwZSA9IGJsb2IudHlwZTsKICAgICAgY29uc3QgYXJyYXlCdWZmZXIgPSBhd2FpdCBibG9iLmFycmF5QnVmZmVyKCk7CiAgICAgIGNvbnN0IGJhc2U2NCA9IGVuY29kZShhcnJheUJ1ZmZlcik7CiAgICAgIGlmICghbGFzdEJsb2JNYXAuaGFzKGlkKSAmJiBhd2FpdCB0cmFuc3BhcmVudEJhc2U2NCA9PT0gYmFzZTY0KSB7CiAgICAgICAgZGVidWcoIltoaWdobGlnaHQtd29ya2VyXSBjYW52YXMgYml0bWFwIGlzIHRyYW5zcGFyZW50IiwgewogICAgICAgICAgaWQsCiAgICAgICAgICBiYXNlNjQKICAgICAgICB9KTsKICAgICAgICBsYXN0QmxvYk1hcC5zZXQoaWQsIGJhc2U2NCk7CiAgICAgICAgcmV0dXJuIHdvcmtlci5wb3N0TWVzc2FnZSh7IGlkLCBzdGF0dXM6ICJ0cmFuc3BhcmVudCIgfSk7CiAgICAgIH0KICAgICAgaWYgKGxhc3RCbG9iTWFwLmdldChpZCkgPT09IGJhc2U2NCkgewogICAgICAgIGRlYnVnKCJbaGlnaGxpZ2h0LXdvcmtlcl0gY2FudmFzIGJpdG1hcCBpcyB1bmNoYW5nZWQiLCB7CiAgICAgICAgICBpZCwKICAgICAgICAgIGJhc2U2NAogICAgICAgIH0pOwogICAgICAgIHJldHVybiB3b3JrZXIucG9zdE1lc3NhZ2UoeyBpZCwgc3RhdHVzOiAidW5jaGFuZ2VkIiB9KTsKICAgICAgfQogICAgICBjb25zdCBtc2cgPSB7CiAgICAgICAgaWQsCiAgICAgICAgdHlwZSwKICAgICAgICBiYXNlNjQsCiAgICAgICAgd2lkdGgsCiAgICAgICAgaGVpZ2h0LAogICAgICAgIGR4LAogICAgICAgIGR5LAogICAgICAgIGR3LAogICAgICAgIGRoCiAgICAgIH07CiAgICAgIGRlYnVnKCJbaGlnaGxpZ2h0LXdvcmtlcl0gY2FudmFzIGJpdG1hcCBwcm9jZXNzZWQiLCBtc2cpOwogICAgICB3b3JrZXIucG9zdE1lc3NhZ2UobXNnKTsKICAgICAgbGFzdEJsb2JNYXAuc2V0KGlkLCBiYXNlNjQpOwogICAgfSBlbHNlIHsKICAgICAgZGVidWcoIltoaWdobGlnaHQtd29ya2VyXSBubyBvZmZzY3JlZW5jYW52YXMgc3VwcG9ydCIsIHsKICAgICAgICBpZDogZS5kYXRhLmlkCiAgICAgIH0pOwogICAgICByZXR1cm4gd29ya2VyLnBvc3RNZXNzYWdlKHsgaWQ6IGUuZGF0YS5pZCwgc3RhdHVzOiAidW5zdXBwb3J0ZWQiIH0pOwogICAgfQogIH07Cn0pKCk7Ci8vIyBzb3VyY2VNYXBwaW5nVVJMPWltYWdlLWJpdG1hcC1kYXRhLXVybC13b3JrZXItS0tvQ2VrWjEuanMubWFwCg==", ya = (e) => Uint8Array.from(atob(e), (t) => t.charCodeAt(0)), Sn = typeof window != "undefined" && window.Blob && new Blob([ya(Ys)], { type: "text/javascript;charset=utf-8" });
function Ga(e) {
  let t;
  try {
    if (t = Sn && (window.URL || window.webkitURL).createObjectURL(Sn), !t)
      throw "";
    const i = new Worker(t, {
      name: e == null ? void 0 : e.name
    });
    return i.addEventListener("error", () => {
      (window.URL || window.webkitURL).revokeObjectURL(t);
    }), i;
  } catch (i) {
    return new Worker(
      "data:text/javascript;base64," + Ys,
      {
        name: e == null ? void 0 : e.name
      }
    );
  } finally {
    t && (window.URL || window.webkitURL).revokeObjectURL(t);
  }
}
class Xa {
  constructor(t) {
    g(this, "pendingCanvasMutations", /* @__PURE__ */ new Map()), g(this, "rafStamps", { latestId: 0, invokeId: null }), g(this, "mirror"), g(this, "logger"), g(this, "worker"), g(this, "snapshotInProgressMap", /* @__PURE__ */ new Map()), g(this, "lastSnapshotTime", /* @__PURE__ */ new Map()), g(this, "options"), g(this, "mutationCb"), g(this, "resetObservers"), g(this, "frozen", !1), g(this, "locked", !1), g(this, "processMutation", (d, u) => {
      (this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId || !this.rafStamps.invokeId) && (this.rafStamps.invokeId = this.rafStamps.latestId), this.pendingCanvasMutations.has(d) || this.pendingCanvasMutations.set(d, []), this.pendingCanvasMutations.get(d).push(u);
    });
    const {
      sampling: i,
      win: n,
      blockClass: s,
      blockSelector: l,
      recordCanvas: o,
      recordVideos: r,
      initialSnapshotDelay: a,
      dataURLOptions: c
    } = t;
    this.mutationCb = t.mutationCb, this.mirror = t.mirror, this.logger = t.logger, this.worker = new Ga(), this.worker.onmessage = (d) => {
      const { id: u } = d.data;
      if (this.snapshotInProgressMap.set(u, !1), !("base64" in d.data)) {
        this.debug(null, "canvas worker received empty message", {
          data: d.data,
          status: d.data.status
        });
        return;
      }
      const { base64: p, type: h, dx: Z, dy: b, dw: W, dh: V } = d.data, I = {
        id: u,
        type: je["2D"],
        commands: [
          {
            property: "clearRect",
            // wipe canvas
            args: [Z, b, W, V]
          },
          {
            property: "drawImage",
            // draws (semi-transparent) image
            args: [
              {
                rr_type: "ImageBitmap",
                args: [
                  {
                    rr_type: "Blob",
                    data: [{ rr_type: "ArrayBuffer", base64: p }],
                    type: h
                  }
                ]
              },
              Z,
              b,
              W,
              V
            ]
          }
        ]
      };
      this.debug(null, "canvas worker recording mutation", I), this.mutationCb(I);
    }, this.options = t, o && i === "all" ? (this.debug(null, "initializing canvas mutation observer", { sampling: i }), this.initCanvasMutationObserver(n, s, l)) : o && typeof i == "number" && (this.debug(null, "initializing canvas fps observer", { sampling: i }), this.initCanvasFPSObserver(
      r,
      i,
      n,
      s,
      l,
      {
        initialSnapshotDelay: a,
        dataURLOptions: c
      },
      t.resizeFactor,
      t.maxSnapshotDimension
    ));
  }
  reset() {
    this.pendingCanvasMutations.clear(), this.resetObservers && this.resetObservers();
  }
  freeze() {
    this.frozen = !0;
  }
  unfreeze() {
    this.frozen = !1;
  }
  lock() {
    this.locked = !0;
  }
  unlock() {
    this.locked = !1;
  }
  debug(t, ...i) {
    if (!this.logger)
      return;
    const n = this.mirror.getId(t);
    let s = "[highlight-canvas-manager]";
    t && (s = `[highlight-canvas] [id:${n}]`, t.tagName.toLowerCase() === "canvas" && (s += ` [ctx:${t.__context}]`)), this.logger.debug(s, t, ...i);
  }
  snapshot(t) {
    return A(this, null, function* () {
      var i;
      const n = this.mirror.getId(t);
      if (this.snapshotInProgressMap.get(n)) {
        this.debug(t, "snapshotting already in progress for", n);
        return;
      }
      const s = 1e3 / (typeof this.options.samplingManual == "number" ? this.options.samplingManual : 1), l = this.lastSnapshotTime.get(n);
      if (!(l && (/* @__PURE__ */ new Date()).getTime() - l < s)) {
        if (this.debug(t, "starting snapshotting"), t.width === 0 || t.height === 0) {
          this.debug(t, "not yet ready", {
            width: t.width,
            height: t.height
          });
          return;
        }
        this.lastSnapshotTime.set(n, (/* @__PURE__ */ new Date()).getTime()), this.snapshotInProgressMap.set(n, !0);
        try {
          if (this.options.clearWebGLBuffer !== !1 && ["webgl", "webgl2"].includes(t.__context)) {
            const d = t.getContext(t.__context);
            ((i = d == null ? void 0 : d.getContextAttributes()) == null ? void 0 : i.preserveDrawingBuffer) === !1 && (d.clear(d.COLOR_BUFFER_BIT), this.debug(t, "cleared webgl canvas to load it into memory", {
              attributes: d == null ? void 0 : d.getContextAttributes()
            }));
          }
          if (t.width === 0 || t.height === 0) {
            this.debug(t, "not yet ready", {
              width: t.width,
              height: t.height
            });
            return;
          }
          let o = this.options.resizeFactor || 1;
          if (this.options.maxSnapshotDimension) {
            const d = Math.max(t.width, t.height);
            o = Math.min(o, this.options.maxSnapshotDimension / d);
          }
          const r = t.width * o, a = t.height * o, c = yield createImageBitmap(t, {
            resizeWidth: r,
            resizeHeight: a
          });
          this.debug(t, "created image bitmap", {
            width: c.width,
            height: c.height
          }), this.worker.postMessage(
            {
              id: n,
              bitmap: c,
              width: r,
              height: a,
              dx: 0,
              dy: 0,
              dw: t.width,
              dh: t.height,
              dataURLOptions: this.options.dataURLOptions,
              logDebug: !!this.logger
            },
            [c]
          ), this.debug(t, "sent message");
        } catch (o) {
          this.debug(t, "failed to snapshot", o);
        } finally {
          this.snapshotInProgressMap.set(n, !1);
        }
      }
    });
  }
  initCanvasFPSObserver(t, i, n, s, l, o, r, a) {
    const c = fn(
      n,
      s,
      l,
      !0
    ), d = 1e3 / i;
    let u = 0, p;
    const h = /* @__PURE__ */ new Map(), Z = (V) => {
      const I = [];
      return n.document.querySelectorAll("canvas").forEach((y) => {
        if (!te(y, s, l, !0)) {
          this.debug(y, "discovered canvas"), I.push(y);
          const G = this.mirror.getId(y);
          h.has(G) || h.set(G, V);
        }
      }), I;
    }, b = (V) => {
      const I = [];
      return t && n.document.querySelectorAll("video").forEach((y) => {
        if (!(y.src !== "" && y.src.indexOf("blob:") === -1) && !te(y, s, l, !0)) {
          I.push(y);
          const G = this.mirror.getId(y);
          h.has(G) || h.set(G, V);
        }
      }), I;
    }, W = (V) => A(this, null, function* () {
      if (u && V - u < d) {
        p = requestAnimationFrame(W);
        return;
      }
      u = V;
      const I = (G) => {
        const w = this.mirror.getId(G), U = h.get(w), f = !o.initialSnapshotDelay || V - U > o.initialSnapshotDelay;
        return this.debug(G, {
          delay: o.initialSnapshotDelay,
          delta: V - U,
          hadLoadingTime: f
        }), f;
      }, y = [];
      y.push(
        ...Z(V).filter(I).map((G) => this.snapshot(G))
      ), y.push(
        ...b(V).filter(I).map((G) => A(this, null, function* () {
          this.debug(G, "starting video snapshotting");
          const w = this.mirror.getId(G);
          if (this.snapshotInProgressMap.get(w)) {
            this.debug(
              G,
              "video snapshotting already in progress for",
              w
            );
            return;
          }
          this.snapshotInProgressMap.set(w, !0);
          try {
            const { width: U, height: f } = G.getBoundingClientRect(), { actualWidth: C, actualHeight: z } = {
              actualWidth: G.videoWidth,
              actualHeight: G.videoHeight
            }, J = Math.max(C, z);
            if (G.width === 0 || G.height === 0 || C === 0 || z === 0 || U === 0 || f === 0) {
              this.debug(G, "not yet ready", {
                width: G.width,
                height: G.height
              });
              return;
            }
            let M = r || 1;
            a && (M = Math.min(M, a / J));
            const q = C * M, k = z * M, m = yield createImageBitmap(G, {
              resizeWidth: q,
              resizeHeight: k
            }), X = Math.max(U, f) / J, L = C * X, E = z * X, T = (U - L) / 2, Y = (f - E) / 2;
            this.debug(G, "created image bitmap", {
              actualWidth: C,
              actualHeight: z,
              boxWidth: U,
              boxHeight: f,
              outputWidth: L,
              outputHeight: E,
              resizeWidth: q,
              resizeHeight: k,
              scale: M,
              outputScale: X,
              offsetX: T,
              offsetY: Y
            }), this.worker.postMessage(
              {
                id: w,
                bitmap: m,
                width: q,
                height: k,
                dx: T,
                dy: Y,
                dw: L,
                dh: E,
                dataURLOptions: o.dataURLOptions,
                logDebug: !!this.logger
              },
              [m]
            ), this.debug(G, "send message");
          } catch (U) {
            this.debug(G, "failed to snapshot", U);
          } finally {
            this.snapshotInProgressMap.set(w, !1);
          }
        }))
      ), yield Promise.all(y).catch(console.error), p = requestAnimationFrame(W);
    });
    p = requestAnimationFrame(W), this.resetObservers = () => {
      c(), p && cancelAnimationFrame(p);
    };
  }
  initCanvasMutationObserver(t, i, n) {
    this.startRAFTimestamping(), this.startPendingCanvasMutationFlusher();
    const s = fn(
      t,
      i,
      n,
      !1
    ), l = pa(
      this.processMutation.bind(this),
      t,
      i,
      n
    ), o = Za(
      this.processMutation.bind(this),
      t,
      i,
      n
    );
    this.resetObservers = () => {
      s(), l(), o();
    };
  }
  startPendingCanvasMutationFlusher() {
    requestAnimationFrame(() => this.flushPendingCanvasMutations());
  }
  startRAFTimestamping() {
    const t = (i) => {
      this.rafStamps.latestId = i, requestAnimationFrame(t);
    };
    requestAnimationFrame(t);
  }
  flushPendingCanvasMutations() {
    this.pendingCanvasMutations.forEach(
      (t, i) => {
        const n = this.mirror.getId(i);
        this.flushPendingCanvasMutationFor(i, n);
      }
    ), requestAnimationFrame(() => this.flushPendingCanvasMutations());
  }
  flushPendingCanvasMutationFor(t, i) {
    if (this.frozen || this.locked)
      return;
    const n = this.pendingCanvasMutations.get(t);
    if (!n || i === -1)
      return;
    const s = n.map((o) => {
      const c = o, { type: r } = c;
      return fe(c, ["type"]);
    }), { type: l } = n[0];
    this.mutationCb({ id: i, type: l, commands: s }), this.pendingCanvasMutations.delete(t);
  }
}
class ga {
  constructor(t) {
    g(this, "trackedLinkElements", /* @__PURE__ */ new WeakSet()), g(this, "mutationCb"), g(this, "adoptedStyleSheetCb"), g(this, "styleMirror", new zo()), this.mutationCb = t.mutationCb, this.adoptedStyleSheetCb = t.adoptedStyleSheetCb;
  }
  attachLinkElement(t, i) {
    "_cssText" in i.attributes && this.mutationCb({
      adds: [],
      removes: [],
      texts: [],
      attributes: [
        {
          id: i.id,
          attributes: i.attributes
        }
      ]
    }), this.trackLinkElement(t);
  }
  trackLinkElement(t) {
    this.trackedLinkElements.has(t) || (this.trackedLinkElements.add(t), this.trackStylesheetInLinkElement(t));
  }
  adoptStyleSheets(t, i) {
    if (t.length === 0)
      return;
    const n = {
      id: i,
      styleIds: []
    }, s = [];
    for (const l of t) {
      let o;
      this.styleMirror.has(l) ? o = this.styleMirror.getId(l) : (o = this.styleMirror.add(l), s.push({
        styleId: o,
        rules: Array.from(l.rules || CSSRule, (r, a) => ({
          rule: is(r, l.href),
          index: a
        }))
      })), n.styleIds.push(o);
    }
    s.length > 0 && (n.styles = s), this.adoptedStyleSheetCb(n);
  }
  reset() {
    this.styleMirror.reset(), this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
  }
  // TODO: take snapshot on stylesheet reload by applying event listener
  trackStylesheetInLinkElement(t) {
  }
}
class Va {
  constructor() {
    g(this, "nodeMap", /* @__PURE__ */ new WeakMap()), g(this, "active", !1);
  }
  inOtherBuffer(t, i) {
    const n = this.nodeMap.get(t);
    return n && Array.from(n).some((s) => s !== i);
  }
  add(t, i) {
    this.active || (this.active = !0, requestAnimationFrame(() => {
      this.nodeMap = /* @__PURE__ */ new WeakMap(), this.active = !1;
    })), this.nodeMap.set(t, (this.nodeMap.get(t) || /* @__PURE__ */ new Set()).add(i));
  }
  destroy() {
  }
}
let j, Yt, rt, Kt = !1;
try {
  if (Array.from([1], (e) => e * 2)[0] !== 2) {
    const e = document.createElement("iframe");
    document.body.appendChild(e), Array.from = ((ln = e.contentWindow) == null ? void 0 : ln.Array.from) || Array.from, document.body.removeChild(e);
  }
} catch (e) {
  console.debug("Unable to override Array.from", e);
}
const he = jl();
function We(e = {}) {
  var t, i, n, s, l, o, r, a;
  const {
    emit: c,
    checkoutEveryNms: d,
    checkoutEveryNth: u,
    blockClass: p = "highlight-block",
    blockSelector: h = null,
    ignoreClass: Z = "highlight-ignore",
    ignoreSelector: b = null,
    maskTextClass: W = "highlight-mask",
    maskTextSelector: V = null,
    inlineStylesheet: I = !0,
    maskAllInputs: y,
    maskInputOptions: G,
    slimDOMOptions: w,
    maskInputFn: U,
    maskTextFn: f = vi,
    hooks: C,
    packFn: z,
    sampling: J = {},
    mousemoveWait: M,
    recordDOM: q = !0,
    recordCanvas: k = !1,
    recordCrossOriginIframes: m = !1,
    recordAfter: X = e.recordAfter === "DOMContentLoaded" ? e.recordAfter : "load",
    userTriggeredOnInput: L = !1,
    collectFonts: E = !1,
    inlineImages: T = !1,
    plugins: Y,
    keepIframeSrcFn: oe = () => !1,
    privacySetting: ee = "default",
    ignoreCSSAttributes: $e = /* @__PURE__ */ new Set([]),
    errorHandler: As,
    logger: _s
  } = e, bt = R(R({}, e.dataURLOptions), (i = (t = e.sampling) == null ? void 0 : t.canvas) == null ? void 0 : i.dataURLOptions);
  Qo(As);
  const Zt = m ? window.parent === window : !0;
  let et = !1;
  if (!Zt)
    try {
      window.parent.document && (et = !1);
    } catch (B) {
      et = !0;
    }
  if (Zt && !c)
    throw new Error("emit function is required");
  if (!Zt && !et)
    return () => {
    };
  M !== void 0 && J.mousemove === void 0 && (J.mousemove = M), he.reset();
  const jt = y === !0 ? {
    color: !0,
    date: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0,
    textarea: !0,
    select: !0,
    password: !0
  } : G !== void 0 ? G : { password: !0 }, At = w === !0 || w === "all" ? {
    script: !0,
    comment: !0,
    headFavicon: !0,
    headWhitespace: !0,
    headMetaSocial: !0,
    headMetaRobots: !0,
    headMetaHttpEquiv: !0,
    headMetaVerification: !0,
    // the following are off for slimDOMOptions === true,
    // as they destroy some (hidden) info:
    headMetaAuthorship: w === "all",
    headMetaDescKeywords: w === "all",
    headTitleMutations: w === "all"
  } : w || {};
  Mo();
  let Ei, _t = 0;
  const Oi = (B) => {
    for (const ue of Y || [])
      ue.eventProcessor && (B = ue.eventProcessor(B));
    return z && // Disable packing events which will be emitted to parent frames.
    !et && (B = z(B)), B;
  };
  j = (B, ue) => {
    var D;
    const Q = B;
    if (Q.timestamp = vt(), (D = Te[0]) != null && D.isFrozen() && Q.type !== H.FullSnapshot && !(Q.type === H.IncrementalSnapshot && Q.data.source === K.Mutation) && Te.forEach((be) => be.unfreeze()), Zt)
      c == null || c(Oi(Q), ue);
    else if (et) {
      const be = {
        type: "rrweb",
        event: Oi(Q),
        origin: window.location.origin,
        isCheckout: ue
      };
      window.parent.postMessage(be, "*");
    }
    if (Q.type === H.FullSnapshot)
      Ei = Q, _t = 0;
    else if (Q.type === H.IncrementalSnapshot) {
      if (Q.data.source === K.Mutation && Q.data.isAttachIframe)
        return;
      _t++;
      const be = u && _t >= u, P = d && Q.timestamp - Ei.timestamp > d;
      (be || P) && Yt(!0);
    }
  };
  const yt = (B) => {
    j({
      type: H.IncrementalSnapshot,
      data: R({
        source: K.Mutation
      }, B)
    });
  }, Di = (B) => j({
    type: H.IncrementalSnapshot,
    data: R({
      source: K.Scroll
    }, B)
  }), Qi = (B) => j({
    type: H.IncrementalSnapshot,
    data: R({
      source: K.CanvasMutation
    }, B)
  }), qs = (B) => j({
    type: H.IncrementalSnapshot,
    data: R({
      source: K.AdoptedStyleSheet
    }, B)
  }), Je = new ga({
    mutationCb: yt,
    adoptedStyleSheetCb: qs
  }), we = new ca({
    mirror: he,
    mutationCb: yt,
    stylesheetManager: Je,
    recordCrossOriginIframes: m,
    wrappedEmit: j
  });
  for (const B of Y || [])
    B.getMirror && B.getMirror({
      nodeMirror: he,
      crossOriginIframeMirror: we.crossOriginIframeMirror,
      crossOriginIframeStyleMirror: we.crossOriginIframeStyleMirror
    });
  const qt = new Va();
  rt = new Xa({
    recordCanvas: k,
    recordVideos: T,
    mutationCb: Qi,
    win: window,
    blockClass: p,
    blockSelector: h,
    mirror: he,
    sampling: (n = J == null ? void 0 : J.canvas) == null ? void 0 : n.fps,
    samplingManual: (s = J == null ? void 0 : J.canvas) == null ? void 0 : s.fpsManual,
    clearWebGLBuffer: (l = J == null ? void 0 : J.canvas) == null ? void 0 : l.clearWebGLBuffer,
    initialSnapshotDelay: (o = J == null ? void 0 : J.canvas) == null ? void 0 : o.initialSnapshotDelay,
    dataURLOptions: bt,
    resizeFactor: (r = J == null ? void 0 : J.canvas) == null ? void 0 : r.resizeFactor,
    maxSnapshotDimension: (a = J == null ? void 0 : J.canvas) == null ? void 0 : a.maxSnapshotDimension,
    logger: _s
  });
  const Gt = new da({
    mutationCb: yt,
    scrollCb: Di,
    bypassOptions: {
      blockClass: p,
      blockSelector: h,
      maskTextClass: W,
      maskTextSelector: V,
      inlineStylesheet: I,
      maskInputOptions: jt,
      dataURLOptions: bt,
      maskTextFn: f,
      maskInputFn: U,
      recordCanvas: k,
      inlineImages: T,
      privacySetting: ee,
      sampling: J,
      slimDOMOptions: At,
      iframeManager: we,
      stylesheetManager: Je,
      canvasManager: rt,
      keepIframeSrcFn: oe,
      processedNodeManager: qt
    },
    mirror: he
  });
  Yt = (B = !1) => {
    if (!q)
      return;
    j(
      {
        type: H.Meta,
        data: {
          href: window.location.href,
          width: bs(),
          height: ps()
        }
      },
      B
    ), Je.reset(), Gt.init(), Te.forEach((D) => D.lock());
    const ue = So(document, {
      mirror: he,
      blockClass: p,
      blockSelector: h,
      maskTextClass: W,
      maskTextSelector: V,
      inlineStylesheet: I,
      maskAllInputs: jt,
      maskTextFn: f,
      maskInputFn: U,
      slimDOM: At,
      dataURLOptions: bt,
      recordCanvas: k,
      inlineImages: T,
      privacySetting: ee,
      onSerialize: (D) => {
        Gs(D, he) && we.addIframe(D), Xs(D, he) && Je.trackLinkElement(D), Si(D) && Gt.addShadowRoot(x.shadowRoot(D), document);
      },
      onIframeLoad: (D, Q) => {
        we.attachIframe(D, Q), Gt.observeAttachShadow(D);
      },
      onStylesheetLoad: (D, Q) => {
        Je.attachLinkElement(D, Q);
      },
      keepIframeSrcFn: oe
    });
    if (!ue)
      return console.warn("Failed to snapshot the document");
    j(
      {
        type: H.FullSnapshot,
        data: {
          node: ue,
          initialOffset: hs(window)
        }
      },
      B
    ), Te.forEach((D) => D.unlock()), document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0 && Je.adoptStyleSheets(
      document.adoptedStyleSheets,
      he.getId(document)
    );
  };
  try {
    const B = [], ue = (Q) => {
      var be;
      return F(ra)(
        {
          mutationCb: yt,
          mousemoveCb: (P, $t) => j({
            type: H.IncrementalSnapshot,
            data: {
              source: $t,
              positions: P
            }
          }),
          mouseInteractionCb: (P) => j({
            type: H.IncrementalSnapshot,
            data: R({
              source: K.MouseInteraction
            }, P)
          }),
          scrollCb: Di,
          viewportResizeCb: (P) => j({
            type: H.IncrementalSnapshot,
            data: R({
              source: K.ViewportResize
            }, P)
          }),
          inputCb: (P) => j({
            type: H.IncrementalSnapshot,
            data: R({
              source: K.Input
            }, P)
          }),
          mediaInteractionCb: (P) => j({
            type: H.IncrementalSnapshot,
            data: R({
              source: K.MediaInteraction
            }, P)
          }),
          styleSheetRuleCb: (P) => j({
            type: H.IncrementalSnapshot,
            data: R({
              source: K.StyleSheetRule
            }, P)
          }),
          styleDeclarationCb: (P) => j({
            type: H.IncrementalSnapshot,
            data: R({
              source: K.StyleDeclaration
            }, P)
          }),
          canvasMutationCb: Qi,
          fontCb: (P) => j({
            type: H.IncrementalSnapshot,
            data: R({
              source: K.Font
            }, P)
          }),
          selectionCb: (P) => {
            j({
              type: H.IncrementalSnapshot,
              data: R({
                source: K.Selection
              }, P)
            });
          },
          customElementCb: (P) => {
            j({
              type: H.IncrementalSnapshot,
              data: R({
                source: K.CustomElement
              }, P)
            });
          },
          blockClass: p,
          ignoreClass: Z,
          ignoreSelector: b,
          maskTextClass: W,
          maskTextSelector: V,
          maskInputOptions: jt,
          inlineStylesheet: I,
          sampling: J,
          recordDOM: q,
          recordCanvas: k,
          inlineImages: T,
          userTriggeredOnInput: L,
          collectFonts: E,
          doc: Q,
          maskInputFn: U,
          maskTextFn: f,
          keepIframeSrcFn: oe,
          blockSelector: h,
          slimDOMOptions: At,
          dataURLOptions: bt,
          mirror: he,
          iframeManager: we,
          stylesheetManager: Je,
          shadowDomManager: Gt,
          processedNodeManager: qt,
          canvasManager: rt,
          ignoreCSSAttributes: $e,
          privacySetting: ee,
          plugins: ((be = Y == null ? void 0 : Y.filter((P) => P.observer)) == null ? void 0 : be.map((P) => ({
            observer: P.observer,
            options: P.options,
            callback: ($t) => j({
              type: H.Plugin,
              data: {
                plugin: P.name,
                payload: $t
              }
            })
          }))) || []
        },
        C
      );
    };
    we.addLoadListener((Q) => {
      try {
        B.push(ue(Q.contentDocument));
      } catch (be) {
        console.warn(be);
      }
    });
    const D = () => {
      Yt(), B.push(ue(document)), Kt = !0;
    };
    return document.readyState === "interactive" || document.readyState === "complete" ? D() : (B.push(
      se("DOMContentLoaded", () => {
        j({
          type: H.DomContentLoaded,
          data: {}
        }), X === "DOMContentLoaded" && D();
      })
    ), B.push(
      se(
        "load",
        () => {
          j({
            type: H.Load,
            data: {}
          }), X === "load" && D();
        },
        window
      )
    )), () => {
      B.forEach((Q) => Q()), qt.destroy(), Kt = !1, jo();
    };
  } catch (B) {
    console.warn(B);
  }
}
We.addCustomEvent = (e, t) => {
  Kt && j({
    type: H.Custom,
    data: {
      tag: e,
      payload: t
    }
  });
};
We.freezePage = () => {
  Te.forEach((e) => e.freeze());
};
We.takeFullSnapshot = (e) => {
  if (!Kt)
    throw new Error("please take full snapshot after start recording");
  Yt(e);
};
We.snapshotCanvas = (e) => A(void 0, null, function* () {
  if (!rt)
    throw new Error("canvas manager is not initialized");
  yield rt.snapshot(e);
});
We.mirror = he;
var Rn;
(function(e) {
  e[e.NotStarted = 0] = "NotStarted", e[e.Running = 1] = "Running", e[e.Stopped = 2] = "Stopped";
})(Rn || (Rn = {}));
const { addCustomEvent: Cn } = We, Ln = {
  key: "_sid"
}, Wa = "rrweb/sequential-id@1", fa = (e) => {
  const t = e ? Object.assign({}, Ln, e) : Ln;
  let i = 0;
  return {
    name: Wa,
    eventProcessor(n) {
      return Object.assign(n, {
        [t.key]: ++i
      }), n;
    },
    options: t
  };
}, Ia = (e) => {
  e(window.location.href);
  const t = history.pushState;
  history.pushState = /* @__PURE__ */ ((l) => function() {
    var r = l.apply(this, arguments);
    return window.dispatchEvent(new Event("pushstate")), window.dispatchEvent(new Event("locationchange")), r;
  })(history.pushState);
  const i = history.replaceState;
  history.replaceState = /* @__PURE__ */ ((l) => function() {
    var r = l.apply(this, arguments);
    return window.dispatchEvent(new Event("replacestate")), window.dispatchEvent(new Event("locationchange")), r;
  })(history.replaceState);
  const n = () => {
    window.dispatchEvent(new Event("locationchange"));
  };
  window.addEventListener("popstate", n);
  const s = function() {
    e(window.location.href);
  };
  return window.addEventListener("locationchange", s), () => {
    window.removeEventListener("popstate", n), window.removeEventListener("locationchange", s), history.pushState = t, history.replaceState = i;
  };
}, Ui = JSON, Sa = (e) => e.toUpperCase(), Ra = (e) => {
  const t = {};
  return e.forEach((i, n) => {
    t[n] = i;
  }), t;
}, Ca = (e, t, i) => e.document ? e : {
  document: e,
  variables: t,
  requestHeaders: i,
  signal: void 0
}, La = (e, t, i) => e.query ? e : {
  query: e,
  variables: t,
  requestHeaders: i,
  signal: void 0
}, Ya = (e, t) => e.documents ? e : {
  documents: e,
  requestHeaders: t,
  signal: void 0
}, Yn = (e) => {
  var n, s;
  let t;
  const i = e.definitions.filter((l) => l.kind === "OperationDefinition");
  return i.length === 1 && (t = (s = (n = i[0]) == null ? void 0 : n.name) == null ? void 0 : s.value), t;
}, ui = (e) => {
  if (typeof e == "string") {
    let i;
    try {
      const n = qn(e);
      i = Yn(n);
    } catch (n) {
    }
    return { query: e, operationName: i };
  }
  const t = Yn(e);
  return { query: $n(e), operationName: t };
};
class De extends Error {
  constructor(t, i) {
    const n = `${De.extractMessage(t)}: ${JSON.stringify({
      response: t,
      request: i
    })}`;
    super(n), Object.setPrototypeOf(this, De.prototype), this.response = t, this.request = i, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, De);
  }
  static extractMessage(t) {
    var i, n, s;
    return (s = (n = (i = t.errors) == null ? void 0 : i[0]) == null ? void 0 : n.message) != null ? s : `GraphQL Error (Code: ${t.status})`;
  }
}
var Ci = { exports: {} };
(function(e, t) {
  var i = typeof self != "undefined" ? self : cl, n = function() {
    function l() {
      this.fetch = !1, this.DOMException = i.DOMException;
    }
    return l.prototype = i, new l();
  }();
  (function(l) {
    (function(o) {
      var r = {
        searchParams: "URLSearchParams" in l,
        iterable: "Symbol" in l && "iterator" in Symbol,
        blob: "FileReader" in l && "Blob" in l && function() {
          try {
            return new Blob(), !0;
          } catch (m) {
            return !1;
          }
        }(),
        formData: "FormData" in l,
        arrayBuffer: "ArrayBuffer" in l
      };
      function a(m) {
        return m && DataView.prototype.isPrototypeOf(m);
      }
      if (r.arrayBuffer)
        var c = [
          "[object Int8Array]",
          "[object Uint8Array]",
          "[object Uint8ClampedArray]",
          "[object Int16Array]",
          "[object Uint16Array]",
          "[object Int32Array]",
          "[object Uint32Array]",
          "[object Float32Array]",
          "[object Float64Array]"
        ], d = ArrayBuffer.isView || function(m) {
          return m && c.indexOf(Object.prototype.toString.call(m)) > -1;
        };
      function u(m) {
        if (typeof m != "string" && (m = String(m)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(m))
          throw new TypeError("Invalid character in header field name");
        return m.toLowerCase();
      }
      function p(m) {
        return typeof m != "string" && (m = String(m)), m;
      }
      function h(m) {
        var X = {
          next: function() {
            var L = m.shift();
            return { done: L === void 0, value: L };
          }
        };
        return r.iterable && (X[Symbol.iterator] = function() {
          return X;
        }), X;
      }
      function Z(m) {
        this.map = {}, m instanceof Z ? m.forEach(function(X, L) {
          this.append(L, X);
        }, this) : Array.isArray(m) ? m.forEach(function(X) {
          this.append(X[0], X[1]);
        }, this) : m && Object.getOwnPropertyNames(m).forEach(function(X) {
          this.append(X, m[X]);
        }, this);
      }
      Z.prototype.append = function(m, X) {
        m = u(m), X = p(X);
        var L = this.map[m];
        this.map[m] = L ? L + ", " + X : X;
      }, Z.prototype.delete = function(m) {
        delete this.map[u(m)];
      }, Z.prototype.get = function(m) {
        return m = u(m), this.has(m) ? this.map[m] : null;
      }, Z.prototype.has = function(m) {
        return this.map.hasOwnProperty(u(m));
      }, Z.prototype.set = function(m, X) {
        this.map[u(m)] = p(X);
      }, Z.prototype.forEach = function(m, X) {
        for (var L in this.map)
          this.map.hasOwnProperty(L) && m.call(X, this.map[L], L, this);
      }, Z.prototype.keys = function() {
        var m = [];
        return this.forEach(function(X, L) {
          m.push(L);
        }), h(m);
      }, Z.prototype.values = function() {
        var m = [];
        return this.forEach(function(X) {
          m.push(X);
        }), h(m);
      }, Z.prototype.entries = function() {
        var m = [];
        return this.forEach(function(X, L) {
          m.push([L, X]);
        }), h(m);
      }, r.iterable && (Z.prototype[Symbol.iterator] = Z.prototype.entries);
      function b(m) {
        if (m.bodyUsed)
          return Promise.reject(new TypeError("Already read"));
        m.bodyUsed = !0;
      }
      function W(m) {
        return new Promise(function(X, L) {
          m.onload = function() {
            X(m.result);
          }, m.onerror = function() {
            L(m.error);
          };
        });
      }
      function V(m) {
        var X = new FileReader(), L = W(X);
        return X.readAsArrayBuffer(m), L;
      }
      function I(m) {
        var X = new FileReader(), L = W(X);
        return X.readAsText(m), L;
      }
      function y(m) {
        for (var X = new Uint8Array(m), L = new Array(X.length), E = 0; E < X.length; E++)
          L[E] = String.fromCharCode(X[E]);
        return L.join("");
      }
      function G(m) {
        if (m.slice)
          return m.slice(0);
        var X = new Uint8Array(m.byteLength);
        return X.set(new Uint8Array(m)), X.buffer;
      }
      function w() {
        return this.bodyUsed = !1, this._initBody = function(m) {
          this._bodyInit = m, m ? typeof m == "string" ? this._bodyText = m : r.blob && Blob.prototype.isPrototypeOf(m) ? this._bodyBlob = m : r.formData && FormData.prototype.isPrototypeOf(m) ? this._bodyFormData = m : r.searchParams && URLSearchParams.prototype.isPrototypeOf(m) ? this._bodyText = m.toString() : r.arrayBuffer && r.blob && a(m) ? (this._bodyArrayBuffer = G(m.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : r.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(m) || d(m)) ? this._bodyArrayBuffer = G(m) : this._bodyText = m = Object.prototype.toString.call(m) : this._bodyText = "", this.headers.get("content-type") || (typeof m == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : r.searchParams && URLSearchParams.prototype.isPrototypeOf(m) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, r.blob && (this.blob = function() {
          var m = b(this);
          if (m)
            return m;
          if (this._bodyBlob)
            return Promise.resolve(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as blob");
          return Promise.resolve(new Blob([this._bodyText]));
        }, this.arrayBuffer = function() {
          return this._bodyArrayBuffer ? b(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(V);
        }), this.text = function() {
          var m = b(this);
          if (m)
            return m;
          if (this._bodyBlob)
            return I(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(y(this._bodyArrayBuffer));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as text");
          return Promise.resolve(this._bodyText);
        }, r.formData && (this.formData = function() {
          return this.text().then(z);
        }), this.json = function() {
          return this.text().then(JSON.parse);
        }, this;
      }
      var U = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      function f(m) {
        var X = m.toUpperCase();
        return U.indexOf(X) > -1 ? X : m;
      }
      function C(m, X) {
        X = X || {};
        var L = X.body;
        if (m instanceof C) {
          if (m.bodyUsed)
            throw new TypeError("Already read");
          this.url = m.url, this.credentials = m.credentials, X.headers || (this.headers = new Z(m.headers)), this.method = m.method, this.mode = m.mode, this.signal = m.signal, !L && m._bodyInit != null && (L = m._bodyInit, m.bodyUsed = !0);
        } else
          this.url = String(m);
        if (this.credentials = X.credentials || this.credentials || "same-origin", (X.headers || !this.headers) && (this.headers = new Z(X.headers)), this.method = f(X.method || this.method || "GET"), this.mode = X.mode || this.mode || null, this.signal = X.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && L)
          throw new TypeError("Body not allowed for GET or HEAD requests");
        this._initBody(L);
      }
      C.prototype.clone = function() {
        return new C(this, { body: this._bodyInit });
      };
      function z(m) {
        var X = new FormData();
        return m.trim().split("&").forEach(function(L) {
          if (L) {
            var E = L.split("="), T = E.shift().replace(/\+/g, " "), Y = E.join("=").replace(/\+/g, " ");
            X.append(decodeURIComponent(T), decodeURIComponent(Y));
          }
        }), X;
      }
      function J(m) {
        var X = new Z(), L = m.replace(/\r?\n[\t ]+/g, " ");
        return L.split(/\r?\n/).forEach(function(E) {
          var T = E.split(":"), Y = T.shift().trim();
          if (Y) {
            var oe = T.join(":").trim();
            X.append(Y, oe);
          }
        }), X;
      }
      w.call(C.prototype);
      function M(m, X) {
        X || (X = {}), this.type = "default", this.status = X.status === void 0 ? 200 : X.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in X ? X.statusText : "OK", this.headers = new Z(X.headers), this.url = X.url || "", this._initBody(m);
      }
      w.call(M.prototype), M.prototype.clone = function() {
        return new M(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new Z(this.headers),
          url: this.url
        });
      }, M.error = function() {
        var m = new M(null, { status: 0, statusText: "" });
        return m.type = "error", m;
      };
      var q = [301, 302, 303, 307, 308];
      M.redirect = function(m, X) {
        if (q.indexOf(X) === -1)
          throw new RangeError("Invalid status code");
        return new M(null, { status: X, headers: { location: m } });
      }, o.DOMException = l.DOMException;
      try {
        new o.DOMException();
      } catch (m) {
        o.DOMException = function(X, L) {
          this.message = X, this.name = L;
          var E = Error(X);
          this.stack = E.stack;
        }, o.DOMException.prototype = Object.create(Error.prototype), o.DOMException.prototype.constructor = o.DOMException;
      }
      function k(m, X) {
        return new Promise(function(L, E) {
          var T = new C(m, X);
          if (T.signal && T.signal.aborted)
            return E(new o.DOMException("Aborted", "AbortError"));
          var Y = new XMLHttpRequest();
          function oe() {
            Y.abort();
          }
          Y.onload = function() {
            var ee = {
              status: Y.status,
              statusText: Y.statusText,
              headers: J(Y.getAllResponseHeaders() || "")
            };
            ee.url = "responseURL" in Y ? Y.responseURL : ee.headers.get("X-Request-URL");
            var $e = "response" in Y ? Y.response : Y.responseText;
            L(new M($e, ee));
          }, Y.onerror = function() {
            E(new TypeError("Network request failed"));
          }, Y.ontimeout = function() {
            E(new TypeError("Network request failed"));
          }, Y.onabort = function() {
            E(new o.DOMException("Aborted", "AbortError"));
          }, Y.open(T.method, T.url, !0), T.credentials === "include" ? Y.withCredentials = !0 : T.credentials === "omit" && (Y.withCredentials = !1), "responseType" in Y && r.blob && (Y.responseType = "blob"), T.headers.forEach(function(ee, $e) {
            Y.setRequestHeader($e, ee);
          }), T.signal && (T.signal.addEventListener("abort", oe), Y.onreadystatechange = function() {
            Y.readyState === 4 && T.signal.removeEventListener("abort", oe);
          }), Y.send(typeof T._bodyInit == "undefined" ? null : T._bodyInit);
        });
      }
      return k.polyfill = !0, l.fetch || (l.fetch = k, l.Headers = Z, l.Request = C, l.Response = M), o.Headers = Z, o.Request = C, o.Response = M, o.fetch = k, Object.defineProperty(o, "__esModule", { value: !0 }), o;
    })({});
  })(n), n.fetch.ponyfill = !0, delete n.fetch.polyfill;
  var s = n;
  t = s.fetch, t.default = s.fetch, t.fetch = s.fetch, t.Headers = s.Headers, t.Request = s.Request, t.Response = s.Response, e.exports = t;
})(Ci, Ci.exports);
var Ft = Ci.exports;
const Nt = /* @__PURE__ */ rl(Ft), Na = /* @__PURE__ */ Gl({
  __proto__: null,
  default: Nt
}, [Ft]), He = (e) => {
  let t = {};
  return e && (typeof Headers != "undefined" && e instanceof Headers || Na && Ft.Headers && e instanceof Ft.Headers ? t = Ra(e) : Array.isArray(e) ? e.forEach(([i, n]) => {
    i && n !== void 0 && (t[i] = n);
  }) : t = e), t;
}, Nn = (e) => e.replace(/([\s,]|#[^\n\r]+)+/g, " ").trim(), ka = (e) => {
  if (!Array.isArray(e.query)) {
    const n = e, s = [`query=${encodeURIComponent(Nn(n.query))}`];
    return e.variables && s.push(`variables=${encodeURIComponent(n.jsonSerializer.stringify(n.variables))}`), n.operationName && s.push(`operationName=${encodeURIComponent(n.operationName)}`), s.join("&");
  }
  if (typeof e.variables != "undefined" && !Array.isArray(e.variables))
    throw new Error("Cannot create query with given variable type, array expected");
  const t = e, i = e.query.reduce((n, s, l) => (n.push({
    query: Nn(s),
    variables: t.variables ? t.jsonSerializer.stringify(t.variables[l]) : void 0
  }), n), []);
  return `query=${encodeURIComponent(t.jsonSerializer.stringify(i))}`;
}, Ja = (e) => (t) => A(void 0, null, function* () {
  var b;
  const { url: i, query: n, variables: s, operationName: l, fetch: o, fetchOptions: r, middleware: a } = t, c = R({}, t.headers);
  let d = "", u;
  e === "POST" ? (u = Ta(n, s, l, r.jsonSerializer), typeof u == "string" && (c["Content-Type"] = "application/json")) : d = ka({
    query: n,
    variables: s,
    operationName: l,
    jsonSerializer: (b = r.jsonSerializer) != null ? b : Ui
  });
  const p = R({
    method: e,
    headers: c,
    body: u
  }, r);
  let h = i, Z = p;
  if (a) {
    const W = yield Promise.resolve(a(ge(R({}, p), { url: i, operationName: l, variables: s }))), { url: I } = W, y = fe(W, ["url"]);
    h = I, Z = y;
  }
  return d && (h = `${h}?${d}`), yield o(h, Z);
});
class wa {
  constructor(t, i = {}) {
    this.url = t, this.requestConfig = i, this.rawRequest = (...n) => A(this, null, function* () {
      const [s, l, o] = n, r = La(s, l, o), W = this.requestConfig, { headers: a, fetch: c = Nt, method: d = "POST", requestMiddleware: u, responseMiddleware: p } = W, h = fe(W, ["headers", "fetch", "method", "requestMiddleware", "responseMiddleware"]), { url: Z } = this;
      r.signal !== void 0 && (h.signal = r.signal);
      const { operationName: b } = ui(r.query);
      return mi({
        url: Z,
        query: r.query,
        variables: r.variables,
        headers: R(R({}, He(hi(a))), He(r.requestHeaders)),
        operationName: b,
        fetch: c,
        method: d,
        fetchOptions: h,
        middleware: u
      }).then((V) => (p && p(V), V)).catch((V) => {
        throw p && p(V), V;
      });
    });
  }
  request(t, ...i) {
    return A(this, null, function* () {
      const [n, s] = i, l = Ca(t, n, s), b = this.requestConfig, { headers: o, fetch: r = Nt, method: a = "POST", requestMiddleware: c, responseMiddleware: d } = b, u = fe(b, ["headers", "fetch", "method", "requestMiddleware", "responseMiddleware"]), { url: p } = this;
      l.signal !== void 0 && (u.signal = l.signal);
      const { query: h, operationName: Z } = ui(l.document);
      return mi({
        url: p,
        query: h,
        variables: l.variables,
        headers: R(R({}, He(hi(o))), He(l.requestHeaders)),
        operationName: Z,
        fetch: r,
        method: a,
        fetchOptions: u,
        middleware: c
      }).then((W) => (d && d(W), W.data)).catch((W) => {
        throw d && d(W), W;
      });
    });
  }
  // prettier-ignore
  batchRequests(t, i) {
    var c;
    const n = Ya(t, i), a = this.requestConfig, { headers: s } = a, l = fe(a, ["headers"]);
    n.signal !== void 0 && (l.signal = n.signal);
    const o = n.documents.map(({ document: d }) => ui(d).query), r = n.documents.map(({ variables: d }) => d);
    return mi({
      url: this.url,
      query: o,
      // @ts-expect-error TODO reconcile batch variables into system.
      variables: r,
      headers: R(R({}, He(hi(s))), He(n.requestHeaders)),
      operationName: void 0,
      fetch: (c = this.requestConfig.fetch) != null ? c : Nt,
      method: this.requestConfig.method || "POST",
      fetchOptions: l,
      middleware: this.requestConfig.requestMiddleware
    }).then((d) => (this.requestConfig.responseMiddleware && this.requestConfig.responseMiddleware(d), d.data)).catch((d) => {
      throw this.requestConfig.responseMiddleware && this.requestConfig.responseMiddleware(d), d;
    });
  }
  setHeaders(t) {
    return this.requestConfig.headers = t, this;
  }
  /**
   * Attach a header to the client. All subsequent requests will have this header.
   */
  setHeader(t, i) {
    const { headers: n } = this.requestConfig;
    return n ? n[t] = i : this.requestConfig.headers = { [t]: i }, this;
  }
  /**
   * Change the client endpoint. All subsequent requests will send to this endpoint.
   */
  setEndpoint(t) {
    return this.url = t, this;
  }
}
const mi = (e) => A(void 0, null, function* () {
  var d, u;
  const { query: t, variables: i, fetchOptions: n } = e, s = Ja(Sa((d = e.method) != null ? d : "post")), l = Array.isArray(e.query), o = yield s(e), r = yield va(o, (u = n.jsonSerializer) != null ? u : Ui), a = Array.isArray(r) ? !r.some(({ data: h }) => !h) : !!r.data, c = Array.isArray(r) || !r.errors || Array.isArray(r.errors) && !r.errors.length || n.errorPolicy === "all" || n.errorPolicy === "ignore";
  if (o.ok && c && a) {
    const p = (Array.isArray(r), r), { errors: h } = p, Z = fe(p, ["errors"]), b = n.errorPolicy === "ignore" ? Z : r;
    return ge(R({}, l ? { data: b } : b), {
      headers: o.headers,
      status: o.status
    });
  } else {
    const h = typeof r == "string" ? {
      error: r
    } : r;
    throw new De(
      // @ts-expect-error TODO
      ge(R({}, h), { status: o.status, headers: o.headers }),
      { query: t, variables: i }
    );
  }
}), Ta = (e, t, i, n) => {
  const s = n != null ? n : Ui;
  if (!Array.isArray(e))
    return s.stringify({ query: e, variables: t, operationName: i });
  if (typeof t != "undefined" && !Array.isArray(t))
    throw new Error("Cannot create request body with given variable type, array expected");
  const l = e.reduce((o, r, a) => (o.push({ query: r, variables: t ? t[a] : void 0 }), o), []);
  return s.stringify(l);
}, va = (e, t) => A(void 0, null, function* () {
  let i;
  return e.headers.forEach((n, s) => {
    s.toLowerCase() === "content-type" && (i = n);
  }), i && (i.toLowerCase().startsWith("application/json") || i.toLowerCase().startsWith("application/graphql+json") || i.toLowerCase().startsWith("application/graphql-response+json")) ? t.parse(yield e.text()) : e.text();
}), hi = (e) => typeof e == "function" ? e() : e;
var Ut = function() {
  return Ut = Object.assign || function(t) {
    for (var i, n = 1, s = arguments.length; n < s; n++) {
      i = arguments[n];
      for (var l in i)
        Object.prototype.hasOwnProperty.call(i, l) && (t[l] = i[l]);
    }
    return t;
  }, Ut.apply(this, arguments);
}, kt = /* @__PURE__ */ new Map(), Li = /* @__PURE__ */ new Map(), Ns = !0, Ht = !1;
function ks(e) {
  return e.replace(/[\s,]+/g, " ").trim();
}
function xa(e) {
  return ks(e.source.body.substring(e.start, e.end));
}
function Ka(e) {
  var t = /* @__PURE__ */ new Set(), i = [];
  return e.definitions.forEach(function(n) {
    if (n.kind === "FragmentDefinition") {
      var s = n.name.value, l = xa(n.loc), o = Li.get(s);
      o && !o.has(l) ? Ns && console.warn("Warning: fragment with name " + s + ` already exists.
graphql-tag enforces all fragment names across your application to be unique; read more about
this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names`) : o || Li.set(s, o = /* @__PURE__ */ new Set()), o.add(l), t.has(l) || (t.add(l), i.push(n));
    } else
      i.push(n);
  }), Ut(Ut({}, e), { definitions: i });
}
function Fa(e) {
  var t = new Set(e.definitions);
  t.forEach(function(n) {
    n.loc && delete n.loc, Object.keys(n).forEach(function(s) {
      var l = n[s];
      l && typeof l == "object" && t.add(l);
    });
  });
  var i = e.loc;
  return i && (delete i.startToken, delete i.endToken), e;
}
function Ua(e) {
  var t = ks(e);
  if (!kt.has(t)) {
    var i = qn(e, {
      experimentalFragmentVariables: Ht,
      allowLegacyFragmentVariables: Ht
    });
    if (!i || i.kind !== "Document")
      throw new Error("Not a valid GraphQL document.");
    kt.set(t, Fa(Ka(i)));
  }
  return kt.get(t);
}
function Ae(e) {
  for (var t = [], i = 1; i < arguments.length; i++)
    t[i - 1] = arguments[i];
  typeof e == "string" && (e = [e]);
  var n = e[0];
  return t.forEach(function(s, l) {
    s && s.kind === "Document" ? n += s.loc.source.body : n += s, n += e[l + 1];
  }), Ua(n);
}
function Ha() {
  kt.clear(), Li.clear();
}
function Ma() {
  Ns = !1;
}
function za() {
  Ht = !0;
}
function Ba() {
  Ht = !1;
}
var it = {
  gql: Ae,
  resetCaches: Ha,
  disableFragmentWarnings: Ma,
  enableExperimentalFragmentVariables: za,
  disableExperimentalFragmentVariables: Ba
};
(function(e) {
  e.gql = it.gql, e.resetCaches = it.resetCaches, e.disableFragmentWarnings = it.disableFragmentWarnings, e.enableExperimentalFragmentVariables = it.enableExperimentalFragmentVariables, e.disableExperimentalFragmentVariables = it.disableExperimentalFragmentVariables;
})(Ae || (Ae = {}));
Ae.default = Ae;
const ke = Ae;
var kn;
(function(e) {
  e.BillingQuotaExceeded = "BillingQuotaExceeded";
})(kn || (kn = {}));
const Js = ke`
	mutation PushPayload(
		$session_secure_id: String!
		$payload_id: ID!
		$events: ReplayEventsInput!
		$messages: String!
		$resources: String!
		$web_socket_events: String!
		$errors: [ErrorObjectInput]!
		$is_beacon: Boolean
		$has_session_unloaded: Boolean
		$highlight_logs: String
	) {
		pushPayload(
			session_secure_id: $session_secure_id
			payload_id: $payload_id
			events: $events
			messages: $messages
			resources: $resources
			web_socket_events: $web_socket_events
			errors: $errors
			is_beacon: $is_beacon
			has_session_unloaded: $has_session_unloaded
			highlight_logs: $highlight_logs
		)
	}
`, Pa = ke`
	mutation PushPayloadCompressed(
		$session_secure_id: String!
		$payload_id: ID!
		$data: String!
	) {
		pushPayloadCompressed(
			session_secure_id: $session_secure_id
			payload_id: $payload_id
			data: $data
		)
	}
`, Ea = ke`
	mutation identifySession(
		$session_secure_id: String!
		$user_identifier: String!
		$user_object: Any
	) {
		identifySession(
			session_secure_id: $session_secure_id
			user_identifier: $user_identifier
			user_object: $user_object
		)
	}
`, Oa = ke`
	mutation addSessionProperties(
		$session_secure_id: String!
		$properties_object: Any
	) {
		addSessionProperties(
			session_secure_id: $session_secure_id
			properties_object: $properties_object
		)
	}
`, Da = ke`
	mutation pushMetrics($metrics: [MetricInput]!) {
		pushMetrics(metrics: $metrics)
	}
`, Qa = ke`
	mutation addSessionFeedback(
		$session_secure_id: String!
		$user_name: String
		$user_email: String
		$verbatim: String!
		$timestamp: Timestamp!
	) {
		addSessionFeedback(
			session_secure_id: $session_secure_id
			user_name: $user_name
			user_email: $user_email
			verbatim: $verbatim
			timestamp: $timestamp
		)
	}
`, ja = ke`
	mutation initializeSession(
		$session_secure_id: String!
		$organization_verbose_id: String!
		$enable_strict_privacy: Boolean!
		$privacy_setting: String!
		$enable_recording_network_contents: Boolean!
		$clientVersion: String!
		$firstloadVersion: String!
		$clientConfig: String!
		$environment: String!
		$id: String!
		$appVersion: String
		$serviceName: String!
		$client_id: String!
		$network_recording_domains: [String!]
		$disable_session_recording: Boolean
	) {
		initializeSession(
			session_secure_id: $session_secure_id
			organization_verbose_id: $organization_verbose_id
			enable_strict_privacy: $enable_strict_privacy
			enable_recording_network_contents: $enable_recording_network_contents
			clientVersion: $clientVersion
			firstloadVersion: $firstloadVersion
			clientConfig: $clientConfig
			environment: $environment
			appVersion: $appVersion
			serviceName: $serviceName
			fingerprint: $id
			client_id: $client_id
			network_recording_domains: $network_recording_domains
			disable_session_recording: $disable_session_recording
			privacy_setting: $privacy_setting
		) {
			secure_id
			project_id
		}
	}
`, Aa = ke`
	query Ignore($id: ID!) {
		ignore(id: $id)
	}
`, _a = (e, t, i, n) => e();
function qa(e, t = _a) {
  return {
    PushPayload(i, n) {
      return t((s) => e.request(Js, i, R(R({}, n), s)), "PushPayload", "mutation", i);
    },
    PushPayloadCompressed(i, n) {
      return t((s) => e.request(Pa, i, R(R({}, n), s)), "PushPayloadCompressed", "mutation", i);
    },
    identifySession(i, n) {
      return t((s) => e.request(Ea, i, R(R({}, n), s)), "identifySession", "mutation", i);
    },
    addSessionProperties(i, n) {
      return t((s) => e.request(Oa, i, R(R({}, n), s)), "addSessionProperties", "mutation", i);
    },
    pushMetrics(i, n) {
      return t((s) => e.request(Da, i, R(R({}, n), s)), "pushMetrics", "mutation", i);
    },
    addSessionFeedback(i, n) {
      return t((s) => e.request(Qa, i, R(R({}, n), s)), "addSessionFeedback", "mutation", i);
    },
    initializeSession(i, n) {
      return t((s) => e.request(ja, i, R(R({}, n), s)), "initializeSession", "mutation", i);
    },
    Ignore(i, n) {
      return t((s) => e.request(Aa, i, R(R({}, n), s)), "Ignore", "query", i);
    }
  };
}
const $a = (e) => {
  switch (e) {
    case "strict":
      return [!0, void 0];
    case "default":
      return [!0, void 0];
    case "none":
      return [!1, { password: !0 }];
  }
}, er = (e) => {
  let t;
  const n = () => {
    clearTimeout(t), t = setTimeout(() => {
      e({
        height: window.innerHeight,
        width: window.innerWidth,
        availHeight: window.screen.availHeight,
        availWidth: window.screen.availWidth,
        colorDepth: window.screen.colorDepth,
        pixelDepth: window.screen.pixelDepth,
        orientation: window.screen.orientation.angle
      });
    }, 500);
  };
  return window.addEventListener("resize", n), n(), () => window.removeEventListener("resize", n);
};
var Ce;
(function(e) {
  e.USER_ID = "ajs_user_id", e.USER_TRAITS = "ajs_user_traits", e.ANONYMOUS_ID = "ajs_anonymous_id";
})(Ce || (Ce = {}));
const tr = (e) => {
  e(window.location.href);
  var t = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function(l) {
    setTimeout(() => {
      var r;
      var o;
      try {
        o = JSON.parse((r = l == null ? void 0 : l.toString()) != null ? r : "");
      } catch (a) {
        return;
      }
      (o.type === "track" || o.type === "identify") && pi(o) && e(o);
    }, 100), t.call(this, l);
  };
  const i = (l) => {
    if (l.key === Ce.USER_ID || l.key === Ce.ANONYMOUS_ID || l.key === Ce.USER_TRAITS) {
      const { userId: o, userTraits: r } = Jn();
      if (o) {
        let a = {};
        r && (a = JSON.parse(r));
        const c = {
          type: "identify",
          userId: o.toString(),
          traits: a
        };
        pi(c) && e(c);
      }
    }
  }, { userId: n, userTraits: s } = Jn();
  if (n) {
    let l = {};
    s && (l = JSON.parse(s));
    const o = {
      type: "identify",
      userId: n.toString(),
      traits: l
    };
    pi(o) && e(o);
  }
  return window.addEventListener("storage", i), dl(({ keyName: l }) => {
    i({
      key: l
    });
  }), () => {
    window.removeEventListener("storage", i), XMLHttpRequest.prototype.send = t;
  };
}, Jn = () => {
  const e = Xe(Ce.USER_ID), t = Xe(Ce.USER_TRAITS), i = Xe(Ce.ANONYMOUS_ID);
  return {
    userId: e,
    userTraits: t,
    anonymousId: i
  };
}, pi = (e) => {
  if (!e)
    return !1;
  let t = "";
  try {
    t = JSON.stringify(e);
  } catch (s) {
    return !1;
  }
  const i = ir(t), n = Xe(Ve.SEGMENT_LAST_SENT_HASH_KEY);
  return n === void 0 ? (ve(Ve.SEGMENT_LAST_SENT_HASH_KEY, i), !0) : i !== n ? (ve(Ve.SEGMENT_LAST_SENT_HASH_KEY, i), !0) : !1;
}, ir = (e) => {
  var t = 0, i = e.length, n = 0;
  if (i > 0)
    for (; n < i; )
      t = (t << 5) - t + e.charCodeAt(n++) | 0;
  return t.toString();
};
var Le;
(function(e) {
  e[e.All = 0] = "All", e[e.Two = 1] = "Two", e[e.One = 2] = "One";
})(Le || (Le = {}));
let re, Hi;
function ws(e, t) {
  return e.nodeType, Node.ELEMENT_NODE, Yi(e);
  return nr(e, t);
}
function Ts(e) {
  if (e.id.length)
    return `#${e.id}`;
  if (e.classList.length) {
    let t = [];
    for (const i of e.classList)
      t.push(`.${i}`);
    return `${e.nodeName.toLowerCase()}${t.join(",")}`;
  }
  return e.nodeName.toLowerCase();
}
function nr(e, t) {
  if (e.tagName.toLowerCase() === "html")
    return "html";
  try {
    const i = {
      root: document.body,
      idName: (s) => !0,
      className: (s) => !0,
      tagName: (s) => !0,
      attr: (s, l) => !1,
      seedMinLength: 1,
      optimizedMinLength: 2,
      threshold: 50,
      maxNumberOfTries: 1e3,
      optimized: !0
    };
    re = R(R({}, i), t), Hi = sr(re.root, i);
    let n = bi(e, Le.All, () => bi(e, Le.Two, () => bi(e, Le.One)));
    if (n) {
      if (re.optimized) {
        const s = Ks(Fs(n, e));
        s.length > 0 && (n = s[0]);
      }
      return Ot(n);
    } else
      return Yi(e);
  } catch (i) {
    return Yi(e);
  }
}
function sr(e, t) {
  return e.nodeType === Node.DOCUMENT_NODE ? e : e === t.root ? e.ownerDocument : e;
}
function bi(e, t, i) {
  let n = null, s = [], l = e, o = 0;
  for (; l && l !== re.root.parentElement; ) {
    let r = St(lr(l)) || St(...or(l)) || St(...ar(l)) || St(rr(l)) || [cr()];
    const a = dr(l);
    if (t === Le.All)
      a && (r = r.concat(r.filter(yi).map((c) => Zi(c, a))));
    else if (t === Le.Two)
      r = r.slice(0, 1), a && (r = r.concat(r.filter(yi).map((c) => Zi(c, a))));
    else if (t === Le.One) {
      const [c] = r = r.slice(0, 1);
      a && yi(c) && (r = [Zi(c, a)]);
    }
    for (let c of r)
      c.level = o;
    if (s.push(r), s.length >= re.seedMinLength && (n = wn(s, i), n))
      break;
    l = l.parentElement, o++;
  }
  return n || (n = wn(s, i)), n;
}
function wn(e, t) {
  const i = Ks(xs(e));
  if (i.length > re.threshold)
    return t ? t() : null;
  for (let n of i)
    if (vs(n))
      return n;
  return null;
}
function Ot(e) {
  let t = e[0], i = t.name;
  for (let n = 1; n < e.length; n++) {
    const s = e[n].level || 0;
    t.level === s - 1 ? i = `${e[n].name} > ${i}` : i = `${e[n].name} ${i}`, t = e[n];
  }
  return i;
}
function Tn(e) {
  return e.map((t) => t.penalty).reduce((t, i) => t + i, 0);
}
function vs(e) {
  switch (Hi.querySelectorAll(Ot(e)).length) {
    case 0:
      return !0;
    case 1:
      return !0;
    default:
      return !1;
  }
}
function lr(e) {
  const t = e.getAttribute("id");
  return t && re.idName(t) ? {
    name: "#" + Mt(t, { isIdentifier: !0 }),
    penalty: 0
  } : null;
}
function or(e) {
  return Array.from(e.attributes).filter((i) => re.attr(i.name, i.value)).map((i) => ({
    name: "[" + Mt(i.name, { isIdentifier: !0 }) + '="' + Mt(i.value) + '"]',
    penalty: 0.5
  }));
}
function ar(e) {
  return Array.from(e.classList).filter(re.className).map((i) => ({
    name: "." + Mt(i, { isIdentifier: !0 }),
    penalty: 1
  }));
}
function rr(e) {
  const t = e.tagName.toLowerCase();
  return re.tagName(t) ? {
    name: t,
    penalty: 2
  } : null;
}
function cr() {
  return {
    name: "*",
    penalty: 3
  };
}
function dr(e) {
  const t = e.parentNode;
  if (!t)
    return null;
  let i = t.firstChild;
  if (!i)
    return null;
  let n = 0;
  for (; i && (i.nodeType === Node.ELEMENT_NODE && n++, i !== e); )
    i = i.nextSibling;
  return n;
}
function Zi(e, t) {
  return {
    name: e.name + `:nth-child(${t})`,
    penalty: e.penalty + 1
  };
}
function yi(e) {
  return e.name !== "html" && !e.name.startsWith("#");
}
function St(...e) {
  const t = e.filter(ur);
  return t.length > 0 ? t : null;
}
function ur(e) {
  return e != null;
}
function* xs(e, t = []) {
  if (e.length > 0)
    for (let i of e[0])
      yield* ii(xs(e.slice(1, e.length), t.concat(i)));
  else
    yield t;
}
function Ks(e) {
  return Array.from(e).sort((t, i) => Tn(t) - Tn(i));
}
function* Fs(e, t, i = {
  counter: 0,
  visited: /* @__PURE__ */ new Map()
}) {
  if (e.length > 2 && e.length > re.optimizedMinLength)
    for (let n = 1; n < e.length - 1; n++) {
      if (i.counter > re.maxNumberOfTries)
        return;
      i.counter += 1;
      const s = [...e];
      s.splice(n, 1);
      const l = Ot(s);
      if (i.visited.has(l))
        return;
      vs(s) && mr(s, t) && (yield s, i.visited.set(l, !0), yield* ii(Fs(s, t, i)));
    }
}
function mr(e, t) {
  return Hi.querySelector(Ot(e)) === t;
}
const hr = /[ -,\.\/:-@\[-\^`\{-~]/, pr = /[ -,\.\/:-@\[\]\^`\{-~]/, br = /(^|\\+)?(\\[A-F0-9]{1,6})\x20(?![a-fA-F0-9\x20])/g, Zr = {
  escapeEverything: !1,
  isIdentifier: !1,
  quotes: "single",
  wrap: !1
};
function Mt(e, t = {}) {
  const i = R(R({}, Zr), t);
  i.quotes != "single" && i.quotes != "double" && (i.quotes = "single");
  const n = i.quotes == "double" ? '"' : "'", s = i.isIdentifier, l = e.charAt(0);
  let o = "", r = 0;
  const a = e.length;
  for (; r < a; ) {
    const c = e.charAt(r++);
    let d = c.charCodeAt(0), u;
    if (d < 32 || d > 126) {
      if (d >= 55296 && d <= 56319 && r < a) {
        const p = e.charCodeAt(r++);
        (p & 64512) == 56320 ? d = ((d & 1023) << 10) + (p & 1023) + 65536 : r--;
      }
      u = "\\" + d.toString(16).toUpperCase() + " ";
    } else
      i.escapeEverything ? hr.test(c) ? u = "\\" + c : u = "\\" + d.toString(16).toUpperCase() + " " : /[\t\n\f\r\x0B]/.test(c) ? u = "\\" + d.toString(16).toUpperCase() + " " : c == "\\" || !s && (c == '"' && n == c || c == "'" && n == c) || s && pr.test(c) ? u = "\\" + c : u = c;
    o += u;
  }
  return s && (/^-[-\d]/.test(o) ? o = "\\-" + o.slice(1) : /\d/.test(l) && (o = "\\3" + l + " " + o.slice(1))), o = o.replace(br, function(c, d, u) {
    return d && d.length % 2 ? c : (d || "") + u;
  }), !s && i.wrap ? n + o + n : o;
}
const Yi = (e) => {
  let t = "";
  const i = e.getAttribute("class"), n = e.getAttribute("id");
  return n && (t = t.concat(vn(n, "#"))), i && (t = t.concat(vn(i, "."))), t === "" && (t = t.concat(e.tagName.toLowerCase())), t;
}, vn = (e, t) => `${t}${e.trim().split(" ").join(t)}`, yr = (e) => {
  const t = (i) => {
    if (i.target) {
      const n = i.target, s = ws(n);
      e(s, i);
    }
  };
  return window.addEventListener("click", t), () => window.removeEventListener("click", t);
}, Gr = (e) => {
  const t = (i) => {
    if (i.target) {
      const n = ws(i.target);
      e(n);
    }
  };
  return window.addEventListener("focusin", t), () => window.removeEventListener("focusin", t);
}, Xr = (e, t) => {
  const i = gr(e);
  let n = [];
  const s = !1, l = !0;
  for (let o = 0; o < i.length; o++) {
    let r = i[o].split("+");
    n = [], r.length > 1 && (n = fr(Us, r)), r = r[r.length - 1], r = r === "*" ? "*" : Wr(r), r in ye || (ye[r] = []), ye[r].push({
      mods: n,
      shortcut: i[o],
      key: i[o],
      method: t,
      keyup: s,
      keydown: l,
      scope: "all",
      splitKey: "+"
    });
  }
  Ir(document, "keydown", (o) => {
    Rr(o);
  });
};
let ie = [];
function gr(e) {
  typeof e != "string" && (e = ""), e = e.replace(/\s/g, "");
  const t = e.split(",");
  let i = t.lastIndexOf("");
  for (; i >= 0; )
    t[i - 1] += ",", t.splice(i, 1), i = t.lastIndexOf("");
  return t;
}
const ye = {}, Gi = typeof navigator != "undefined" ? navigator.userAgent.toLowerCase().indexOf("firefox") > 0 : !1, Vr = {
  backspace: 8,
  tab: 9,
  clear: 12,
  enter: 13,
  return: 13,
  esc: 27,
  escape: 27,
  space: 32,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  del: 46,
  delete: 46,
  ins: 45,
  insert: 45,
  home: 36,
  end: 35,
  pageup: 33,
  pagedown: 34,
  capslock: 20,
  num_0: 96,
  num_1: 97,
  num_2: 98,
  num_3: 99,
  num_4: 100,
  num_5: 101,
  num_6: 102,
  num_7: 103,
  num_8: 104,
  num_9: 105,
  num_multiply: 106,
  num_add: 107,
  num_enter: 108,
  num_subtract: 109,
  num_decimal: 110,
  num_divide: 111,
  "⇪": 20,
  ",": 188,
  ".": 190,
  "/": 191,
  "`": 192,
  "-": Gi ? 173 : 189,
  "=": Gi ? 61 : 187,
  ";": Gi ? 59 : 186,
  "'": 222,
  "[": 219,
  "]": 221,
  "\\": 220
}, xn = {
  16: "shiftKey",
  18: "altKey",
  17: "ctrlKey",
  91: "metaKey",
  shiftKey: 16,
  ctrlKey: 17,
  altKey: 18,
  metaKey: 91
}, ne = {
  16: !1,
  18: !1,
  17: !1,
  91: !1
}, Us = {
  // shiftKey
  "⇧": 16,
  shift: 16,
  // altKey
  "⌥": 18,
  alt: 18,
  option: 18,
  // ctrlKey
  "⌃": 17,
  ctrl: 17,
  control: 17,
  // metaKey
  "⌘": 91,
  cmd: 91,
  command: 91
}, Wr = (e) => (
  // @ts-expect-error
  Vr[e.toLowerCase()] || // @ts-expect-error
  Us[e.toLowerCase()] || e.toUpperCase().charCodeAt(0)
);
function fr(e, t) {
  const i = t.slice(0, t.length - 1);
  for (let n = 0; n < i.length; n++)
    i[n] = e[i[n].toLowerCase()];
  return i;
}
function Ir(e, t, i) {
  e.addEventListener ? e.addEventListener(t, i, !1) : e.attachEvent && e.attachEvent(`on${t}`, () => {
    i(window.event);
  });
}
function Sr(e, t, i) {
  let n;
  if (t.scope === i || t.scope === "all") {
    n = t.mods.length > 0;
    for (const s in ne)
      Object.prototype.hasOwnProperty.call(ne, s) && // @ts-expect-error
      (!ne[s] && t.mods.indexOf(+s) > -1 || // @ts-expect-error
      ne[s] && t.mods.indexOf(+s) === -1) && (n = !1);
    (t.mods.length === 0 && !ne[16] && !ne[18] && !ne[17] && !ne[91] || n || t.shortcut === "*") && t.method(e, t) === !1 && (e.preventDefault ? e.preventDefault() : e.returnValue = !1, e.stopPropagation && e.stopPropagation(), e.cancelBubble && (e.cancelBubble = !0));
  }
}
function Rr(e) {
  const t = ye["*"];
  let i = e.keyCode || e.which || e.charCode;
  if ((i === 93 || i === 224) && (i = 91), ie.indexOf(i) === -1 && i !== 229 && ie.push(i), ["ctrlKey", "altKey", "shiftKey", "metaKey"].forEach((n) => {
    const s = xn[n];
    e[n] && ie.indexOf(s) === -1 ? ie.push(s) : !e[n] && ie.indexOf(s) > -1 ? ie.splice(ie.indexOf(s), 1) : n === "metaKey" && e[n] && ie.length === 3 && (e.ctrlKey || e.shiftKey || e.altKey || (ie = ie.slice(ie.indexOf(s))));
  }), !(i in ne && (ne[i] = !0, !t))) {
    for (const n in ne)
      Object.prototype.hasOwnProperty.call(ne, n) && (ne[n] = e[xn[n]]);
    if (e.getModifierState && !(e.altKey && !e.ctrlKey) && e.getModifierState("AltGraph") && (ie.indexOf(17) === -1 && ie.push(17), ie.indexOf(18) === -1 && ie.push(18), ne[17] = !0, ne[18] = !0), i in ye) {
      for (let n = 0; n < ye[i].length; n++)
        if (
          // @ts-expect-error
          (e.type === "keydown" && ye[i][n].keydown || // @ts-expect-error
          e.type === "keyup" && ye[i][n].keyup) && ye[i][n].key
        ) {
          const s = ye[i][n];
          Sr(e, s, "all");
        }
    }
  }
}
var Re, ct, Hs, zt, Ni, Ms = -1, xe = function(e) {
  addEventListener("pageshow", function(t) {
    t.persisted && (Ms = t.timeStamp, e(t));
  }, !0);
}, Mi = function() {
  return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
}, Dt = function() {
  var e = Mi();
  return e && e.activationStart || 0;
}, ce = function(e, t) {
  var i = Mi(), n = "navigate";
  return Ms >= 0 ? n = "back-forward-cache" : i && (document.prerendering || Dt() > 0 ? n = "prerender" : document.wasDiscarded ? n = "restore" : i.type && (n = i.type.replace(/_/g, "-"))), { name: e, value: t === void 0 ? -1 : t, rating: "good", delta: 0, entries: [], id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12), navigationType: n };
}, qe = function(e, t, i) {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(e)) {
      var n = new PerformanceObserver(function(s) {
        Promise.resolve().then(function() {
          t(s.getEntries());
        });
      });
      return n.observe(Object.assign({ type: e, buffered: !0 }, i || {})), n;
    }
  } catch (s) {
  }
}, de = function(e, t, i, n) {
  var s, l;
  return function(o) {
    t.value >= 0 && (o || n) && ((l = t.value - (s || 0)) || s === void 0) && (s = t.value, t.delta = l, t.rating = function(r, a) {
      return r > a[1] ? "poor" : r > a[0] ? "needs-improvement" : "good";
    }(t.value, i), e(t));
  };
}, zi = function(e) {
  requestAnimationFrame(function() {
    return requestAnimationFrame(function() {
      return e();
    });
  });
}, Qt = function(e) {
  var t = function(i) {
    i.type !== "pagehide" && document.visibilityState !== "hidden" || e(i);
  };
  addEventListener("visibilitychange", t, !0), addEventListener("pagehide", t, !0);
}, Bi = function(e) {
  var t = !1;
  return function(i) {
    t || (e(i), t = !0);
  };
}, Oe = -1, Kn = function() {
  return document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0;
}, Bt = function(e) {
  document.visibilityState === "hidden" && Oe > -1 && (Oe = e.type === "visibilitychange" ? e.timeStamp : 0, Cr());
}, Fn = function() {
  addEventListener("visibilitychange", Bt, !0), addEventListener("prerenderingchange", Bt, !0);
}, Cr = function() {
  removeEventListener("visibilitychange", Bt, !0), removeEventListener("prerenderingchange", Bt, !0);
}, Pi = function() {
  return Oe < 0 && (Oe = Kn(), Fn(), xe(function() {
    setTimeout(function() {
      Oe = Kn(), Fn();
    }, 0);
  })), { get firstHiddenTime() {
    return Oe;
  } };
}, pt = function(e) {
  document.prerendering ? addEventListener("prerenderingchange", function() {
    return e();
  }, !0) : e();
}, Un = [1800, 3e3], zs = function(e, t) {
  t = t || {}, pt(function() {
    var i, n = Pi(), s = ce("FCP"), l = qe("paint", function(o) {
      o.forEach(function(r) {
        r.name === "first-contentful-paint" && (l.disconnect(), r.startTime < n.firstHiddenTime && (s.value = Math.max(r.startTime - Dt(), 0), s.entries.push(r), i(!0)));
      });
    });
    l && (i = de(e, s, Un, t.reportAllChanges), xe(function(o) {
      s = ce("FCP"), i = de(e, s, Un, t.reportAllChanges), zi(function() {
        s.value = performance.now() - o.timeStamp, i(!0);
      });
    }));
  });
}, Hn = [0.1, 0.25], Lr = function(e, t) {
  t = t || {}, zs(Bi(function() {
    var i, n = ce("CLS", 0), s = 0, l = [], o = function(a) {
      a.forEach(function(c) {
        if (!c.hadRecentInput) {
          var d = l[0], u = l[l.length - 1];
          s && c.startTime - u.startTime < 1e3 && c.startTime - d.startTime < 5e3 ? (s += c.value, l.push(c)) : (s = c.value, l = [c]);
        }
      }), s > n.value && (n.value = s, n.entries = l, i());
    }, r = qe("layout-shift", o);
    r && (i = de(e, n, Hn, t.reportAllChanges), Qt(function() {
      o(r.takeRecords()), i(!0);
    }), xe(function() {
      s = 0, n = ce("CLS", 0), i = de(e, n, Hn, t.reportAllChanges), zi(function() {
        return i();
      });
    }), setTimeout(i, 0));
  }));
}, st = { passive: !0, capture: !0 }, Yr = /* @__PURE__ */ new Date(), Mn = function(e, t) {
  Re || (Re = t, ct = e, Hs = /* @__PURE__ */ new Date(), Ps(removeEventListener), Bs());
}, Bs = function() {
  if (ct >= 0 && ct < Hs - Yr) {
    var e = { entryType: "first-input", name: Re.type, target: Re.target, cancelable: Re.cancelable, startTime: Re.timeStamp, processingStart: Re.timeStamp + ct };
    zt.forEach(function(t) {
      t(e);
    }), zt = [];
  }
}, Nr = function(e) {
  if (e.cancelable) {
    var t = (e.timeStamp > 1e12 ? /* @__PURE__ */ new Date() : performance.now()) - e.timeStamp;
    e.type == "pointerdown" ? function(i, n) {
      var s = function() {
        Mn(i, n), o();
      }, l = function() {
        o();
      }, o = function() {
        removeEventListener("pointerup", s, st), removeEventListener("pointercancel", l, st);
      };
      addEventListener("pointerup", s, st), addEventListener("pointercancel", l, st);
    }(t, e) : Mn(t, e);
  }
}, Ps = function(e) {
  ["mousedown", "keydown", "touchstart", "pointerdown"].forEach(function(t) {
    return e(t, Nr, st);
  });
}, zn = [100, 300], kr = function(e, t) {
  t = t || {}, pt(function() {
    var i, n = Pi(), s = ce("FID"), l = function(a) {
      a.startTime < n.firstHiddenTime && (s.value = a.processingStart - a.startTime, s.entries.push(a), i(!0));
    }, o = function(a) {
      a.forEach(l);
    }, r = qe("first-input", o);
    i = de(e, s, zn, t.reportAllChanges), r && Qt(Bi(function() {
      o(r.takeRecords()), r.disconnect();
    })), r && xe(function() {
      var a;
      s = ce("FID"), i = de(e, s, zn, t.reportAllChanges), zt = [], ct = -1, Re = null, Ps(addEventListener), a = l, zt.push(a), Bs();
    });
  });
}, Es = 0, Xi = 1 / 0, Rt = 0, Jr = function(e) {
  e.forEach(function(t) {
    t.interactionId && (Xi = Math.min(Xi, t.interactionId), Rt = Math.max(Rt, t.interactionId), Es = Rt ? (Rt - Xi) / 7 + 1 : 0);
  });
}, Os = function() {
  return Ni ? Es : performance.interactionCount || 0;
}, wr = function() {
  "interactionCount" in performance || Ni || (Ni = qe("event", Jr, { type: "event", buffered: !0, durationThreshold: 0 }));
}, Bn = [200, 500], Ds = 0, Pn = function() {
  return Os() - Ds;
}, Ge = [], gi = {}, En = function(e) {
  var t = Ge[Ge.length - 1], i = gi[e.interactionId];
  if (i || Ge.length < 10 || e.duration > t.latency) {
    if (i)
      i.entries.push(e), i.latency = Math.max(i.latency, e.duration);
    else {
      var n = { id: e.interactionId, latency: e.duration, entries: [e] };
      gi[n.id] = n, Ge.push(n);
    }
    Ge.sort(function(s, l) {
      return l.latency - s.latency;
    }), Ge.splice(10).forEach(function(s) {
      delete gi[s.id];
    });
  }
}, Tr = function(e, t) {
  t = t || {}, pt(function() {
    var i;
    wr();
    var n, s = ce("INP"), l = function(r) {
      r.forEach(function(d) {
        d.interactionId && En(d), d.entryType === "first-input" && !Ge.some(function(u) {
          return u.entries.some(function(p) {
            return d.duration === p.duration && d.startTime === p.startTime;
          });
        }) && En(d);
      });
      var a, c = (a = Math.min(Ge.length - 1, Math.floor(Pn() / 50)), Ge[a]);
      c && c.latency !== s.value && (s.value = c.latency, s.entries = c.entries, n());
    }, o = qe("event", l, { durationThreshold: (i = t.durationThreshold) !== null && i !== void 0 ? i : 40 });
    n = de(e, s, Bn, t.reportAllChanges), o && ("interactionId" in PerformanceEventTiming.prototype && o.observe({ type: "first-input", buffered: !0 }), Qt(function() {
      l(o.takeRecords()), s.value < 0 && Pn() > 0 && (s.value = 0, s.entries = []), n(!0);
    }), xe(function() {
      Ge = [], Ds = Os(), s = ce("INP"), n = de(e, s, Bn, t.reportAllChanges);
    }));
  });
}, On = [2500, 4e3], Vi = {}, vr = function(e, t) {
  t = t || {}, pt(function() {
    var i, n = Pi(), s = ce("LCP"), l = function(a) {
      var c = a[a.length - 1];
      c && c.startTime < n.firstHiddenTime && (s.value = Math.max(c.startTime - Dt(), 0), s.entries = [c], i());
    }, o = qe("largest-contentful-paint", l);
    if (o) {
      i = de(e, s, On, t.reportAllChanges);
      var r = Bi(function() {
        Vi[s.id] || (l(o.takeRecords()), o.disconnect(), Vi[s.id] = !0, i(!0));
      });
      ["keydown", "click"].forEach(function(a) {
        addEventListener(a, function() {
          return setTimeout(r, 0);
        }, !0);
      }), Qt(r), xe(function(a) {
        s = ce("LCP"), i = de(e, s, On, t.reportAllChanges), zi(function() {
          s.value = performance.now() - a.timeStamp, Vi[s.id] = !0, i(!0);
        });
      });
    }
  });
}, Dn = [800, 1800], xr = function e(t) {
  document.prerendering ? pt(function() {
    return e(t);
  }) : document.readyState !== "complete" ? addEventListener("load", function() {
    return e(t);
  }, !0) : setTimeout(t, 0);
}, Kr = function(e, t) {
  t = t || {};
  var i = ce("TTFB"), n = de(e, i, Dn, t.reportAllChanges);
  xr(function() {
    var s = Mi();
    if (s) {
      var l = s.responseStart;
      if (l <= 0 || l > performance.now())
        return;
      i.value = Math.max(l - Dt(), 0), i.entries = [s], n(!0), xe(function() {
        i = ce("TTFB", 0), (n = de(e, i, Dn, t.reportAllChanges))(!0);
      });
    }
  });
};
const Fr = (e) => (Lr(e), zs(e), kr(e), vr(e), Kr(e), Tr(e), () => {
}), Ur = () => {
  if (!("performance" in window && "memory" in performance))
    return {
      getDeviceDetails: void 0,
      getCurrentDeviceDetails: void 0
    };
  const e = window.performance;
  return {
    getDeviceDetails: () => ({
      deviceMemory: Hr(navigator.deviceMemory || 0)
    }),
    getCurrentDeviceDetails: () => {
      const n = Wi(e.memory.jsHeapSizeLimit), s = Wi(e.memory.totalJSHeapSize), l = Wi(e.memory.usedJSHeapSize);
      return {
        jsHeapSizeLimit: n,
        totalJSHeapSize: s,
        usedJSHeapSize: l
      };
    }
  };
}, Wi = (e) => e / Math.pow(1e3, 2), Hr = (e) => 1024 * e, Mr = typeof window != "undefined", Qn = Mr && "performance" in window && "memory" in performance ? performance : { memory: {} }, zr = (e, t) => {
  let i = 0, n = 0;
  const s = () => {
    const d = ((/* @__PURE__ */ new Date()).getTime() - t) / 1e3, u = Qn.memory.jsHeapSizeLimit || 0, p = Qn.memory.usedJSHeapSize || 0;
    e({
      jsHeapSizeLimit: u,
      usedJSHeapSize: p,
      relativeTimestamp: d,
      fps: i
    });
  };
  s();
  let l;
  l = setInterval(() => {
    s();
  }, 1e3 * 5);
  let o = 0, r = Date.now();
  const a = function() {
    var c = Date.now();
    o++, c > 1e3 + r && (i = Math.round(o * 1e3 / (c - r)), o = 0, r = c), n = requestAnimationFrame(a);
  };
  return a(), () => {
    clearInterval(l), cancelAnimationFrame(n);
  };
}, Br = (e) => {
  let t, i;
  if (typeof document.hidden != "undefined" ? (t = "hidden", i = "visibilitychange") : typeof document.msHidden != "undefined" ? (t = "msHidden", i = "msvisibilitychange") : typeof document.webkitHidden != "undefined" && (t = "webkitHidden", i = "webkitvisibilitychange"), i === void 0)
    return () => {
    };
  if (t === void 0)
    return () => {
    };
  const n = t, s = () => {
    const o = document[n];
    e(!!o);
  };
  document.addEventListener(i, s);
  const l = i;
  return () => document.removeEventListener(l, s);
}, mt = "highlightLogs", Pr = (e) => {
  let t = Xe(mt) || "";
  t = t + "[" + (/* @__PURE__ */ new Date()).getTime() + "] " + e + `
`, ve(mt, t);
}, Er = () => Xe(mt) || "", Or = (e) => {
  if (!e)
    return;
  let t = Xe(mt) || "";
  t && (t.startsWith(e) ? (t = t.slice(e.length), ve(mt, t)) : Pr("Unable to clear logs " + e.replace(`
`, " ") + " from " + t.replace(`
`, " ")));
}, Qs = "dmFyIFZyPU9iamVjdC5kZWZpbmVQcm9wZXJ0eSxqcj1PYmplY3QuZGVmaW5lUHJvcGVydGllczt2YXIgcXI9T2JqZWN0LmdldE93blByb3BlcnR5RGVzY3JpcHRvcnM7dmFyIEJlPU9iamVjdC5nZXRPd25Qcm9wZXJ0eVN5bWJvbHM7dmFyIFh0PU9iamVjdC5wcm90b3R5cGUuaGFzT3duUHJvcGVydHksV3Q9T2JqZWN0LnByb3RvdHlwZS5wcm9wZXJ0eUlzRW51bWVyYWJsZTt2YXIgZnQ9KEIsRCxGKT0+RCBpbiBCP1ZyKEIsRCx7ZW51bWVyYWJsZTohMCxjb25maWd1cmFibGU6ITAsd3JpdGFibGU6ITAsdmFsdWU6Rn0pOkJbRF09RixrPShCLEQpPT57Zm9yKHZhciBGIGluIER8fChEPXt9KSlYdC5jYWxsKEQsRikmJmZ0KEIsRixEW0ZdKTtpZihCZSlmb3IodmFyIEYgb2YgQmUoRCkpV3QuY2FsbChELEYpJiZmdChCLEYsRFtGXSk7cmV0dXJuIEJ9LE1lPShCLEQpPT5qcihCLHFyKEQpKTt2YXIgRWU9KEIsRCk9Pnt2YXIgRj17fTtmb3IodmFyIEogaW4gQilYdC5jYWxsKEIsSikmJkQuaW5kZXhPZihKKTwwJiYoRltKXT1CW0pdKTtpZihCIT1udWxsJiZCZSlmb3IodmFyIEogb2YgQmUoQikpRC5pbmRleE9mKEopPDAmJld0LmNhbGwoQixKKSYmKEZbSl09QltKXSk7cmV0dXJuIEZ9O3ZhciBodD0oQixELEYpPT4oZnQoQix0eXBlb2YgRCE9InN5bWJvbCI/RCsiIjpELEYpLEYpO3ZhciBYPShCLEQsRik9Pm5ldyBQcm9taXNlKChKLGZlKT0+e3ZhciAkZT1LPT57dHJ5e3NlKEYubmV4dChLKSl9Y2F0Y2goX2Upe2ZlKF9lKX19LG5lPUs9Pnt0cnl7c2UoRi50aHJvdyhLKSl9Y2F0Y2goX2Upe2ZlKF9lKX19LHNlPUs9PksuZG9uZT9KKEsudmFsdWUpOlByb21pc2UucmVzb2x2ZShLLnZhbHVlKS50aGVuKCRlLG5lKTtzZSgoRj1GLmFwcGx5KEIsRCkpLm5leHQoKSl9KTsoZnVuY3Rpb24oKXsidXNlIHN0cmljdCI7ZnVuY3Rpb24gQihlLHQpe3JldHVybiB0LmZvckVhY2goZnVuY3Rpb24obil7biYmdHlwZW9mIG4hPSJzdHJpbmciJiYhQXJyYXkuaXNBcnJheShuKSYmT2JqZWN0LmtleXMobikuZm9yRWFjaChmdW5jdGlvbihyKXtpZihyIT09ImRlZmF1bHQiJiYhKHIgaW4gZSkpe3ZhciBpPU9iamVjdC5nZXRPd25Qcm9wZXJ0eURlc2NyaXB0b3IobixyKTtPYmplY3QuZGVmaW5lUHJvcGVydHkoZSxyLGkuZ2V0P2k6e2VudW1lcmFibGU6ITAsZ2V0OmZ1bmN0aW9uKCl7cmV0dXJuIG5bcl19fSl9fSl9KSxPYmplY3QuZnJlZXplKGUpfXZhciBEOyhmdW5jdGlvbihlKXtlW2UuSW5pdGlhbGl6ZT0wXT0iSW5pdGlhbGl6ZSIsZVtlLkFzeW5jRXZlbnRzPTFdPSJBc3luY0V2ZW50cyIsZVtlLklkZW50aWZ5PTJdPSJJZGVudGlmeSIsZVtlLlByb3BlcnRpZXM9M109IlByb3BlcnRpZXMiLGVbZS5NZXRyaWNzPTRdPSJNZXRyaWNzIixlW2UuRmVlZGJhY2s9NV09IkZlZWRiYWNrIixlW2UuQ3VzdG9tRXZlbnQ9Nl09IkN1c3RvbUV2ZW50IixlW2UuU3RvcD03XT0iU3RvcCJ9KShEfHwoRD17fSkpO3ZhciBGPXR5cGVvZiBnbG9iYWxUaGlzIT0idW5kZWZpbmVkIj9nbG9iYWxUaGlzOnR5cGVvZiB3aW5kb3chPSJ1bmRlZmluZWQiP3dpbmRvdzp0eXBlb2YgZ2xvYmFsIT0idW5kZWZpbmVkIj9nbG9iYWw6dHlwZW9mIHNlbGYhPSJ1bmRlZmluZWQiP3NlbGY6e307ZnVuY3Rpb24gSihlKXtyZXR1cm4gZSYmZS5fX2VzTW9kdWxlJiZPYmplY3QucHJvdG90eXBlLmhhc093blByb3BlcnR5LmNhbGwoZSwiZGVmYXVsdCIpP2UuZGVmYXVsdDplfXZhciBmZT17ZXhwb3J0czp7fX07KGZ1bmN0aW9uKGUsdCl7dD1lLmV4cG9ydHM9bix0LmdldFNlcmlhbGl6ZT1yO2Z1bmN0aW9uIG4oaSxzLG8sYyl7cmV0dXJuIEpTT04uc3RyaW5naWZ5KGkscihzLGMpLG8pfWZ1bmN0aW9uIHIoaSxzKXt2YXIgbz1bXSxjPVtdO3JldHVybiBzPT1udWxsJiYocz1mdW5jdGlvbihkLGYpe3JldHVybiBvWzBdPT09Zj8iW0NpcmN1bGFyIH5dIjoiW0NpcmN1bGFyIH4uIitjLnNsaWNlKDAsby5pbmRleE9mKGYpKS5qb2luKCIuIikrIl0ifSksZnVuY3Rpb24oZCxmKXtpZihvLmxlbmd0aD4wKXt2YXIgdT1vLmluZGV4T2YodGhpcyk7fnU/by5zcGxpY2UodSsxKTpvLnB1c2godGhpcyksfnU/Yy5zcGxpY2UodSwxLzAsZCk6Yy5wdXNoKGQpLH5vLmluZGV4T2YoZikmJihmPXMuY2FsbCh0aGlzLGQsZikpfWVsc2Ugby5wdXNoKGYpO3JldHVybiBpPT1udWxsP2Y6aS5jYWxsKHRoaXMsZCxmKX19fSkoZmUsZmUuZXhwb3J0cyk7dmFyICRlPWZlLmV4cG9ydHMsbmU9SigkZSksc2U9ZnVuY3Rpb24oKXtyZXR1cm4gc2U9T2JqZWN0LmFzc2lnbnx8ZnVuY3Rpb24odCl7Zm9yKHZhciBuLHI9MSxpPWFyZ3VtZW50cy5sZW5ndGg7cjxpO3IrKyl7bj1hcmd1bWVudHNbcl07Zm9yKHZhciBzIGluIG4pT2JqZWN0LnByb3RvdHlwZS5oYXNPd25Qcm9wZXJ0eS5jYWxsKG4scykmJih0W3NdPW5bc10pfXJldHVybiB0fSxzZS5hcHBseSh0aGlzLGFyZ3VtZW50cyl9O2Z1bmN0aW9uIEsoZSx0KXtpZighISFlKXRocm93IG5ldyBFcnJvcih0KX1mdW5jdGlvbiBfZShlKXtyZXR1cm4gdHlwZW9mIGU9PSJvYmplY3QiJiZlIT09bnVsbH1mdW5jdGlvbiBadChlLHQpe2lmKCEhIWUpdGhyb3cgbmV3IEVycm9yKHQhPW51bGw/dDoiVW5leHBlY3RlZCBpbnZhcmlhbnQgdHJpZ2dlcmVkLiIpfWNvbnN0IEt0PS9cclxufFtcblxyXS9nO2Z1bmN0aW9uIFVlKGUsdCl7bGV0IG49MCxyPTE7Zm9yKGNvbnN0IGkgb2YgZS5ib2R5Lm1hdGNoQWxsKEt0KSl7aWYodHlwZW9mIGkuaW5kZXg9PSJudW1iZXIifHxadCghMSksaS5pbmRleD49dClicmVhaztuPWkuaW5kZXgraVswXS5sZW5ndGgscis9MX1yZXR1cm57bGluZTpyLGNvbHVtbjp0KzEtbn19ZnVuY3Rpb24gZW4oZSl7cmV0dXJuIGR0KGUuc291cmNlLFVlKGUuc291cmNlLGUuc3RhcnQpKX1mdW5jdGlvbiBkdChlLHQpe2NvbnN0IG49ZS5sb2NhdGlvbk9mZnNldC5jb2x1bW4tMSxyPSIiLnBhZFN0YXJ0KG4pK2UuYm9keSxpPXQubGluZS0xLHM9ZS5sb2NhdGlvbk9mZnNldC5saW5lLTEsbz10LmxpbmUrcyxjPXQubGluZT09PTE/bjowLGQ9dC5jb2x1bW4rYyxmPWAke2UubmFtZX06JHtvfToke2R9CmAsdT1yLnNwbGl0KC9cclxufFtcblxyXS9nKSxnPXVbaV07aWYoZy5sZW5ndGg+MTIwKXtjb25zdCBFPU1hdGguZmxvb3IoZC84MCksYj1kJTgwLHk9W107Zm9yKGxldCBwPTA7cDxnLmxlbmd0aDtwKz04MCl5LnB1c2goZy5zbGljZShwLHArODApKTtyZXR1cm4gZitwdChbW2Ake299IHxgLHlbMF1dLC4uLnkuc2xpY2UoMSxFKzEpLm1hcChwPT5bInwiLHBdKSxbInwiLCJeIi5wYWRTdGFydChiKV0sWyJ8Iix5W0UrMV1dXSl9cmV0dXJuIGYrcHQoW1tgJHtvLTF9IHxgLHVbaS0xXV0sW2Ake299IHxgLGddLFsifCIsIl4iLnBhZFN0YXJ0KGQpXSxbYCR7bysxfSB8YCx1W2krMV1dXSl9ZnVuY3Rpb24gcHQoZSl7Y29uc3QgdD1lLmZpbHRlcigoW3IsaV0pPT5pIT09dm9pZCAwKSxuPU1hdGgubWF4KC4uLnQubWFwKChbcl0pPT5yLmxlbmd0aCkpO3JldHVybiB0Lm1hcCgoW3IsaV0pPT5yLnBhZFN0YXJ0KG4pKyhpPyIgIitpOiIiKSkuam9pbihgCmApfWZ1bmN0aW9uIHRuKGUpe2NvbnN0IHQ9ZVswXTtyZXR1cm4gdD09bnVsbHx8ImtpbmQiaW4gdHx8Imxlbmd0aCJpbiB0P3tub2Rlczp0LHNvdXJjZTplWzFdLHBvc2l0aW9uczplWzJdLHBhdGg6ZVszXSxvcmlnaW5hbEVycm9yOmVbNF0sZXh0ZW5zaW9uczplWzVdfTp0fWNsYXNzIFZlIGV4dGVuZHMgRXJyb3J7Y29uc3RydWN0b3IodCwuLi5uKXt2YXIgcixpLHM7Y29uc3R7bm9kZXM6byxzb3VyY2U6Yyxwb3NpdGlvbnM6ZCxwYXRoOmYsb3JpZ2luYWxFcnJvcjp1LGV4dGVuc2lvbnM6Z309dG4obik7c3VwZXIodCksdGhpcy5uYW1lPSJHcmFwaFFMRXJyb3IiLHRoaXMucGF0aD1mIT1udWxsP2Y6dm9pZCAwLHRoaXMub3JpZ2luYWxFcnJvcj11IT1udWxsP3U6dm9pZCAwLHRoaXMubm9kZXM9bXQoQXJyYXkuaXNBcnJheShvKT9vOm8/W29dOnZvaWQgMCk7Y29uc3QgRT1tdCgocj10aGlzLm5vZGVzKT09PW51bGx8fHI9PT12b2lkIDA/dm9pZCAwOnIubWFwKHk9PnkubG9jKS5maWx0ZXIoeT0+eSE9bnVsbCkpO3RoaXMuc291cmNlPWMhPW51bGw/YzpFPT1udWxsfHwoaT1FWzBdKT09PW51bGx8fGk9PT12b2lkIDA/dm9pZCAwOmkuc291cmNlLHRoaXMucG9zaXRpb25zPWQhPW51bGw/ZDpFPT1udWxsP3ZvaWQgMDpFLm1hcCh5PT55LnN0YXJ0KSx0aGlzLmxvY2F0aW9ucz1kJiZjP2QubWFwKHk9PlVlKGMseSkpOkU9PW51bGw/dm9pZCAwOkUubWFwKHk9PlVlKHkuc291cmNlLHkuc3RhcnQpKTtjb25zdCBiPV9lKHU9PW51bGw/dm9pZCAwOnUuZXh0ZW5zaW9ucyk/dT09bnVsbD92b2lkIDA6dS5leHRlbnNpb25zOnZvaWQgMDt0aGlzLmV4dGVuc2lvbnM9KHM9ZyE9bnVsbD9nOmIpIT09bnVsbCYmcyE9PXZvaWQgMD9zOk9iamVjdC5jcmVhdGUobnVsbCksT2JqZWN0LmRlZmluZVByb3BlcnRpZXModGhpcyx7bWVzc2FnZTp7d3JpdGFibGU6ITAsZW51bWVyYWJsZTohMH0sbmFtZTp7ZW51bWVyYWJsZTohMX0sbm9kZXM6e2VudW1lcmFibGU6ITF9LHNvdXJjZTp7ZW51bWVyYWJsZTohMX0scG9zaXRpb25zOntlbnVtZXJhYmxlOiExfSxvcmlnaW5hbEVycm9yOntlbnVtZXJhYmxlOiExfX0pLHUhPW51bGwmJnUuc3RhY2s/T2JqZWN0LmRlZmluZVByb3BlcnR5KHRoaXMsInN0YWNrIix7dmFsdWU6dS5zdGFjayx3cml0YWJsZTohMCxjb25maWd1cmFibGU6ITB9KTpFcnJvci5jYXB0dXJlU3RhY2tUcmFjZT9FcnJvci5jYXB0dXJlU3RhY2tUcmFjZSh0aGlzLFZlKTpPYmplY3QuZGVmaW5lUHJvcGVydHkodGhpcywic3RhY2siLHt2YWx1ZTpFcnJvcigpLnN0YWNrLHdyaXRhYmxlOiEwLGNvbmZpZ3VyYWJsZTohMH0pfWdldFtTeW1ib2wudG9TdHJpbmdUYWddKCl7cmV0dXJuIkdyYXBoUUxFcnJvciJ9dG9TdHJpbmcoKXtsZXQgdD10aGlzLm1lc3NhZ2U7aWYodGhpcy5ub2Rlcylmb3IoY29uc3QgbiBvZiB0aGlzLm5vZGVzKW4ubG9jJiYodCs9YAoKYCtlbihuLmxvYykpO2Vsc2UgaWYodGhpcy5zb3VyY2UmJnRoaXMubG9jYXRpb25zKWZvcihjb25zdCBuIG9mIHRoaXMubG9jYXRpb25zKXQrPWAKCmArZHQodGhpcy5zb3VyY2Usbik7cmV0dXJuIHR9dG9KU09OKCl7Y29uc3QgdD17bWVzc2FnZTp0aGlzLm1lc3NhZ2V9O3JldHVybiB0aGlzLmxvY2F0aW9ucyE9bnVsbCYmKHQubG9jYXRpb25zPXRoaXMubG9jYXRpb25zKSx0aGlzLnBhdGghPW51bGwmJih0LnBhdGg9dGhpcy5wYXRoKSx0aGlzLmV4dGVuc2lvbnMhPW51bGwmJk9iamVjdC5rZXlzKHRoaXMuZXh0ZW5zaW9ucykubGVuZ3RoPjAmJih0LmV4dGVuc2lvbnM9dGhpcy5leHRlbnNpb25zKSx0fX1mdW5jdGlvbiBtdChlKXtyZXR1cm4gZT09PXZvaWQgMHx8ZS5sZW5ndGg9PT0wP3ZvaWQgMDplfWZ1bmN0aW9uIEcoZSx0LG4pe3JldHVybiBuZXcgVmUoYFN5bnRheCBFcnJvcjogJHtufWAse3NvdXJjZTplLHBvc2l0aW9uczpbdF19KX1jbGFzcyBubntjb25zdHJ1Y3Rvcih0LG4scil7dGhpcy5zdGFydD10LnN0YXJ0LHRoaXMuZW5kPW4uZW5kLHRoaXMuc3RhcnRUb2tlbj10LHRoaXMuZW5kVG9rZW49bix0aGlzLnNvdXJjZT1yfWdldFtTeW1ib2wudG9TdHJpbmdUYWddKCl7cmV0dXJuIkxvY2F0aW9uIn10b0pTT04oKXtyZXR1cm57c3RhcnQ6dGhpcy5zdGFydCxlbmQ6dGhpcy5lbmR9fX1jbGFzcyB5dHtjb25zdHJ1Y3Rvcih0LG4scixpLHMsbyl7dGhpcy5raW5kPXQsdGhpcy5zdGFydD1uLHRoaXMuZW5kPXIsdGhpcy5saW5lPWksdGhpcy5jb2x1bW49cyx0aGlzLnZhbHVlPW8sdGhpcy5wcmV2PW51bGwsdGhpcy5uZXh0PW51bGx9Z2V0W1N5bWJvbC50b1N0cmluZ1RhZ10oKXtyZXR1cm4iVG9rZW4ifXRvSlNPTigpe3JldHVybntraW5kOnRoaXMua2luZCx2YWx1ZTp0aGlzLnZhbHVlLGxpbmU6dGhpcy5saW5lLGNvbHVtbjp0aGlzLmNvbHVtbn19fWNvbnN0IHZ0PXtOYW1lOltdLERvY3VtZW50OlsiZGVmaW5pdGlvbnMiXSxPcGVyYXRpb25EZWZpbml0aW9uOlsibmFtZSIsInZhcmlhYmxlRGVmaW5pdGlvbnMiLCJkaXJlY3RpdmVzIiwic2VsZWN0aW9uU2V0Il0sVmFyaWFibGVEZWZpbml0aW9uOlsidmFyaWFibGUiLCJ0eXBlIiwiZGVmYXVsdFZhbHVlIiwiZGlyZWN0aXZlcyJdLFZhcmlhYmxlOlsibmFtZSJdLFNlbGVjdGlvblNldDpbInNlbGVjdGlvbnMiXSxGaWVsZDpbImFsaWFzIiwibmFtZSIsImFyZ3VtZW50cyIsImRpcmVjdGl2ZXMiLCJzZWxlY3Rpb25TZXQiXSxBcmd1bWVudDpbIm5hbWUiLCJ2YWx1ZSJdLEZyYWdtZW50U3ByZWFkOlsibmFtZSIsImRpcmVjdGl2ZXMiXSxJbmxpbmVGcmFnbWVudDpbInR5cGVDb25kaXRpb24iLCJkaXJlY3RpdmVzIiwic2VsZWN0aW9uU2V0Il0sRnJhZ21lbnREZWZpbml0aW9uOlsibmFtZSIsInZhcmlhYmxlRGVmaW5pdGlvbnMiLCJ0eXBlQ29uZGl0aW9uIiwiZGlyZWN0aXZlcyIsInNlbGVjdGlvblNldCJdLEludFZhbHVlOltdLEZsb2F0VmFsdWU6W10sU3RyaW5nVmFsdWU6W10sQm9vbGVhblZhbHVlOltdLE51bGxWYWx1ZTpbXSxFbnVtVmFsdWU6W10sTGlzdFZhbHVlOlsidmFsdWVzIl0sT2JqZWN0VmFsdWU6WyJmaWVsZHMiXSxPYmplY3RGaWVsZDpbIm5hbWUiLCJ2YWx1ZSJdLERpcmVjdGl2ZTpbIm5hbWUiLCJhcmd1bWVudHMiXSxOYW1lZFR5cGU6WyJuYW1lIl0sTGlzdFR5cGU6WyJ0eXBlIl0sTm9uTnVsbFR5cGU6WyJ0eXBlIl0sU2NoZW1hRGVmaW5pdGlvbjpbImRlc2NyaXB0aW9uIiwiZGlyZWN0aXZlcyIsIm9wZXJhdGlvblR5cGVzIl0sT3BlcmF0aW9uVHlwZURlZmluaXRpb246WyJ0eXBlIl0sU2NhbGFyVHlwZURlZmluaXRpb246WyJkZXNjcmlwdGlvbiIsIm5hbWUiLCJkaXJlY3RpdmVzIl0sT2JqZWN0VHlwZURlZmluaXRpb246WyJkZXNjcmlwdGlvbiIsIm5hbWUiLCJpbnRlcmZhY2VzIiwiZGlyZWN0aXZlcyIsImZpZWxkcyJdLEZpZWxkRGVmaW5pdGlvbjpbImRlc2NyaXB0aW9uIiwibmFtZSIsImFyZ3VtZW50cyIsInR5cGUiLCJkaXJlY3RpdmVzIl0sSW5wdXRWYWx1ZURlZmluaXRpb246WyJkZXNjcmlwdGlvbiIsIm5hbWUiLCJ0eXBlIiwiZGVmYXVsdFZhbHVlIiwiZGlyZWN0aXZlcyJdLEludGVyZmFjZVR5cGVEZWZpbml0aW9uOlsiZGVzY3JpcHRpb24iLCJuYW1lIiwiaW50ZXJmYWNlcyIsImRpcmVjdGl2ZXMiLCJmaWVsZHMiXSxVbmlvblR5cGVEZWZpbml0aW9uOlsiZGVzY3JpcHRpb24iLCJuYW1lIiwiZGlyZWN0aXZlcyIsInR5cGVzIl0sRW51bVR5cGVEZWZpbml0aW9uOlsiZGVzY3JpcHRpb24iLCJuYW1lIiwiZGlyZWN0aXZlcyIsInZhbHVlcyJdLEVudW1WYWx1ZURlZmluaXRpb246WyJkZXNjcmlwdGlvbiIsIm5hbWUiLCJkaXJlY3RpdmVzIl0sSW5wdXRPYmplY3RUeXBlRGVmaW5pdGlvbjpbImRlc2NyaXB0aW9uIiwibmFtZSIsImRpcmVjdGl2ZXMiLCJmaWVsZHMiXSxEaXJlY3RpdmVEZWZpbml0aW9uOlsiZGVzY3JpcHRpb24iLCJuYW1lIiwiYXJndW1lbnRzIiwibG9jYXRpb25zIl0sU2NoZW1hRXh0ZW5zaW9uOlsiZGlyZWN0aXZlcyIsIm9wZXJhdGlvblR5cGVzIl0sU2NhbGFyVHlwZUV4dGVuc2lvbjpbIm5hbWUiLCJkaXJlY3RpdmVzIl0sT2JqZWN0VHlwZUV4dGVuc2lvbjpbIm5hbWUiLCJpbnRlcmZhY2VzIiwiZGlyZWN0aXZlcyIsImZpZWxkcyJdLEludGVyZmFjZVR5cGVFeHRlbnNpb246WyJuYW1lIiwiaW50ZXJmYWNlcyIsImRpcmVjdGl2ZXMiLCJmaWVsZHMiXSxVbmlvblR5cGVFeHRlbnNpb246WyJuYW1lIiwiZGlyZWN0aXZlcyIsInR5cGVzIl0sRW51bVR5cGVFeHRlbnNpb246WyJuYW1lIiwiZGlyZWN0aXZlcyIsInZhbHVlcyJdLElucHV0T2JqZWN0VHlwZUV4dGVuc2lvbjpbIm5hbWUiLCJkaXJlY3RpdmVzIiwiZmllbGRzIl19LHJuPW5ldyBTZXQoT2JqZWN0LmtleXModnQpKTtmdW5jdGlvbiBndChlKXtjb25zdCB0PWU9PW51bGw/dm9pZCAwOmUua2luZDtyZXR1cm4gdHlwZW9mIHQ9PSJzdHJpbmciJiZybi5oYXModCl9dmFyIGhlOyhmdW5jdGlvbihlKXtlLlFVRVJZPSJxdWVyeSIsZS5NVVRBVElPTj0ibXV0YXRpb24iLGUuU1VCU0NSSVBUSU9OPSJzdWJzY3JpcHRpb24ifSkoaGV8fChoZT17fSkpO3ZhciBqZTsoZnVuY3Rpb24oZSl7ZS5RVUVSWT0iUVVFUlkiLGUuTVVUQVRJT049Ik1VVEFUSU9OIixlLlNVQlNDUklQVElPTj0iU1VCU0NSSVBUSU9OIixlLkZJRUxEPSJGSUVMRCIsZS5GUkFHTUVOVF9ERUZJTklUSU9OPSJGUkFHTUVOVF9ERUZJTklUSU9OIixlLkZSQUdNRU5UX1NQUkVBRD0iRlJBR01FTlRfU1BSRUFEIixlLklOTElORV9GUkFHTUVOVD0iSU5MSU5FX0ZSQUdNRU5UIixlLlZBUklBQkxFX0RFRklOSVRJT049IlZBUklBQkxFX0RFRklOSVRJT04iLGUuU0NIRU1BPSJTQ0hFTUEiLGUuU0NBTEFSPSJTQ0FMQVIiLGUuT0JKRUNUPSJPQkpFQ1QiLGUuRklFTERfREVGSU5JVElPTj0iRklFTERfREVGSU5JVElPTiIsZS5BUkdVTUVOVF9ERUZJTklUSU9OPSJBUkdVTUVOVF9ERUZJTklUSU9OIixlLklOVEVSRkFDRT0iSU5URVJGQUNFIixlLlVOSU9OPSJVTklPTiIsZS5FTlVNPSJFTlVNIixlLkVOVU1fVkFMVUU9IkVOVU1fVkFMVUUiLGUuSU5QVVRfT0JKRUNUPSJJTlBVVF9PQkpFQ1QiLGUuSU5QVVRfRklFTERfREVGSU5JVElPTj0iSU5QVVRfRklFTERfREVGSU5JVElPTiJ9KShqZXx8KGplPXt9KSk7dmFyIFQ7KGZ1bmN0aW9uKGUpe2UuTkFNRT0iTmFtZSIsZS5ET0NVTUVOVD0iRG9jdW1lbnQiLGUuT1BFUkFUSU9OX0RFRklOSVRJT049Ik9wZXJhdGlvbkRlZmluaXRpb24iLGUuVkFSSUFCTEVfREVGSU5JVElPTj0iVmFyaWFibGVEZWZpbml0aW9uIixlLlNFTEVDVElPTl9TRVQ9IlNlbGVjdGlvblNldCIsZS5GSUVMRD0iRmllbGQiLGUuQVJHVU1FTlQ9IkFyZ3VtZW50IixlLkZSQUdNRU5UX1NQUkVBRD0iRnJhZ21lbnRTcHJlYWQiLGUuSU5MSU5FX0ZSQUdNRU5UPSJJbmxpbmVGcmFnbWVudCIsZS5GUkFHTUVOVF9ERUZJTklUSU9OPSJGcmFnbWVudERlZmluaXRpb24iLGUuVkFSSUFCTEU9IlZhcmlhYmxlIixlLklOVD0iSW50VmFsdWUiLGUuRkxPQVQ9IkZsb2F0VmFsdWUiLGUuU1RSSU5HPSJTdHJpbmdWYWx1ZSIsZS5CT09MRUFOPSJCb29sZWFuVmFsdWUiLGUuTlVMTD0iTnVsbFZhbHVlIixlLkVOVU09IkVudW1WYWx1ZSIsZS5MSVNUPSJMaXN0VmFsdWUiLGUuT0JKRUNUPSJPYmplY3RWYWx1ZSIsZS5PQkpFQ1RfRklFTEQ9Ik9iamVjdEZpZWxkIixlLkRJUkVDVElWRT0iRGlyZWN0aXZlIixlLk5BTUVEX1RZUEU9Ik5hbWVkVHlwZSIsZS5MSVNUX1RZUEU9Ikxpc3RUeXBlIixlLk5PTl9OVUxMX1RZUEU9Ik5vbk51bGxUeXBlIixlLlNDSEVNQV9ERUZJTklUSU9OPSJTY2hlbWFEZWZpbml0aW9uIixlLk9QRVJBVElPTl9UWVBFX0RFRklOSVRJT049Ik9wZXJhdGlvblR5cGVEZWZpbml0aW9uIixlLlNDQUxBUl9UWVBFX0RFRklOSVRJT049IlNjYWxhclR5cGVEZWZpbml0aW9uIixlLk9CSkVDVF9UWVBFX0RFRklOSVRJT049Ik9iamVjdFR5cGVEZWZpbml0aW9uIixlLkZJRUxEX0RFRklOSVRJT049IkZpZWxkRGVmaW5pdGlvbiIsZS5JTlBVVF9WQUxVRV9ERUZJTklUSU9OPSJJbnB1dFZhbHVlRGVmaW5pdGlvbiIsZS5JTlRFUkZBQ0VfVFlQRV9ERUZJTklUSU9OPSJJbnRlcmZhY2VUeXBlRGVmaW5pdGlvbiIsZS5VTklPTl9UWVBFX0RFRklOSVRJT049IlVuaW9uVHlwZURlZmluaXRpb24iLGUuRU5VTV9UWVBFX0RFRklOSVRJT049IkVudW1UeXBlRGVmaW5pdGlvbiIsZS5FTlVNX1ZBTFVFX0RFRklOSVRJT049IkVudW1WYWx1ZURlZmluaXRpb24iLGUuSU5QVVRfT0JKRUNUX1RZUEVfREVGSU5JVElPTj0iSW5wdXRPYmplY3RUeXBlRGVmaW5pdGlvbiIsZS5ESVJFQ1RJVkVfREVGSU5JVElPTj0iRGlyZWN0aXZlRGVmaW5pdGlvbiIsZS5TQ0hFTUFfRVhURU5TSU9OPSJTY2hlbWFFeHRlbnNpb24iLGUuU0NBTEFSX1RZUEVfRVhURU5TSU9OPSJTY2FsYXJUeXBlRXh0ZW5zaW9uIixlLk9CSkVDVF9UWVBFX0VYVEVOU0lPTj0iT2JqZWN0VHlwZUV4dGVuc2lvbiIsZS5JTlRFUkZBQ0VfVFlQRV9FWFRFTlNJT049IkludGVyZmFjZVR5cGVFeHRlbnNpb24iLGUuVU5JT05fVFlQRV9FWFRFTlNJT049IlVuaW9uVHlwZUV4dGVuc2lvbiIsZS5FTlVNX1RZUEVfRVhURU5TSU9OPSJFbnVtVHlwZUV4dGVuc2lvbiIsZS5JTlBVVF9PQkpFQ1RfVFlQRV9FWFRFTlNJT049IklucHV0T2JqZWN0VHlwZUV4dGVuc2lvbiJ9KShUfHwoVD17fSkpO2Z1bmN0aW9uIHFlKGUpe3JldHVybiBlPT09OXx8ZT09PTMyfWZ1bmN0aW9uIFRlKGUpe3JldHVybiBlPj00OCYmZTw9NTd9ZnVuY3Rpb24gRXQoZSl7cmV0dXJuIGU+PTk3JiZlPD0xMjJ8fGU+PTY1JiZlPD05MH1mdW5jdGlvbiBfdChlKXtyZXR1cm4gRXQoZSl8fGU9PT05NX1mdW5jdGlvbiBzbihlKXtyZXR1cm4gRXQoZSl8fFRlKGUpfHxlPT09OTV9ZnVuY3Rpb24gb24oZSl7dmFyIHQ7bGV0IG49TnVtYmVyLk1BWF9TQUZFX0lOVEVHRVIscj1udWxsLGk9LTE7Zm9yKGxldCBvPTA7bzxlLmxlbmd0aDsrK28pe3ZhciBzO2NvbnN0IGM9ZVtvXSxkPWFuKGMpO2QhPT1jLmxlbmd0aCYmKHI9KHM9cikhPT1udWxsJiZzIT09dm9pZCAwP3M6byxpPW8sbyE9PTAmJmQ8biYmKG49ZCkpfXJldHVybiBlLm1hcCgobyxjKT0+Yz09PTA/bzpvLnNsaWNlKG4pKS5zbGljZSgodD1yKSE9PW51bGwmJnQhPT12b2lkIDA/dDowLGkrMSl9ZnVuY3Rpb24gYW4oZSl7bGV0IHQ9MDtmb3IoO3Q8ZS5sZW5ndGgmJnFlKGUuY2hhckNvZGVBdCh0KSk7KSsrdDtyZXR1cm4gdH1mdW5jdGlvbiBjbihlLHQpe2NvbnN0IG49ZS5yZXBsYWNlKC8iIiIvZywnXFwiIiInKSxyPW4uc3BsaXQoL1xyXG58W1xuXHJdL2cpLGk9ci5sZW5ndGg9PT0xLHM9ci5sZW5ndGg+MSYmci5zbGljZSgxKS5ldmVyeShiPT5iLmxlbmd0aD09PTB8fHFlKGIuY2hhckNvZGVBdCgwKSkpLG89bi5lbmRzV2l0aCgnXFwiIiInKSxjPWUuZW5kc1dpdGgoJyInKSYmIW8sZD1lLmVuZHNXaXRoKCJcXCIpLGY9Y3x8ZCx1PSEodCE9bnVsbCYmdC5taW5pbWl6ZSkmJighaXx8ZS5sZW5ndGg+NzB8fGZ8fHN8fG8pO2xldCBnPSIiO2NvbnN0IEU9aSYmcWUoZS5jaGFyQ29kZUF0KDApKTtyZXR1cm4odSYmIUV8fHMpJiYoZys9YApgKSxnKz1uLCh1fHxmKSYmKGcrPWAKYCksJyIiIicrZysnIiIiJ312YXIgbDsoZnVuY3Rpb24oZSl7ZS5TT0Y9IjxTT0Y+IixlLkVPRj0iPEVPRj4iLGUuQkFORz0iISIsZS5ET0xMQVI9IiQiLGUuQU1QPSImIixlLlBBUkVOX0w9IigiLGUuUEFSRU5fUj0iKSIsZS5TUFJFQUQ9Ii4uLiIsZS5DT0xPTj0iOiIsZS5FUVVBTFM9Ij0iLGUuQVQ9IkAiLGUuQlJBQ0tFVF9MPSJbIixlLkJSQUNLRVRfUj0iXSIsZS5CUkFDRV9MPSJ7IixlLlBJUEU9InwiLGUuQlJBQ0VfUj0ifSIsZS5OQU1FPSJOYW1lIixlLklOVD0iSW50IixlLkZMT0FUPSJGbG9hdCIsZS5TVFJJTkc9IlN0cmluZyIsZS5CTE9DS19TVFJJTkc9IkJsb2NrU3RyaW5nIixlLkNPTU1FTlQ9IkNvbW1lbnQifSkobHx8KGw9e30pKTtjbGFzcyB1bntjb25zdHJ1Y3Rvcih0KXtjb25zdCBuPW5ldyB5dChsLlNPRiwwLDAsMCwwKTt0aGlzLnNvdXJjZT10LHRoaXMubGFzdFRva2VuPW4sdGhpcy50b2tlbj1uLHRoaXMubGluZT0xLHRoaXMubGluZVN0YXJ0PTB9Z2V0W1N5bWJvbC50b1N0cmluZ1RhZ10oKXtyZXR1cm4iTGV4ZXIifWFkdmFuY2UoKXtyZXR1cm4gdGhpcy5sYXN0VG9rZW49dGhpcy50b2tlbix0aGlzLnRva2VuPXRoaXMubG9va2FoZWFkKCl9bG9va2FoZWFkKCl7bGV0IHQ9dGhpcy50b2tlbjtpZih0LmtpbmQhPT1sLkVPRilkbyBpZih0Lm5leHQpdD10Lm5leHQ7ZWxzZXtjb25zdCBuPWZuKHRoaXMsdC5lbmQpO3QubmV4dD1uLG4ucHJldj10LHQ9bn13aGlsZSh0LmtpbmQ9PT1sLkNPTU1FTlQpO3JldHVybiB0fX1mdW5jdGlvbiBsbihlKXtyZXR1cm4gZT09PWwuQkFOR3x8ZT09PWwuRE9MTEFSfHxlPT09bC5BTVB8fGU9PT1sLlBBUkVOX0x8fGU9PT1sLlBBUkVOX1J8fGU9PT1sLlNQUkVBRHx8ZT09PWwuQ09MT058fGU9PT1sLkVRVUFMU3x8ZT09PWwuQVR8fGU9PT1sLkJSQUNLRVRfTHx8ZT09PWwuQlJBQ0tFVF9SfHxlPT09bC5CUkFDRV9MfHxlPT09bC5QSVBFfHxlPT09bC5CUkFDRV9SfWZ1bmN0aW9uIGRlKGUpe3JldHVybiBlPj0wJiZlPD01NTI5NXx8ZT49NTczNDQmJmU8PTExMTQxMTF9ZnVuY3Rpb24gT2UoZSx0KXtyZXR1cm4gVHQoZS5jaGFyQ29kZUF0KHQpKSYmYnQoZS5jaGFyQ29kZUF0KHQrMSkpfWZ1bmN0aW9uIFR0KGUpe3JldHVybiBlPj01NTI5NiYmZTw9NTYzMTl9ZnVuY3Rpb24gYnQoZSl7cmV0dXJuIGU+PTU2MzIwJiZlPD01NzM0M31mdW5jdGlvbiB1ZShlLHQpe2NvbnN0IG49ZS5zb3VyY2UuYm9keS5jb2RlUG9pbnRBdCh0KTtpZihuPT09dm9pZCAwKXJldHVybiBsLkVPRjtpZihuPj0zMiYmbjw9MTI2KXtjb25zdCByPVN0cmluZy5mcm9tQ29kZVBvaW50KG4pO3JldHVybiByPT09JyInP2AnIidgOmAiJHtyfSJgfXJldHVybiJVKyIrbi50b1N0cmluZygxNikudG9VcHBlckNhc2UoKS5wYWRTdGFydCg0LCIwIil9ZnVuY3Rpb24gVShlLHQsbixyLGkpe2NvbnN0IHM9ZS5saW5lLG89MStuLWUubGluZVN0YXJ0O3JldHVybiBuZXcgeXQodCxuLHIscyxvLGkpfWZ1bmN0aW9uIGZuKGUsdCl7Y29uc3Qgbj1lLnNvdXJjZS5ib2R5LHI9bi5sZW5ndGg7bGV0IGk9dDtmb3IoO2k8cjspe2NvbnN0IHM9bi5jaGFyQ29kZUF0KGkpO3N3aXRjaChzKXtjYXNlIDY1Mjc5OmNhc2UgOTpjYXNlIDMyOmNhc2UgNDQ6KytpO2NvbnRpbnVlO2Nhc2UgMTA6KytpLCsrZS5saW5lLGUubGluZVN0YXJ0PWk7Y29udGludWU7Y2FzZSAxMzpuLmNoYXJDb2RlQXQoaSsxKT09PTEwP2krPTI6KytpLCsrZS5saW5lLGUubGluZVN0YXJ0PWk7Y29udGludWU7Y2FzZSAzNTpyZXR1cm4gaG4oZSxpKTtjYXNlIDMzOnJldHVybiBVKGUsbC5CQU5HLGksaSsxKTtjYXNlIDM2OnJldHVybiBVKGUsbC5ET0xMQVIsaSxpKzEpO2Nhc2UgMzg6cmV0dXJuIFUoZSxsLkFNUCxpLGkrMSk7Y2FzZSA0MDpyZXR1cm4gVShlLGwuUEFSRU5fTCxpLGkrMSk7Y2FzZSA0MTpyZXR1cm4gVShlLGwuUEFSRU5fUixpLGkrMSk7Y2FzZSA0NjppZihuLmNoYXJDb2RlQXQoaSsxKT09PTQ2JiZuLmNoYXJDb2RlQXQoaSsyKT09PTQ2KXJldHVybiBVKGUsbC5TUFJFQUQsaSxpKzMpO2JyZWFrO2Nhc2UgNTg6cmV0dXJuIFUoZSxsLkNPTE9OLGksaSsxKTtjYXNlIDYxOnJldHVybiBVKGUsbC5FUVVBTFMsaSxpKzEpO2Nhc2UgNjQ6cmV0dXJuIFUoZSxsLkFULGksaSsxKTtjYXNlIDkxOnJldHVybiBVKGUsbC5CUkFDS0VUX0wsaSxpKzEpO2Nhc2UgOTM6cmV0dXJuIFUoZSxsLkJSQUNLRVRfUixpLGkrMSk7Y2FzZSAxMjM6cmV0dXJuIFUoZSxsLkJSQUNFX0wsaSxpKzEpO2Nhc2UgMTI0OnJldHVybiBVKGUsbC5QSVBFLGksaSsxKTtjYXNlIDEyNTpyZXR1cm4gVShlLGwuQlJBQ0VfUixpLGkrMSk7Y2FzZSAzNDpyZXR1cm4gbi5jaGFyQ29kZUF0KGkrMSk9PT0zNCYmbi5jaGFyQ29kZUF0KGkrMik9PT0zND9nbihlLGkpOnBuKGUsaSl9aWYoVGUocyl8fHM9PT00NSlyZXR1cm4gZG4oZSxpLHMpO2lmKF90KHMpKXJldHVybiBFbihlLGkpO3Rocm93IEcoZS5zb3VyY2UsaSxzPT09Mzk/YFVuZXhwZWN0ZWQgc2luZ2xlIHF1b3RlIGNoYXJhY3RlciAoJyksIGRpZCB5b3UgbWVhbiB0byB1c2UgYSBkb3VibGUgcXVvdGUgKCIpP2A6ZGUocyl8fE9lKG4saSk/YFVuZXhwZWN0ZWQgY2hhcmFjdGVyOiAke3VlKGUsaSl9LmA6YEludmFsaWQgY2hhcmFjdGVyOiAke3VlKGUsaSl9LmApfXJldHVybiBVKGUsbC5FT0YscixyKX1mdW5jdGlvbiBobihlLHQpe2NvbnN0IG49ZS5zb3VyY2UuYm9keSxyPW4ubGVuZ3RoO2xldCBpPXQrMTtmb3IoO2k8cjspe2NvbnN0IHM9bi5jaGFyQ29kZUF0KGkpO2lmKHM9PT0xMHx8cz09PTEzKWJyZWFrO2lmKGRlKHMpKSsraTtlbHNlIGlmKE9lKG4saSkpaSs9MjtlbHNlIGJyZWFrfXJldHVybiBVKGUsbC5DT01NRU5ULHQsaSxuLnNsaWNlKHQrMSxpKSl9ZnVuY3Rpb24gZG4oZSx0LG4pe2NvbnN0IHI9ZS5zb3VyY2UuYm9keTtsZXQgaT10LHM9bixvPSExO2lmKHM9PT00NSYmKHM9ci5jaGFyQ29kZUF0KCsraSkpLHM9PT00OCl7aWYocz1yLmNoYXJDb2RlQXQoKytpKSxUZShzKSl0aHJvdyBHKGUuc291cmNlLGksYEludmFsaWQgbnVtYmVyLCB1bmV4cGVjdGVkIGRpZ2l0IGFmdGVyIDA6ICR7dWUoZSxpKX0uYCl9ZWxzZSBpPUdlKGUsaSxzKSxzPXIuY2hhckNvZGVBdChpKTtpZihzPT09NDYmJihvPSEwLHM9ci5jaGFyQ29kZUF0KCsraSksaT1HZShlLGkscykscz1yLmNoYXJDb2RlQXQoaSkpLChzPT09Njl8fHM9PT0xMDEpJiYobz0hMCxzPXIuY2hhckNvZGVBdCgrK2kpLChzPT09NDN8fHM9PT00NSkmJihzPXIuY2hhckNvZGVBdCgrK2kpKSxpPUdlKGUsaSxzKSxzPXIuY2hhckNvZGVBdChpKSkscz09PTQ2fHxfdChzKSl0aHJvdyBHKGUuc291cmNlLGksYEludmFsaWQgbnVtYmVyLCBleHBlY3RlZCBkaWdpdCBidXQgZ290OiAke3VlKGUsaSl9LmApO3JldHVybiBVKGUsbz9sLkZMT0FUOmwuSU5ULHQsaSxyLnNsaWNlKHQsaSkpfWZ1bmN0aW9uIEdlKGUsdCxuKXtpZighVGUobikpdGhyb3cgRyhlLnNvdXJjZSx0LGBJbnZhbGlkIG51bWJlciwgZXhwZWN0ZWQgZGlnaXQgYnV0IGdvdDogJHt1ZShlLHQpfS5gKTtjb25zdCByPWUuc291cmNlLmJvZHk7bGV0IGk9dCsxO2Zvcig7VGUoci5jaGFyQ29kZUF0KGkpKTspKytpO3JldHVybiBpfWZ1bmN0aW9uIHBuKGUsdCl7Y29uc3Qgbj1lLnNvdXJjZS5ib2R5LHI9bi5sZW5ndGg7bGV0IGk9dCsxLHM9aSxvPSIiO2Zvcig7aTxyOyl7Y29uc3QgYz1uLmNoYXJDb2RlQXQoaSk7aWYoYz09PTM0KXJldHVybiBvKz1uLnNsaWNlKHMsaSksVShlLGwuU1RSSU5HLHQsaSsxLG8pO2lmKGM9PT05Mil7bys9bi5zbGljZShzLGkpO2NvbnN0IGQ9bi5jaGFyQ29kZUF0KGkrMSk9PT0xMTc/bi5jaGFyQ29kZUF0KGkrMik9PT0xMjM/bW4oZSxpKTp5bihlLGkpOnZuKGUsaSk7bys9ZC52YWx1ZSxpKz1kLnNpemUscz1pO2NvbnRpbnVlfWlmKGM9PT0xMHx8Yz09PTEzKWJyZWFrO2lmKGRlKGMpKSsraTtlbHNlIGlmKE9lKG4saSkpaSs9MjtlbHNlIHRocm93IEcoZS5zb3VyY2UsaSxgSW52YWxpZCBjaGFyYWN0ZXIgd2l0aGluIFN0cmluZzogJHt1ZShlLGkpfS5gKX10aHJvdyBHKGUuc291cmNlLGksIlVudGVybWluYXRlZCBzdHJpbmcuIil9ZnVuY3Rpb24gbW4oZSx0KXtjb25zdCBuPWUuc291cmNlLmJvZHk7bGV0IHI9MCxpPTM7Zm9yKDtpPDEyOyl7Y29uc3Qgcz1uLmNoYXJDb2RlQXQodCtpKyspO2lmKHM9PT0xMjUpe2lmKGk8NXx8IWRlKHIpKWJyZWFrO3JldHVybnt2YWx1ZTpTdHJpbmcuZnJvbUNvZGVQb2ludChyKSxzaXplOml9fWlmKHI9cjw8NHxiZShzKSxyPDApYnJlYWt9dGhyb3cgRyhlLnNvdXJjZSx0LGBJbnZhbGlkIFVuaWNvZGUgZXNjYXBlIHNlcXVlbmNlOiAiJHtuLnNsaWNlKHQsdCtpKX0iLmApfWZ1bmN0aW9uIHluKGUsdCl7Y29uc3Qgbj1lLnNvdXJjZS5ib2R5LHI9TnQobix0KzIpO2lmKGRlKHIpKXJldHVybnt2YWx1ZTpTdHJpbmcuZnJvbUNvZGVQb2ludChyKSxzaXplOjZ9O2lmKFR0KHIpJiZuLmNoYXJDb2RlQXQodCs2KT09PTkyJiZuLmNoYXJDb2RlQXQodCs3KT09PTExNyl7Y29uc3QgaT1OdChuLHQrOCk7aWYoYnQoaSkpcmV0dXJue3ZhbHVlOlN0cmluZy5mcm9tQ29kZVBvaW50KHIsaSksc2l6ZToxMn19dGhyb3cgRyhlLnNvdXJjZSx0LGBJbnZhbGlkIFVuaWNvZGUgZXNjYXBlIHNlcXVlbmNlOiAiJHtuLnNsaWNlKHQsdCs2KX0iLmApfWZ1bmN0aW9uIE50KGUsdCl7cmV0dXJuIGJlKGUuY2hhckNvZGVBdCh0KSk8PDEyfGJlKGUuY2hhckNvZGVBdCh0KzEpKTw8OHxiZShlLmNoYXJDb2RlQXQodCsyKSk8PDR8YmUoZS5jaGFyQ29kZUF0KHQrMykpfWZ1bmN0aW9uIGJlKGUpe3JldHVybiBlPj00OCYmZTw9NTc/ZS00ODplPj02NSYmZTw9NzA/ZS01NTplPj05NyYmZTw9MTAyP2UtODc6LTF9ZnVuY3Rpb24gdm4oZSx0KXtjb25zdCBuPWUuc291cmNlLmJvZHk7c3dpdGNoKG4uY2hhckNvZGVBdCh0KzEpKXtjYXNlIDM0OnJldHVybnt2YWx1ZTonIicsc2l6ZToyfTtjYXNlIDkyOnJldHVybnt2YWx1ZToiXFwiLHNpemU6Mn07Y2FzZSA0NzpyZXR1cm57dmFsdWU6Ii8iLHNpemU6Mn07Y2FzZSA5ODpyZXR1cm57dmFsdWU6IlxiIixzaXplOjJ9O2Nhc2UgMTAyOnJldHVybnt2YWx1ZToiXGYiLHNpemU6Mn07Y2FzZSAxMTA6cmV0dXJue3ZhbHVlOmAKYCxzaXplOjJ9O2Nhc2UgMTE0OnJldHVybnt2YWx1ZToiXHIiLHNpemU6Mn07Y2FzZSAxMTY6cmV0dXJue3ZhbHVlOiIJIixzaXplOjJ9fXRocm93IEcoZS5zb3VyY2UsdCxgSW52YWxpZCBjaGFyYWN0ZXIgZXNjYXBlIHNlcXVlbmNlOiAiJHtuLnNsaWNlKHQsdCsyKX0iLmApfWZ1bmN0aW9uIGduKGUsdCl7Y29uc3Qgbj1lLnNvdXJjZS5ib2R5LHI9bi5sZW5ndGg7bGV0IGk9ZS5saW5lU3RhcnQscz10KzMsbz1zLGM9IiI7Y29uc3QgZD1bXTtmb3IoO3M8cjspe2NvbnN0IGY9bi5jaGFyQ29kZUF0KHMpO2lmKGY9PT0zNCYmbi5jaGFyQ29kZUF0KHMrMSk9PT0zNCYmbi5jaGFyQ29kZUF0KHMrMik9PT0zNCl7Yys9bi5zbGljZShvLHMpLGQucHVzaChjKTtjb25zdCB1PVUoZSxsLkJMT0NLX1NUUklORyx0LHMrMyxvbihkKS5qb2luKGAKYCkpO3JldHVybiBlLmxpbmUrPWQubGVuZ3RoLTEsZS5saW5lU3RhcnQ9aSx1fWlmKGY9PT05MiYmbi5jaGFyQ29kZUF0KHMrMSk9PT0zNCYmbi5jaGFyQ29kZUF0KHMrMik9PT0zNCYmbi5jaGFyQ29kZUF0KHMrMyk9PT0zNCl7Yys9bi5zbGljZShvLHMpLG89cysxLHMrPTQ7Y29udGludWV9aWYoZj09PTEwfHxmPT09MTMpe2MrPW4uc2xpY2UobyxzKSxkLnB1c2goYyksZj09PTEzJiZuLmNoYXJDb2RlQXQocysxKT09PTEwP3MrPTI6KytzLGM9IiIsbz1zLGk9cztjb250aW51ZX1pZihkZShmKSkrK3M7ZWxzZSBpZihPZShuLHMpKXMrPTI7ZWxzZSB0aHJvdyBHKGUuc291cmNlLHMsYEludmFsaWQgY2hhcmFjdGVyIHdpdGhpbiBTdHJpbmc6ICR7dWUoZSxzKX0uYCl9dGhyb3cgRyhlLnNvdXJjZSxzLCJVbnRlcm1pbmF0ZWQgc3RyaW5nLiIpfWZ1bmN0aW9uIEVuKGUsdCl7Y29uc3Qgbj1lLnNvdXJjZS5ib2R5LHI9bi5sZW5ndGg7bGV0IGk9dCsxO2Zvcig7aTxyOyl7Y29uc3Qgcz1uLmNoYXJDb2RlQXQoaSk7aWYoc24ocykpKytpO2Vsc2UgYnJlYWt9cmV0dXJuIFUoZSxsLk5BTUUsdCxpLG4uc2xpY2UodCxpKSl9Y29uc3QgX249MTAseHQ9MjtmdW5jdGlvbiBIZShlKXtyZXR1cm4gU2UoZSxbXSl9ZnVuY3Rpb24gU2UoZSx0KXtzd2l0Y2godHlwZW9mIGUpe2Nhc2Uic3RyaW5nIjpyZXR1cm4gSlNPTi5zdHJpbmdpZnkoZSk7Y2FzZSJmdW5jdGlvbiI6cmV0dXJuIGUubmFtZT9gW2Z1bmN0aW9uICR7ZS5uYW1lfV1gOiJbZnVuY3Rpb25dIjtjYXNlIm9iamVjdCI6cmV0dXJuIFRuKGUsdCk7ZGVmYXVsdDpyZXR1cm4gU3RyaW5nKGUpfX1mdW5jdGlvbiBUbihlLHQpe2lmKGU9PT1udWxsKXJldHVybiJudWxsIjtpZih0LmluY2x1ZGVzKGUpKXJldHVybiJbQ2lyY3VsYXJdIjtjb25zdCBuPVsuLi50LGVdO2lmKGJuKGUpKXtjb25zdCByPWUudG9KU09OKCk7aWYociE9PWUpcmV0dXJuIHR5cGVvZiByPT0ic3RyaW5nIj9yOlNlKHIsbil9ZWxzZSBpZihBcnJheS5pc0FycmF5KGUpKXJldHVybiB4bihlLG4pO3JldHVybiBObihlLG4pfWZ1bmN0aW9uIGJuKGUpe3JldHVybiB0eXBlb2YgZS50b0pTT049PSJmdW5jdGlvbiJ9ZnVuY3Rpb24gTm4oZSx0KXtjb25zdCBuPU9iamVjdC5lbnRyaWVzKGUpO3JldHVybiBuLmxlbmd0aD09PTA/Int9Ijp0Lmxlbmd0aD54dD8iWyIrQW4oZSkrIl0iOiJ7ICIrbi5tYXAoKFtpLHNdKT0+aSsiOiAiK1NlKHMsdCkpLmpvaW4oIiwgIikrIiB9In1mdW5jdGlvbiB4bihlLHQpe2lmKGUubGVuZ3RoPT09MClyZXR1cm4iW10iO2lmKHQubGVuZ3RoPnh0KXJldHVybiJbQXJyYXldIjtjb25zdCBuPU1hdGgubWluKF9uLGUubGVuZ3RoKSxyPWUubGVuZ3RoLW4saT1bXTtmb3IobGV0IHM9MDtzPG47KytzKWkucHVzaChTZShlW3NdLHQpKTtyZXR1cm4gcj09PTE/aS5wdXNoKCIuLi4gMSBtb3JlIGl0ZW0iKTpyPjEmJmkucHVzaChgLi4uICR7cn0gbW9yZSBpdGVtc2ApLCJbIitpLmpvaW4oIiwgIikrIl0ifWZ1bmN0aW9uIEFuKGUpe2NvbnN0IHQ9T2JqZWN0LnByb3RvdHlwZS50b1N0cmluZy5jYWxsKGUpLnJlcGxhY2UoL15cW29iamVjdCAvLCIiKS5yZXBsYWNlKC9dJC8sIiIpO2lmKHQ9PT0iT2JqZWN0IiYmdHlwZW9mIGUuY29uc3RydWN0b3I9PSJmdW5jdGlvbiIpe2NvbnN0IG49ZS5jb25zdHJ1Y3Rvci5uYW1lO2lmKHR5cGVvZiBuPT0ic3RyaW5nIiYmbiE9PSIiKXJldHVybiBufXJldHVybiB0fWNvbnN0IEluPWdsb2JhbFRoaXMucHJvY2VzcyYmZ2xvYmFsVGhpcy5wcm9jZXNzLmVudi5OT0RFX0VOVj09PSJwcm9kdWN0aW9uIj9mdW5jdGlvbih0LG4pe3JldHVybiB0IGluc3RhbmNlb2Ygbn06ZnVuY3Rpb24odCxuKXtpZih0IGluc3RhbmNlb2YgbilyZXR1cm4hMDtpZih0eXBlb2YgdD09Im9iamVjdCImJnQhPT1udWxsKXt2YXIgcjtjb25zdCBpPW4ucHJvdG90eXBlW1N5bWJvbC50b1N0cmluZ1RhZ10scz1TeW1ib2wudG9TdHJpbmdUYWcgaW4gdD90W1N5bWJvbC50b1N0cmluZ1RhZ106KHI9dC5jb25zdHJ1Y3Rvcik9PT1udWxsfHxyPT09dm9pZCAwP3ZvaWQgMDpyLm5hbWU7aWYoaT09PXMpe2NvbnN0IG89SGUodCk7dGhyb3cgbmV3IEVycm9yKGBDYW5ub3QgdXNlICR7aX0gIiR7b30iIGZyb20gYW5vdGhlciBtb2R1bGUgb3IgcmVhbG0uCgpFbnN1cmUgdGhhdCB0aGVyZSBpcyBvbmx5IG9uZSBpbnN0YW5jZSBvZiAiZ3JhcGhxbCIgaW4gdGhlIG5vZGVfbW9kdWxlcwpkaXJlY3RvcnkuIElmIGRpZmZlcmVudCB2ZXJzaW9ucyBvZiAiZ3JhcGhxbCIgYXJlIHRoZSBkZXBlbmRlbmNpZXMgb2Ygb3RoZXIKcmVsaWVkIG9uIG1vZHVsZXMsIHVzZSAicmVzb2x1dGlvbnMiIHRvIGVuc3VyZSBvbmx5IG9uZSB2ZXJzaW9uIGlzIGluc3RhbGxlZC4KCmh0dHBzOi8veWFybnBrZy5jb20vZW4vZG9jcy9zZWxlY3RpdmUtdmVyc2lvbi1yZXNvbHV0aW9ucwoKRHVwbGljYXRlICJncmFwaHFsIiBtb2R1bGVzIGNhbm5vdCBiZSB1c2VkIGF0IHRoZSBzYW1lIHRpbWUgc2luY2UgZGlmZmVyZW50CnZlcnNpb25zIG1heSBoYXZlIGRpZmZlcmVudCBjYXBhYmlsaXRpZXMgYW5kIGJlaGF2aW9yLiBUaGUgZGF0YSBmcm9tIG9uZQp2ZXJzaW9uIHVzZWQgaW4gdGhlIGZ1bmN0aW9uIGZyb20gYW5vdGhlciBjb3VsZCBwcm9kdWNlIGNvbmZ1c2luZyBhbmQKc3B1cmlvdXMgcmVzdWx0cy5gKX19cmV0dXJuITF9O2NsYXNzIEF0e2NvbnN0cnVjdG9yKHQsbj0iR3JhcGhRTCByZXF1ZXN0IixyPXtsaW5lOjEsY29sdW1uOjF9KXt0eXBlb2YgdD09InN0cmluZyJ8fEsoITEsYEJvZHkgbXVzdCBiZSBhIHN0cmluZy4gUmVjZWl2ZWQ6ICR7SGUodCl9LmApLHRoaXMuYm9keT10LHRoaXMubmFtZT1uLHRoaXMubG9jYXRpb25PZmZzZXQ9cix0aGlzLmxvY2F0aW9uT2Zmc2V0LmxpbmU+MHx8SyghMSwibGluZSBpbiBsb2NhdGlvbk9mZnNldCBpcyAxLWluZGV4ZWQgYW5kIG11c3QgYmUgcG9zaXRpdmUuIiksdGhpcy5sb2NhdGlvbk9mZnNldC5jb2x1bW4+MHx8SyghMSwiY29sdW1uIGluIGxvY2F0aW9uT2Zmc2V0IGlzIDEtaW5kZXhlZCBhbmQgbXVzdCBiZSBwb3NpdGl2ZS4iKX1nZXRbU3ltYm9sLnRvU3RyaW5nVGFnXSgpe3JldHVybiJTb3VyY2UifX1mdW5jdGlvbiBPbihlKXtyZXR1cm4gSW4oZSxBdCl9ZnVuY3Rpb24gSXQoZSx0KXtyZXR1cm4gbmV3IFNuKGUsdCkucGFyc2VEb2N1bWVudCgpfWNsYXNzIFNue2NvbnN0cnVjdG9yKHQsbj17fSl7Y29uc3Qgcj1Pbih0KT90Om5ldyBBdCh0KTt0aGlzLl9sZXhlcj1uZXcgdW4ociksdGhpcy5fb3B0aW9ucz1uLHRoaXMuX3Rva2VuQ291bnRlcj0wfXBhcnNlTmFtZSgpe2NvbnN0IHQ9dGhpcy5leHBlY3RUb2tlbihsLk5BTUUpO3JldHVybiB0aGlzLm5vZGUodCx7a2luZDpULk5BTUUsdmFsdWU6dC52YWx1ZX0pfXBhcnNlRG9jdW1lbnQoKXtyZXR1cm4gdGhpcy5ub2RlKHRoaXMuX2xleGVyLnRva2VuLHtraW5kOlQuRE9DVU1FTlQsZGVmaW5pdGlvbnM6dGhpcy5tYW55KGwuU09GLHRoaXMucGFyc2VEZWZpbml0aW9uLGwuRU9GKX0pfXBhcnNlRGVmaW5pdGlvbigpe2lmKHRoaXMucGVlayhsLkJSQUNFX0wpKXJldHVybiB0aGlzLnBhcnNlT3BlcmF0aW9uRGVmaW5pdGlvbigpO2NvbnN0IHQ9dGhpcy5wZWVrRGVzY3JpcHRpb24oKSxuPXQ/dGhpcy5fbGV4ZXIubG9va2FoZWFkKCk6dGhpcy5fbGV4ZXIudG9rZW47aWYobi5raW5kPT09bC5OQU1FKXtzd2l0Y2gobi52YWx1ZSl7Y2FzZSJzY2hlbWEiOnJldHVybiB0aGlzLnBhcnNlU2NoZW1hRGVmaW5pdGlvbigpO2Nhc2Uic2NhbGFyIjpyZXR1cm4gdGhpcy5wYXJzZVNjYWxhclR5cGVEZWZpbml0aW9uKCk7Y2FzZSJ0eXBlIjpyZXR1cm4gdGhpcy5wYXJzZU9iamVjdFR5cGVEZWZpbml0aW9uKCk7Y2FzZSJpbnRlcmZhY2UiOnJldHVybiB0aGlzLnBhcnNlSW50ZXJmYWNlVHlwZURlZmluaXRpb24oKTtjYXNlInVuaW9uIjpyZXR1cm4gdGhpcy5wYXJzZVVuaW9uVHlwZURlZmluaXRpb24oKTtjYXNlImVudW0iOnJldHVybiB0aGlzLnBhcnNlRW51bVR5cGVEZWZpbml0aW9uKCk7Y2FzZSJpbnB1dCI6cmV0dXJuIHRoaXMucGFyc2VJbnB1dE9iamVjdFR5cGVEZWZpbml0aW9uKCk7Y2FzZSJkaXJlY3RpdmUiOnJldHVybiB0aGlzLnBhcnNlRGlyZWN0aXZlRGVmaW5pdGlvbigpfWlmKHQpdGhyb3cgRyh0aGlzLl9sZXhlci5zb3VyY2UsdGhpcy5fbGV4ZXIudG9rZW4uc3RhcnQsIlVuZXhwZWN0ZWQgZGVzY3JpcHRpb24sIGRlc2NyaXB0aW9ucyBhcmUgc3VwcG9ydGVkIG9ubHkgb24gdHlwZSBkZWZpbml0aW9ucy4iKTtzd2l0Y2gobi52YWx1ZSl7Y2FzZSJxdWVyeSI6Y2FzZSJtdXRhdGlvbiI6Y2FzZSJzdWJzY3JpcHRpb24iOnJldHVybiB0aGlzLnBhcnNlT3BlcmF0aW9uRGVmaW5pdGlvbigpO2Nhc2UiZnJhZ21lbnQiOnJldHVybiB0aGlzLnBhcnNlRnJhZ21lbnREZWZpbml0aW9uKCk7Y2FzZSJleHRlbmQiOnJldHVybiB0aGlzLnBhcnNlVHlwZVN5c3RlbUV4dGVuc2lvbigpfX10aHJvdyB0aGlzLnVuZXhwZWN0ZWQobil9cGFyc2VPcGVyYXRpb25EZWZpbml0aW9uKCl7Y29uc3QgdD10aGlzLl9sZXhlci50b2tlbjtpZih0aGlzLnBlZWsobC5CUkFDRV9MKSlyZXR1cm4gdGhpcy5ub2RlKHQse2tpbmQ6VC5PUEVSQVRJT05fREVGSU5JVElPTixvcGVyYXRpb246aGUuUVVFUlksbmFtZTp2b2lkIDAsdmFyaWFibGVEZWZpbml0aW9uczpbXSxkaXJlY3RpdmVzOltdLHNlbGVjdGlvblNldDp0aGlzLnBhcnNlU2VsZWN0aW9uU2V0KCl9KTtjb25zdCBuPXRoaXMucGFyc2VPcGVyYXRpb25UeXBlKCk7bGV0IHI7cmV0dXJuIHRoaXMucGVlayhsLk5BTUUpJiYocj10aGlzLnBhcnNlTmFtZSgpKSx0aGlzLm5vZGUodCx7a2luZDpULk9QRVJBVElPTl9ERUZJTklUSU9OLG9wZXJhdGlvbjpuLG5hbWU6cix2YXJpYWJsZURlZmluaXRpb25zOnRoaXMucGFyc2VWYXJpYWJsZURlZmluaXRpb25zKCksZGlyZWN0aXZlczp0aGlzLnBhcnNlRGlyZWN0aXZlcyghMSksc2VsZWN0aW9uU2V0OnRoaXMucGFyc2VTZWxlY3Rpb25TZXQoKX0pfXBhcnNlT3BlcmF0aW9uVHlwZSgpe2NvbnN0IHQ9dGhpcy5leHBlY3RUb2tlbihsLk5BTUUpO3N3aXRjaCh0LnZhbHVlKXtjYXNlInF1ZXJ5IjpyZXR1cm4gaGUuUVVFUlk7Y2FzZSJtdXRhdGlvbiI6cmV0dXJuIGhlLk1VVEFUSU9OO2Nhc2Uic3Vic2NyaXB0aW9uIjpyZXR1cm4gaGUuU1VCU0NSSVBUSU9OfXRocm93IHRoaXMudW5leHBlY3RlZCh0KX1wYXJzZVZhcmlhYmxlRGVmaW5pdGlvbnMoKXtyZXR1cm4gdGhpcy5vcHRpb25hbE1hbnkobC5QQVJFTl9MLHRoaXMucGFyc2VWYXJpYWJsZURlZmluaXRpb24sbC5QQVJFTl9SKX1wYXJzZVZhcmlhYmxlRGVmaW5pdGlvbigpe3JldHVybiB0aGlzLm5vZGUodGhpcy5fbGV4ZXIudG9rZW4se2tpbmQ6VC5WQVJJQUJMRV9ERUZJTklUSU9OLHZhcmlhYmxlOnRoaXMucGFyc2VWYXJpYWJsZSgpLHR5cGU6KHRoaXMuZXhwZWN0VG9rZW4obC5DT0xPTiksdGhpcy5wYXJzZVR5cGVSZWZlcmVuY2UoKSksZGVmYXVsdFZhbHVlOnRoaXMuZXhwZWN0T3B0aW9uYWxUb2tlbihsLkVRVUFMUyk/dGhpcy5wYXJzZUNvbnN0VmFsdWVMaXRlcmFsKCk6dm9pZCAwLGRpcmVjdGl2ZXM6dGhpcy5wYXJzZUNvbnN0RGlyZWN0aXZlcygpfSl9cGFyc2VWYXJpYWJsZSgpe2NvbnN0IHQ9dGhpcy5fbGV4ZXIudG9rZW47cmV0dXJuIHRoaXMuZXhwZWN0VG9rZW4obC5ET0xMQVIpLHRoaXMubm9kZSh0LHtraW5kOlQuVkFSSUFCTEUsbmFtZTp0aGlzLnBhcnNlTmFtZSgpfSl9cGFyc2VTZWxlY3Rpb25TZXQoKXtyZXR1cm4gdGhpcy5ub2RlKHRoaXMuX2xleGVyLnRva2VuLHtraW5kOlQuU0VMRUNUSU9OX1NFVCxzZWxlY3Rpb25zOnRoaXMubWFueShsLkJSQUNFX0wsdGhpcy5wYXJzZVNlbGVjdGlvbixsLkJSQUNFX1IpfSl9cGFyc2VTZWxlY3Rpb24oKXtyZXR1cm4gdGhpcy5wZWVrKGwuU1BSRUFEKT90aGlzLnBhcnNlRnJhZ21lbnQoKTp0aGlzLnBhcnNlRmllbGQoKX1wYXJzZUZpZWxkKCl7Y29uc3QgdD10aGlzLl9sZXhlci50b2tlbixuPXRoaXMucGFyc2VOYW1lKCk7bGV0IHIsaTtyZXR1cm4gdGhpcy5leHBlY3RPcHRpb25hbFRva2VuKGwuQ09MT04pPyhyPW4saT10aGlzLnBhcnNlTmFtZSgpKTppPW4sdGhpcy5ub2RlKHQse2tpbmQ6VC5GSUVMRCxhbGlhczpyLG5hbWU6aSxhcmd1bWVudHM6dGhpcy5wYXJzZUFyZ3VtZW50cyghMSksZGlyZWN0aXZlczp0aGlzLnBhcnNlRGlyZWN0aXZlcyghMSksc2VsZWN0aW9uU2V0OnRoaXMucGVlayhsLkJSQUNFX0wpP3RoaXMucGFyc2VTZWxlY3Rpb25TZXQoKTp2b2lkIDB9KX1wYXJzZUFyZ3VtZW50cyh0KXtjb25zdCBuPXQ/dGhpcy5wYXJzZUNvbnN0QXJndW1lbnQ6dGhpcy5wYXJzZUFyZ3VtZW50O3JldHVybiB0aGlzLm9wdGlvbmFsTWFueShsLlBBUkVOX0wsbixsLlBBUkVOX1IpfXBhcnNlQXJndW1lbnQodD0hMSl7Y29uc3Qgbj10aGlzLl9sZXhlci50b2tlbixyPXRoaXMucGFyc2VOYW1lKCk7cmV0dXJuIHRoaXMuZXhwZWN0VG9rZW4obC5DT0xPTiksdGhpcy5ub2RlKG4se2tpbmQ6VC5BUkdVTUVOVCxuYW1lOnIsdmFsdWU6dGhpcy5wYXJzZVZhbHVlTGl0ZXJhbCh0KX0pfXBhcnNlQ29uc3RBcmd1bWVudCgpe3JldHVybiB0aGlzLnBhcnNlQXJndW1lbnQoITApfXBhcnNlRnJhZ21lbnQoKXtjb25zdCB0PXRoaXMuX2xleGVyLnRva2VuO3RoaXMuZXhwZWN0VG9rZW4obC5TUFJFQUQpO2NvbnN0IG49dGhpcy5leHBlY3RPcHRpb25hbEtleXdvcmQoIm9uIik7cmV0dXJuIW4mJnRoaXMucGVlayhsLk5BTUUpP3RoaXMubm9kZSh0LHtraW5kOlQuRlJBR01FTlRfU1BSRUFELG5hbWU6dGhpcy5wYXJzZUZyYWdtZW50TmFtZSgpLGRpcmVjdGl2ZXM6dGhpcy5wYXJzZURpcmVjdGl2ZXMoITEpfSk6dGhpcy5ub2RlKHQse2tpbmQ6VC5JTkxJTkVfRlJBR01FTlQsdHlwZUNvbmRpdGlvbjpuP3RoaXMucGFyc2VOYW1lZFR5cGUoKTp2b2lkIDAsZGlyZWN0aXZlczp0aGlzLnBhcnNlRGlyZWN0aXZlcyghMSksc2VsZWN0aW9uU2V0OnRoaXMucGFyc2VTZWxlY3Rpb25TZXQoKX0pfXBhcnNlRnJhZ21lbnREZWZpbml0aW9uKCl7Y29uc3QgdD10aGlzLl9sZXhlci50b2tlbjtyZXR1cm4gdGhpcy5leHBlY3RLZXl3b3JkKCJmcmFnbWVudCIpLHRoaXMuX29wdGlvbnMuYWxsb3dMZWdhY3lGcmFnbWVudFZhcmlhYmxlcz09PSEwP3RoaXMubm9kZSh0LHtraW5kOlQuRlJBR01FTlRfREVGSU5JVElPTixuYW1lOnRoaXMucGFyc2VGcmFnbWVudE5hbWUoKSx2YXJpYWJsZURlZmluaXRpb25zOnRoaXMucGFyc2VWYXJpYWJsZURlZmluaXRpb25zKCksdHlwZUNvbmRpdGlvbjoodGhpcy5leHBlY3RLZXl3b3JkKCJvbiIpLHRoaXMucGFyc2VOYW1lZFR5cGUoKSksZGlyZWN0aXZlczp0aGlzLnBhcnNlRGlyZWN0aXZlcyghMSksc2VsZWN0aW9uU2V0OnRoaXMucGFyc2VTZWxlY3Rpb25TZXQoKX0pOnRoaXMubm9kZSh0LHtraW5kOlQuRlJBR01FTlRfREVGSU5JVElPTixuYW1lOnRoaXMucGFyc2VGcmFnbWVudE5hbWUoKSx0eXBlQ29uZGl0aW9uOih0aGlzLmV4cGVjdEtleXdvcmQoIm9uIiksdGhpcy5wYXJzZU5hbWVkVHlwZSgpKSxkaXJlY3RpdmVzOnRoaXMucGFyc2VEaXJlY3RpdmVzKCExKSxzZWxlY3Rpb25TZXQ6dGhpcy5wYXJzZVNlbGVjdGlvblNldCgpfSl9cGFyc2VGcmFnbWVudE5hbWUoKXtpZih0aGlzLl9sZXhlci50b2tlbi52YWx1ZT09PSJvbiIpdGhyb3cgdGhpcy51bmV4cGVjdGVkKCk7cmV0dXJuIHRoaXMucGFyc2VOYW1lKCl9cGFyc2VWYWx1ZUxpdGVyYWwodCl7Y29uc3Qgbj10aGlzLl9sZXhlci50b2tlbjtzd2l0Y2gobi5raW5kKXtjYXNlIGwuQlJBQ0tFVF9MOnJldHVybiB0aGlzLnBhcnNlTGlzdCh0KTtjYXNlIGwuQlJBQ0VfTDpyZXR1cm4gdGhpcy5wYXJzZU9iamVjdCh0KTtjYXNlIGwuSU5UOnJldHVybiB0aGlzLmFkdmFuY2VMZXhlcigpLHRoaXMubm9kZShuLHtraW5kOlQuSU5ULHZhbHVlOm4udmFsdWV9KTtjYXNlIGwuRkxPQVQ6cmV0dXJuIHRoaXMuYWR2YW5jZUxleGVyKCksdGhpcy5ub2RlKG4se2tpbmQ6VC5GTE9BVCx2YWx1ZTpuLnZhbHVlfSk7Y2FzZSBsLlNUUklORzpjYXNlIGwuQkxPQ0tfU1RSSU5HOnJldHVybiB0aGlzLnBhcnNlU3RyaW5nTGl0ZXJhbCgpO2Nhc2UgbC5OQU1FOnN3aXRjaCh0aGlzLmFkdmFuY2VMZXhlcigpLG4udmFsdWUpe2Nhc2UidHJ1ZSI6cmV0dXJuIHRoaXMubm9kZShuLHtraW5kOlQuQk9PTEVBTix2YWx1ZTohMH0pO2Nhc2UiZmFsc2UiOnJldHVybiB0aGlzLm5vZGUobix7a2luZDpULkJPT0xFQU4sdmFsdWU6ITF9KTtjYXNlIm51bGwiOnJldHVybiB0aGlzLm5vZGUobix7a2luZDpULk5VTEx9KTtkZWZhdWx0OnJldHVybiB0aGlzLm5vZGUobix7a2luZDpULkVOVU0sdmFsdWU6bi52YWx1ZX0pfWNhc2UgbC5ET0xMQVI6aWYodClpZih0aGlzLmV4cGVjdFRva2VuKGwuRE9MTEFSKSx0aGlzLl9sZXhlci50b2tlbi5raW5kPT09bC5OQU1FKXtjb25zdCByPXRoaXMuX2xleGVyLnRva2VuLnZhbHVlO3Rocm93IEcodGhpcy5fbGV4ZXIuc291cmNlLG4uc3RhcnQsYFVuZXhwZWN0ZWQgdmFyaWFibGUgIiQke3J9IiBpbiBjb25zdGFudCB2YWx1ZS5gKX1lbHNlIHRocm93IHRoaXMudW5leHBlY3RlZChuKTtyZXR1cm4gdGhpcy5wYXJzZVZhcmlhYmxlKCk7ZGVmYXVsdDp0aHJvdyB0aGlzLnVuZXhwZWN0ZWQoKX19cGFyc2VDb25zdFZhbHVlTGl0ZXJhbCgpe3JldHVybiB0aGlzLnBhcnNlVmFsdWVMaXRlcmFsKCEwKX1wYXJzZVN0cmluZ0xpdGVyYWwoKXtjb25zdCB0PXRoaXMuX2xleGVyLnRva2VuO3JldHVybiB0aGlzLmFkdmFuY2VMZXhlcigpLHRoaXMubm9kZSh0LHtraW5kOlQuU1RSSU5HLHZhbHVlOnQudmFsdWUsYmxvY2s6dC5raW5kPT09bC5CTE9DS19TVFJJTkd9KX1wYXJzZUxpc3QodCl7Y29uc3Qgbj0oKT0+dGhpcy5wYXJzZVZhbHVlTGl0ZXJhbCh0KTtyZXR1cm4gdGhpcy5ub2RlKHRoaXMuX2xleGVyLnRva2VuLHtraW5kOlQuTElTVCx2YWx1ZXM6dGhpcy5hbnkobC5CUkFDS0VUX0wsbixsLkJSQUNLRVRfUil9KX1wYXJzZU9iamVjdCh0KXtjb25zdCBuPSgpPT50aGlzLnBhcnNlT2JqZWN0RmllbGQodCk7cmV0dXJuIHRoaXMubm9kZSh0aGlzLl9sZXhlci50b2tlbix7a2luZDpULk9CSkVDVCxmaWVsZHM6dGhpcy5hbnkobC5CUkFDRV9MLG4sbC5CUkFDRV9SKX0pfXBhcnNlT2JqZWN0RmllbGQodCl7Y29uc3Qgbj10aGlzLl9sZXhlci50b2tlbixyPXRoaXMucGFyc2VOYW1lKCk7cmV0dXJuIHRoaXMuZXhwZWN0VG9rZW4obC5DT0xPTiksdGhpcy5ub2RlKG4se2tpbmQ6VC5PQkpFQ1RfRklFTEQsbmFtZTpyLHZhbHVlOnRoaXMucGFyc2VWYWx1ZUxpdGVyYWwodCl9KX1wYXJzZURpcmVjdGl2ZXModCl7Y29uc3Qgbj1bXTtmb3IoO3RoaXMucGVlayhsLkFUKTspbi5wdXNoKHRoaXMucGFyc2VEaXJlY3RpdmUodCkpO3JldHVybiBufXBhcnNlQ29uc3REaXJlY3RpdmVzKCl7cmV0dXJuIHRoaXMucGFyc2VEaXJlY3RpdmVzKCEwKX1wYXJzZURpcmVjdGl2ZSh0KXtjb25zdCBuPXRoaXMuX2xleGVyLnRva2VuO3JldHVybiB0aGlzLmV4cGVjdFRva2VuKGwuQVQpLHRoaXMubm9kZShuLHtraW5kOlQuRElSRUNUSVZFLG5hbWU6dGhpcy5wYXJzZU5hbWUoKSxhcmd1bWVudHM6dGhpcy5wYXJzZUFyZ3VtZW50cyh0KX0pfXBhcnNlVHlwZVJlZmVyZW5jZSgpe2NvbnN0IHQ9dGhpcy5fbGV4ZXIudG9rZW47bGV0IG47aWYodGhpcy5leHBlY3RPcHRpb25hbFRva2VuKGwuQlJBQ0tFVF9MKSl7Y29uc3Qgcj10aGlzLnBhcnNlVHlwZVJlZmVyZW5jZSgpO3RoaXMuZXhwZWN0VG9rZW4obC5CUkFDS0VUX1IpLG49dGhpcy5ub2RlKHQse2tpbmQ6VC5MSVNUX1RZUEUsdHlwZTpyfSl9ZWxzZSBuPXRoaXMucGFyc2VOYW1lZFR5cGUoKTtyZXR1cm4gdGhpcy5leHBlY3RPcHRpb25hbFRva2VuKGwuQkFORyk/dGhpcy5ub2RlKHQse2tpbmQ6VC5OT05fTlVMTF9UWVBFLHR5cGU6bn0pOm59cGFyc2VOYW1lZFR5cGUoKXtyZXR1cm4gdGhpcy5ub2RlKHRoaXMuX2xleGVyLnRva2VuLHtraW5kOlQuTkFNRURfVFlQRSxuYW1lOnRoaXMucGFyc2VOYW1lKCl9KX1wZWVrRGVzY3JpcHRpb24oKXtyZXR1cm4gdGhpcy5wZWVrKGwuU1RSSU5HKXx8dGhpcy5wZWVrKGwuQkxPQ0tfU1RSSU5HKX1wYXJzZURlc2NyaXB0aW9uKCl7aWYodGhpcy5wZWVrRGVzY3JpcHRpb24oKSlyZXR1cm4gdGhpcy5wYXJzZVN0cmluZ0xpdGVyYWwoKX1wYXJzZVNjaGVtYURlZmluaXRpb24oKXtjb25zdCB0PXRoaXMuX2xleGVyLnRva2VuLG49dGhpcy5wYXJzZURlc2NyaXB0aW9uKCk7dGhpcy5leHBlY3RLZXl3b3JkKCJzY2hlbWEiKTtjb25zdCByPXRoaXMucGFyc2VDb25zdERpcmVjdGl2ZXMoKSxpPXRoaXMubWFueShsLkJSQUNFX0wsdGhpcy5wYXJzZU9wZXJhdGlvblR5cGVEZWZpbml0aW9uLGwuQlJBQ0VfUik7cmV0dXJuIHRoaXMubm9kZSh0LHtraW5kOlQuU0NIRU1BX0RFRklOSVRJT04sZGVzY3JpcHRpb246bixkaXJlY3RpdmVzOnIsb3BlcmF0aW9uVHlwZXM6aX0pfXBhcnNlT3BlcmF0aW9uVHlwZURlZmluaXRpb24oKXtjb25zdCB0PXRoaXMuX2xleGVyLnRva2VuLG49dGhpcy5wYXJzZU9wZXJhdGlvblR5cGUoKTt0aGlzLmV4cGVjdFRva2VuKGwuQ09MT04pO2NvbnN0IHI9dGhpcy5wYXJzZU5hbWVkVHlwZSgpO3JldHVybiB0aGlzLm5vZGUodCx7a2luZDpULk9QRVJBVElPTl9UWVBFX0RFRklOSVRJT04sb3BlcmF0aW9uOm4sdHlwZTpyfSl9cGFyc2VTY2FsYXJUeXBlRGVmaW5pdGlvbigpe2NvbnN0IHQ9dGhpcy5fbGV4ZXIudG9rZW4sbj10aGlzLnBhcnNlRGVzY3JpcHRpb24oKTt0aGlzLmV4cGVjdEtleXdvcmQoInNjYWxhciIpO2NvbnN0IHI9dGhpcy5wYXJzZU5hbWUoKSxpPXRoaXMucGFyc2VDb25zdERpcmVjdGl2ZXMoKTtyZXR1cm4gdGhpcy5ub2RlKHQse2tpbmQ6VC5TQ0FMQVJfVFlQRV9ERUZJTklUSU9OLGRlc2NyaXB0aW9uOm4sbmFtZTpyLGRpcmVjdGl2ZXM6aX0pfXBhcnNlT2JqZWN0VHlwZURlZmluaXRpb24oKXtjb25zdCB0PXRoaXMuX2xleGVyLnRva2VuLG49dGhpcy5wYXJzZURlc2NyaXB0aW9uKCk7dGhpcy5leHBlY3RLZXl3b3JkKCJ0eXBlIik7Y29uc3Qgcj10aGlzLnBhcnNlTmFtZSgpLGk9dGhpcy5wYXJzZUltcGxlbWVudHNJbnRlcmZhY2VzKCkscz10aGlzLnBhcnNlQ29uc3REaXJlY3RpdmVzKCksbz10aGlzLnBhcnNlRmllbGRzRGVmaW5pdGlvbigpO3JldHVybiB0aGlzLm5vZGUodCx7a2luZDpULk9CSkVDVF9UWVBFX0RFRklOSVRJT04sZGVzY3JpcHRpb246bixuYW1lOnIsaW50ZXJmYWNlczppLGRpcmVjdGl2ZXM6cyxmaWVsZHM6b30pfXBhcnNlSW1wbGVtZW50c0ludGVyZmFjZXMoKXtyZXR1cm4gdGhpcy5leHBlY3RPcHRpb25hbEtleXdvcmQoImltcGxlbWVudHMiKT90aGlzLmRlbGltaXRlZE1hbnkobC5BTVAsdGhpcy5wYXJzZU5hbWVkVHlwZSk6W119cGFyc2VGaWVsZHNEZWZpbml0aW9uKCl7cmV0dXJuIHRoaXMub3B0aW9uYWxNYW55KGwuQlJBQ0VfTCx0aGlzLnBhcnNlRmllbGREZWZpbml0aW9uLGwuQlJBQ0VfUil9cGFyc2VGaWVsZERlZmluaXRpb24oKXtjb25zdCB0PXRoaXMuX2xleGVyLnRva2VuLG49dGhpcy5wYXJzZURlc2NyaXB0aW9uKCkscj10aGlzLnBhcnNlTmFtZSgpLGk9dGhpcy5wYXJzZUFyZ3VtZW50RGVmcygpO3RoaXMuZXhwZWN0VG9rZW4obC5DT0xPTik7Y29uc3Qgcz10aGlzLnBhcnNlVHlwZVJlZmVyZW5jZSgpLG89dGhpcy5wYXJzZUNvbnN0RGlyZWN0aXZlcygpO3JldHVybiB0aGlzLm5vZGUodCx7a2luZDpULkZJRUxEX0RFRklOSVRJT04sZGVzY3JpcHRpb246bixuYW1lOnIsYXJndW1lbnRzOmksdHlwZTpzLGRpcmVjdGl2ZXM6b30pfXBhcnNlQXJndW1lbnREZWZzKCl7cmV0dXJuIHRoaXMub3B0aW9uYWxNYW55KGwuUEFSRU5fTCx0aGlzLnBhcnNlSW5wdXRWYWx1ZURlZixsLlBBUkVOX1IpfXBhcnNlSW5wdXRWYWx1ZURlZigpe2NvbnN0IHQ9dGhpcy5fbGV4ZXIudG9rZW4sbj10aGlzLnBhcnNlRGVzY3JpcHRpb24oKSxyPXRoaXMucGFyc2VOYW1lKCk7dGhpcy5leHBlY3RUb2tlbihsLkNPTE9OKTtjb25zdCBpPXRoaXMucGFyc2VUeXBlUmVmZXJlbmNlKCk7bGV0IHM7dGhpcy5leHBlY3RPcHRpb25hbFRva2VuKGwuRVFVQUxTKSYmKHM9dGhpcy5wYXJzZUNvbnN0VmFsdWVMaXRlcmFsKCkpO2NvbnN0IG89dGhpcy5wYXJzZUNvbnN0RGlyZWN0aXZlcygpO3JldHVybiB0aGlzLm5vZGUodCx7a2luZDpULklOUFVUX1ZBTFVFX0RFRklOSVRJT04sZGVzY3JpcHRpb246bixuYW1lOnIsdHlwZTppLGRlZmF1bHRWYWx1ZTpzLGRpcmVjdGl2ZXM6b30pfXBhcnNlSW50ZXJmYWNlVHlwZURlZmluaXRpb24oKXtjb25zdCB0PXRoaXMuX2xleGVyLnRva2VuLG49dGhpcy5wYXJzZURlc2NyaXB0aW9uKCk7dGhpcy5leHBlY3RLZXl3b3JkKCJpbnRlcmZhY2UiKTtjb25zdCByPXRoaXMucGFyc2VOYW1lKCksaT10aGlzLnBhcnNlSW1wbGVtZW50c0ludGVyZmFjZXMoKSxzPXRoaXMucGFyc2VDb25zdERpcmVjdGl2ZXMoKSxvPXRoaXMucGFyc2VGaWVsZHNEZWZpbml0aW9uKCk7cmV0dXJuIHRoaXMubm9kZSh0LHtraW5kOlQuSU5URVJGQUNFX1RZUEVfREVGSU5JVElPTixkZXNjcmlwdGlvbjpuLG5hbWU6cixpbnRlcmZhY2VzOmksZGlyZWN0aXZlczpzLGZpZWxkczpvfSl9cGFyc2VVbmlvblR5cGVEZWZpbml0aW9uKCl7Y29uc3QgdD10aGlzLl9sZXhlci50b2tlbixuPXRoaXMucGFyc2VEZXNjcmlwdGlvbigpO3RoaXMuZXhwZWN0S2V5d29yZCgidW5pb24iKTtjb25zdCByPXRoaXMucGFyc2VOYW1lKCksaT10aGlzLnBhcnNlQ29uc3REaXJlY3RpdmVzKCkscz10aGlzLnBhcnNlVW5pb25NZW1iZXJUeXBlcygpO3JldHVybiB0aGlzLm5vZGUodCx7a2luZDpULlVOSU9OX1RZUEVfREVGSU5JVElPTixkZXNjcmlwdGlvbjpuLG5hbWU6cixkaXJlY3RpdmVzOmksdHlwZXM6c30pfXBhcnNlVW5pb25NZW1iZXJUeXBlcygpe3JldHVybiB0aGlzLmV4cGVjdE9wdGlvbmFsVG9rZW4obC5FUVVBTFMpP3RoaXMuZGVsaW1pdGVkTWFueShsLlBJUEUsdGhpcy5wYXJzZU5hbWVkVHlwZSk6W119cGFyc2VFbnVtVHlwZURlZmluaXRpb24oKXtjb25zdCB0PXRoaXMuX2xleGVyLnRva2VuLG49dGhpcy5wYXJzZURlc2NyaXB0aW9uKCk7dGhpcy5leHBlY3RLZXl3b3JkKCJlbnVtIik7Y29uc3Qgcj10aGlzLnBhcnNlTmFtZSgpLGk9dGhpcy5wYXJzZUNvbnN0RGlyZWN0aXZlcygpLHM9dGhpcy5wYXJzZUVudW1WYWx1ZXNEZWZpbml0aW9uKCk7cmV0dXJuIHRoaXMubm9kZSh0LHtraW5kOlQuRU5VTV9UWVBFX0RFRklOSVRJT04sZGVzY3JpcHRpb246bixuYW1lOnIsZGlyZWN0aXZlczppLHZhbHVlczpzfSl9cGFyc2VFbnVtVmFsdWVzRGVmaW5pdGlvbigpe3JldHVybiB0aGlzLm9wdGlvbmFsTWFueShsLkJSQUNFX0wsdGhpcy5wYXJzZUVudW1WYWx1ZURlZmluaXRpb24sbC5CUkFDRV9SKX1wYXJzZUVudW1WYWx1ZURlZmluaXRpb24oKXtjb25zdCB0PXRoaXMuX2xleGVyLnRva2VuLG49dGhpcy5wYXJzZURlc2NyaXB0aW9uKCkscj10aGlzLnBhcnNlRW51bVZhbHVlTmFtZSgpLGk9dGhpcy5wYXJzZUNvbnN0RGlyZWN0aXZlcygpO3JldHVybiB0aGlzLm5vZGUodCx7a2luZDpULkVOVU1fVkFMVUVfREVGSU5JVElPTixkZXNjcmlwdGlvbjpuLG5hbWU6cixkaXJlY3RpdmVzOml9KX1wYXJzZUVudW1WYWx1ZU5hbWUoKXtpZih0aGlzLl9sZXhlci50b2tlbi52YWx1ZT09PSJ0cnVlInx8dGhpcy5fbGV4ZXIudG9rZW4udmFsdWU9PT0iZmFsc2UifHx0aGlzLl9sZXhlci50b2tlbi52YWx1ZT09PSJudWxsIil0aHJvdyBHKHRoaXMuX2xleGVyLnNvdXJjZSx0aGlzLl9sZXhlci50b2tlbi5zdGFydCxgJHt3ZSh0aGlzLl9sZXhlci50b2tlbil9IGlzIHJlc2VydmVkIGFuZCBjYW5ub3QgYmUgdXNlZCBmb3IgYW4gZW51bSB2YWx1ZS5gKTtyZXR1cm4gdGhpcy5wYXJzZU5hbWUoKX1wYXJzZUlucHV0T2JqZWN0VHlwZURlZmluaXRpb24oKXtjb25zdCB0PXRoaXMuX2xleGVyLnRva2VuLG49dGhpcy5wYXJzZURlc2NyaXB0aW9uKCk7dGhpcy5leHBlY3RLZXl3b3JkKCJpbnB1dCIpO2NvbnN0IHI9dGhpcy5wYXJzZU5hbWUoKSxpPXRoaXMucGFyc2VDb25zdERpcmVjdGl2ZXMoKSxzPXRoaXMucGFyc2VJbnB1dEZpZWxkc0RlZmluaXRpb24oKTtyZXR1cm4gdGhpcy5ub2RlKHQse2tpbmQ6VC5JTlBVVF9PQkpFQ1RfVFlQRV9ERUZJTklUSU9OLGRlc2NyaXB0aW9uOm4sbmFtZTpyLGRpcmVjdGl2ZXM6aSxmaWVsZHM6c30pfXBhcnNlSW5wdXRGaWVsZHNEZWZpbml0aW9uKCl7cmV0dXJuIHRoaXMub3B0aW9uYWxNYW55KGwuQlJBQ0VfTCx0aGlzLnBhcnNlSW5wdXRWYWx1ZURlZixsLkJSQUNFX1IpfXBhcnNlVHlwZVN5c3RlbUV4dGVuc2lvbigpe2NvbnN0IHQ9dGhpcy5fbGV4ZXIubG9va2FoZWFkKCk7aWYodC5raW5kPT09bC5OQU1FKXN3aXRjaCh0LnZhbHVlKXtjYXNlInNjaGVtYSI6cmV0dXJuIHRoaXMucGFyc2VTY2hlbWFFeHRlbnNpb24oKTtjYXNlInNjYWxhciI6cmV0dXJuIHRoaXMucGFyc2VTY2FsYXJUeXBlRXh0ZW5zaW9uKCk7Y2FzZSJ0eXBlIjpyZXR1cm4gdGhpcy5wYXJzZU9iamVjdFR5cGVFeHRlbnNpb24oKTtjYXNlImludGVyZmFjZSI6cmV0dXJuIHRoaXMucGFyc2VJbnRlcmZhY2VUeXBlRXh0ZW5zaW9uKCk7Y2FzZSJ1bmlvbiI6cmV0dXJuIHRoaXMucGFyc2VVbmlvblR5cGVFeHRlbnNpb24oKTtjYXNlImVudW0iOnJldHVybiB0aGlzLnBhcnNlRW51bVR5cGVFeHRlbnNpb24oKTtjYXNlImlucHV0IjpyZXR1cm4gdGhpcy5wYXJzZUlucHV0T2JqZWN0VHlwZUV4dGVuc2lvbigpfXRocm93IHRoaXMudW5leHBlY3RlZCh0KX1wYXJzZVNjaGVtYUV4dGVuc2lvbigpe2NvbnN0IHQ9dGhpcy5fbGV4ZXIudG9rZW47dGhpcy5leHBlY3RLZXl3b3JkKCJleHRlbmQiKSx0aGlzLmV4cGVjdEtleXdvcmQoInNjaGVtYSIpO2NvbnN0IG49dGhpcy5wYXJzZUNvbnN0RGlyZWN0aXZlcygpLHI9dGhpcy5vcHRpb25hbE1hbnkobC5CUkFDRV9MLHRoaXMucGFyc2VPcGVyYXRpb25UeXBlRGVmaW5pdGlvbixsLkJSQUNFX1IpO2lmKG4ubGVuZ3RoPT09MCYmci5sZW5ndGg9PT0wKXRocm93IHRoaXMudW5leHBlY3RlZCgpO3JldHVybiB0aGlzLm5vZGUodCx7a2luZDpULlNDSEVNQV9FWFRFTlNJT04sZGlyZWN0aXZlczpuLG9wZXJhdGlvblR5cGVzOnJ9KX1wYXJzZVNjYWxhclR5cGVFeHRlbnNpb24oKXtjb25zdCB0PXRoaXMuX2xleGVyLnRva2VuO3RoaXMuZXhwZWN0S2V5d29yZCgiZXh0ZW5kIiksdGhpcy5leHBlY3RLZXl3b3JkKCJzY2FsYXIiKTtjb25zdCBuPXRoaXMucGFyc2VOYW1lKCkscj10aGlzLnBhcnNlQ29uc3REaXJlY3RpdmVzKCk7aWYoci5sZW5ndGg9PT0wKXRocm93IHRoaXMudW5leHBlY3RlZCgpO3JldHVybiB0aGlzLm5vZGUodCx7a2luZDpULlNDQUxBUl9UWVBFX0VYVEVOU0lPTixuYW1lOm4sZGlyZWN0aXZlczpyfSl9cGFyc2VPYmplY3RUeXBlRXh0ZW5zaW9uKCl7Y29uc3QgdD10aGlzLl9sZXhlci50b2tlbjt0aGlzLmV4cGVjdEtleXdvcmQoImV4dGVuZCIpLHRoaXMuZXhwZWN0S2V5d29yZCgidHlwZSIpO2NvbnN0IG49dGhpcy5wYXJzZU5hbWUoKSxyPXRoaXMucGFyc2VJbXBsZW1lbnRzSW50ZXJmYWNlcygpLGk9dGhpcy5wYXJzZUNvbnN0RGlyZWN0aXZlcygpLHM9dGhpcy5wYXJzZUZpZWxkc0RlZmluaXRpb24oKTtpZihyLmxlbmd0aD09PTAmJmkubGVuZ3RoPT09MCYmcy5sZW5ndGg9PT0wKXRocm93IHRoaXMudW5leHBlY3RlZCgpO3JldHVybiB0aGlzLm5vZGUodCx7a2luZDpULk9CSkVDVF9UWVBFX0VYVEVOU0lPTixuYW1lOm4saW50ZXJmYWNlczpyLGRpcmVjdGl2ZXM6aSxmaWVsZHM6c30pfXBhcnNlSW50ZXJmYWNlVHlwZUV4dGVuc2lvbigpe2NvbnN0IHQ9dGhpcy5fbGV4ZXIudG9rZW47dGhpcy5leHBlY3RLZXl3b3JkKCJleHRlbmQiKSx0aGlzLmV4cGVjdEtleXdvcmQoImludGVyZmFjZSIpO2NvbnN0IG49dGhpcy5wYXJzZU5hbWUoKSxyPXRoaXMucGFyc2VJbXBsZW1lbnRzSW50ZXJmYWNlcygpLGk9dGhpcy5wYXJzZUNvbnN0RGlyZWN0aXZlcygpLHM9dGhpcy5wYXJzZUZpZWxkc0RlZmluaXRpb24oKTtpZihyLmxlbmd0aD09PTAmJmkubGVuZ3RoPT09MCYmcy5sZW5ndGg9PT0wKXRocm93IHRoaXMudW5leHBlY3RlZCgpO3JldHVybiB0aGlzLm5vZGUodCx7a2luZDpULklOVEVSRkFDRV9UWVBFX0VYVEVOU0lPTixuYW1lOm4saW50ZXJmYWNlczpyLGRpcmVjdGl2ZXM6aSxmaWVsZHM6c30pfXBhcnNlVW5pb25UeXBlRXh0ZW5zaW9uKCl7Y29uc3QgdD10aGlzLl9sZXhlci50b2tlbjt0aGlzLmV4cGVjdEtleXdvcmQoImV4dGVuZCIpLHRoaXMuZXhwZWN0S2V5d29yZCgidW5pb24iKTtjb25zdCBuPXRoaXMucGFyc2VOYW1lKCkscj10aGlzLnBhcnNlQ29uc3REaXJlY3RpdmVzKCksaT10aGlzLnBhcnNlVW5pb25NZW1iZXJUeXBlcygpO2lmKHIubGVuZ3RoPT09MCYmaS5sZW5ndGg9PT0wKXRocm93IHRoaXMudW5leHBlY3RlZCgpO3JldHVybiB0aGlzLm5vZGUodCx7a2luZDpULlVOSU9OX1RZUEVfRVhURU5TSU9OLG5hbWU6bixkaXJlY3RpdmVzOnIsdHlwZXM6aX0pfXBhcnNlRW51bVR5cGVFeHRlbnNpb24oKXtjb25zdCB0PXRoaXMuX2xleGVyLnRva2VuO3RoaXMuZXhwZWN0S2V5d29yZCgiZXh0ZW5kIiksdGhpcy5leHBlY3RLZXl3b3JkKCJlbnVtIik7Y29uc3Qgbj10aGlzLnBhcnNlTmFtZSgpLHI9dGhpcy5wYXJzZUNvbnN0RGlyZWN0aXZlcygpLGk9dGhpcy5wYXJzZUVudW1WYWx1ZXNEZWZpbml0aW9uKCk7aWYoci5sZW5ndGg9PT0wJiZpLmxlbmd0aD09PTApdGhyb3cgdGhpcy51bmV4cGVjdGVkKCk7cmV0dXJuIHRoaXMubm9kZSh0LHtraW5kOlQuRU5VTV9UWVBFX0VYVEVOU0lPTixuYW1lOm4sZGlyZWN0aXZlczpyLHZhbHVlczppfSl9cGFyc2VJbnB1dE9iamVjdFR5cGVFeHRlbnNpb24oKXtjb25zdCB0PXRoaXMuX2xleGVyLnRva2VuO3RoaXMuZXhwZWN0S2V5d29yZCgiZXh0ZW5kIiksdGhpcy5leHBlY3RLZXl3b3JkKCJpbnB1dCIpO2NvbnN0IG49dGhpcy5wYXJzZU5hbWUoKSxyPXRoaXMucGFyc2VDb25zdERpcmVjdGl2ZXMoKSxpPXRoaXMucGFyc2VJbnB1dEZpZWxkc0RlZmluaXRpb24oKTtpZihyLmxlbmd0aD09PTAmJmkubGVuZ3RoPT09MCl0aHJvdyB0aGlzLnVuZXhwZWN0ZWQoKTtyZXR1cm4gdGhpcy5ub2RlKHQse2tpbmQ6VC5JTlBVVF9PQkpFQ1RfVFlQRV9FWFRFTlNJT04sbmFtZTpuLGRpcmVjdGl2ZXM6cixmaWVsZHM6aX0pfXBhcnNlRGlyZWN0aXZlRGVmaW5pdGlvbigpe2NvbnN0IHQ9dGhpcy5fbGV4ZXIudG9rZW4sbj10aGlzLnBhcnNlRGVzY3JpcHRpb24oKTt0aGlzLmV4cGVjdEtleXdvcmQoImRpcmVjdGl2ZSIpLHRoaXMuZXhwZWN0VG9rZW4obC5BVCk7Y29uc3Qgcj10aGlzLnBhcnNlTmFtZSgpLGk9dGhpcy5wYXJzZUFyZ3VtZW50RGVmcygpLHM9dGhpcy5leHBlY3RPcHRpb25hbEtleXdvcmQoInJlcGVhdGFibGUiKTt0aGlzLmV4cGVjdEtleXdvcmQoIm9uIik7Y29uc3Qgbz10aGlzLnBhcnNlRGlyZWN0aXZlTG9jYXRpb25zKCk7cmV0dXJuIHRoaXMubm9kZSh0LHtraW5kOlQuRElSRUNUSVZFX0RFRklOSVRJT04sZGVzY3JpcHRpb246bixuYW1lOnIsYXJndW1lbnRzOmkscmVwZWF0YWJsZTpzLGxvY2F0aW9uczpvfSl9cGFyc2VEaXJlY3RpdmVMb2NhdGlvbnMoKXtyZXR1cm4gdGhpcy5kZWxpbWl0ZWRNYW55KGwuUElQRSx0aGlzLnBhcnNlRGlyZWN0aXZlTG9jYXRpb24pfXBhcnNlRGlyZWN0aXZlTG9jYXRpb24oKXtjb25zdCB0PXRoaXMuX2xleGVyLnRva2VuLG49dGhpcy5wYXJzZU5hbWUoKTtpZihPYmplY3QucHJvdG90eXBlLmhhc093blByb3BlcnR5LmNhbGwoamUsbi52YWx1ZSkpcmV0dXJuIG47dGhyb3cgdGhpcy51bmV4cGVjdGVkKHQpfW5vZGUodCxuKXtyZXR1cm4gdGhpcy5fb3B0aW9ucy5ub0xvY2F0aW9uIT09ITAmJihuLmxvYz1uZXcgbm4odCx0aGlzLl9sZXhlci5sYXN0VG9rZW4sdGhpcy5fbGV4ZXIuc291cmNlKSksbn1wZWVrKHQpe3JldHVybiB0aGlzLl9sZXhlci50b2tlbi5raW5kPT09dH1leHBlY3RUb2tlbih0KXtjb25zdCBuPXRoaXMuX2xleGVyLnRva2VuO2lmKG4ua2luZD09PXQpcmV0dXJuIHRoaXMuYWR2YW5jZUxleGVyKCksbjt0aHJvdyBHKHRoaXMuX2xleGVyLnNvdXJjZSxuLnN0YXJ0LGBFeHBlY3RlZCAke090KHQpfSwgZm91bmQgJHt3ZShuKX0uYCl9ZXhwZWN0T3B0aW9uYWxUb2tlbih0KXtyZXR1cm4gdGhpcy5fbGV4ZXIudG9rZW4ua2luZD09PXQ/KHRoaXMuYWR2YW5jZUxleGVyKCksITApOiExfWV4cGVjdEtleXdvcmQodCl7Y29uc3Qgbj10aGlzLl9sZXhlci50b2tlbjtpZihuLmtpbmQ9PT1sLk5BTUUmJm4udmFsdWU9PT10KXRoaXMuYWR2YW5jZUxleGVyKCk7ZWxzZSB0aHJvdyBHKHRoaXMuX2xleGVyLnNvdXJjZSxuLnN0YXJ0LGBFeHBlY3RlZCAiJHt0fSIsIGZvdW5kICR7d2Uobil9LmApfWV4cGVjdE9wdGlvbmFsS2V5d29yZCh0KXtjb25zdCBuPXRoaXMuX2xleGVyLnRva2VuO3JldHVybiBuLmtpbmQ9PT1sLk5BTUUmJm4udmFsdWU9PT10Pyh0aGlzLmFkdmFuY2VMZXhlcigpLCEwKTohMX11bmV4cGVjdGVkKHQpe2NvbnN0IG49dCE9bnVsbD90OnRoaXMuX2xleGVyLnRva2VuO3JldHVybiBHKHRoaXMuX2xleGVyLnNvdXJjZSxuLnN0YXJ0LGBVbmV4cGVjdGVkICR7d2Uobil9LmApfWFueSh0LG4scil7dGhpcy5leHBlY3RUb2tlbih0KTtjb25zdCBpPVtdO2Zvcig7IXRoaXMuZXhwZWN0T3B0aW9uYWxUb2tlbihyKTspaS5wdXNoKG4uY2FsbCh0aGlzKSk7cmV0dXJuIGl9b3B0aW9uYWxNYW55KHQsbixyKXtpZih0aGlzLmV4cGVjdE9wdGlvbmFsVG9rZW4odCkpe2NvbnN0IGk9W107ZG8gaS5wdXNoKG4uY2FsbCh0aGlzKSk7d2hpbGUoIXRoaXMuZXhwZWN0T3B0aW9uYWxUb2tlbihyKSk7cmV0dXJuIGl9cmV0dXJuW119bWFueSh0LG4scil7dGhpcy5leHBlY3RUb2tlbih0KTtjb25zdCBpPVtdO2RvIGkucHVzaChuLmNhbGwodGhpcykpO3doaWxlKCF0aGlzLmV4cGVjdE9wdGlvbmFsVG9rZW4ocikpO3JldHVybiBpfWRlbGltaXRlZE1hbnkodCxuKXt0aGlzLmV4cGVjdE9wdGlvbmFsVG9rZW4odCk7Y29uc3Qgcj1bXTtkbyByLnB1c2gobi5jYWxsKHRoaXMpKTt3aGlsZSh0aGlzLmV4cGVjdE9wdGlvbmFsVG9rZW4odCkpO3JldHVybiByfWFkdmFuY2VMZXhlcigpe2NvbnN0e21heFRva2Vuczp0fT10aGlzLl9vcHRpb25zLG49dGhpcy5fbGV4ZXIuYWR2YW5jZSgpO2lmKHQhPT12b2lkIDAmJm4ua2luZCE9PWwuRU9GJiYoKyt0aGlzLl90b2tlbkNvdW50ZXIsdGhpcy5fdG9rZW5Db3VudGVyPnQpKXRocm93IEcodGhpcy5fbGV4ZXIuc291cmNlLG4uc3RhcnQsYERvY3VtZW50IGNvbnRhaW5zIG1vcmUgdGhhdCAke3R9IHRva2Vucy4gUGFyc2luZyBhYm9ydGVkLmApfX1mdW5jdGlvbiB3ZShlKXtjb25zdCB0PWUudmFsdWU7cmV0dXJuIE90KGUua2luZCkrKHQhPW51bGw/YCAiJHt0fSJgOiIiKX1mdW5jdGlvbiBPdChlKXtyZXR1cm4gbG4oZSk/YCIke2V9ImA6ZX1mdW5jdGlvbiB3bihlKXtyZXR1cm5gIiR7ZS5yZXBsYWNlKERuLENuKX0iYH1jb25zdCBEbj0vW1x4MDAtXHgxZlx4MjJceDVjXHg3Zi1ceDlmXS9nO2Z1bmN0aW9uIENuKGUpe3JldHVybiBrbltlLmNoYXJDb2RlQXQoMCldfWNvbnN0IGtuPVsiXFx1MDAwMCIsIlxcdTAwMDEiLCJcXHUwMDAyIiwiXFx1MDAwMyIsIlxcdTAwMDQiLCJcXHUwMDA1IiwiXFx1MDAwNiIsIlxcdTAwMDciLCJcXGIiLCJcXHQiLCJcXG4iLCJcXHUwMDBCIiwiXFxmIiwiXFxyIiwiXFx1MDAwRSIsIlxcdTAwMEYiLCJcXHUwMDEwIiwiXFx1MDAxMSIsIlxcdTAwMTIiLCJcXHUwMDEzIiwiXFx1MDAxNCIsIlxcdTAwMTUiLCJcXHUwMDE2IiwiXFx1MDAxNyIsIlxcdTAwMTgiLCJcXHUwMDE5IiwiXFx1MDAxQSIsIlxcdTAwMUIiLCJcXHUwMDFDIiwiXFx1MDAxRCIsIlxcdTAwMUUiLCJcXHUwMDFGIiwiIiwiIiwnXFwiJywiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiIiwiXFxcXCIsIiIsIiIsIiIsIiIsIiIsIiIsIiIsIiIsIiIsIiIsIiIsIiIsIiIsIiIsIiIsIiIsIiIsIiIsIiIsIiIsIiIsIiIsIiIsIiIsIiIsIiIsIiIsIiIsIiIsIiIsIiIsIiIsIiIsIiIsIlxcdTAwN0YiLCJcXHUwMDgwIiwiXFx1MDA4MSIsIlxcdTAwODIiLCJcXHUwMDgzIiwiXFx1MDA4NCIsIlxcdTAwODUiLCJcXHUwMDg2IiwiXFx1MDA4NyIsIlxcdTAwODgiLCJcXHUwMDg5IiwiXFx1MDA4QSIsIlxcdTAwOEIiLCJcXHUwMDhDIiwiXFx1MDA4RCIsIlxcdTAwOEUiLCJcXHUwMDhGIiwiXFx1MDA5MCIsIlxcdTAwOTEiLCJcXHUwMDkyIiwiXFx1MDA5MyIsIlxcdTAwOTQiLCJcXHUwMDk1IiwiXFx1MDA5NiIsIlxcdTAwOTciLCJcXHUwMDk4IiwiXFx1MDA5OSIsIlxcdTAwOUEiLCJcXHUwMDlCIiwiXFx1MDA5QyIsIlxcdTAwOUQiLCJcXHUwMDlFIiwiXFx1MDA5RiJdLFJuPU9iamVjdC5mcmVlemUoe30pO2Z1bmN0aW9uIExuKGUsdCxuPXZ0KXtjb25zdCByPW5ldyBNYXA7Zm9yKGNvbnN0IE4gb2YgT2JqZWN0LnZhbHVlcyhUKSlyLnNldChOLFBuKHQsTikpO2xldCBpLHM9QXJyYXkuaXNBcnJheShlKSxvPVtlXSxjPS0xLGQ9W10sZj1lLHUsZztjb25zdCBFPVtdLGI9W107ZG97YysrO2NvbnN0IE49Yz09PW8ubGVuZ3RoLEM9TiYmZC5sZW5ndGghPT0wO2lmKE4pe2lmKHU9Yi5sZW5ndGg9PT0wP3ZvaWQgMDpFW0UubGVuZ3RoLTFdLGY9ZyxnPWIucG9wKCksQylpZihzKXtmPWYuc2xpY2UoKTtsZXQgTD0wO2Zvcihjb25zdFtNLEhdb2YgZCl7Y29uc3QgJD1NLUw7SD09PW51bGw/KGYuc3BsaWNlKCQsMSksTCsrKTpmWyRdPUh9fWVsc2V7Zj1PYmplY3QuZGVmaW5lUHJvcGVydGllcyh7fSxPYmplY3QuZ2V0T3duUHJvcGVydHlEZXNjcmlwdG9ycyhmKSk7Zm9yKGNvbnN0W0wsTV1vZiBkKWZbTF09TX1jPWkuaW5kZXgsbz1pLmtleXMsZD1pLmVkaXRzLHM9aS5pbkFycmF5LGk9aS5wcmV2fWVsc2UgaWYoZyl7aWYodT1zP2M6b1tjXSxmPWdbdV0sZj09bnVsbCljb250aW51ZTtFLnB1c2godSl9bGV0IFI7aWYoIUFycmF5LmlzQXJyYXkoZikpe3ZhciB5LHA7Z3QoZil8fEsoITEsYEludmFsaWQgQVNUIE5vZGU6ICR7SGUoZil9LmApO2NvbnN0IEw9Tj8oeT1yLmdldChmLmtpbmQpKT09PW51bGx8fHk9PT12b2lkIDA/dm9pZCAwOnkubGVhdmU6KHA9ci5nZXQoZi5raW5kKSk9PT1udWxsfHxwPT09dm9pZCAwP3ZvaWQgMDpwLmVudGVyO2lmKFI9TD09bnVsbD92b2lkIDA6TC5jYWxsKHQsZix1LGcsRSxiKSxSPT09Um4pYnJlYWs7aWYoUj09PSExKXtpZighTil7RS5wb3AoKTtjb250aW51ZX19ZWxzZSBpZihSIT09dm9pZCAwJiYoZC5wdXNoKFt1LFJdKSwhTikpaWYoZ3QoUikpZj1SO2Vsc2V7RS5wb3AoKTtjb250aW51ZX19aWYoUj09PXZvaWQgMCYmQyYmZC5wdXNoKFt1LGZdKSxOKUUucG9wKCk7ZWxzZXt2YXIgdjtpPXtpbkFycmF5OnMsaW5kZXg6YyxrZXlzOm8sZWRpdHM6ZCxwcmV2Oml9LHM9QXJyYXkuaXNBcnJheShmKSxvPXM/Zjoodj1uW2Yua2luZF0pIT09bnVsbCYmdiE9PXZvaWQgMD92OltdLGM9LTEsZD1bXSxnJiZiLnB1c2goZyksZz1mfX13aGlsZShpIT09dm9pZCAwKTtyZXR1cm4gZC5sZW5ndGghPT0wP2RbZC5sZW5ndGgtMV1bMV06ZX1mdW5jdGlvbiBQbihlLHQpe2NvbnN0IG49ZVt0XTtyZXR1cm4gdHlwZW9mIG49PSJvYmplY3QiP246dHlwZW9mIG49PSJmdW5jdGlvbiI/e2VudGVyOm4sbGVhdmU6dm9pZCAwfTp7ZW50ZXI6ZS5lbnRlcixsZWF2ZTplLmxlYXZlfX1mdW5jdGlvbiBGbihlKXtyZXR1cm4gTG4oZSxNbil9Y29uc3QgQm49ODAsTW49e05hbWU6e2xlYXZlOmU9PmUudmFsdWV9LFZhcmlhYmxlOntsZWF2ZTplPT4iJCIrZS5uYW1lfSxEb2N1bWVudDp7bGVhdmU6ZT0+bShlLmRlZmluaXRpb25zLGAKCmApfSxPcGVyYXRpb25EZWZpbml0aW9uOntsZWF2ZShlKXtjb25zdCB0PU8oIigiLG0oZS52YXJpYWJsZURlZmluaXRpb25zLCIsICIpLCIpIiksbj1tKFtlLm9wZXJhdGlvbixtKFtlLm5hbWUsdF0pLG0oZS5kaXJlY3RpdmVzLCIgIildLCIgIik7cmV0dXJuKG49PT0icXVlcnkiPyIiOm4rIiAiKStlLnNlbGVjdGlvblNldH19LFZhcmlhYmxlRGVmaW5pdGlvbjp7bGVhdmU6KHt2YXJpYWJsZTplLHR5cGU6dCxkZWZhdWx0VmFsdWU6bixkaXJlY3RpdmVzOnJ9KT0+ZSsiOiAiK3QrTygiID0gIixuKStPKCIgIixtKHIsIiAiKSl9LFNlbGVjdGlvblNldDp7bGVhdmU6KHtzZWxlY3Rpb25zOmV9KT0+ZWUoZSl9LEZpZWxkOntsZWF2ZSh7YWxpYXM6ZSxuYW1lOnQsYXJndW1lbnRzOm4sZGlyZWN0aXZlczpyLHNlbGVjdGlvblNldDppfSl7Y29uc3Qgcz1PKCIiLGUsIjogIikrdDtsZXQgbz1zK08oIigiLG0obiwiLCAiKSwiKSIpO3JldHVybiBvLmxlbmd0aD5CbiYmKG89cytPKGAoCmAsRGUobShuLGAKYCkpLGAKKWApKSxtKFtvLG0ociwiICIpLGldLCIgIil9fSxBcmd1bWVudDp7bGVhdmU6KHtuYW1lOmUsdmFsdWU6dH0pPT5lKyI6ICIrdH0sRnJhZ21lbnRTcHJlYWQ6e2xlYXZlOih7bmFtZTplLGRpcmVjdGl2ZXM6dH0pPT4iLi4uIitlK08oIiAiLG0odCwiICIpKX0sSW5saW5lRnJhZ21lbnQ6e2xlYXZlOih7dHlwZUNvbmRpdGlvbjplLGRpcmVjdGl2ZXM6dCxzZWxlY3Rpb25TZXQ6bn0pPT5tKFsiLi4uIixPKCJvbiAiLGUpLG0odCwiICIpLG5dLCIgIil9LEZyYWdtZW50RGVmaW5pdGlvbjp7bGVhdmU6KHtuYW1lOmUsdHlwZUNvbmRpdGlvbjp0LHZhcmlhYmxlRGVmaW5pdGlvbnM6bixkaXJlY3RpdmVzOnIsc2VsZWN0aW9uU2V0Oml9KT0+YGZyYWdtZW50ICR7ZX0ke08oIigiLG0obiwiLCAiKSwiKSIpfSBvbiAke3R9ICR7TygiIixtKHIsIiAiKSwiICIpfWAraX0sSW50VmFsdWU6e2xlYXZlOih7dmFsdWU6ZX0pPT5lfSxGbG9hdFZhbHVlOntsZWF2ZTooe3ZhbHVlOmV9KT0+ZX0sU3RyaW5nVmFsdWU6e2xlYXZlOih7dmFsdWU6ZSxibG9jazp0fSk9PnQ/Y24oZSk6d24oZSl9LEJvb2xlYW5WYWx1ZTp7bGVhdmU6KHt2YWx1ZTplfSk9PmU/InRydWUiOiJmYWxzZSJ9LE51bGxWYWx1ZTp7bGVhdmU6KCk9PiJudWxsIn0sRW51bVZhbHVlOntsZWF2ZTooe3ZhbHVlOmV9KT0+ZX0sTGlzdFZhbHVlOntsZWF2ZTooe3ZhbHVlczplfSk9PiJbIittKGUsIiwgIikrIl0ifSxPYmplY3RWYWx1ZTp7bGVhdmU6KHtmaWVsZHM6ZX0pPT4ieyIrbShlLCIsICIpKyJ9In0sT2JqZWN0RmllbGQ6e2xlYXZlOih7bmFtZTplLHZhbHVlOnR9KT0+ZSsiOiAiK3R9LERpcmVjdGl2ZTp7bGVhdmU6KHtuYW1lOmUsYXJndW1lbnRzOnR9KT0+IkAiK2UrTygiKCIsbSh0LCIsICIpLCIpIil9LE5hbWVkVHlwZTp7bGVhdmU6KHtuYW1lOmV9KT0+ZX0sTGlzdFR5cGU6e2xlYXZlOih7dHlwZTplfSk9PiJbIitlKyJdIn0sTm9uTnVsbFR5cGU6e2xlYXZlOih7dHlwZTplfSk9PmUrIiEifSxTY2hlbWFEZWZpbml0aW9uOntsZWF2ZTooe2Rlc2NyaXB0aW9uOmUsZGlyZWN0aXZlczp0LG9wZXJhdGlvblR5cGVzOm59KT0+TygiIixlLGAKYCkrbShbInNjaGVtYSIsbSh0LCIgIiksZWUobildLCIgIil9LE9wZXJhdGlvblR5cGVEZWZpbml0aW9uOntsZWF2ZTooe29wZXJhdGlvbjplLHR5cGU6dH0pPT5lKyI6ICIrdH0sU2NhbGFyVHlwZURlZmluaXRpb246e2xlYXZlOih7ZGVzY3JpcHRpb246ZSxuYW1lOnQsZGlyZWN0aXZlczpufSk9Pk8oIiIsZSxgCmApK20oWyJzY2FsYXIiLHQsbShuLCIgIildLCIgIil9LE9iamVjdFR5cGVEZWZpbml0aW9uOntsZWF2ZTooe2Rlc2NyaXB0aW9uOmUsbmFtZTp0LGludGVyZmFjZXM6bixkaXJlY3RpdmVzOnIsZmllbGRzOml9KT0+TygiIixlLGAKYCkrbShbInR5cGUiLHQsTygiaW1wbGVtZW50cyAiLG0obiwiICYgIikpLG0ociwiICIpLGVlKGkpXSwiICIpfSxGaWVsZERlZmluaXRpb246e2xlYXZlOih7ZGVzY3JpcHRpb246ZSxuYW1lOnQsYXJndW1lbnRzOm4sdHlwZTpyLGRpcmVjdGl2ZXM6aX0pPT5PKCIiLGUsYApgKSt0KyhTdChuKT9PKGAoCmAsRGUobShuLGAKYCkpLGAKKWApOk8oIigiLG0obiwiLCAiKSwiKSIpKSsiOiAiK3IrTygiICIsbShpLCIgIikpfSxJbnB1dFZhbHVlRGVmaW5pdGlvbjp7bGVhdmU6KHtkZXNjcmlwdGlvbjplLG5hbWU6dCx0eXBlOm4sZGVmYXVsdFZhbHVlOnIsZGlyZWN0aXZlczppfSk9Pk8oIiIsZSxgCmApK20oW3QrIjogIituLE8oIj0gIixyKSxtKGksIiAiKV0sIiAiKX0sSW50ZXJmYWNlVHlwZURlZmluaXRpb246e2xlYXZlOih7ZGVzY3JpcHRpb246ZSxuYW1lOnQsaW50ZXJmYWNlczpuLGRpcmVjdGl2ZXM6cixmaWVsZHM6aX0pPT5PKCIiLGUsYApgKSttKFsiaW50ZXJmYWNlIix0LE8oImltcGxlbWVudHMgIixtKG4sIiAmICIpKSxtKHIsIiAiKSxlZShpKV0sIiAiKX0sVW5pb25UeXBlRGVmaW5pdGlvbjp7bGVhdmU6KHtkZXNjcmlwdGlvbjplLG5hbWU6dCxkaXJlY3RpdmVzOm4sdHlwZXM6cn0pPT5PKCIiLGUsYApgKSttKFsidW5pb24iLHQsbShuLCIgIiksTygiPSAiLG0ociwiIHwgIikpXSwiICIpfSxFbnVtVHlwZURlZmluaXRpb246e2xlYXZlOih7ZGVzY3JpcHRpb246ZSxuYW1lOnQsZGlyZWN0aXZlczpuLHZhbHVlczpyfSk9Pk8oIiIsZSxgCmApK20oWyJlbnVtIix0LG0obiwiICIpLGVlKHIpXSwiICIpfSxFbnVtVmFsdWVEZWZpbml0aW9uOntsZWF2ZTooe2Rlc2NyaXB0aW9uOmUsbmFtZTp0LGRpcmVjdGl2ZXM6bn0pPT5PKCIiLGUsYApgKSttKFt0LG0obiwiICIpXSwiICIpfSxJbnB1dE9iamVjdFR5cGVEZWZpbml0aW9uOntsZWF2ZTooe2Rlc2NyaXB0aW9uOmUsbmFtZTp0LGRpcmVjdGl2ZXM6bixmaWVsZHM6cn0pPT5PKCIiLGUsYApgKSttKFsiaW5wdXQiLHQsbShuLCIgIiksZWUocildLCIgIil9LERpcmVjdGl2ZURlZmluaXRpb246e2xlYXZlOih7ZGVzY3JpcHRpb246ZSxuYW1lOnQsYXJndW1lbnRzOm4scmVwZWF0YWJsZTpyLGxvY2F0aW9uczppfSk9Pk8oIiIsZSxgCmApKyJkaXJlY3RpdmUgQCIrdCsoU3Qobik/TyhgKApgLERlKG0obixgCmApKSxgCilgKTpPKCIoIixtKG4sIiwgIiksIikiKSkrKHI/IiByZXBlYXRhYmxlIjoiIikrIiBvbiAiK20oaSwiIHwgIil9LFNjaGVtYUV4dGVuc2lvbjp7bGVhdmU6KHtkaXJlY3RpdmVzOmUsb3BlcmF0aW9uVHlwZXM6dH0pPT5tKFsiZXh0ZW5kIHNjaGVtYSIsbShlLCIgIiksZWUodCldLCIgIil9LFNjYWxhclR5cGVFeHRlbnNpb246e2xlYXZlOih7bmFtZTplLGRpcmVjdGl2ZXM6dH0pPT5tKFsiZXh0ZW5kIHNjYWxhciIsZSxtKHQsIiAiKV0sIiAiKX0sT2JqZWN0VHlwZUV4dGVuc2lvbjp7bGVhdmU6KHtuYW1lOmUsaW50ZXJmYWNlczp0LGRpcmVjdGl2ZXM6bixmaWVsZHM6cn0pPT5tKFsiZXh0ZW5kIHR5cGUiLGUsTygiaW1wbGVtZW50cyAiLG0odCwiICYgIikpLG0obiwiICIpLGVlKHIpXSwiICIpfSxJbnRlcmZhY2VUeXBlRXh0ZW5zaW9uOntsZWF2ZTooe25hbWU6ZSxpbnRlcmZhY2VzOnQsZGlyZWN0aXZlczpuLGZpZWxkczpyfSk9Pm0oWyJleHRlbmQgaW50ZXJmYWNlIixlLE8oImltcGxlbWVudHMgIixtKHQsIiAmICIpKSxtKG4sIiAiKSxlZShyKV0sIiAiKX0sVW5pb25UeXBlRXh0ZW5zaW9uOntsZWF2ZTooe25hbWU6ZSxkaXJlY3RpdmVzOnQsdHlwZXM6bn0pPT5tKFsiZXh0ZW5kIHVuaW9uIixlLG0odCwiICIpLE8oIj0gIixtKG4sIiB8ICIpKV0sIiAiKX0sRW51bVR5cGVFeHRlbnNpb246e2xlYXZlOih7bmFtZTplLGRpcmVjdGl2ZXM6dCx2YWx1ZXM6bn0pPT5tKFsiZXh0ZW5kIGVudW0iLGUsbSh0LCIgIiksZWUobildLCIgIil9LElucHV0T2JqZWN0VHlwZUV4dGVuc2lvbjp7bGVhdmU6KHtuYW1lOmUsZGlyZWN0aXZlczp0LGZpZWxkczpufSk9Pm0oWyJleHRlbmQgaW5wdXQiLGUsbSh0LCIgIiksZWUobildLCIgIil9fTtmdW5jdGlvbiBtKGUsdD0iIil7dmFyIG47cmV0dXJuKG49ZT09bnVsbD92b2lkIDA6ZS5maWx0ZXIocj0+cikuam9pbih0KSkhPT1udWxsJiZuIT09dm9pZCAwP246IiJ9ZnVuY3Rpb24gZWUoZSl7cmV0dXJuIE8oYHsKYCxEZShtKGUsYApgKSksYAp9YCl9ZnVuY3Rpb24gTyhlLHQsbj0iIil7cmV0dXJuIHQhPW51bGwmJnQhPT0iIj9lK3QrbjoiIn1mdW5jdGlvbiBEZShlKXtyZXR1cm4gTygiICAiLGUucmVwbGFjZSgvXG4vZyxgCiAgYCkpfWZ1bmN0aW9uIFN0KGUpe3ZhciB0O3JldHVybih0PWU9PW51bGw/dm9pZCAwOmUuc29tZShuPT5uLmluY2x1ZGVzKGAKYCkpKSE9PW51bGwmJnQhPT12b2lkIDA/dDohMX12YXIgQ2U9bmV3IE1hcCx6ZT1uZXcgTWFwLHd0PSEwLGtlPSExO2Z1bmN0aW9uIER0KGUpe3JldHVybiBlLnJlcGxhY2UoL1tccyxdKy9nLCIgIikudHJpbSgpfWZ1bmN0aW9uICRuKGUpe3JldHVybiBEdChlLnNvdXJjZS5ib2R5LnN1YnN0cmluZyhlLnN0YXJ0LGUuZW5kKSl9ZnVuY3Rpb24gVW4oZSl7dmFyIHQ9bmV3IFNldCxuPVtdO3JldHVybiBlLmRlZmluaXRpb25zLmZvckVhY2goZnVuY3Rpb24ocil7aWYoci5raW5kPT09IkZyYWdtZW50RGVmaW5pdGlvbiIpe3ZhciBpPXIubmFtZS52YWx1ZSxzPSRuKHIubG9jKSxvPXplLmdldChpKTtvJiYhby5oYXMocyk/d3QmJmNvbnNvbGUud2FybigiV2FybmluZzogZnJhZ21lbnQgd2l0aCBuYW1lICIraStgIGFscmVhZHkgZXhpc3RzLgpncmFwaHFsLXRhZyBlbmZvcmNlcyBhbGwgZnJhZ21lbnQgbmFtZXMgYWNyb3NzIHlvdXIgYXBwbGljYXRpb24gdG8gYmUgdW5pcXVlOyByZWFkIG1vcmUgYWJvdXQKdGhpcyBpbiB0aGUgZG9jczogaHR0cDovL2Rldi5hcG9sbG9kYXRhLmNvbS9jb3JlL2ZyYWdtZW50cy5odG1sI3VuaXF1ZS1uYW1lc2ApOm98fHplLnNldChpLG89bmV3IFNldCksby5hZGQocyksdC5oYXMocyl8fCh0LmFkZChzKSxuLnB1c2gocikpfWVsc2Ugbi5wdXNoKHIpfSksc2Uoc2Uoe30sZSkse2RlZmluaXRpb25zOm59KX1mdW5jdGlvbiBWbihlKXt2YXIgdD1uZXcgU2V0KGUuZGVmaW5pdGlvbnMpO3QuZm9yRWFjaChmdW5jdGlvbihyKXtyLmxvYyYmZGVsZXRlIHIubG9jLE9iamVjdC5rZXlzKHIpLmZvckVhY2goZnVuY3Rpb24oaSl7dmFyIHM9cltpXTtzJiZ0eXBlb2Ygcz09Im9iamVjdCImJnQuYWRkKHMpfSl9KTt2YXIgbj1lLmxvYztyZXR1cm4gbiYmKGRlbGV0ZSBuLnN0YXJ0VG9rZW4sZGVsZXRlIG4uZW5kVG9rZW4pLGV9ZnVuY3Rpb24gam4oZSl7dmFyIHQ9RHQoZSk7aWYoIUNlLmhhcyh0KSl7dmFyIG49SXQoZSx7ZXhwZXJpbWVudGFsRnJhZ21lbnRWYXJpYWJsZXM6a2UsYWxsb3dMZWdhY3lGcmFnbWVudFZhcmlhYmxlczprZX0pO2lmKCFufHxuLmtpbmQhPT0iRG9jdW1lbnQiKXRocm93IG5ldyBFcnJvcigiTm90IGEgdmFsaWQgR3JhcGhRTCBkb2N1bWVudC4iKTtDZS5zZXQodCxWbihVbihuKSkpfXJldHVybiBDZS5nZXQodCl9ZnVuY3Rpb24gcGUoZSl7Zm9yKHZhciB0PVtdLG49MTtuPGFyZ3VtZW50cy5sZW5ndGg7bisrKXRbbi0xXT1hcmd1bWVudHNbbl07dHlwZW9mIGU9PSJzdHJpbmciJiYoZT1bZV0pO3ZhciByPWVbMF07cmV0dXJuIHQuZm9yRWFjaChmdW5jdGlvbihpLHMpe2kmJmkua2luZD09PSJEb2N1bWVudCI/cis9aS5sb2Muc291cmNlLmJvZHk6cis9aSxyKz1lW3MrMV19KSxqbihyKX1mdW5jdGlvbiBxbigpe0NlLmNsZWFyKCksemUuY2xlYXIoKX1mdW5jdGlvbiBHbigpe3d0PSExfWZ1bmN0aW9uIEhuKCl7a2U9ITB9ZnVuY3Rpb24gem4oKXtrZT0hMX12YXIgTmU9e2dxbDpwZSxyZXNldENhY2hlczpxbixkaXNhYmxlRnJhZ21lbnRXYXJuaW5nczpHbixlbmFibGVFeHBlcmltZW50YWxGcmFnbWVudFZhcmlhYmxlczpIbixkaXNhYmxlRXhwZXJpbWVudGFsRnJhZ21lbnRWYXJpYWJsZXM6em59OyhmdW5jdGlvbihlKXtlLmdxbD1OZS5ncWwsZS5yZXNldENhY2hlcz1OZS5yZXNldENhY2hlcyxlLmRpc2FibGVGcmFnbWVudFdhcm5pbmdzPU5lLmRpc2FibGVGcmFnbWVudFdhcm5pbmdzLGUuZW5hYmxlRXhwZXJpbWVudGFsRnJhZ21lbnRWYXJpYWJsZXM9TmUuZW5hYmxlRXhwZXJpbWVudGFsRnJhZ21lbnRWYXJpYWJsZXMsZS5kaXNhYmxlRXhwZXJpbWVudGFsRnJhZ21lbnRWYXJpYWJsZXM9TmUuZGlzYWJsZUV4cGVyaW1lbnRhbEZyYWdtZW50VmFyaWFibGVzfSkocGV8fChwZT17fSkpLHBlLmRlZmF1bHQ9cGU7dmFyIG9lPXBlLEN0OyhmdW5jdGlvbihlKXtlLkJpbGxpbmdRdW90YUV4Y2VlZGVkPSJCaWxsaW5nUXVvdGFFeGNlZWRlZCJ9KShDdHx8KEN0PXt9KSk7Y29uc3QgWW49b2VgCgltdXRhdGlvbiBQdXNoUGF5bG9hZCgKCQkkc2Vzc2lvbl9zZWN1cmVfaWQ6IFN0cmluZyEKCQkkcGF5bG9hZF9pZDogSUQhCgkJJGV2ZW50czogUmVwbGF5RXZlbnRzSW5wdXQhCgkJJG1lc3NhZ2VzOiBTdHJpbmchCgkJJHJlc291cmNlczogU3RyaW5nIQoJCSR3ZWJfc29ja2V0X2V2ZW50czogU3RyaW5nIQoJCSRlcnJvcnM6IFtFcnJvck9iamVjdElucHV0XSEKCQkkaXNfYmVhY29uOiBCb29sZWFuCgkJJGhhc19zZXNzaW9uX3VubG9hZGVkOiBCb29sZWFuCgkJJGhpZ2hsaWdodF9sb2dzOiBTdHJpbmcKCSkgewoJCXB1c2hQYXlsb2FkKAoJCQlzZXNzaW9uX3NlY3VyZV9pZDogJHNlc3Npb25fc2VjdXJlX2lkCgkJCXBheWxvYWRfaWQ6ICRwYXlsb2FkX2lkCgkJCWV2ZW50czogJGV2ZW50cwoJCQltZXNzYWdlczogJG1lc3NhZ2VzCgkJCXJlc291cmNlczogJHJlc291cmNlcwoJCQl3ZWJfc29ja2V0X2V2ZW50czogJHdlYl9zb2NrZXRfZXZlbnRzCgkJCWVycm9yczogJGVycm9ycwoJCQlpc19iZWFjb246ICRpc19iZWFjb24KCQkJaGFzX3Nlc3Npb25fdW5sb2FkZWQ6ICRoYXNfc2Vzc2lvbl91bmxvYWRlZAoJCQloaWdobGlnaHRfbG9nczogJGhpZ2hsaWdodF9sb2dzCgkJKQoJfQpgLEpuPW9lYAoJbXV0YXRpb24gUHVzaFBheWxvYWRDb21wcmVzc2VkKAoJCSRzZXNzaW9uX3NlY3VyZV9pZDogU3RyaW5nIQoJCSRwYXlsb2FkX2lkOiBJRCEKCQkkZGF0YTogU3RyaW5nIQoJKSB7CgkJcHVzaFBheWxvYWRDb21wcmVzc2VkKAoJCQlzZXNzaW9uX3NlY3VyZV9pZDogJHNlc3Npb25fc2VjdXJlX2lkCgkJCXBheWxvYWRfaWQ6ICRwYXlsb2FkX2lkCgkJCWRhdGE6ICRkYXRhCgkJKQoJfQpgLFFuPW9lYAoJbXV0YXRpb24gaWRlbnRpZnlTZXNzaW9uKAoJCSRzZXNzaW9uX3NlY3VyZV9pZDogU3RyaW5nIQoJCSR1c2VyX2lkZW50aWZpZXI6IFN0cmluZyEKCQkkdXNlcl9vYmplY3Q6IEFueQoJKSB7CgkJaWRlbnRpZnlTZXNzaW9uKAoJCQlzZXNzaW9uX3NlY3VyZV9pZDogJHNlc3Npb25fc2VjdXJlX2lkCgkJCXVzZXJfaWRlbnRpZmllcjogJHVzZXJfaWRlbnRpZmllcgoJCQl1c2VyX29iamVjdDogJHVzZXJfb2JqZWN0CgkJKQoJfQpgLFhuPW9lYAoJbXV0YXRpb24gYWRkU2Vzc2lvblByb3BlcnRpZXMoCgkJJHNlc3Npb25fc2VjdXJlX2lkOiBTdHJpbmchCgkJJHByb3BlcnRpZXNfb2JqZWN0OiBBbnkKCSkgewoJCWFkZFNlc3Npb25Qcm9wZXJ0aWVzKAoJCQlzZXNzaW9uX3NlY3VyZV9pZDogJHNlc3Npb25fc2VjdXJlX2lkCgkJCXByb3BlcnRpZXNfb2JqZWN0OiAkcHJvcGVydGllc19vYmplY3QKCQkpCgl9CmAsV249b2VgCgltdXRhdGlvbiBwdXNoTWV0cmljcygkbWV0cmljczogW01ldHJpY0lucHV0XSEpIHsKCQlwdXNoTWV0cmljcyhtZXRyaWNzOiAkbWV0cmljcykKCX0KYCxabj1vZWAKCW11dGF0aW9uIGFkZFNlc3Npb25GZWVkYmFjaygKCQkkc2Vzc2lvbl9zZWN1cmVfaWQ6IFN0cmluZyEKCQkkdXNlcl9uYW1lOiBTdHJpbmcKCQkkdXNlcl9lbWFpbDogU3RyaW5nCgkJJHZlcmJhdGltOiBTdHJpbmchCgkJJHRpbWVzdGFtcDogVGltZXN0YW1wIQoJKSB7CgkJYWRkU2Vzc2lvbkZlZWRiYWNrKAoJCQlzZXNzaW9uX3NlY3VyZV9pZDogJHNlc3Npb25fc2VjdXJlX2lkCgkJCXVzZXJfbmFtZTogJHVzZXJfbmFtZQoJCQl1c2VyX2VtYWlsOiAkdXNlcl9lbWFpbAoJCQl2ZXJiYXRpbTogJHZlcmJhdGltCgkJCXRpbWVzdGFtcDogJHRpbWVzdGFtcAoJCSkKCX0KYCxLbj1vZWAKCW11dGF0aW9uIGluaXRpYWxpemVTZXNzaW9uKAoJCSRzZXNzaW9uX3NlY3VyZV9pZDogU3RyaW5nIQoJCSRvcmdhbml6YXRpb25fdmVyYm9zZV9pZDogU3RyaW5nIQoJCSRlbmFibGVfc3RyaWN0X3ByaXZhY3k6IEJvb2xlYW4hCgkJJHByaXZhY3lfc2V0dGluZzogU3RyaW5nIQoJCSRlbmFibGVfcmVjb3JkaW5nX25ldHdvcmtfY29udGVudHM6IEJvb2xlYW4hCgkJJGNsaWVudFZlcnNpb246IFN0cmluZyEKCQkkZmlyc3Rsb2FkVmVyc2lvbjogU3RyaW5nIQoJCSRjbGllbnRDb25maWc6IFN0cmluZyEKCQkkZW52aXJvbm1lbnQ6IFN0cmluZyEKCQkkaWQ6IFN0cmluZyEKCQkkYXBwVmVyc2lvbjogU3RyaW5nCgkJJHNlcnZpY2VOYW1lOiBTdHJpbmchCgkJJGNsaWVudF9pZDogU3RyaW5nIQoJCSRuZXR3b3JrX3JlY29yZGluZ19kb21haW5zOiBbU3RyaW5nIV0KCQkkZGlzYWJsZV9zZXNzaW9uX3JlY29yZGluZzogQm9vbGVhbgoJKSB7CgkJaW5pdGlhbGl6ZVNlc3Npb24oCgkJCXNlc3Npb25fc2VjdXJlX2lkOiAkc2Vzc2lvbl9zZWN1cmVfaWQKCQkJb3JnYW5pemF0aW9uX3ZlcmJvc2VfaWQ6ICRvcmdhbml6YXRpb25fdmVyYm9zZV9pZAoJCQllbmFibGVfc3RyaWN0X3ByaXZhY3k6ICRlbmFibGVfc3RyaWN0X3ByaXZhY3kKCQkJZW5hYmxlX3JlY29yZGluZ19uZXR3b3JrX2NvbnRlbnRzOiAkZW5hYmxlX3JlY29yZGluZ19uZXR3b3JrX2NvbnRlbnRzCgkJCWNsaWVudFZlcnNpb246ICRjbGllbnRWZXJzaW9uCgkJCWZpcnN0bG9hZFZlcnNpb246ICRmaXJzdGxvYWRWZXJzaW9uCgkJCWNsaWVudENvbmZpZzogJGNsaWVudENvbmZpZwoJCQllbnZpcm9ubWVudDogJGVudmlyb25tZW50CgkJCWFwcFZlcnNpb246ICRhcHBWZXJzaW9uCgkJCXNlcnZpY2VOYW1lOiAkc2VydmljZU5hbWUKCQkJZmluZ2VycHJpbnQ6ICRpZAoJCQljbGllbnRfaWQ6ICRjbGllbnRfaWQKCQkJbmV0d29ya19yZWNvcmRpbmdfZG9tYWluczogJG5ldHdvcmtfcmVjb3JkaW5nX2RvbWFpbnMKCQkJZGlzYWJsZV9zZXNzaW9uX3JlY29yZGluZzogJGRpc2FibGVfc2Vzc2lvbl9yZWNvcmRpbmcKCQkJcHJpdmFjeV9zZXR0aW5nOiAkcHJpdmFjeV9zZXR0aW5nCgkJKSB7CgkJCXNlY3VyZV9pZAoJCQlwcm9qZWN0X2lkCgkJfQoJfQpgLGVyPW9lYAoJcXVlcnkgSWdub3JlKCRpZDogSUQhKSB7CgkJaWdub3JlKGlkOiAkaWQpCgl9CmAsdHI9KGUsdCxuLHIpPT5lKCk7ZnVuY3Rpb24gbnIoZSx0PXRyKXtyZXR1cm57UHVzaFBheWxvYWQobixyKXtyZXR1cm4gdChpPT5lLnJlcXVlc3QoWW4sbixrKGsoe30sciksaSkpLCJQdXNoUGF5bG9hZCIsIm11dGF0aW9uIixuKX0sUHVzaFBheWxvYWRDb21wcmVzc2VkKG4scil7cmV0dXJuIHQoaT0+ZS5yZXF1ZXN0KEpuLG4sayhrKHt9LHIpLGkpKSwiUHVzaFBheWxvYWRDb21wcmVzc2VkIiwibXV0YXRpb24iLG4pfSxpZGVudGlmeVNlc3Npb24obixyKXtyZXR1cm4gdChpPT5lLnJlcXVlc3QoUW4sbixrKGsoe30sciksaSkpLCJpZGVudGlmeVNlc3Npb24iLCJtdXRhdGlvbiIsbil9LGFkZFNlc3Npb25Qcm9wZXJ0aWVzKG4scil7cmV0dXJuIHQoaT0+ZS5yZXF1ZXN0KFhuLG4sayhrKHt9LHIpLGkpKSwiYWRkU2Vzc2lvblByb3BlcnRpZXMiLCJtdXRhdGlvbiIsbil9LHB1c2hNZXRyaWNzKG4scil7cmV0dXJuIHQoaT0+ZS5yZXF1ZXN0KFduLG4sayhrKHt9LHIpLGkpKSwicHVzaE1ldHJpY3MiLCJtdXRhdGlvbiIsbil9LGFkZFNlc3Npb25GZWVkYmFjayhuLHIpe3JldHVybiB0KGk9PmUucmVxdWVzdChabixuLGsoayh7fSxyKSxpKSksImFkZFNlc3Npb25GZWVkYmFjayIsIm11dGF0aW9uIixuKX0saW5pdGlhbGl6ZVNlc3Npb24obixyKXtyZXR1cm4gdChpPT5lLnJlcXVlc3QoS24sbixrKGsoe30sciksaSkpLCJpbml0aWFsaXplU2Vzc2lvbiIsIm11dGF0aW9uIixuKX0sSWdub3JlKG4scil7cmV0dXJuIHQoaT0+ZS5yZXF1ZXN0KGVyLG4sayhrKHt9LHIpLGkpKSwiSWdub3JlIiwicXVlcnkiLG4pfX19Y29uc3QgWWU9SlNPTixycj1lPT5lLnRvVXBwZXJDYXNlKCksaXI9ZT0+e2NvbnN0IHQ9e307cmV0dXJuIGUuZm9yRWFjaCgobixyKT0+e3Rbcl09bn0pLHR9LHNyPShlLHQsbik9PmUuZG9jdW1lbnQ/ZTp7ZG9jdW1lbnQ6ZSx2YXJpYWJsZXM6dCxyZXF1ZXN0SGVhZGVyczpuLHNpZ25hbDp2b2lkIDB9LG9yPShlLHQsbik9PmUucXVlcnk/ZTp7cXVlcnk6ZSx2YXJpYWJsZXM6dCxyZXF1ZXN0SGVhZGVyczpuLHNpZ25hbDp2b2lkIDB9LGFyPShlLHQpPT5lLmRvY3VtZW50cz9lOntkb2N1bWVudHM6ZSxyZXF1ZXN0SGVhZGVyczp0LHNpZ25hbDp2b2lkIDB9LGt0PWU9Pnt2YXIgcixpO2xldCB0O2NvbnN0IG49ZS5kZWZpbml0aW9ucy5maWx0ZXIocz0+cy5raW5kPT09Ik9wZXJhdGlvbkRlZmluaXRpb24iKTtyZXR1cm4gbi5sZW5ndGg9PT0xJiYodD0oaT0ocj1uWzBdKT09bnVsbD92b2lkIDA6ci5uYW1lKT09bnVsbD92b2lkIDA6aS52YWx1ZSksdH0sSmU9ZT0+e2lmKHR5cGVvZiBlPT0ic3RyaW5nIil7bGV0IG47dHJ5e2NvbnN0IHI9SXQoZSk7bj1rdChyKX1jYXRjaChyKXt9cmV0dXJue3F1ZXJ5OmUsb3BlcmF0aW9uTmFtZTpufX1jb25zdCB0PWt0KGUpO3JldHVybntxdWVyeTpGbihlKSxvcGVyYXRpb25OYW1lOnR9fTtjbGFzcyBtZSBleHRlbmRzIEVycm9ye2NvbnN0cnVjdG9yKHQsbil7Y29uc3Qgcj1gJHttZS5leHRyYWN0TWVzc2FnZSh0KX06ICR7SlNPTi5zdHJpbmdpZnkoe3Jlc3BvbnNlOnQscmVxdWVzdDpufSl9YDtzdXBlcihyKSxPYmplY3Quc2V0UHJvdG90eXBlT2YodGhpcyxtZS5wcm90b3R5cGUpLHRoaXMucmVzcG9uc2U9dCx0aGlzLnJlcXVlc3Q9bix0eXBlb2YgRXJyb3IuY2FwdHVyZVN0YWNrVHJhY2U9PSJmdW5jdGlvbiImJkVycm9yLmNhcHR1cmVTdGFja1RyYWNlKHRoaXMsbWUpfXN0YXRpYyBleHRyYWN0TWVzc2FnZSh0KXt2YXIgbixyLGk7cmV0dXJuKGk9KHI9KG49dC5lcnJvcnMpPT1udWxsP3ZvaWQgMDpuWzBdKT09bnVsbD92b2lkIDA6ci5tZXNzYWdlKSE9bnVsbD9pOmBHcmFwaFFMIEVycm9yIChDb2RlOiAke3Quc3RhdHVzfSlgfX12YXIgUWU9e2V4cG9ydHM6e319OyhmdW5jdGlvbihlLHQpe3ZhciBuPXR5cGVvZiBzZWxmIT0idW5kZWZpbmVkIj9zZWxmOkYscj1mdW5jdGlvbigpe2Z1bmN0aW9uIHMoKXt0aGlzLmZldGNoPSExLHRoaXMuRE9NRXhjZXB0aW9uPW4uRE9NRXhjZXB0aW9ufXJldHVybiBzLnByb3RvdHlwZT1uLG5ldyBzfSgpOyhmdW5jdGlvbihzKXsoZnVuY3Rpb24obyl7dmFyIGM9e3NlYXJjaFBhcmFtczoiVVJMU2VhcmNoUGFyYW1zImluIHMsaXRlcmFibGU6IlN5bWJvbCJpbiBzJiYiaXRlcmF0b3IiaW4gU3ltYm9sLGJsb2I6IkZpbGVSZWFkZXIiaW4gcyYmIkJsb2IiaW4gcyYmZnVuY3Rpb24oKXt0cnl7cmV0dXJuIG5ldyBCbG9iLCEwfWNhdGNoKGEpe3JldHVybiExfX0oKSxmb3JtRGF0YToiRm9ybURhdGEiaW4gcyxhcnJheUJ1ZmZlcjoiQXJyYXlCdWZmZXIiaW4gc307ZnVuY3Rpb24gZChhKXtyZXR1cm4gYSYmRGF0YVZpZXcucHJvdG90eXBlLmlzUHJvdG90eXBlT2YoYSl9aWYoYy5hcnJheUJ1ZmZlcil2YXIgZj1bIltvYmplY3QgSW50OEFycmF5XSIsIltvYmplY3QgVWludDhBcnJheV0iLCJbb2JqZWN0IFVpbnQ4Q2xhbXBlZEFycmF5XSIsIltvYmplY3QgSW50MTZBcnJheV0iLCJbb2JqZWN0IFVpbnQxNkFycmF5XSIsIltvYmplY3QgSW50MzJBcnJheV0iLCJbb2JqZWN0IFVpbnQzMkFycmF5XSIsIltvYmplY3QgRmxvYXQzMkFycmF5XSIsIltvYmplY3QgRmxvYXQ2NEFycmF5XSJdLHU9QXJyYXlCdWZmZXIuaXNWaWV3fHxmdW5jdGlvbihhKXtyZXR1cm4gYSYmZi5pbmRleE9mKE9iamVjdC5wcm90b3R5cGUudG9TdHJpbmcuY2FsbChhKSk+LTF9O2Z1bmN0aW9uIGcoYSl7aWYodHlwZW9mIGEhPSJzdHJpbmciJiYoYT1TdHJpbmcoYSkpLC9bXmEtejAtOVwtIyQlJicqKy5eX2B8fl0vaS50ZXN0KGEpKXRocm93IG5ldyBUeXBlRXJyb3IoIkludmFsaWQgY2hhcmFjdGVyIGluIGhlYWRlciBmaWVsZCBuYW1lIik7cmV0dXJuIGEudG9Mb3dlckNhc2UoKX1mdW5jdGlvbiBFKGEpe3JldHVybiB0eXBlb2YgYSE9InN0cmluZyImJihhPVN0cmluZyhhKSksYX1mdW5jdGlvbiBiKGEpe3ZhciBoPXtuZXh0OmZ1bmN0aW9uKCl7dmFyIF89YS5zaGlmdCgpO3JldHVybntkb25lOl89PT12b2lkIDAsdmFsdWU6X319fTtyZXR1cm4gYy5pdGVyYWJsZSYmKGhbU3ltYm9sLml0ZXJhdG9yXT1mdW5jdGlvbigpe3JldHVybiBofSksaH1mdW5jdGlvbiB5KGEpe3RoaXMubWFwPXt9LGEgaW5zdGFuY2VvZiB5P2EuZm9yRWFjaChmdW5jdGlvbihoLF8pe3RoaXMuYXBwZW5kKF8saCl9LHRoaXMpOkFycmF5LmlzQXJyYXkoYSk/YS5mb3JFYWNoKGZ1bmN0aW9uKGgpe3RoaXMuYXBwZW5kKGhbMF0saFsxXSl9LHRoaXMpOmEmJk9iamVjdC5nZXRPd25Qcm9wZXJ0eU5hbWVzKGEpLmZvckVhY2goZnVuY3Rpb24oaCl7dGhpcy5hcHBlbmQoaCxhW2hdKX0sdGhpcyl9eS5wcm90b3R5cGUuYXBwZW5kPWZ1bmN0aW9uKGEsaCl7YT1nKGEpLGg9RShoKTt2YXIgXz10aGlzLm1hcFthXTt0aGlzLm1hcFthXT1fP18rIiwgIitoOmh9LHkucHJvdG90eXBlLmRlbGV0ZT1mdW5jdGlvbihhKXtkZWxldGUgdGhpcy5tYXBbZyhhKV19LHkucHJvdG90eXBlLmdldD1mdW5jdGlvbihhKXtyZXR1cm4gYT1nKGEpLHRoaXMuaGFzKGEpP3RoaXMubWFwW2FdOm51bGx9LHkucHJvdG90eXBlLmhhcz1mdW5jdGlvbihhKXtyZXR1cm4gdGhpcy5tYXAuaGFzT3duUHJvcGVydHkoZyhhKSl9LHkucHJvdG90eXBlLnNldD1mdW5jdGlvbihhLGgpe3RoaXMubWFwW2coYSldPUUoaCl9LHkucHJvdG90eXBlLmZvckVhY2g9ZnVuY3Rpb24oYSxoKXtmb3IodmFyIF8gaW4gdGhpcy5tYXApdGhpcy5tYXAuaGFzT3duUHJvcGVydHkoXykmJmEuY2FsbChoLHRoaXMubWFwW19dLF8sdGhpcyl9LHkucHJvdG90eXBlLmtleXM9ZnVuY3Rpb24oKXt2YXIgYT1bXTtyZXR1cm4gdGhpcy5mb3JFYWNoKGZ1bmN0aW9uKGgsXyl7YS5wdXNoKF8pfSksYihhKX0seS5wcm90b3R5cGUudmFsdWVzPWZ1bmN0aW9uKCl7dmFyIGE9W107cmV0dXJuIHRoaXMuZm9yRWFjaChmdW5jdGlvbihoKXthLnB1c2goaCl9KSxiKGEpfSx5LnByb3RvdHlwZS5lbnRyaWVzPWZ1bmN0aW9uKCl7dmFyIGE9W107cmV0dXJuIHRoaXMuZm9yRWFjaChmdW5jdGlvbihoLF8pe2EucHVzaChbXyxoXSl9KSxiKGEpfSxjLml0ZXJhYmxlJiYoeS5wcm90b3R5cGVbU3ltYm9sLml0ZXJhdG9yXT15LnByb3RvdHlwZS5lbnRyaWVzKTtmdW5jdGlvbiBwKGEpe2lmKGEuYm9keVVzZWQpcmV0dXJuIFByb21pc2UucmVqZWN0KG5ldyBUeXBlRXJyb3IoIkFscmVhZHkgcmVhZCIpKTthLmJvZHlVc2VkPSEwfWZ1bmN0aW9uIHYoYSl7cmV0dXJuIG5ldyBQcm9taXNlKGZ1bmN0aW9uKGgsXyl7YS5vbmxvYWQ9ZnVuY3Rpb24oKXtoKGEucmVzdWx0KX0sYS5vbmVycm9yPWZ1bmN0aW9uKCl7XyhhLmVycm9yKX19KX1mdW5jdGlvbiBOKGEpe3ZhciBoPW5ldyBGaWxlUmVhZGVyLF89dihoKTtyZXR1cm4gaC5yZWFkQXNBcnJheUJ1ZmZlcihhKSxffWZ1bmN0aW9uIEMoYSl7dmFyIGg9bmV3IEZpbGVSZWFkZXIsXz12KGgpO3JldHVybiBoLnJlYWRBc1RleHQoYSksX31mdW5jdGlvbiBSKGEpe2Zvcih2YXIgaD1uZXcgVWludDhBcnJheShhKSxfPW5ldyBBcnJheShoLmxlbmd0aCksST0wO0k8aC5sZW5ndGg7SSsrKV9bSV09U3RyaW5nLmZyb21DaGFyQ29kZShoW0ldKTtyZXR1cm4gXy5qb2luKCIiKX1mdW5jdGlvbiBMKGEpe2lmKGEuc2xpY2UpcmV0dXJuIGEuc2xpY2UoMCk7dmFyIGg9bmV3IFVpbnQ4QXJyYXkoYS5ieXRlTGVuZ3RoKTtyZXR1cm4gaC5zZXQobmV3IFVpbnQ4QXJyYXkoYSkpLGguYnVmZmVyfWZ1bmN0aW9uIE0oKXtyZXR1cm4gdGhpcy5ib2R5VXNlZD0hMSx0aGlzLl9pbml0Qm9keT1mdW5jdGlvbihhKXt0aGlzLl9ib2R5SW5pdD1hLGE/dHlwZW9mIGE9PSJzdHJpbmciP3RoaXMuX2JvZHlUZXh0PWE6Yy5ibG9iJiZCbG9iLnByb3RvdHlwZS5pc1Byb3RvdHlwZU9mKGEpP3RoaXMuX2JvZHlCbG9iPWE6Yy5mb3JtRGF0YSYmRm9ybURhdGEucHJvdG90eXBlLmlzUHJvdG90eXBlT2YoYSk/dGhpcy5fYm9keUZvcm1EYXRhPWE6Yy5zZWFyY2hQYXJhbXMmJlVSTFNlYXJjaFBhcmFtcy5wcm90b3R5cGUuaXNQcm90b3R5cGVPZihhKT90aGlzLl9ib2R5VGV4dD1hLnRvU3RyaW5nKCk6Yy5hcnJheUJ1ZmZlciYmYy5ibG9iJiZkKGEpPyh0aGlzLl9ib2R5QXJyYXlCdWZmZXI9TChhLmJ1ZmZlciksdGhpcy5fYm9keUluaXQ9bmV3IEJsb2IoW3RoaXMuX2JvZHlBcnJheUJ1ZmZlcl0pKTpjLmFycmF5QnVmZmVyJiYoQXJyYXlCdWZmZXIucHJvdG90eXBlLmlzUHJvdG90eXBlT2YoYSl8fHUoYSkpP3RoaXMuX2JvZHlBcnJheUJ1ZmZlcj1MKGEpOnRoaXMuX2JvZHlUZXh0PWE9T2JqZWN0LnByb3RvdHlwZS50b1N0cmluZy5jYWxsKGEpOnRoaXMuX2JvZHlUZXh0PSIiLHRoaXMuaGVhZGVycy5nZXQoImNvbnRlbnQtdHlwZSIpfHwodHlwZW9mIGE9PSJzdHJpbmciP3RoaXMuaGVhZGVycy5zZXQoImNvbnRlbnQtdHlwZSIsInRleHQvcGxhaW47Y2hhcnNldD1VVEYtOCIpOnRoaXMuX2JvZHlCbG9iJiZ0aGlzLl9ib2R5QmxvYi50eXBlP3RoaXMuaGVhZGVycy5zZXQoImNvbnRlbnQtdHlwZSIsdGhpcy5fYm9keUJsb2IudHlwZSk6Yy5zZWFyY2hQYXJhbXMmJlVSTFNlYXJjaFBhcmFtcy5wcm90b3R5cGUuaXNQcm90b3R5cGVPZihhKSYmdGhpcy5oZWFkZXJzLnNldCgiY29udGVudC10eXBlIiwiYXBwbGljYXRpb24veC13d3ctZm9ybS11cmxlbmNvZGVkO2NoYXJzZXQ9VVRGLTgiKSl9LGMuYmxvYiYmKHRoaXMuYmxvYj1mdW5jdGlvbigpe3ZhciBhPXAodGhpcyk7aWYoYSlyZXR1cm4gYTtpZih0aGlzLl9ib2R5QmxvYilyZXR1cm4gUHJvbWlzZS5yZXNvbHZlKHRoaXMuX2JvZHlCbG9iKTtpZih0aGlzLl9ib2R5QXJyYXlCdWZmZXIpcmV0dXJuIFByb21pc2UucmVzb2x2ZShuZXcgQmxvYihbdGhpcy5fYm9keUFycmF5QnVmZmVyXSkpO2lmKHRoaXMuX2JvZHlGb3JtRGF0YSl0aHJvdyBuZXcgRXJyb3IoImNvdWxkIG5vdCByZWFkIEZvcm1EYXRhIGJvZHkgYXMgYmxvYiIpO3JldHVybiBQcm9taXNlLnJlc29sdmUobmV3IEJsb2IoW3RoaXMuX2JvZHlUZXh0XSkpfSx0aGlzLmFycmF5QnVmZmVyPWZ1bmN0aW9uKCl7cmV0dXJuIHRoaXMuX2JvZHlBcnJheUJ1ZmZlcj9wKHRoaXMpfHxQcm9taXNlLnJlc29sdmUodGhpcy5fYm9keUFycmF5QnVmZmVyKTp0aGlzLmJsb2IoKS50aGVuKE4pfSksdGhpcy50ZXh0PWZ1bmN0aW9uKCl7dmFyIGE9cCh0aGlzKTtpZihhKXJldHVybiBhO2lmKHRoaXMuX2JvZHlCbG9iKXJldHVybiBDKHRoaXMuX2JvZHlCbG9iKTtpZih0aGlzLl9ib2R5QXJyYXlCdWZmZXIpcmV0dXJuIFByb21pc2UucmVzb2x2ZShSKHRoaXMuX2JvZHlBcnJheUJ1ZmZlcikpO2lmKHRoaXMuX2JvZHlGb3JtRGF0YSl0aHJvdyBuZXcgRXJyb3IoImNvdWxkIG5vdCByZWFkIEZvcm1EYXRhIGJvZHkgYXMgdGV4dCIpO3JldHVybiBQcm9taXNlLnJlc29sdmUodGhpcy5fYm9keVRleHQpfSxjLmZvcm1EYXRhJiYodGhpcy5mb3JtRGF0YT1mdW5jdGlvbigpe3JldHVybiB0aGlzLnRleHQoKS50aGVuKHgpfSksdGhpcy5qc29uPWZ1bmN0aW9uKCl7cmV0dXJuIHRoaXMudGV4dCgpLnRoZW4oSlNPTi5wYXJzZSl9LHRoaXN9dmFyIEg9WyJERUxFVEUiLCJHRVQiLCJIRUFEIiwiT1BUSU9OUyIsIlBPU1QiLCJQVVQiXTtmdW5jdGlvbiAkKGEpe3ZhciBoPWEudG9VcHBlckNhc2UoKTtyZXR1cm4gSC5pbmRleE9mKGgpPi0xP2g6YX1mdW5jdGlvbiBBKGEsaCl7aD1ofHx7fTt2YXIgXz1oLmJvZHk7aWYoYSBpbnN0YW5jZW9mIEEpe2lmKGEuYm9keVVzZWQpdGhyb3cgbmV3IFR5cGVFcnJvcigiQWxyZWFkeSByZWFkIik7dGhpcy51cmw9YS51cmwsdGhpcy5jcmVkZW50aWFscz1hLmNyZWRlbnRpYWxzLGguaGVhZGVyc3x8KHRoaXMuaGVhZGVycz1uZXcgeShhLmhlYWRlcnMpKSx0aGlzLm1ldGhvZD1hLm1ldGhvZCx0aGlzLm1vZGU9YS5tb2RlLHRoaXMuc2lnbmFsPWEuc2lnbmFsLCFfJiZhLl9ib2R5SW5pdCE9bnVsbCYmKF89YS5fYm9keUluaXQsYS5ib2R5VXNlZD0hMCl9ZWxzZSB0aGlzLnVybD1TdHJpbmcoYSk7aWYodGhpcy5jcmVkZW50aWFscz1oLmNyZWRlbnRpYWxzfHx0aGlzLmNyZWRlbnRpYWxzfHwic2FtZS1vcmlnaW4iLChoLmhlYWRlcnN8fCF0aGlzLmhlYWRlcnMpJiYodGhpcy5oZWFkZXJzPW5ldyB5KGguaGVhZGVycykpLHRoaXMubWV0aG9kPSQoaC5tZXRob2R8fHRoaXMubWV0aG9kfHwiR0VUIiksdGhpcy5tb2RlPWgubW9kZXx8dGhpcy5tb2RlfHxudWxsLHRoaXMuc2lnbmFsPWguc2lnbmFsfHx0aGlzLnNpZ25hbCx0aGlzLnJlZmVycmVyPW51bGwsKHRoaXMubWV0aG9kPT09IkdFVCJ8fHRoaXMubWV0aG9kPT09IkhFQUQiKSYmXyl0aHJvdyBuZXcgVHlwZUVycm9yKCJCb2R5IG5vdCBhbGxvd2VkIGZvciBHRVQgb3IgSEVBRCByZXF1ZXN0cyIpO3RoaXMuX2luaXRCb2R5KF8pfUEucHJvdG90eXBlLmNsb25lPWZ1bmN0aW9uKCl7cmV0dXJuIG5ldyBBKHRoaXMse2JvZHk6dGhpcy5fYm9keUluaXR9KX07ZnVuY3Rpb24geChhKXt2YXIgaD1uZXcgRm9ybURhdGE7cmV0dXJuIGEudHJpbSgpLnNwbGl0KCImIikuZm9yRWFjaChmdW5jdGlvbihfKXtpZihfKXt2YXIgST1fLnNwbGl0KCI9Iiksdz1JLnNoaWZ0KCkucmVwbGFjZSgvXCsvZywiICIpLFM9SS5qb2luKCI9IikucmVwbGFjZSgvXCsvZywiICIpO2guYXBwZW5kKGRlY29kZVVSSUNvbXBvbmVudCh3KSxkZWNvZGVVUklDb21wb25lbnQoUykpfX0pLGh9ZnVuY3Rpb24gaihhKXt2YXIgaD1uZXcgeSxfPWEucmVwbGFjZSgvXHI/XG5bXHQgXSsvZywiICIpO3JldHVybiBfLnNwbGl0KC9ccj9cbi8pLmZvckVhY2goZnVuY3Rpb24oSSl7dmFyIHc9SS5zcGxpdCgiOiIpLFM9dy5zaGlmdCgpLnRyaW0oKTtpZihTKXt2YXIgY2U9dy5qb2luKCI6IikudHJpbSgpO2guYXBwZW5kKFMsY2UpfX0pLGh9TS5jYWxsKEEucHJvdG90eXBlKTtmdW5jdGlvbiBWKGEsaCl7aHx8KGg9e30pLHRoaXMudHlwZT0iZGVmYXVsdCIsdGhpcy5zdGF0dXM9aC5zdGF0dXM9PT12b2lkIDA/MjAwOmguc3RhdHVzLHRoaXMub2s9dGhpcy5zdGF0dXM+PTIwMCYmdGhpcy5zdGF0dXM8MzAwLHRoaXMuc3RhdHVzVGV4dD0ic3RhdHVzVGV4dCJpbiBoP2guc3RhdHVzVGV4dDoiT0siLHRoaXMuaGVhZGVycz1uZXcgeShoLmhlYWRlcnMpLHRoaXMudXJsPWgudXJsfHwiIix0aGlzLl9pbml0Qm9keShhKX1NLmNhbGwoVi5wcm90b3R5cGUpLFYucHJvdG90eXBlLmNsb25lPWZ1bmN0aW9uKCl7cmV0dXJuIG5ldyBWKHRoaXMuX2JvZHlJbml0LHtzdGF0dXM6dGhpcy5zdGF0dXMsc3RhdHVzVGV4dDp0aGlzLnN0YXR1c1RleHQsaGVhZGVyczpuZXcgeSh0aGlzLmhlYWRlcnMpLHVybDp0aGlzLnVybH0pfSxWLmVycm9yPWZ1bmN0aW9uKCl7dmFyIGE9bmV3IFYobnVsbCx7c3RhdHVzOjAsc3RhdHVzVGV4dDoiIn0pO3JldHVybiBhLnR5cGU9ImVycm9yIixhfTt2YXIgcT1bMzAxLDMwMiwzMDMsMzA3LDMwOF07Vi5yZWRpcmVjdD1mdW5jdGlvbihhLGgpe2lmKHEuaW5kZXhPZihoKT09PS0xKXRocm93IG5ldyBSYW5nZUVycm9yKCJJbnZhbGlkIHN0YXR1cyBjb2RlIik7cmV0dXJuIG5ldyBWKG51bGwse3N0YXR1czpoLGhlYWRlcnM6e2xvY2F0aW9uOmF9fSl9LG8uRE9NRXhjZXB0aW9uPXMuRE9NRXhjZXB0aW9uO3RyeXtuZXcgby5ET01FeGNlcHRpb259Y2F0Y2goYSl7by5ET01FeGNlcHRpb249ZnVuY3Rpb24oaCxfKXt0aGlzLm1lc3NhZ2U9aCx0aGlzLm5hbWU9Xzt2YXIgST1FcnJvcihoKTt0aGlzLnN0YWNrPUkuc3RhY2t9LG8uRE9NRXhjZXB0aW9uLnByb3RvdHlwZT1PYmplY3QuY3JlYXRlKEVycm9yLnByb3RvdHlwZSksby5ET01FeGNlcHRpb24ucHJvdG90eXBlLmNvbnN0cnVjdG9yPW8uRE9NRXhjZXB0aW9ufWZ1bmN0aW9uIFooYSxoKXtyZXR1cm4gbmV3IFByb21pc2UoZnVuY3Rpb24oXyxJKXt2YXIgdz1uZXcgQShhLGgpO2lmKHcuc2lnbmFsJiZ3LnNpZ25hbC5hYm9ydGVkKXJldHVybiBJKG5ldyBvLkRPTUV4Y2VwdGlvbigiQWJvcnRlZCIsIkFib3J0RXJyb3IiKSk7dmFyIFM9bmV3IFhNTEh0dHBSZXF1ZXN0O2Z1bmN0aW9uIGNlKCl7Uy5hYm9ydCgpfVMub25sb2FkPWZ1bmN0aW9uKCl7dmFyIHo9e3N0YXR1czpTLnN0YXR1cyxzdGF0dXNUZXh0OlMuc3RhdHVzVGV4dCxoZWFkZXJzOmooUy5nZXRBbGxSZXNwb25zZUhlYWRlcnMoKXx8IiIpfTt6LnVybD0icmVzcG9uc2VVUkwiaW4gUz9TLnJlc3BvbnNlVVJMOnouaGVhZGVycy5nZXQoIlgtUmVxdWVzdC1VUkwiKTt2YXIgaWU9InJlc3BvbnNlImluIFM/Uy5yZXNwb25zZTpTLnJlc3BvbnNlVGV4dDtfKG5ldyBWKGllLHopKX0sUy5vbmVycm9yPWZ1bmN0aW9uKCl7SShuZXcgVHlwZUVycm9yKCJOZXR3b3JrIHJlcXVlc3QgZmFpbGVkIikpfSxTLm9udGltZW91dD1mdW5jdGlvbigpe0kobmV3IFR5cGVFcnJvcigiTmV0d29yayByZXF1ZXN0IGZhaWxlZCIpKX0sUy5vbmFib3J0PWZ1bmN0aW9uKCl7SShuZXcgby5ET01FeGNlcHRpb24oIkFib3J0ZWQiLCJBYm9ydEVycm9yIikpfSxTLm9wZW4ody5tZXRob2Qsdy51cmwsITApLHcuY3JlZGVudGlhbHM9PT0iaW5jbHVkZSI/Uy53aXRoQ3JlZGVudGlhbHM9ITA6dy5jcmVkZW50aWFscz09PSJvbWl0IiYmKFMud2l0aENyZWRlbnRpYWxzPSExKSwicmVzcG9uc2VUeXBlImluIFMmJmMuYmxvYiYmKFMucmVzcG9uc2VUeXBlPSJibG9iIiksdy5oZWFkZXJzLmZvckVhY2goZnVuY3Rpb24oeixpZSl7Uy5zZXRSZXF1ZXN0SGVhZGVyKGllLHopfSksdy5zaWduYWwmJih3LnNpZ25hbC5hZGRFdmVudExpc3RlbmVyKCJhYm9ydCIsY2UpLFMub25yZWFkeXN0YXRlY2hhbmdlPWZ1bmN0aW9uKCl7Uy5yZWFkeVN0YXRlPT09NCYmdy5zaWduYWwucmVtb3ZlRXZlbnRMaXN0ZW5lcigiYWJvcnQiLGNlKX0pLFMuc2VuZCh0eXBlb2Ygdy5fYm9keUluaXQ9PSJ1bmRlZmluZWQiP251bGw6dy5fYm9keUluaXQpfSl9cmV0dXJuIFoucG9seWZpbGw9ITAscy5mZXRjaHx8KHMuZmV0Y2g9WixzLkhlYWRlcnM9eSxzLlJlcXVlc3Q9QSxzLlJlc3BvbnNlPVYpLG8uSGVhZGVycz15LG8uUmVxdWVzdD1BLG8uUmVzcG9uc2U9VixvLmZldGNoPVosT2JqZWN0LmRlZmluZVByb3BlcnR5KG8sIl9fZXNNb2R1bGUiLHt2YWx1ZTohMH0pLG99KSh7fSl9KShyKSxyLmZldGNoLnBvbnlmaWxsPSEwLGRlbGV0ZSByLmZldGNoLnBvbHlmaWxsO3ZhciBpPXI7dD1pLmZldGNoLHQuZGVmYXVsdD1pLmZldGNoLHQuZmV0Y2g9aS5mZXRjaCx0LkhlYWRlcnM9aS5IZWFkZXJzLHQuUmVxdWVzdD1pLlJlcXVlc3QsdC5SZXNwb25zZT1pLlJlc3BvbnNlLGUuZXhwb3J0cz10fSkoUWUsUWUuZXhwb3J0cyk7dmFyIFJlPVFlLmV4cG9ydHMsTGU9SihSZSksY3I9Qih7X19wcm90b19fOm51bGwsZGVmYXVsdDpMZX0sW1JlXSk7Y29uc3QgeWU9ZT0+e2xldCB0PXt9O3JldHVybiBlJiYodHlwZW9mIEhlYWRlcnMhPSJ1bmRlZmluZWQiJiZlIGluc3RhbmNlb2YgSGVhZGVyc3x8Y3ImJlJlLkhlYWRlcnMmJmUgaW5zdGFuY2VvZiBSZS5IZWFkZXJzP3Q9aXIoZSk6QXJyYXkuaXNBcnJheShlKT9lLmZvckVhY2goKFtuLHJdKT0+e24mJnIhPT12b2lkIDAmJih0W25dPXIpfSk6dD1lKSx0fSxSdD1lPT5lLnJlcGxhY2UoLyhbXHMsXXwjW15cblxyXSspKy9nLCIgIikudHJpbSgpLHVyPWU9PntpZighQXJyYXkuaXNBcnJheShlLnF1ZXJ5KSl7Y29uc3Qgcj1lLGk9W2BxdWVyeT0ke2VuY29kZVVSSUNvbXBvbmVudChSdChyLnF1ZXJ5KSl9YF07cmV0dXJuIGUudmFyaWFibGVzJiZpLnB1c2goYHZhcmlhYmxlcz0ke2VuY29kZVVSSUNvbXBvbmVudChyLmpzb25TZXJpYWxpemVyLnN0cmluZ2lmeShyLnZhcmlhYmxlcykpfWApLHIub3BlcmF0aW9uTmFtZSYmaS5wdXNoKGBvcGVyYXRpb25OYW1lPSR7ZW5jb2RlVVJJQ29tcG9uZW50KHIub3BlcmF0aW9uTmFtZSl9YCksaS5qb2luKCImIil9aWYodHlwZW9mIGUudmFyaWFibGVzIT0idW5kZWZpbmVkIiYmIUFycmF5LmlzQXJyYXkoZS52YXJpYWJsZXMpKXRocm93IG5ldyBFcnJvcigiQ2Fubm90IGNyZWF0ZSBxdWVyeSB3aXRoIGdpdmVuIHZhcmlhYmxlIHR5cGUsIGFycmF5IGV4cGVjdGVkIik7Y29uc3QgdD1lLG49ZS5xdWVyeS5yZWR1Y2UoKHIsaSxzKT0+KHIucHVzaCh7cXVlcnk6UnQoaSksdmFyaWFibGVzOnQudmFyaWFibGVzP3QuanNvblNlcmlhbGl6ZXIuc3RyaW5naWZ5KHQudmFyaWFibGVzW3NdKTp2b2lkIDB9KSxyKSxbXSk7cmV0dXJuYHF1ZXJ5PSR7ZW5jb2RlVVJJQ29tcG9uZW50KHQuanNvblNlcmlhbGl6ZXIuc3RyaW5naWZ5KG4pKX1gfSxscj1lPT50PT5YKHRoaXMsbnVsbCxmdW5jdGlvbiooKXt2YXIgcDtjb25zdHt1cmw6bixxdWVyeTpyLHZhcmlhYmxlczppLG9wZXJhdGlvbk5hbWU6cyxmZXRjaDpvLGZldGNoT3B0aW9uczpjLG1pZGRsZXdhcmU6ZH09dCxmPWsoe30sdC5oZWFkZXJzKTtsZXQgdT0iIixnO2U9PT0iUE9TVCI/KGc9aHIocixpLHMsYy5qc29uU2VyaWFsaXplciksdHlwZW9mIGc9PSJzdHJpbmciJiYoZlsiQ29udGVudC1UeXBlIl09ImFwcGxpY2F0aW9uL2pzb24iKSk6dT11cih7cXVlcnk6cix2YXJpYWJsZXM6aSxvcGVyYXRpb25OYW1lOnMsanNvblNlcmlhbGl6ZXI6KHA9Yy5qc29uU2VyaWFsaXplcikhPW51bGw/cDpZZX0pO2NvbnN0IEU9ayh7bWV0aG9kOmUsaGVhZGVyczpmLGJvZHk6Z30sYyk7bGV0IGI9bix5PUU7aWYoZCl7Y29uc3Qgdj15aWVsZCBQcm9taXNlLnJlc29sdmUoZChNZShrKHt9LEUpLHt1cmw6bixvcGVyYXRpb25OYW1lOnMsdmFyaWFibGVzOml9KSkpLHt1cmw6Q309dixSPUVlKHYsWyJ1cmwiXSk7Yj1DLHk9Un1yZXR1cm4gdSYmKGI9YCR7Yn0/JHt1fWApLHlpZWxkIG8oYix5KX0pO2NsYXNzIGZye2NvbnN0cnVjdG9yKHQsbj17fSl7dGhpcy51cmw9dCx0aGlzLnJlcXVlc3RDb25maWc9bix0aGlzLnJhd1JlcXVlc3Q9KC4uLnIpPT5YKHRoaXMsbnVsbCxmdW5jdGlvbiooKXtjb25zdFtpLHMsb109cixjPW9yKGkscyxvKSx2PXRoaXMucmVxdWVzdENvbmZpZyx7aGVhZGVyczpkLGZldGNoOmY9TGUsbWV0aG9kOnU9IlBPU1QiLHJlcXVlc3RNaWRkbGV3YXJlOmcscmVzcG9uc2VNaWRkbGV3YXJlOkV9PXYsYj1FZSh2LFsiaGVhZGVycyIsImZldGNoIiwibWV0aG9kIiwicmVxdWVzdE1pZGRsZXdhcmUiLCJyZXNwb25zZU1pZGRsZXdhcmUiXSkse3VybDp5fT10aGlzO2Muc2lnbmFsIT09dm9pZCAwJiYoYi5zaWduYWw9Yy5zaWduYWwpO2NvbnN0e29wZXJhdGlvbk5hbWU6cH09SmUoYy5xdWVyeSk7cmV0dXJuIFhlKHt1cmw6eSxxdWVyeTpjLnF1ZXJ5LHZhcmlhYmxlczpjLnZhcmlhYmxlcyxoZWFkZXJzOmsoayh7fSx5ZShXZShkKSkpLHllKGMucmVxdWVzdEhlYWRlcnMpKSxvcGVyYXRpb25OYW1lOnAsZmV0Y2g6ZixtZXRob2Q6dSxmZXRjaE9wdGlvbnM6YixtaWRkbGV3YXJlOmd9KS50aGVuKE49PihFJiZFKE4pLE4pKS5jYXRjaChOPT57dGhyb3cgRSYmRShOKSxOfSl9KX1yZXF1ZXN0KHQsLi4ubil7cmV0dXJuIFgodGhpcyxudWxsLGZ1bmN0aW9uKigpe2NvbnN0W3IsaV09bixzPXNyKHQscixpKSxwPXRoaXMucmVxdWVzdENvbmZpZyx7aGVhZGVyczpvLGZldGNoOmM9TGUsbWV0aG9kOmQ9IlBPU1QiLHJlcXVlc3RNaWRkbGV3YXJlOmYscmVzcG9uc2VNaWRkbGV3YXJlOnV9PXAsZz1FZShwLFsiaGVhZGVycyIsImZldGNoIiwibWV0aG9kIiwicmVxdWVzdE1pZGRsZXdhcmUiLCJyZXNwb25zZU1pZGRsZXdhcmUiXSkse3VybDpFfT10aGlzO3Muc2lnbmFsIT09dm9pZCAwJiYoZy5zaWduYWw9cy5zaWduYWwpO2NvbnN0e3F1ZXJ5OmIsb3BlcmF0aW9uTmFtZTp5fT1KZShzLmRvY3VtZW50KTtyZXR1cm4gWGUoe3VybDpFLHF1ZXJ5OmIsdmFyaWFibGVzOnMudmFyaWFibGVzLGhlYWRlcnM6ayhrKHt9LHllKFdlKG8pKSkseWUocy5yZXF1ZXN0SGVhZGVycykpLG9wZXJhdGlvbk5hbWU6eSxmZXRjaDpjLG1ldGhvZDpkLGZldGNoT3B0aW9uczpnLG1pZGRsZXdhcmU6Zn0pLnRoZW4odj0+KHUmJnUodiksdi5kYXRhKSkuY2F0Y2godj0+e3Rocm93IHUmJnUodiksdn0pfSl9YmF0Y2hSZXF1ZXN0cyh0LG4pe3ZhciBmO2NvbnN0IHI9YXIodCxuKSxkPXRoaXMucmVxdWVzdENvbmZpZyx7aGVhZGVyczppfT1kLHM9RWUoZCxbImhlYWRlcnMiXSk7ci5zaWduYWwhPT12b2lkIDAmJihzLnNpZ25hbD1yLnNpZ25hbCk7Y29uc3Qgbz1yLmRvY3VtZW50cy5tYXAoKHtkb2N1bWVudDp1fSk9PkplKHUpLnF1ZXJ5KSxjPXIuZG9jdW1lbnRzLm1hcCgoe3ZhcmlhYmxlczp1fSk9PnUpO3JldHVybiBYZSh7dXJsOnRoaXMudXJsLHF1ZXJ5Om8sdmFyaWFibGVzOmMsaGVhZGVyczprKGsoe30seWUoV2UoaSkpKSx5ZShyLnJlcXVlc3RIZWFkZXJzKSksb3BlcmF0aW9uTmFtZTp2b2lkIDAsZmV0Y2g6KGY9dGhpcy5yZXF1ZXN0Q29uZmlnLmZldGNoKSE9bnVsbD9mOkxlLG1ldGhvZDp0aGlzLnJlcXVlc3RDb25maWcubWV0aG9kfHwiUE9TVCIsZmV0Y2hPcHRpb25zOnMsbWlkZGxld2FyZTp0aGlzLnJlcXVlc3RDb25maWcucmVxdWVzdE1pZGRsZXdhcmV9KS50aGVuKHU9Pih0aGlzLnJlcXVlc3RDb25maWcucmVzcG9uc2VNaWRkbGV3YXJlJiZ0aGlzLnJlcXVlc3RDb25maWcucmVzcG9uc2VNaWRkbGV3YXJlKHUpLHUuZGF0YSkpLmNhdGNoKHU9Pnt0aHJvdyB0aGlzLnJlcXVlc3RDb25maWcucmVzcG9uc2VNaWRkbGV3YXJlJiZ0aGlzLnJlcXVlc3RDb25maWcucmVzcG9uc2VNaWRkbGV3YXJlKHUpLHV9KX1zZXRIZWFkZXJzKHQpe3JldHVybiB0aGlzLnJlcXVlc3RDb25maWcuaGVhZGVycz10LHRoaXN9c2V0SGVhZGVyKHQsbil7Y29uc3R7aGVhZGVyczpyfT10aGlzLnJlcXVlc3RDb25maWc7cmV0dXJuIHI/clt0XT1uOnRoaXMucmVxdWVzdENvbmZpZy5oZWFkZXJzPXtbdF06bn0sdGhpc31zZXRFbmRwb2ludCh0KXtyZXR1cm4gdGhpcy51cmw9dCx0aGlzfX1jb25zdCBYZT1lPT5YKHRoaXMsbnVsbCxmdW5jdGlvbiooKXt2YXIgdSxnO2NvbnN0e3F1ZXJ5OnQsdmFyaWFibGVzOm4sZmV0Y2hPcHRpb25zOnJ9PWUsaT1scihycigodT1lLm1ldGhvZCkhPW51bGw/dToicG9zdCIpKSxzPUFycmF5LmlzQXJyYXkoZS5xdWVyeSksbz15aWVsZCBpKGUpLGM9eWllbGQgZHIobywoZz1yLmpzb25TZXJpYWxpemVyKSE9bnVsbD9nOlllKSxkPUFycmF5LmlzQXJyYXkoYyk/IWMuc29tZSgoe2RhdGE6Yn0pPT4hYik6ISFjLmRhdGEsZj1BcnJheS5pc0FycmF5KGMpfHwhYy5lcnJvcnN8fEFycmF5LmlzQXJyYXkoYy5lcnJvcnMpJiYhYy5lcnJvcnMubGVuZ3RofHxyLmVycm9yUG9saWN5PT09ImFsbCJ8fHIuZXJyb3JQb2xpY3k9PT0iaWdub3JlIjtpZihvLm9rJiZmJiZkKXtjb25zdCBFPShBcnJheS5pc0FycmF5KGMpLGMpLHtlcnJvcnM6Yn09RSx5PUVlKEUsWyJlcnJvcnMiXSkscD1yLmVycm9yUG9saWN5PT09Imlnbm9yZSI/eTpjO3JldHVybiBNZShrKHt9LHM/e2RhdGE6cH06cCkse2hlYWRlcnM6by5oZWFkZXJzLHN0YXR1czpvLnN0YXR1c30pfWVsc2V7Y29uc3QgYj10eXBlb2YgYz09InN0cmluZyI/e2Vycm9yOmN9OmM7dGhyb3cgbmV3IG1lKE1lKGsoe30sYikse3N0YXR1czpvLnN0YXR1cyxoZWFkZXJzOm8uaGVhZGVyc30pLHtxdWVyeTp0LHZhcmlhYmxlczpufSl9fSksaHI9KGUsdCxuLHIpPT57Y29uc3QgaT1yIT1udWxsP3I6WWU7aWYoIUFycmF5LmlzQXJyYXkoZSkpcmV0dXJuIGkuc3RyaW5naWZ5KHtxdWVyeTplLHZhcmlhYmxlczp0LG9wZXJhdGlvbk5hbWU6bn0pO2lmKHR5cGVvZiB0IT0idW5kZWZpbmVkIiYmIUFycmF5LmlzQXJyYXkodCkpdGhyb3cgbmV3IEVycm9yKCJDYW5ub3QgY3JlYXRlIHJlcXVlc3QgYm9keSB3aXRoIGdpdmVuIHZhcmlhYmxlIHR5cGUsIGFycmF5IGV4cGVjdGVkIik7Y29uc3Qgcz1lLnJlZHVjZSgobyxjLGQpPT4oby5wdXNoKHtxdWVyeTpjLHZhcmlhYmxlczp0P3RbZF06dm9pZCAwfSksbyksW10pO3JldHVybiBpLnN0cmluZ2lmeShzKX0sZHI9KGUsdCk9PlgodGhpcyxudWxsLGZ1bmN0aW9uKigpe2xldCBuO3JldHVybiBlLmhlYWRlcnMuZm9yRWFjaCgocixpKT0+e2kudG9Mb3dlckNhc2UoKT09PSJjb250ZW50LXR5cGUiJiYobj1yKX0pLG4mJihuLnRvTG93ZXJDYXNlKCkuc3RhcnRzV2l0aCgiYXBwbGljYXRpb24vanNvbiIpfHxuLnRvTG93ZXJDYXNlKCkuc3RhcnRzV2l0aCgiYXBwbGljYXRpb24vZ3JhcGhxbCtqc29uIil8fG4udG9Mb3dlckNhc2UoKS5zdGFydHNXaXRoKCJhcHBsaWNhdGlvbi9ncmFwaHFsLXJlc3BvbnNlK2pzb24iKSk/dC5wYXJzZSh5aWVsZCBlLnRleHQoKSk6ZS50ZXh0KCl9KSxXZT1lPT50eXBlb2YgZT09ImZ1bmN0aW9uIj9lKCk6ZTt2YXIgWmU7KGZ1bmN0aW9uKGUpe2UuQmlsbGluZ1F1b3RhRXhjZWVkZWQ9IkJpbGxpbmdRdW90YUV4Y2VlZGVkIn0pKFplfHwoWmU9e30pKTtjb25zdCBwcj0xMCxtcj0xZTMseXI9NTAwLHZyPVtaZS5CaWxsaW5nUXVvdGFFeGNlZWRlZC50b1N0cmluZygpXSxncj1lPT57dmFyIG47cmV0dXJuKChuPWUucmVzcG9uc2UuZXJyb3JzKT09bnVsbD92b2lkIDA6bi5maW5kKHI9PnZyLmluY2x1ZGVzKHIubWVzc2FnZSkpKT09PXZvaWQgMH0sRXI9ZT0+e2NvbnN0IHQ9KG4scixpLHMsbz0wKT0+WCh0aGlzLG51bGwsZnVuY3Rpb24qKCl7dHJ5e3JldHVybiB5aWVsZCBuKCl9Y2F0Y2goYyl7aWYoYyBpbnN0YW5jZW9mIG1lJiYhZ3IoYykpdGhyb3cgYztpZihvPHByKXJldHVybiB5aWVsZCBuZXcgUHJvbWlzZShkPT5zZXRUaW1lb3V0KGQsbXIreXIqTWF0aC5wb3coMixvKSkpLHlpZWxkIHQobixyLGkscyxvKzEpO3Rocm93IGNvbnNvbGUuZXJyb3IoYGhpZ2hsaWdodC5pbzogWyR7ZXx8ZX1dIGRhdGEgcmVxdWVzdCBmYWlsZWQgYWZ0ZXIgJHtvfSByZXRyaWVzYCksY319KTtyZXR1cm4gdH0sX3I9NSxMdD0yZTMsVHI9WyJudW1iZXIiLCJzdHJpbmciLCJib29sZWFuIl07Y2xhc3MgYnJ7Y29uc3RydWN0b3IodCxuKXtodCh0aGlzLCJkZWJ1ZyIpO2h0KHRoaXMsIm5hbWUiKTt0aGlzLmRlYnVnPXQsdGhpcy5uYW1lPW59bG9nKC4uLnQpe2lmKHRoaXMuZGVidWcpe2xldCBuPWBbJHtEYXRlLm5vdygpfV1gO3RoaXMubmFtZSYmKG4rPWAgLSAke3RoaXMubmFtZX1gKSxjb25zb2xlLmxvZy5hcHBseShjb25zb2xlLFtuLC4uLnRdKX19fXZhciBRPVVpbnQ4QXJyYXksVz1VaW50MTZBcnJheSxLZT1JbnQzMkFycmF5LGV0PW5ldyBRKFswLDAsMCwwLDAsMCwwLDAsMSwxLDEsMSwyLDIsMiwyLDMsMywzLDMsNCw0LDQsNCw1LDUsNSw1LDAsMCwwLDBdKSx0dD1uZXcgUShbMCwwLDAsMCwxLDEsMiwyLDMsMyw0LDQsNSw1LDYsNiw3LDcsOCw4LDksOSwxMCwxMCwxMSwxMSwxMiwxMiwxMywxMywwLDBdKSxQdD1uZXcgUShbMTYsMTcsMTgsMCw4LDcsOSw2LDEwLDUsMTEsNCwxMiwzLDEzLDIsMTQsMSwxNV0pLEZ0PWZ1bmN0aW9uKGUsdCl7Zm9yKHZhciBuPW5ldyBXKDMxKSxyPTA7cjwzMTsrK3IpbltyXT10Kz0xPDxlW3ItMV07Zm9yKHZhciBpPW5ldyBLZShuWzMwXSkscj0xO3I8MzA7KytyKWZvcih2YXIgcz1uW3JdO3M8bltyKzFdOysrcylpW3NdPXMtbltyXTw8NXxyO3JldHVybntiOm4scjppfX0sQnQ9RnQoZXQsMiksTnI9QnQuYixudD1CdC5yO05yWzI4XT0yNTgsbnRbMjU4XT0yODtmb3IodmFyIHhyPUZ0KHR0LDApLE10PXhyLnIscnQ9bmV3IFcoMzI3NjgpLFA9MDtQPDMyNzY4OysrUCl7dmFyIGFlPShQJjQzNjkwKT4+MXwoUCYyMTg0NSk8PDE7YWU9KGFlJjUyNDI4KT4+MnwoYWUmMTMxMDcpPDwyLGFlPShhZSY2MTY4MCk+PjR8KGFlJjM4NTUpPDw0LHJ0W1BdPSgoYWUmNjUyODApPj44fChhZSYyNTUpPDw4KT4+MX1mb3IodmFyIHhlPWZ1bmN0aW9uKGUsdCxuKXtmb3IodmFyIHI9ZS5sZW5ndGgsaT0wLHM9bmV3IFcodCk7aTxyOysraSllW2ldJiYrK3NbZVtpXS0xXTt2YXIgbz1uZXcgVyh0KTtmb3IoaT0xO2k8dDsrK2kpb1tpXT1vW2ktMV0rc1tpLTFdPDwxO3ZhciBjO2lmKG4pe2M9bmV3IFcoMTw8dCk7dmFyIGQ9MTUtdDtmb3IoaT0wO2k8cjsrK2kpaWYoZVtpXSlmb3IodmFyIGY9aTw8NHxlW2ldLHU9dC1lW2ldLGc9b1tlW2ldLTFdKys8PHUsRT1nfCgxPDx1KS0xO2c8PUU7KytnKWNbcnRbZ10+PmRdPWZ9ZWxzZSBmb3IoYz1uZXcgVyhyKSxpPTA7aTxyOysraSllW2ldJiYoY1tpXT1ydFtvW2VbaV0tMV0rK10+PjE1LWVbaV0pO3JldHVybiBjfSxsZT1uZXcgUSgyODgpLFA9MDtQPDE0NDsrK1ApbGVbUF09ODtmb3IodmFyIFA9MTQ0O1A8MjU2OysrUClsZVtQXT05O2Zvcih2YXIgUD0yNTY7UDwyODA7KytQKWxlW1BdPTc7Zm9yKHZhciBQPTI4MDtQPDI4ODsrK1ApbGVbUF09ODtmb3IodmFyIFBlPW5ldyBRKDMyKSxQPTA7UDwzMjsrK1ApUGVbUF09NTt2YXIgQXI9eGUobGUsOSwwKSxJcj14ZShQZSw1LDApLCR0PWZ1bmN0aW9uKGUpe3JldHVybihlKzcpLzh8MH0sVXQ9ZnVuY3Rpb24oZSx0LG4pe3JldHVybih0PT1udWxsfHx0PDApJiYodD0wKSwobj09bnVsbHx8bj5lLmxlbmd0aCkmJihuPWUubGVuZ3RoKSxuZXcgUShlLnN1YmFycmF5KHQsbikpfSxyZT1mdW5jdGlvbihlLHQsbil7bjw8PXQmNzt2YXIgcj10Lzh8MDtlW3JdfD1uLGVbcisxXXw9bj4+OH0sQWU9ZnVuY3Rpb24oZSx0LG4pe248PD10Jjc7dmFyIHI9dC84fDA7ZVtyXXw9bixlW3IrMV18PW4+PjgsZVtyKzJdfD1uPj4xNn0saXQ9ZnVuY3Rpb24oZSx0KXtmb3IodmFyIG49W10scj0wO3I8ZS5sZW5ndGg7KytyKWVbcl0mJm4ucHVzaCh7czpyLGY6ZVtyXX0pO3ZhciBpPW4ubGVuZ3RoLHM9bi5zbGljZSgpO2lmKCFpKXJldHVybnt0Okd0LGw6MH07aWYoaT09MSl7dmFyIG89bmV3IFEoblswXS5zKzEpO3JldHVybiBvW25bMF0uc109MSx7dDpvLGw6MX19bi5zb3J0KGZ1bmN0aW9uKE0sSCl7cmV0dXJuIE0uZi1ILmZ9KSxuLnB1c2goe3M6LTEsZjoyNTAwMX0pO3ZhciBjPW5bMF0sZD1uWzFdLGY9MCx1PTEsZz0yO2ZvcihuWzBdPXtzOi0xLGY6Yy5mK2QuZixsOmMscjpkfTt1IT1pLTE7KWM9bltuW2ZdLmY8bltnXS5mP2YrKzpnKytdLGQ9bltmIT11JiZuW2ZdLmY8bltnXS5mP2YrKzpnKytdLG5bdSsrXT17czotMSxmOmMuZitkLmYsbDpjLHI6ZH07Zm9yKHZhciBFPXNbMF0ucyxyPTE7cjxpOysrcilzW3JdLnM+RSYmKEU9c1tyXS5zKTt2YXIgYj1uZXcgVyhFKzEpLHk9c3Qoblt1LTFdLGIsMCk7aWYoeT50KXt2YXIgcj0wLHA9MCx2PXktdCxOPTE8PHY7Zm9yKHMuc29ydChmdW5jdGlvbihILCQpe3JldHVybiBiWyQuc10tYltILnNdfHxILmYtJC5mfSk7cjxpOysrcil7dmFyIEM9c1tyXS5zO2lmKGJbQ10+dClwKz1OLSgxPDx5LWJbQ10pLGJbQ109dDtlbHNlIGJyZWFrfWZvcihwPj49djtwPjA7KXt2YXIgUj1zW3JdLnM7YltSXTx0P3AtPTE8PHQtYltSXSsrLTE6KytyfWZvcig7cj49MCYmcDstLXIpe3ZhciBMPXNbcl0ucztiW0xdPT10JiYoLS1iW0xdLCsrcCl9eT10fXJldHVybnt0Om5ldyBRKGIpLGw6eX19LHN0PWZ1bmN0aW9uKGUsdCxuKXtyZXR1cm4gZS5zPT0tMT9NYXRoLm1heChzdChlLmwsdCxuKzEpLHN0KGUucix0LG4rMSkpOnRbZS5zXT1ufSxWdD1mdW5jdGlvbihlKXtmb3IodmFyIHQ9ZS5sZW5ndGg7dCYmIWVbLS10XTspO2Zvcih2YXIgbj1uZXcgVygrK3QpLHI9MCxpPWVbMF0scz0xLG89ZnVuY3Rpb24oZCl7bltyKytdPWR9LGM9MTtjPD10OysrYylpZihlW2NdPT1pJiZjIT10KSsrcztlbHNle2lmKCFpJiZzPjIpe2Zvcig7cz4xMzg7cy09MTM4KW8oMzI3NTQpO3M+MiYmKG8ocz4xMD9zLTExPDw1fDI4NjkwOnMtMzw8NXwxMjMwNSkscz0wKX1lbHNlIGlmKHM+Myl7Zm9yKG8oaSksLS1zO3M+NjtzLT02KW8oODMwNCk7cz4yJiYobyhzLTM8PDV8ODIwOCkscz0wKX1mb3IoO3MtLTspbyhpKTtzPTEsaT1lW2NdfXJldHVybntjOm4uc3ViYXJyYXkoMCxyKSxuOnR9fSxJZT1mdW5jdGlvbihlLHQpe2Zvcih2YXIgbj0wLHI9MDtyPHQubGVuZ3RoOysrciluKz1lW3JdKnRbcl07cmV0dXJuIG59LGp0PWZ1bmN0aW9uKGUsdCxuKXt2YXIgcj1uLmxlbmd0aCxpPSR0KHQrMik7ZVtpXT1yJjI1NSxlW2krMV09cj4+OCxlW2krMl09ZVtpXV4yNTUsZVtpKzNdPWVbaSsxXV4yNTU7Zm9yKHZhciBzPTA7czxyOysrcyllW2krcys0XT1uW3NdO3JldHVybihpKzQrcikqOH0scXQ9ZnVuY3Rpb24oZSx0LG4scixpLHMsbyxjLGQsZix1KXtyZSh0LHUrKyxuKSwrK2lbMjU2XTtmb3IodmFyIGc9aXQoaSwxNSksRT1nLnQsYj1nLmwseT1pdChzLDE1KSxwPXkudCx2PXkubCxOPVZ0KEUpLEM9Ti5jLFI9Ti5uLEw9VnQocCksTT1MLmMsSD1MLm4sJD1uZXcgVygxOSksQT0wO0E8Qy5sZW5ndGg7KytBKSsrJFtDW0FdJjMxXTtmb3IodmFyIEE9MDtBPE0ubGVuZ3RoOysrQSkrKyRbTVtBXSYzMV07Zm9yKHZhciB4PWl0KCQsNyksaj14LnQsVj14LmwscT0xOTtxPjQmJiFqW1B0W3EtMV1dOy0tcSk7dmFyIFo9Zis1PDwzLGE9SWUoaSxsZSkrSWUocyxQZSkrbyxoPUllKGksRSkrSWUocyxwKStvKzE0KzMqcStJZSgkLGopKzIqJFsxNl0rMyokWzE3XSs3KiRbMThdO2lmKGQ+PTAmJlo8PWEmJlo8PWgpcmV0dXJuIGp0KHQsdSxlLnN1YmFycmF5KGQsZCtmKSk7dmFyIF8sSSx3LFM7aWYocmUodCx1LDErKGg8YSkpLHUrPTIsaDxhKXtfPXhlKEUsYiwwKSxJPUUsdz14ZShwLHYsMCksUz1wO3ZhciBjZT14ZShqLFYsMCk7cmUodCx1LFItMjU3KSxyZSh0LHUrNSxILTEpLHJlKHQsdSsxMCxxLTQpLHUrPTE0O2Zvcih2YXIgQT0wO0E8cTsrK0EpcmUodCx1KzMqQSxqW1B0W0FdXSk7dSs9MypxO2Zvcih2YXIgej1bQyxNXSxpZT0wO2llPDI7KytpZSlmb3IodmFyIHZlPXpbaWVdLEE9MDtBPHZlLmxlbmd0aDsrK0Epe3ZhciB0ZT12ZVtBXSYzMTtyZSh0LHUsY2VbdGVdKSx1Kz1qW3RlXSx0ZT4xNSYmKHJlKHQsdSx2ZVtBXT4+NSYxMjcpLHUrPXZlW0FdPj4xMil9fWVsc2UgXz1BcixJPWxlLHc9SXIsUz1QZTtmb3IodmFyIEE9MDtBPGM7KytBKXt2YXIgWT1yW0FdO2lmKFk+MjU1KXt2YXIgdGU9WT4+MTgmMzE7QWUodCx1LF9bdGUrMjU3XSksdSs9SVt0ZSsyNTddLHRlPjcmJihyZSh0LHUsWT4+MjMmMzEpLHUrPWV0W3RlXSk7dmFyIGdlPVkmMzE7QWUodCx1LHdbZ2VdKSx1Kz1TW2dlXSxnZT4zJiYoQWUodCx1LFk+PjUmODE5MSksdSs9dHRbZ2VdKX1lbHNlIEFlKHQsdSxfW1ldKSx1Kz1JW1ldfXJldHVybiBBZSh0LHUsX1syNTZdKSx1K0lbMjU2XX0sT3I9bmV3IEtlKFs2NTU0MCwxMzEwODAsMTMxMDg4LDEzMTEwNCwyNjIxNzYsMTA0ODcwNCwxMDQ4ODMyLDIxMTQ1NjAsMjExNzYzMl0pLEd0PW5ldyBRKDApLFNyPWZ1bmN0aW9uKGUsdCxuLHIsaSxzKXt2YXIgbz1zLnp8fGUubGVuZ3RoLGM9bmV3IFEocitvKzUqKDErTWF0aC5jZWlsKG8vN2UzKSkraSksZD1jLnN1YmFycmF5KHIsYy5sZW5ndGgtaSksZj1zLmwsdT0ocy5yfHwwKSY3O2lmKHQpe3UmJihkWzBdPXMucj4+Myk7Zm9yKHZhciBnPU9yW3QtMV0sRT1nPj4xMyxiPWcmODE5MSx5PSgxPDxuKS0xLHA9cy5wfHxuZXcgVygzMjc2OCksdj1zLmh8fG5ldyBXKHkrMSksTj1NYXRoLmNlaWwobi8zKSxDPTIqTixSPWZ1bmN0aW9uKGx0KXtyZXR1cm4oZVtsdF1eZVtsdCsxXTw8Tl5lW2x0KzJdPDxDKSZ5fSxMPW5ldyBLZSgyNWUzKSxNPW5ldyBXKDI4OCksSD1uZXcgVygzMiksJD0wLEE9MCx4PXMuaXx8MCxqPTAsVj1zLnd8fDAscT0wO3grMjxvOysreCl7dmFyIFo9Uih4KSxhPXgmMzI3NjcsaD12W1pdO2lmKHBbYV09aCx2W1pdPWEsVjw9eCl7dmFyIF89by14O2lmKCgkPjdlM3x8aj4yNDU3NikmJihfPjQyM3x8IWYpKXt1PXF0KGUsZCwwLEwsTSxILEEsaixxLHgtcSx1KSxqPSQ9QT0wLHE9eDtmb3IodmFyIEk9MDtJPDI4NjsrK0kpTVtJXT0wO2Zvcih2YXIgST0wO0k8MzA7KytJKUhbSV09MH12YXIgdz0yLFM9MCxjZT1iLHo9YS1oJjMyNzY3O2lmKF8+MiYmWj09Uih4LXopKWZvcih2YXIgaWU9TWF0aC5taW4oRSxfKS0xLHZlPU1hdGgubWluKDMyNzY3LHgpLHRlPU1hdGgubWluKDI1OCxfKTt6PD12ZSYmLS1jZSYmYSE9aDspe2lmKGVbeCt3XT09ZVt4K3ctel0pe2Zvcih2YXIgWT0wO1k8dGUmJmVbeCtZXT09ZVt4K1ktel07KytZKTtpZihZPncpe2lmKHc9WSxTPXosWT5pZSlicmVhaztmb3IodmFyIGdlPU1hdGgubWluKHosWS0yKSx6dD0wLEk9MDtJPGdlOysrSSl7dmFyIGN0PXgteitJJjMyNzY3LFVyPXBbY3RdLFl0PWN0LVVyJjMyNzY3O1l0Pnp0JiYoenQ9WXQsaD1jdCl9fX1hPWgsaD1wW2FdLHorPWEtaCYzMjc2N31pZihTKXtMW2orK109MjY4NDM1NDU2fG50W3ddPDwxOHxNdFtTXTt2YXIgSnQ9bnRbd10mMzEsUXQ9TXRbU10mMzE7QSs9ZXRbSnRdK3R0W1F0XSwrK01bMjU3K0p0XSwrK0hbUXRdLFY9eCt3LCsrJH1lbHNlIExbaisrXT1lW3hdLCsrTVtlW3hdXX19Zm9yKHg9TWF0aC5tYXgoeCxWKTt4PG87Kyt4KUxbaisrXT1lW3hdLCsrTVtlW3hdXTt1PXF0KGUsZCxmLEwsTSxILEEsaixxLHgtcSx1KSxmfHwocy5yPXUmN3xkW3UvOHwwXTw8Myx1LT03LHMuaD12LHMucD1wLHMuaT14LHMudz1WKX1lbHNle2Zvcih2YXIgeD1zLnd8fDA7eDxvK2Y7eCs9NjU1MzUpe3ZhciB1dD14KzY1NTM1O3V0Pj1vJiYoZFt1Lzh8MF09Zix1dD1vKSx1PWp0KGQsdSsxLGUuc3ViYXJyYXkoeCx1dCkpfXMuaT1vfXJldHVybiBVdChjLDAsciskdCh1KStpKX0sd3I9ZnVuY3Rpb24oKXtmb3IodmFyIGU9bmV3IEludDMyQXJyYXkoMjU2KSx0PTA7dDwyNTY7Kyt0KXtmb3IodmFyIG49dCxyPTk7LS1yOyluPShuJjEmJi0zMDY2NzQ5MTIpXm4+Pj4xO2VbdF09bn1yZXR1cm4gZX0oKSxEcj1mdW5jdGlvbigpe3ZhciBlPS0xO3JldHVybntwOmZ1bmN0aW9uKHQpe2Zvcih2YXIgbj1lLHI9MDtyPHQubGVuZ3RoOysrciluPXdyW24mMjU1XnRbcl1dXm4+Pj44O2U9bn0sZDpmdW5jdGlvbigpe3JldHVybn5lfX19LENyPWZ1bmN0aW9uKGUsdCxuLHIsaSl7aWYoIWkmJihpPXtsOjF9LHQuZGljdGlvbmFyeSkpe3ZhciBzPXQuZGljdGlvbmFyeS5zdWJhcnJheSgtMzI3NjgpLG89bmV3IFEocy5sZW5ndGgrZS5sZW5ndGgpO28uc2V0KHMpLG8uc2V0KGUscy5sZW5ndGgpLGU9byxpLnc9cy5sZW5ndGh9cmV0dXJuIFNyKGUsdC5sZXZlbD09bnVsbD82OnQubGV2ZWwsdC5tZW09PW51bGw/TWF0aC5jZWlsKE1hdGgubWF4KDgsTWF0aC5taW4oMTMsTWF0aC5sb2coZS5sZW5ndGgpKSkqMS41KToxMit0Lm1lbSxuLHIsaSl9LG90PWZ1bmN0aW9uKGUsdCxuKXtmb3IoO247Kyt0KWVbdF09bixuPj4+PTh9LGtyPWZ1bmN0aW9uKGUsdCl7dmFyIG49dC5maWxlbmFtZTtpZihlWzBdPTMxLGVbMV09MTM5LGVbMl09OCxlWzhdPXQubGV2ZWw8Mj80OnQubGV2ZWw9PTk/MjowLGVbOV09Myx0Lm10aW1lIT0wJiZvdChlLDQsTWF0aC5mbG9vcihuZXcgRGF0ZSh0Lm10aW1lfHxEYXRlLm5vdygpKS8xZTMpKSxuKXtlWzNdPTg7Zm9yKHZhciByPTA7cjw9bi5sZW5ndGg7KytyKWVbcisxMF09bi5jaGFyQ29kZUF0KHIpfX0sUnI9ZnVuY3Rpb24oZSl7cmV0dXJuIDEwKyhlLmZpbGVuYW1lP2UuZmlsZW5hbWUubGVuZ3RoKzE6MCl9O2Z1bmN0aW9uIExyKGUsdCl7dHx8KHQ9e30pO3ZhciBuPURyKCkscj1lLmxlbmd0aDtuLnAoZSk7dmFyIGk9Q3IoZSx0LFJyKHQpLDgpLHM9aS5sZW5ndGg7cmV0dXJuIGtyKGksdCksb3QoaSxzLTgsbi5kKCkpLG90KGkscy00LHIpLGl9dmFyIEh0PXR5cGVvZiBUZXh0RW5jb2RlciE9InVuZGVmaW5lZCImJm5ldyBUZXh0RW5jb2RlcixQcj10eXBlb2YgVGV4dERlY29kZXIhPSJ1bmRlZmluZWQiJiZuZXcgVGV4dERlY29kZXIsRnI9MDt0cnl7UHIuZGVjb2RlKEd0LHtzdHJlYW06ITB9KSxGcj0xfWNhdGNoKGUpe31mdW5jdGlvbiBCcihlLHQpe2lmKHQpe2Zvcih2YXIgbj1uZXcgUShlLmxlbmd0aCkscj0wO3I8ZS5sZW5ndGg7KytyKW5bcl09ZS5jaGFyQ29kZUF0KHIpO3JldHVybiBufWlmKEh0KXJldHVybiBIdC5lbmNvZGUoZSk7Zm9yKHZhciBpPWUubGVuZ3RoLHM9bmV3IFEoZS5sZW5ndGgrKGUubGVuZ3RoPj4xKSksbz0wLGM9ZnVuY3Rpb24odSl7c1tvKytdPXV9LHI9MDtyPGk7KytyKXtpZihvKzU+cy5sZW5ndGgpe3ZhciBkPW5ldyBRKG8rOCsoaS1yPDwxKSk7ZC5zZXQocykscz1kfXZhciBmPWUuY2hhckNvZGVBdChyKTtmPDEyOHx8dD9jKGYpOmY8MjA0OD8oYygxOTJ8Zj4+NiksYygxMjh8ZiY2MykpOmY+NTUyOTUmJmY8NTczNDQ/KGY9NjU1MzYrKGYmMTA0NzU1Mil8ZS5jaGFyQ29kZUF0KCsrcikmMTAyMyxjKDI0MHxmPj4xOCksYygxMjh8Zj4+MTImNjMpLGMoMTI4fGY+PjYmNjMpLGMoMTI4fGYmNjMpKTooYygyMjR8Zj4+MTIpLGMoMTI4fGY+PjYmNjMpLGMoMTI4fGYmNjMpKX1yZXR1cm4gVXQocywwLG8pfWNvbnN0IE1yPTFlMyoxNTtmdW5jdGlvbiAkcihlKXtyZXR1cm4gWCh0aGlzLG51bGwsZnVuY3Rpb24qKCl7Y29uc3QgdD15aWVsZCBuZXcgUHJvbWlzZShuPT57Y29uc3Qgcj1uZXcgRmlsZVJlYWRlcjtyLm9ubG9hZD0oKT0+bihyLnJlc3VsdCksci5yZWFkQXNEYXRhVVJMKG5ldyBCbG9iKFtlXSkpfSk7cmV0dXJuIHQuc2xpY2UodC5pbmRleE9mKCIsIikrMSl9KX1jb25zdCBGZT1zZWxmO2Z1bmN0aW9uIGF0KGUsdCl7Y29uc3Qgbj17fSxyPVtdLGk9W107Zm9yKGNvbnN0W3Msb11vZiBPYmplY3QuZW50cmllcyhlKSl7aWYobz09bnVsbCljb250aW51ZTtUci5pbmNsdWRlcyh0eXBlb2Ygbyl8fHIucHVzaCh7W3NdOm99KTtsZXQgYzt0eXBlb2Ygbz09InN0cmluZyI/Yz1vOmM9bmUobyksYy5sZW5ndGg+THQmJihpLnB1c2goe1tzXTpvfSksYz1jLnN1YnN0cmluZygwLEx0KSksbltzXT1jfXJldHVybiB0IT09InNlc3Npb24iJiYoci5sZW5ndGg+MCYmY29uc29sZS53YXJuKGBIaWdobGlnaHQgd2FzIHBhc3NlZCBvbmUgb3IgbW9yZSAke3R9IHByb3BlcnRpZXMgbm90IG9mIHR5cGUgc3RyaW5nLCBudW1iZXIsIG9yIGJvb2xlYW4uYCxyKSxpLmxlbmd0aD4wJiZjb25zb2xlLndhcm4oYEhpZ2hsaWdodCB3YXMgcGFzc2VkIG9uZSBvciBtb3JlICR7dH0gcHJvcGVydGllcyBleGNlZWRpbmcgMjAwMCBjaGFyYWN0ZXJzLCB3aGljaCB3aWxsIGJlIHRydW5jYXRlZC5gLGkpKSxufXtsZXQgZSx0LG4scj0wLGk9ITEscz0wLG89bmV3IGJyKCExLCJbd29ya2VyXSIpO2NvbnN0IGM9W10sZD0oKT0+cyE9PTAmJnI8X3ImJiEhKG4hPW51bGwmJm4ubGVuZ3RoKSxmPShwLHYpPT57RmUucG9zdE1lc3NhZ2Uoe3Jlc3BvbnNlOnt0eXBlOkQuQ3VzdG9tRXZlbnQsdGFnOnAscGF5bG9hZDp2fX0pfSx1PXA9PlgodGhpcyxudWxsLGZ1bmN0aW9uKigpe2NvbnN0e2lkOnYsZXZlbnRzOk4sbWVzc2FnZXM6QyxlcnJvcnM6UixyZXNvdXJjZXNTdHJpbmc6TCx3ZWJTb2NrZXRFdmVudHNTdHJpbmc6TSxoYXNTZXNzaW9uVW5sb2FkZWQ6SCxoaWdobGlnaHRMb2dzOiR9PXAsQT1uZSh7bWVzc2FnZXM6Q30pO2xldCB4PXtzZXNzaW9uX3NlY3VyZV9pZDpuLHBheWxvYWRfaWQ6di50b1N0cmluZygpLGV2ZW50czp7ZXZlbnRzOk59LG1lc3NhZ2VzOkEscmVzb3VyY2VzOkwsd2ViX3NvY2tldF9ldmVudHM6TSxlcnJvcnM6Uixpc19iZWFjb246ITEsaGFzX3Nlc3Npb25fdW5sb2FkZWQ6SH07JCYmKHguaGlnaGxpZ2h0X2xvZ3M9JCk7Y29uc3Qgaj1CcihKU09OLnN0cmluZ2lmeSh4KSksVj1McihqKSxxPXlpZWxkICRyKFYpLFo9e3R5cGU6RC5Bc3luY0V2ZW50cyxpZDp2LGV2ZW50c1NpemU6ai5sZW5ndGgsY29tcHJlc3NlZFNpemU6cS5sZW5ndGh9O28ubG9nKGBQdXNoaW5nIHBheWxvYWQ6ICR7SlNPTi5zdHJpbmdpZnkoe3Nlc3Npb25TZWN1cmVJRDpuLGlkOnYsZmlyc3RTSUQ6TWF0aC5taW4oLi4ueC5ldmVudHMuZXZlbnRzLm1hcCh3PT53PT1udWxsP3ZvaWQgMDp3Ll9zaWQpLmZpbHRlcih3PT4hIXcpKSxldmVudHNMZW5ndGg6eC5ldmVudHMuZXZlbnRzLmxlbmd0aCxtZXNzYWdlc0xlbmd0aDpDLmxlbmd0aCxyZXNvdXJjZXNMZW5ndGg6TC5sZW5ndGgsd2ViU29ja2V0TGVuZ3RoOk0ubGVuZ3RoLGVycm9yc0xlbmd0aDpSLmxlbmd0aCxidWZMZW5ndGg6ai5sZW5ndGgsY29tcHJlc3NlZExlbmd0aDpWLmxlbmd0aCxjb21wcmVzc2VkQmFzZTY0TGVuZ3RoOnEubGVuZ3RofSx2b2lkIDAsMil9YCk7Y29uc3QgYT1lLlB1c2hQYXlsb2FkQ29tcHJlc3NlZCh7c2Vzc2lvbl9zZWN1cmVfaWQ6bixwYXlsb2FkX2lkOnYudG9TdHJpbmcoKSxkYXRhOnF9KTtsZXQgaD1Qcm9taXNlLnJlc29sdmUoKTtjLmxlbmd0aCYmKGg9ZS5wdXNoTWV0cmljcyh7bWV0cmljczpjfSksYy5zcGxpY2UoMCkpO2xldCBfPXBlcmZvcm1hbmNlLm5vdygpO2NvbnN0IEk9c2V0SW50ZXJ2YWwoKCk9PntfJiZwZXJmb3JtYW5jZS5ub3coKS1fPk1yJiYoY29uc29sZS53YXJuKCJVcGxvYWRpbmcgcHVzaFBheWxvYWQgdG9vayB0b28gbG9uZywgc3RvcHBpbmcgcmVjb3JkaW5nIHRvIGF2b2lkIE9PTS4iKSxjbGVhckludGVydmFsKEkpLEZlLnBvc3RNZXNzYWdlKHtyZXNwb25zZTp7dHlwZTpELlN0b3AscmVxdWVzdFN0YXJ0Ol8sYXN5bmNFdmVudHNSZXNwb25zZTpafX0pLEUoe3R5cGU6RC5Qcm9wZXJ0aWVzLHByb3BlcnRpZXNPYmplY3Q6e3N0b3BSZWFzb246IlB1c2ggUGF5bG9hZCBUaW1lb3V0In0scHJvcGVydHlUeXBlOnt0eXBlOiJ0cmFjayJ9fSkpfSwxMDApO3RyeXt5aWVsZCBQcm9taXNlLmFsbChbYSxoXSl9ZmluYWxseXtfPTAsY2xlYXJJbnRlcnZhbChJKX1GZS5wb3N0TWVzc2FnZSh7cmVzcG9uc2U6Wn0pfSksZz1wPT5YKHRoaXMsbnVsbCxmdW5jdGlvbiooKXtjb25zdHt1c2VyT2JqZWN0OnYsdXNlcklkZW50aWZpZXI6Tixzb3VyY2U6Q309cDtDPT09InNlZ21lbnQiP2YoIlNlZ21lbnQgSWRlbnRpZnkiLG5lKGsoe3VzZXJJZGVudGlmaWVyOk59LHYpKSk6ZigiSWRlbnRpZnkiLG5lKGsoe3VzZXJJZGVudGlmaWVyOk59LHYpKSkseWllbGQgZS5pZGVudGlmeVNlc3Npb24oe3Nlc3Npb25fc2VjdXJlX2lkOm4sdXNlcl9pZGVudGlmaWVyOk4sdXNlcl9vYmplY3Q6YXQodiwidXNlciIpfSk7Y29uc3QgUj1DPT09InNlZ21lbnQiP0M6ImRlZmF1bHQiO28ubG9nKGBJZGVudGlmeSAoJHtOfSwgc291cmNlOiAke1J9KSB3LyBvYmo6ICR7bmUodil9IEAgJHt0fWApfSksRT1wPT5YKHRoaXMsbnVsbCxmdW5jdGlvbiooKXtjb25zdHtwcm9wZXJ0aWVzT2JqZWN0OnYscHJvcGVydHlUeXBlOk59PXA7bGV0IEM7KHY9PW51bGw/dm9pZCAwOnYuY2xpY2tUZXh0Q29udGVudCkhPT12b2lkIDA/KEM9IkNsaWNrVGV4dENvbnRlbnQiLHlpZWxkIGUuYWRkU2Vzc2lvblByb3BlcnRpZXMoe3Nlc3Npb25fc2VjdXJlX2lkOm4scHJvcGVydGllc19vYmplY3Q6YXQodiwic2Vzc2lvbiIpfSkpOihOPT1udWxsP3ZvaWQgMDpOLnR5cGUpPT09InNlc3Npb24iPyhDPSJTZXNzaW9uIix5aWVsZCBlLmFkZFNlc3Npb25Qcm9wZXJ0aWVzKHtzZXNzaW9uX3NlY3VyZV9pZDpuLHByb3BlcnRpZXNfb2JqZWN0OmF0KHYsInNlc3Npb24iKX0pKTooTj09bnVsbD92b2lkIDA6Ti5zb3VyY2UpPT09InNlZ21lbnQiPyhDPSJTZWdtZW50IixmKCJTZWdtZW50IFRyYWNrIixuZSh2KSkpOihDPSJUcmFjayIsZihDLG5lKHYpKSksby5sb2coYEFkZGluZyAke0N9IFByb3BlcnRpZXMgdG8gc2Vzc2lvbiAoJHtufSkgdy8gb2JqOiAke0pTT04uc3RyaW5naWZ5KHYpfSBAICR7dH1gKX0pLGI9cD0+WCh0aGlzLG51bGwsZnVuY3Rpb24qKCl7Yy5wdXNoKC4uLnAubWV0cmljcy5tYXAodj0+KHtuYW1lOnYubmFtZSx2YWx1ZTp2LnZhbHVlLHNlc3Npb25fc2VjdXJlX2lkOm4sY2F0ZWdvcnk6di5jYXRlZ29yeSxncm91cDp2Lmdyb3VwLHRpbWVzdGFtcDp2LnRpbWVzdGFtcC50b0lTT1N0cmluZygpLHRhZ3M6di50YWdzfSkpKX0pLHk9cD0+WCh0aGlzLG51bGwsZnVuY3Rpb24qKCl7Y29uc3R7dGltZXN0YW1wOnYsdmVyYmF0aW06Tix1c2VyRW1haWw6Qyx1c2VyTmFtZTpSfT1wO3lpZWxkIGUuYWRkU2Vzc2lvbkZlZWRiYWNrKHtzZXNzaW9uX3NlY3VyZV9pZDpuLHRpbWVzdGFtcDp2LHZlcmJhdGltOk4sdXNlcl9lbWFpbDpDLHVzZXJfbmFtZTpSfSl9KTtGZS5vbm1lc3NhZ2U9ZnVuY3Rpb24ocCl7cmV0dXJuIFgodGhpcyxudWxsLGZ1bmN0aW9uKigpe2lmKHAuZGF0YS5tZXNzYWdlLnR5cGU9PT1ELkluaXRpYWxpemUpe3Q9cC5kYXRhLm1lc3NhZ2UuYmFja2VuZCxuPXAuZGF0YS5tZXNzYWdlLnNlc3Npb25TZWN1cmVJRCxpPXAuZGF0YS5tZXNzYWdlLmRlYnVnLHM9cC5kYXRhLm1lc3NhZ2UucmVjb3JkaW5nU3RhcnRUaW1lLG8uZGVidWc9aSxlPW5yKG5ldyBmcih0LHtoZWFkZXJzOnt9fSksRXIobikpO3JldHVybn1pZihkKCkpdHJ5e3AuZGF0YS5tZXNzYWdlLnR5cGU9PT1ELkFzeW5jRXZlbnRzP3lpZWxkIHUocC5kYXRhLm1lc3NhZ2UpOnAuZGF0YS5tZXNzYWdlLnR5cGU9PT1ELklkZW50aWZ5P3lpZWxkIGcocC5kYXRhLm1lc3NhZ2UpOnAuZGF0YS5tZXNzYWdlLnR5cGU9PT1ELlByb3BlcnRpZXM/eWllbGQgRShwLmRhdGEubWVzc2FnZSk6cC5kYXRhLm1lc3NhZ2UudHlwZT09PUQuTWV0cmljcz95aWVsZCBiKHAuZGF0YS5tZXNzYWdlKTpwLmRhdGEubWVzc2FnZS50eXBlPT09RC5GZWVkYmFjayYmKHlpZWxkIHkocC5kYXRhLm1lc3NhZ2UpKSxyPTB9Y2F0Y2godil7aSYmY29uc29sZS5lcnJvcih2KSxyKz0xfX0pfX19KSgpOwovLyMgc291cmNlTWFwcGluZ1VSTD1oaWdobGlnaHQtY2xpZW50LXdvcmtlci1EUmNneEVNUC5qcy5tYXAK", Dr = (e) => Uint8Array.from(atob(e), (t) => t.charCodeAt(0)), jn = typeof window != "undefined" && window.Blob && new Blob([Dr(Qs)], { type: "text/javascript;charset=utf-8" });
function Qr(e) {
  let t;
  try {
    if (t = jn && (window.URL || window.webkitURL).createObjectURL(jn), !t)
      throw "";
    const i = new Worker(t, {
      name: e == null ? void 0 : e.name
    });
    return i.addEventListener("error", () => {
      (window.URL || window.webkitURL).revokeObjectURL(t);
    }), i;
  } catch (i) {
    return new Worker(
      "data:text/javascript;base64," + Qs,
      {
        name: e == null ? void 0 : e.name
      }
    );
  } finally {
    t && (window.URL || window.webkitURL).revokeObjectURL(t);
  }
}
var ki;
(function(e) {
  e.BillingQuotaExceeded = "BillingQuotaExceeded";
})(ki || (ki = {}));
const jr = 10, Ar = 1e3, _r = 500, qr = [ki.BillingQuotaExceeded.toString()], $r = (e) => {
  var i;
  return ((i = e.response.errors) == null ? void 0 : i.find((n) => qr.includes(n.message))) === void 0;
}, ec = (e) => {
  const t = (i, n, s, l, o = 0) => A(void 0, null, function* () {
    try {
      return yield i();
    } catch (r) {
      if (r instanceof De && !$r(r))
        throw r;
      if (o < jr)
        return yield new Promise((a) => setTimeout(a, Ar + _r * Math.pow(2, o))), yield t(i, n, s, l, o + 1);
      throw console.error(`highlight.io: [${e || e}] data request failed after ${o} retries`), r;
    }
  });
  return t;
};
var pe;
(function(e) {
  e[e.Initialize = 0] = "Initialize", e[e.AsyncEvents = 1] = "AsyncEvents", e[e.Identify = 2] = "Identify", e[e.Properties = 3] = "Properties", e[e.Metrics = 4] = "Metrics", e[e.Feedback = 5] = "Feedback", e[e.CustomEvent = 6] = "CustomEvent", e[e.Stop = 7] = "Stop";
})(pe || (pe = {}));
class tc {
  constructor(t, i) {
    N(this, "debug");
    N(this, "name");
    this.debug = t, this.name = i;
  }
  log(...t) {
    if (this.debug) {
      let i = `[${Date.now()}]`;
      this.name && (i += ` - ${this.name}`), console.log.apply(console, [i, ...t]);
    }
  }
}
const ic = 30, nc = () => new Promise((e) => requestAnimationFrame((t) => requestAnimationFrame((i) => e(i - t)))), sc = () => A(void 0, null, function* () {
  const e = [];
  for (let t = 0; t < ic; t++)
    e.push(yield nc());
  return e.reduce((t, i) => t + i, 0) / e.length;
}), lc = (e, t) => {
  let i = {}, n = 16.666666666666668;
  sc().then((a) => n = a);
  const s = (a) => {
    var c;
    i != null && i.event || (i = {
      event: a,
      location: window.location.href,
      timerStart: (c = window.performance) == null ? void 0 : c.now()
    }, window.requestAnimationFrame(l));
  }, l = () => {
    if (!(i != null && i.timerStart))
      return;
    const a = window.performance.now() - i.timerStart - n;
    o(a), i = {};
  }, o = (a) => {
    const c = ((/* @__PURE__ */ new Date()).getTime() - t) / 1e3;
    e({
      relativeTimestamp: c,
      jankAmount: a,
      querySelector: r(),
      newLocation: window.location.href != i.location ? window.location.href : void 0
    });
  }, r = () => {
    var a;
    return (a = i == null ? void 0 : i.event) != null && a.target ? Ts(i.event.target) : "";
  };
  return window.addEventListener("click", s, !0), window.addEventListener("keydown", s, !0), () => {
    window.removeEventListener("keydown", s, !0), window.removeEventListener("click", s, !0);
  };
}, An = "iframe parent ready", _n = "iframe ok", nt = (e, t) => {
  console.warn(`Highlight Warning: (${e}): `, { output: t });
};
var Pt;
(function(e) {
  e.CLIENT_ID = "highlightClientID";
})(Pt || (Pt = {}));
class js {
  constructor(t, i) {
    N(this, "options");
    /** Determines if the client is running on a Highlight property (e.g. frontend). */
    N(this, "isRunningOnHighlight");
    /** Verbose project ID that is exposed to users. Legacy users may still be using ints. */
    N(this, "organizationID");
    N(this, "graphqlSDK");
    N(this, "events");
    N(this, "sessionData");
    N(this, "ready");
    N(this, "manualStopped");
    N(this, "state");
    N(this, "logger");
    N(this, "enableSegmentIntegration");
    N(this, "privacySetting");
    N(this, "enableCanvasRecording");
    N(this, "enablePerformanceRecording");
    N(this, "samplingStrategy");
    N(this, "inlineImages");
    N(this, "inlineStylesheet");
    N(this, "debugOptions");
    N(this, "listeners");
    N(this, "firstloadVersion");
    N(this, "environment");
    N(this, "sessionShortcut");
    /** The end-user's app version. This isn't Highlight's version. */
    N(this, "appVersion");
    N(this, "serviceName");
    N(this, "_worker");
    N(this, "_optionsInternal");
    N(this, "_backendUrl");
    N(this, "_recordingStartTime");
    N(this, "_isOnLocalHost");
    N(this, "_onToggleFeedbackFormVisibility");
    N(this, "_firstLoadListeners");
    N(this, "_isCrossOriginIframe");
    N(this, "_eventBytesSinceSnapshot");
    N(this, "_lastSnapshotTime");
    N(this, "_lastVisibilityChangeTime");
    N(this, "pushPayloadTimerId");
    N(this, "hasSessionUnloaded");
    N(this, "hasPushedData");
    N(this, "reloaded");
    N(this, "_hasPreviouslyInitialized");
    N(this, "_recordStop");
    var s, l, o, r, a;
    t.sessionSecureID || (t.sessionSecureID = ni()), this.options = t, typeof ((s = this.options) == null ? void 0 : s.debug) == "boolean" ? this.debugOptions = this.options.debug ? { clientInteractions: !0 } : {} : this.debugOptions = (o = (l = this.options) == null ? void 0 : l.debug) != null ? o : {}, this.logger = new tc(this.debugOptions.clientInteractions), t.storageMode && (this.logger.log(`initializing in ${t.storageMode} session mode`), Zl(t.storageMode)), yl(!(t != null && t.skipCookieSessionDataLoad)), this._worker = new Qr(), this._worker.onmessage = (c) => {
      var d, u, p;
      ((d = c.data.response) == null ? void 0 : d.type) === pe.AsyncEvents ? (this._eventBytesSinceSnapshot += c.data.response.eventsSize, this.logger.log(`Web worker sent payloadID ${c.data.response.id} size ${c.data.response.eventsSize} bytes, compression ratio ${c.data.response.eventsSize / c.data.response.compressedSize}.
                Total since snapshot: ${(this._eventBytesSinceSnapshot / 1e6).toFixed(1)}MB`)) : ((u = c.data.response) == null ? void 0 : u.type) === pe.CustomEvent ? this.addCustomEvent(c.data.response.tag, c.data.response.payload) : ((p = c.data.response) == null ? void 0 : p.type) === pe.Stop && (nt("Stopping recording due to worker failure", c.data.response), this.stopRecording(!1));
    };
    let n = qi();
    if (this.reloaded = !1, !((r = this.sessionData) != null && r.sessionSecureID) && (n != null && n.sessionSecureID))
      this.sessionData = n, this.options.sessionSecureID = n.sessionSecureID, this.reloaded = !0, this.logger.log(`Tab reloaded, continuing previous session: ${this.sessionData.sessionSecureID}`);
    else {
      for (const c of Object.values(Ve))
        $i(c);
      this.sessionData = {
        sessionSecureID: this.options.sessionSecureID,
        projectID: 0,
        payloadID: 1,
        sessionStartTime: Date.now()
      };
    }
    this._hasPreviouslyInitialized = !1, this._firstLoadListeners = i || new Ke(this.options);
    try {
      window.parent.document && (this._isCrossOriginIframe = !1);
    } catch (c) {
      this._isCrossOriginIframe = (a = this.options.recordCrossOriginIframe) != null ? a : !0;
    }
    this._initMembers(this.options);
  }
  static create(t) {
    return new js(t);
  }
  // Start a new session
  _reset(i) {
    return A(this, arguments, function* ({ forceNew: t }) {
      this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0);
      let n, s;
      if (!t)
        try {
          n = Xe(Ve.USER_IDENTIFIER);
          const l = Xe(Ve.USER_OBJECT);
          l && (s = JSON.parse(l));
        } catch (l) {
        }
      for (const l of Object.values(Ve))
        $i(l);
      this.sessionData.sessionSecureID = ni(), this.sessionData.sessionStartTime = Date.now(), this.options.sessionSecureID = this.sessionData.sessionSecureID, this.stopRecording(), this._firstLoadListeners = new Ke(this.options), yield this.initialize(), n && s && this.identify(n, s);
    });
  }
  _initMembers(t) {
    var l, o, r, a, c, d, u, p, h, Z, b;
    this.sessionShortcut = !1, this._recordingStartTime = 0, this._isOnLocalHost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || window.location.hostname === "", this.ready = !1, this.state = "NotRecording", this.manualStopped = !1, this.enableSegmentIntegration = !!t.enableSegmentIntegration, this.privacySetting = (l = t.privacySetting) != null ? l : "default", this.enableCanvasRecording = (o = t.enableCanvasRecording) != null ? o : !1, this.enablePerformanceRecording = (r = t.enablePerformanceRecording) != null ? r : !0, this.inlineImages = (a = t.inlineImages) != null ? a : this._isOnLocalHost, this.inlineStylesheet = (c = t.inlineStylesheet) != null ? c : !0, this.samplingStrategy = R({
      canvasFactor: 0.5,
      canvasMaxSnapshotDimension: 360,
      canvasClearWebGLBuffer: !0,
      dataUrlOptions: ul()
    }, (d = t.samplingStrategy) != null ? d : {
      canvas: 2
    }), this._backendUrl = (u = t == null ? void 0 : t.backendUrl) != null ? u : "https://pub.highlight.io", this._backendUrl[0] === "/" && (this._backendUrl = new URL(this._backendUrl, document.baseURI).href);
    const i = new wa(`${this._backendUrl}`, {
      headers: {}
    });
    this.graphqlSDK = qa(i, ec(((p = this.sessionData) == null ? void 0 : p.sessionSecureID) || ((h = this.options) == null ? void 0 : h.sessionSecureID))), this.environment = (Z = t.environment) != null ? Z : "production", this.appVersion = t.appVersion, this.serviceName = (b = t.serviceName) != null ? b : "", typeof t.organizationID == "string" ? this.organizationID = t.organizationID : this.organizationID = t.organizationID.toString(), this.isRunningOnHighlight = this.organizationID === "1" || this.organizationID === "1jdkoe52", this.firstloadVersion = t.firstloadVersion || "unknown", this.sessionShortcut = t.sessionShortcut || !1, this._onToggleFeedbackFormVisibility = () => {
    };
    const W = t, { firstloadVersion: n } = W, s = fe(W, ["firstloadVersion"]);
    this._optionsInternal = s, this.listeners = [], this.events = [], this.hasSessionUnloaded = !1, this.hasPushedData = !1, window.Intercom && window.Intercom("onShow", () => {
      window.Intercom("update", {
        highlightSessionURL: this.getCurrentSessionURLWithTimestamp()
      }), this.addProperties({ event: "Intercom onShow" });
    }), this._eventBytesSinceSnapshot = 0, this._lastSnapshotTime = (/* @__PURE__ */ new Date()).getTime(), this._lastVisibilityChangeTime = (/* @__PURE__ */ new Date()).getTime();
  }
  identify(t, i = {}, n) {
    if (!t || t === "") {
      console.warn("Highlight's identify() call was passed an empty identifier.", { user_identifier: t, user_object: i });
      return;
    }
    this.sessionData.userIdentifier = t.toString(), this.sessionData.userObject = i, ve(Ve.USER_IDENTIFIER, t.toString()), ve(Ve.USER_OBJECT, JSON.stringify(i)), this._worker.postMessage({
      message: {
        type: pe.Identify,
        userIdentifier: t,
        userObject: i,
        source: n
      }
    });
  }
  pushCustomError(t, i) {
    return this.consumeCustomError(new Error(t), void 0, i);
  }
  consumeCustomError(t, i, n) {
    let s = {};
    if (n)
      try {
        s = R(R({}, JSON.parse(n)), s);
      } catch (l) {
      }
    return this.consumeError(t, {
      message: i,
      payload: s
    });
  }
  consumeError(t, { message: i, payload: n, source: s, type: l }) {
    var a, c, d, u;
    t.cause && (n = ge(R({}, n), { "exception.cause": t.cause }));
    let o = i ? i + ":" + t.message : t.message;
    l === "React.ErrorBoundary" && (o = "ErrorBoundary: " + o);
    const r = ml.parse(t);
    this._firstLoadListeners.errors.push({
      event: o,
      type: l != null ? l : "custom",
      url: window.location.href,
      source: s != null ? s : "",
      lineNumber: (a = r[0]) != null && a.lineNumber ? (c = r[0]) == null ? void 0 : c.lineNumber : 0,
      columnNumber: (d = r[0]) != null && d.columnNumber ? (u = r[0]) == null ? void 0 : u.columnNumber : 0,
      stackTrace: r,
      timestamp: (/* @__PURE__ */ new Date()).toISOString(),
      payload: JSON.stringify(n)
    });
  }
  addProperties(t = {}, i) {
    const n = R({}, t);
    Object.entries(n).forEach(([s, l]) => {
      try {
        structuredClone(l);
      } catch (o) {
        delete n[s];
      }
    }), this._worker.postMessage({
      message: {
        type: pe.Properties,
        propertiesObject: n,
        propertyType: i
      }
    });
  }
  initialize(t) {
    return A(this, null, function* () {
      var i, n, s, l, o, r, a, c, d;
      if (this.logger.log("Initializing...", t, this.sessionData, this.options), navigator != null && navigator.webdriver && !window.Cypress || (i = navigator == null ? void 0 : navigator.userAgent) != null && i.includes("Googlebot") || (n = navigator == null ? void 0 : navigator.userAgent) != null && n.includes("AdsBot")) {
        (s = this._firstLoadListeners) == null || s.stopListening();
        return;
      }
      try {
        if (t != null && t.forceNew) {
          yield this._reset(t);
          return;
        }
        this.sessionData = (l = qi(this.sessionData.sessionSecureID)) != null ? l : this.sessionData, (o = this.sessionData) != null && o.sessionStartTime ? this._recordingStartTime = (r = this.sessionData) == null ? void 0 : r.sessionStartTime : (this._recordingStartTime = (/* @__PURE__ */ new Date()).getTime(), this.sessionData.sessionStartTime = this._recordingStartTime), si(""), tt(this.sessionData);
        let u = Xe(Pt.CLIENT_ID);
        u || (u = ni(), ve(Pt.CLIENT_ID, u));
        let p;
        this.options.disableSessionRecording || this.options.disableNetworkRecording !== void 0 || typeof this.options.networkRecording == "boolean" ? p = !1 : p = ((a = this.options.networkRecording) == null ? void 0 : a.recordHeadersAndBody) || !1;
        let h = [];
        if (typeof this.options.networkRecording == "object" && ((c = this.options.networkRecording.destinationDomains) != null && c.length) && (h = this.options.networkRecording.destinationDomains), this._isCrossOriginIframe)
          yield this._setupCrossOriginIframe();
        else {
          const y = yield this.graphqlSDK.initializeSession({
            organization_verbose_id: this.organizationID,
            enable_strict_privacy: this.privacySetting === "strict",
            privacy_setting: this.privacySetting,
            enable_recording_network_contents: p,
            clientVersion: this.firstloadVersion,
            firstloadVersion: this.firstloadVersion,
            clientConfig: JSON.stringify(this._optionsInternal),
            environment: this.environment,
            id: u,
            appVersion: this.appVersion,
            serviceName: this.serviceName,
            session_secure_id: this.sessionData.sessionSecureID,
            client_id: u,
            network_recording_domains: h,
            disable_session_recording: this.options.disableSessionRecording
          });
          if (y.initializeSession.secure_id !== this.sessionData.sessionSecureID && this.logger.log(`Unexpected secure id returned by initializeSession: ${y.initializeSession.secure_id}, expected ${this.sessionData.sessionSecureID}`), this.sessionData.sessionSecureID = y.initializeSession.secure_id, this.sessionData.projectID = parseInt(((d = y == null ? void 0 : y.initializeSession) == null ? void 0 : d.project_id) || "0"), !this.sessionData.projectID || !this.sessionData.sessionSecureID) {
            console.error("Failed to initialize Highlight; an error occurred on our end.", this.sessionData);
            return;
          }
        }
        if (this.logger.log(`Loaded Highlight
Remote: ${this._backendUrl}
Project ID: ${this.sessionData.projectID}
SessionSecureID: ${this.sessionData.sessionSecureID}`), this.options.sessionSecureID = this.sessionData.sessionSecureID, this._worker.postMessage({
          message: {
            type: pe.Initialize,
            sessionSecureID: this.sessionData.sessionSecureID,
            backend: this._backendUrl,
            debug: !!this.debugOptions.clientInteractions,
            recordingStartTime: this._recordingStartTime
          }
        }), this.sessionData.userIdentifier && this.identify(this.sessionData.userIdentifier, this.sessionData.userObject), this._firstLoadListeners.isListening() ? this._firstLoadListeners.hasNetworkRecording || Ke.setupNetworkListener(this._firstLoadListeners, this.options) : this._firstLoadListeners.startListening(), this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0), this._isCrossOriginIframe || (this.pushPayloadTimerId = setTimeout(() => {
          this._save();
        }, en)), this.options.disableSessionRecording) {
          this.logger.log("Highlight is NOT RECORDING a session replay per H.init setting."), this.ready = !0, this.state = "Recording", this.manualStopped = !1;
          return;
        }
        const { getDeviceDetails: Z } = Ur();
        Z && this.recordMetric([
          {
            name: Fe.DeviceMemory,
            value: Z().deviceMemory,
            category: Ze.Device,
            group: window.location.href
          }
        ]);
        const b = (y, G) => {
          G && this.logger.log("received isCheckout emit", { event: y }), this.events.push(y);
        };
        b.bind(this);
        const W = !!this._recordStop;
        this._recordStop && (this._recordStop(), this._recordStop = void 0);
        const [V, I] = $a(this.privacySetting);
        this._recordStop = We({
          ignoreClass: "highlight-ignore",
          blockClass: "highlight-block",
          emit: b,
          recordCrossOriginIframes: this.options.recordCrossOriginIframe,
          privacySetting: this.privacySetting,
          maskAllInputs: V,
          maskInputOptions: I,
          recordCanvas: this.enableCanvasRecording,
          sampling: {
            canvas: {
              fps: this.samplingStrategy.canvas,
              fpsManual: this.samplingStrategy.canvasManualSnapshot,
              resizeFactor: this.samplingStrategy.canvasFactor,
              clearWebGLBuffer: this.samplingStrategy.canvasClearWebGLBuffer,
              initialSnapshotDelay: this.samplingStrategy.canvasInitialSnapshotDelay,
              dataURLOptions: this.samplingStrategy.dataUrlOptions,
              maxSnapshotDimension: this.samplingStrategy.canvasMaxSnapshotDimension
            }
          },
          keepIframeSrcFn: (y) => !this.options.recordCrossOriginIframe,
          inlineImages: this.inlineImages,
          collectFonts: this.inlineImages,
          inlineStylesheet: this.inlineStylesheet,
          plugins: [fa()],
          logger: typeof this.options.debug == "boolean" && this.options.debug || typeof this.options.debug == "object" && this.options.debug.domRecording ? {
            debug: this.logger.log,
            warn: nt
          } : void 0
        }), W || this.options.recordCrossOriginIframe && this._setupCrossOriginIframeParent(), document.referrer && (window && document.referrer.includes(window.location.origin) || (this.addCustomEvent("Referrer", document.referrer), this.addProperties({ referrer: document.referrer }, { type: "session" }))), this._setupWindowListeners(), this.ready = !0, this.state = "Recording", this.manualStopped = !1;
      } catch (u) {
        this._isOnLocalHost && (console.error(u), nt("initializeSession", u));
      }
    });
  }
  _visibilityHandler(t) {
    return A(this, null, function* () {
      if (this.manualStopped) {
        this.logger.log("Ignoring visibility event due to manual stop.");
        return;
      }
      (/* @__PURE__ */ new Date()).getTime() - this._lastVisibilityChangeTime < hl || (this._lastVisibilityChangeTime = (/* @__PURE__ */ new Date()).getTime(), this.logger.log(`Detected window ${t ? "hidden" : "visible"}.`), t ? (this.addCustomEvent("TabHidden", !0), this.options.disableBackgroundRecording && this.stopRecording()) : (this.options.disableBackgroundRecording && (yield this.initialize()), this.addCustomEvent("TabHidden", !1)));
    });
  }
  _setupCrossOriginIframe() {
    return A(this, null, function* () {
      this.logger.log("highlight in cross-origin iframe is waiting "), yield new Promise((t) => {
        const i = (n) => {
          if (n.data.highlight === An) {
            const s = n.data;
            this.logger.log("highlight got window message ", s), this.sessionData.projectID = s.projectID, this.sessionData.sessionSecureID = s.sessionSecureID, window.parent.postMessage({
              highlight: _n
            }, "*"), window.removeEventListener("message", i), t();
          }
        };
        window.addEventListener("message", i);
      });
    });
  }
  _setupCrossOriginIframeParent() {
    this.logger.log("highlight setting up cross origin iframe parent notification"), setInterval(() => {
      window.document.querySelectorAll("iframe").forEach((t) => {
        var i;
        (i = t.contentWindow) == null || i.postMessage({
          highlight: An,
          projectID: this.sessionData.projectID,
          sessionSecureID: this.sessionData.sessionSecureID
        }, "*");
      });
    }, en), window.addEventListener("message", (t) => {
      t.data.highlight === _n && this.logger.log("highlight got response from initialized iframe");
    });
  }
  _setupWindowListeners() {
    var n;
    try {
      const s = this;
      this.enableSegmentIntegration && this.listeners.push(tr((o) => {
        if (o.type === "track") {
          const r = {};
          r["segment-event"] = o.event, s.addProperties(r, {
            type: "track",
            source: "segment"
          });
        } else if (o.type === "identify") {
          const r = o.userId.replace(/^"(.*)"$/, "$1");
          s.identify(r, o.traits, "segment");
        }
      })), this.listeners.push(Ia((o) => {
        this.reloaded ? (this.addCustomEvent("Reload", o), this.reloaded = !1, s.addProperties({ reload: !0 }, { type: "session" })) : this.addCustomEvent("Navigate", o), s.addProperties({ "visited-url": o }, { type: "session" });
      })), this.listeners.push(er((o) => {
        this.addCustomEvent("Viewport", o), this.submitViewportMetrics(o);
      })), this.listeners.push(yr((o, r) => {
        o && this.addCustomEvent("Click", o);
        let a = null, c = null;
        if (r && r.target) {
          const d = r.target;
          a = Ts(d), c = d.textContent, c && c.length > 2e3 && (c = c.substring(0, 2e3));
        }
        s.addProperties({
          clickTextContent: c,
          clickSelector: a
        }, { type: "session" });
      })), this.listeners.push(Gr((o) => {
        o && this.addCustomEvent("Focus", o);
      })), this.listeners.push(Fr((o) => {
        const { name: r, value: a } = o;
        this.recordMetric([
          {
            name: r,
            value: a,
            group: window.location.href,
            category: Ze.WebVital
          }
        ]);
      })), this.sessionShortcut && Xr(this.sessionShortcut, () => {
        window.open(this.getCurrentSessionURLWithTimestamp(), "_blank");
      }), this.enablePerformanceRecording && (this.listeners.push(zr((o) => {
        this.addCustomEvent("Performance", li(o)), this.recordMetric(Object.entries(o).map(([r, a]) => a ? {
          name: r,
          value: a,
          category: Ze.Performance,
          group: window.location.href
        } : void 0).filter((r) => r));
      }, this._recordingStartTime)), this.listeners.push(lc((o) => {
        this.addCustomEvent("Jank", li(o)), this.recordMetric([
          {
            name: "Jank",
            value: o.jankAmount,
            category: Ze.WebVital,
            group: o.querySelector
          }
        ]);
      }, this._recordingStartTime))), this._hasPreviouslyInitialized || ((n = window.electron) != null && n.ipcRenderer ? (window.electron.ipcRenderer.on("highlight.run", ({ visible: o }) => {
        this._visibilityHandler(!o);
      }), this.logger.log("Set up Electron highlight.run events.")) : (Br((o) => this._visibilityHandler(o)), this.logger.log("Set up document visibility listener.")), this._hasPreviouslyInitialized = !0);
      const l = () => {
        this.hasSessionUnloaded = !0, this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0);
      };
      window.addEventListener("beforeunload", l), this.listeners.push(() => window.removeEventListener("beforeunload", l));
    } catch (s) {
      this._isOnLocalHost && (console.error(s), nt("initializeSession _setupWindowListeners", s));
    }
    const t = () => {
      this.addCustomEvent("Page Unload", ""), si(this.sessionData.sessionSecureID), tt(this.sessionData);
    };
    if (window.addEventListener("beforeunload", t), this.listeners.push(() => window.removeEventListener("beforeunload", t)), navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i)) {
      const s = () => {
        this.addCustomEvent("Page Unload", ""), si(this.sessionData.sessionSecureID), tt(this.sessionData);
      };
      window.addEventListener("pagehide", s), this.listeners.push(() => window.removeEventListener("beforeunload", s));
    }
  }
  submitViewportMetrics({ height: t, width: i, availHeight: n, availWidth: s }) {
    this.recordMetric([
      {
        name: Fe.ViewportHeight,
        value: t,
        category: Ze.Device,
        group: window.location.href
      },
      {
        name: Fe.ViewportWidth,
        value: i,
        category: Ze.Device,
        group: window.location.href
      },
      {
        name: Fe.ScreenHeight,
        value: n,
        category: Ze.Device,
        group: window.location.href
      },
      {
        name: Fe.ScreenWidth,
        value: s,
        category: Ze.Device,
        group: window.location.href
      },
      {
        name: Fe.ViewportArea,
        value: t * i,
        category: Ze.Device,
        group: window.location.href
      }
    ]);
  }
  recordMetric(t) {
    this._worker.postMessage({
      message: {
        type: pe.Metrics,
        metrics: t.map((i) => ge(R({}, i), {
          tags: i.tags || [],
          group: i.group || window.location.href,
          category: i.category || Ze.Frontend,
          timestamp: /* @__PURE__ */ new Date()
        }))
      }
    });
  }
  /**
   * Stops Highlight from recording.
   * @param manual The end user requested to stop recording.
   */
  stopRecording(t) {
    this.manualStopped = !!t, this.manualStopped && this.addCustomEvent("Stop", "H.stop() was called which stops Highlight from recording."), this.state = "NotRecording", t && this._recordStop && (this._recordStop(), this._recordStop = void 0), this.listeners.forEach((i) => i()), this.listeners = [];
  }
  getCurrentSessionTimestamp() {
    return this._recordingStartTime;
  }
  /**
   * Returns the current timestamp for the current session.
   */
  getCurrentSessionURLWithTimestamp() {
    const t = (/* @__PURE__ */ new Date()).getTime(), { projectID: i, sessionSecureID: n } = this.sessionData, s = (t - this._recordingStartTime) / 1e3;
    return `https://${tn}/${i}/sessions/${n}?ts=${s}`;
  }
  getCurrentSessionURL() {
    const t = this.sessionData.projectID, i = this.sessionData.sessionSecureID;
    return t && i ? `https://${tn}/${t}/sessions/${i}` : null;
  }
  snapshot(t) {
    return A(this, null, function* () {
      yield We.snapshotCanvas(t);
    });
  }
  addSessionFeedback({ timestamp: t, verbatim: i, user_email: n, user_name: s }) {
    var l;
    this._worker.postMessage({
      message: {
        type: pe.Feedback,
        verbatim: i,
        timestamp: t,
        userName: s || this.sessionData.userIdentifier,
        userEmail: n || ((l = this.sessionData.userObject) == null ? void 0 : l.name)
      }
    });
  }
  // Reset the events array and push to a backend.
  _save() {
    return A(this, null, function* () {
      var t;
      try {
        this.state === "Recording" && this.listeners && this.sessionData.sessionStartTime && Date.now() - this.sessionData.sessionStartTime > pl && (this.logger.log("Resetting session", {
          start: this.sessionData.sessionStartTime
        }), yield this._reset({}));
        let i;
        ((t = this.options) == null ? void 0 : t.sendMode) === "local" && (i = (n) => A(this, null, function* () {
          let s = new Blob([
            JSON.stringify({
              query: $n(Js),
              variables: n
            })
          ], {
            type: "application/json"
          });
          return yield window.fetch(`${this._backendUrl}`, {
            method: "POST",
            body: s
          }), 0;
        })), yield this._sendPayload({ sendFn: i }), this.hasPushedData = !0, this.sessionData.lastPushTime = Date.now(), tt(this.sessionData);
      } catch (i) {
        this._isOnLocalHost && (console.error(i), nt("_save", i));
      }
      this.state === "Recording" && (this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0), this.pushPayloadTimerId = setTimeout(() => {
        this._save();
      }, bl));
    });
  }
  /**
   * This proxy should be used instead of rrweb's native addCustomEvent.
   * The proxy makes sure recording has started before emitting a custom event.
   */
  addCustomEvent(t, i) {
    if (this.state === "NotRecording") {
      let n;
      const s = () => {
        clearInterval(n), this.state === "Recording" && this.events.length > 0 ? Cn(t, i) : n = setTimeout(s, 500);
      };
      n = setTimeout(s, 500);
    } else
      this.state === "Recording" && (this.events.length > 0 || this.hasPushedData) && Cn(t, i);
  }
  _sendPayload(i) {
    return A(this, arguments, function* ({ sendFn: t }) {
      const n = Ke.getRecordedNetworkResources(this._firstLoadListeners, this._recordingStartTime), s = Ke.getRecordedWebSocketEvents(this._firstLoadListeners), l = [...this.events], o = [...this._firstLoadListeners.messages], r = [...this._firstLoadListeners.errors], { bytes: a, time: c } = this.enableCanvasRecording ? nn.canvas : nn.normal;
      this._eventBytesSinceSnapshot >= a && (/* @__PURE__ */ new Date()).getTime() - this._lastSnapshotTime >= c && this.takeFullSnapshot(), this.logger.log(`Sending: ${l.length} events, ${o.length} messages, ${n.length} network resources, ${r.length} errors 
To: ${this._backendUrl}
Org: ${this.organizationID}
SessionSecureID: ${this.sessionData.sessionSecureID}`);
      const d = Er();
      t ? yield t({
        session_secure_id: this.sessionData.sessionSecureID,
        payload_id: this.sessionData.payloadID.toString(),
        events: { events: l },
        messages: li({ messages: o }),
        resources: JSON.stringify({ resources: n }),
        web_socket_events: JSON.stringify({
          webSocketEvents: s
        }),
        errors: r,
        is_beacon: !1,
        has_session_unloaded: this.hasSessionUnloaded
      }) : this._worker.postMessage({
        message: {
          type: pe.AsyncEvents,
          id: this.sessionData.payloadID++,
          events: l,
          messages: o,
          errors: r,
          resourcesString: JSON.stringify({ resources: n }),
          webSocketEventsString: JSON.stringify({
            webSocketEvents: s
          }),
          hasSessionUnloaded: this.hasSessionUnloaded,
          highlightLogs: d
        }
      }), tt(this.sessionData), Ke.clearRecordedNetworkResources(this._firstLoadListeners), this.events = this.events.slice(l.length), this._firstLoadListeners.messages = this._firstLoadListeners.messages.slice(o.length), this._firstLoadListeners.errors = this._firstLoadListeners.errors.slice(r.length), Or(d);
    });
  }
  takeFullSnapshot() {
    this.logger.log("taking full snapshot", {
      bytesSinceSnapshot: this._eventBytesSinceSnapshot,
      lastSnapshotTime: this._lastSnapshotTime
    }), We.takeFullSnapshot(!0), this._eventBytesSinceSnapshot = 0, this._lastSnapshotTime = (/* @__PURE__ */ new Date()).getTime();
  }
}
export {
  Ke as FirstLoadListeners,
  ni as GenerateSecureID,
  js as Highlight,
  nt as HighlightWarning,
  Ze as MetricCategory,
  qi as getPreviousSessionData,
  dc as getTracer,
  uc as setupBrowserTracing
};
//# sourceMappingURL=index-DOW7TX9H.js.map
